webpackJsonp([1],{

/***/ "/8cq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/FCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__("tVBY");
var range_default = /*#__PURE__*/__webpack_require__.n(range);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("kvU2");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/components/reports-schedule-edit-modal.vue + 2 modules
var reports_schedule_edit_modal = __webpack_require__("vRDl");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports-schedule.vue







/* harmony default export */ var reports_schedule = ({
  name: 'ReportsSchedule',
  props: {
    value: {},
    id: {}
  },
  methods: {
    edit: function edit() {
      var _this = this;

      this.$root.showModal(reports_schedule_edit_modal["default"], {
        value: this.value && cloneDeep_default()(this.value) || { days: [] },
        ids: [this.id]
      }).then(function (value) {
        if (value) {
          _this.$emit('input', value);
        }
      });
    }
  },
  computed: {
    daysLabel: function daysLabel() {
      if (!this.value) return null;
      if (isEqual_default()(this.value.days, range_default()(0, 5))) {
        return 'Будни';
      } else if (isEqual_default()(this.value.days, range_default()(5, 7))) {
        return 'Выходные дни';
      } else if (isEqual_default()(this.value.days, range_default()(0, 7))) {
        return 'Ежедневно';
      } else {
        return this.value.days.map(function (d) {
          return moment_default()().weekday(d).format('dd');
        }).join(' ');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e56a005","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/reports-schedule.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports-schedule"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between flex-wrap"},[(_vm.value && _vm.daysLabel)?_c('div',{staticClass:"mr-2"},[_c('span',{staticClass:"badge text-capitalize"},[_vm._v(_vm._s(_vm.daysLabel))]),_vm._v(" c\n      "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.value.from))]),_vm._v(" по\n      "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.value.till))]),_vm._v(" каждые\n      "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.value.every))]),_vm._v(" ч\n    ")]):_c('div',{staticClass:"text-muted mr-2"},[_vm._v("Нет")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function($event){$event.stopPropagation();return _vm.edit($event)}}},[_vm._v("Редактировать")])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/reports-schedule.vue
function injectStyle (context) {
  __webpack_require__("hVME")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  reports_schedule,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_reports_schedule = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/Rpq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/not-found.vue


/* harmony default export */ var not_found = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5350c4e6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/not-found.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('div',{staticClass:"container-fluid"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Страница не найдена")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/not-found.vue
function injectStyle (context) {
  __webpack_require__("KAfx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  not_found,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_not_found = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/tRM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/filters.js
var filters = __webpack_require__("rm9P");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders/ingredients/create.vue





/* harmony default export */ var create = ({
  metaInfo: { title: 'Новая заявка на ингредиенты' },
  data: function data() {
    return {
      selectedOperator: null,
      selectedMachines: []
    };
  },

  computed: {},
  methods: {
    fullName: filters["a" /* default */].fullName,
    save: function save() {
      var _this = this;

      return api["a" /* default */].post('orders/ingredients', {
        user_id: this.selectedOperator.id,
        request: this.ingredients.map(function (current) {
          return {
            amount: current.need,
            component_id: current.component.id
          };
        })
      }).then(function () {
        _this.$router.push('/orders/ingredients');
      });
    },
    deleteMachine: function deleteMachine(index) {
      this.selectedMachines.splice(index, 1);
    }
  },
  watch: {
    selectedOperator: function selectedOperator() {
      this.selectedMachines = [];
    }
  },
  asyncComputed: {
    ingredients: function ingredients() {
      return api["a" /* default */].post('orders/need', {
        machines: this.selectedMachines.map(function (current) {
          return current.id;
        })
      }).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e089d5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders/ingredients/create.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_c('back-button',{attrs:{"to":"/orders/ingredients"}}),_vm._v("Новая заявка")],1),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.selectedOperator === null},on:{"click":_vm.save}},[_vm._v("Оформить заявку")])],1),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"max-width":"28rem"}},[_c('server-select',{attrs:{"custom-label":_vm.fullName,"endpoint":"users_by_role","endpoint-params":{role: ['service']}},model:{value:(_vm.selectedOperator),callback:function ($$v) {_vm.selectedOperator=$$v},expression:"selectedOperator"}})],1)]),_vm._v(" "),(_vm.selectedOperator)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('server-select',{staticClass:"select-machines-orders-ingredients-create",attrs:{"endpoint":"orders/machines","endpoint-params":{operator_id: _vm.selectedOperator.id},"multiple":true,"label":"serial_number","custom-label":function (machine) { return ((machine.serial_number) + " – " + (machine.address)); }},model:{value:(_vm.selectedMachines),callback:function ($$v) {_vm.selectedMachines=$$v},expression:"selectedMachines"}}),_vm._v(" "),(_vm.selectedMachines && _vm.selectedMachines.length)?_c('table',{staticClass:"table table-sm px-0 mt-2 mb-0"},_vm._l((_vm.selectedMachines),function(machine,index){return _c('tr',[_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(machine.serial_number))])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(machine.address))]),_vm._v(" "),_c('td',{attrs:{"width":"1"}},[_c('button',{staticClass:"btn btn-sm btn-outline-danger",on:{"click":function($event){return _vm.deleteMachine(index)}}},[_vm._v("× Удалить")])])])}),0):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.ingredients && _vm.ingredients.length)?_c('table',{staticClass:"table table-sm px-0 mt-2 mb-0"},_vm._l((_vm.ingredients),function(ingredient,index){return _c('tr',[_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(ingredient.component.name))])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v("\n                "+_vm._s(_vm._f("remainder")(ingredient.need))+" "+_vm._s(ingredient.component.measure)+"\n              ")])])}),0):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Оператор")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Автоматы для расчета")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Суммарное количество необходимых ингредиентов")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders/ingredients/create.vue
function injectStyle (context) {
  __webpack_require__("gcqA")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  create,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ingredients_create = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/zYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Utu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/table-column-string.vue


/* harmony default export */ var table_column_string = ({
  props: {
    tableColumnType: { type: String, default: 'string' } }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d91ddaf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-string.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-column-element',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n      "+_vm._s(scope.row[scope.column.property])+"\n    ")]}}])},'table-column-element',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/table-column-string.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_column_string,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_column_string = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0mbS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0sks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/dom-events/index.js
var dom_events = __webpack_require__("Fn2p");
var dom_events_default = /*#__PURE__*/__webpack_require__.n(dom_events);

// EXTERNAL MODULE: ./node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js
var bootstrap_datepicker = __webpack_require__("71lI");
var bootstrap_datepicker_default = /*#__PURE__*/__webpack_require__.n(bootstrap_datepicker);

// EXTERNAL MODULE: ./node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.ru.js
var bootstrap_datepicker_ru = __webpack_require__("xaR9");
var bootstrap_datepicker_ru_default = /*#__PURE__*/__webpack_require__.n(bootstrap_datepicker_ru);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/monthpicker.vue








jquery_default.a.fn.datepicker.defaults.language = 'ru';

/* harmony default export */ var monthpicker = ({
  name: 'monthpicker',
  props: {
    value: {
      type: String
    }
  },
  data: function data() {
    return {
      date: this.valueToDate(this.value)
    };
  },

  watch: {
    value: function value(newValue) {
      var _this = this;

      this.date = this.valueToDate(newValue);
      this.$nextTick(function () {
        return _this.$input.datepicker('update');
      });
    },
    date: function date(newDate) {
      var value = this.dateToValue(newDate);
      if (!newDate || newDate && value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    valueToDate: function valueToDate(value) {
      var m = moment_default()(value, 'YYYY-MM', true);
      if (m.isValid()) {
        return m.format('MM.YYYY');
      }
    },
    dateToValue: function dateToValue(date) {
      var m = moment_default()(date, 'MM.YYYY', true);
      if (m.isValid()) {
        return m.format('YYYY-MM');
      }
    }
  },
  computed: {
    $input: function $input() {
      return jquery_default()(this.$refs.input);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var config = {
      todayHighlight: true,
      autoclose: true,
      minViewMode: 'months',
      format: 'mm.yyyy'
    };
    this.$input.datepicker(config);

    this.$input.on('change clearDate cleared blur', function (e) {
      _this2.$nextTick(function () {
        return dom_events_default.a.emit(_this2.$refs.input, 'input');
      });
    });
    this.$input.trigger('change');
  },
  beforeDestroy: function beforeDestroy() {
    this.$input.datepicker('destroy');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d11dd4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/monthpicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],ref:"input",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value}}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/monthpicker.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  monthpicker,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_monthpicker = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0wIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/admin/documents.vue


/* harmony default export */ var documents = ({
  data: function data() {
    return {
      subnav: [{
        text: 'Документы',
        to: '/admin/documents',
        exact: true
      }, {
        text: 'Чек-листы',
        to: '/admin/documents/checklists'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a02bd4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/documents.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('subnav',{attrs:{"links":_vm.subnav,"heading":"Документы и чек-листы"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/admin/documents.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  documents,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var admin_documents = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1H0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);

// EXTERNAL MODULE: ./resources/assets/js/auth.js
var auth = __webpack_require__("S8OL");

// EXTERNAL MODULE: ./resources/assets/js/root.js + 9 modules
var root = __webpack_require__("je9+");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__("Y81h");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// CONCATENATED MODULE: ./resources/assets/js/nprogress.js






var nprogress_Progress = function () {
  function Progress() {
    var _this = this;

    classCallCheck_default()(this, Progress);

    this.counter = 0;

    nprogress_default.a.configure({
      minimum: 0.16,
      speed: 200,
      trickleRate: 0.1,
      trickleSpeed: 250
    });

    jquery_default()(document).bind('ajaxStart', function () {
      return _this.start();
    }).bind('ajaxComplete', function () {
      return _this.done();
    });
  }

  createClass_default()(Progress, [{
    key: 'use',
    value: function use(axios) {
      var _this2 = this;

      axios.interceptors.request.use(function (config) {
        _this2.start();
        return config;
      }, function (error) {
        return promise_default.a.reject(error);
      });

      axios.interceptors.response.use(function (response) {
        _this2.done();
        return response;
      }, function (error) {
        _this2.done();
        return promise_default.a.reject(error);
      });
    }
  }, {
    key: 'start',
    value: function start() {
      if (this.counter === 0) {
        nprogress_default.a.start();
      } else {
        nprogress_default.a.inc();
      }
      this.counter++;
    }
  }, {
    key: 'done',
    value: function done() {
      var _this3 = this;

      setTimeout(function () {
        _this3.counter--;
        if (_this3.counter === 0) {
          nprogress_default.a.done();
        } else {
          nprogress_default.a.inc();
        }
      }, 100);
    }
  }]);

  return Progress;
}();

/* harmony default export */ var js_nprogress = (new nprogress_Progress());
// CONCATENATED MODULE: ./resources/assets/js/api.js







var api = axios_default.a.create({
  baseURL: '/api/admin/',
  paramsSerializer: jquery_default.a.param,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
});
js_nprogress.use(api);

api.interceptors.response.use(function (response) {
  if (response && response.headers && response.headers.release) {
    if (root["default"]) {
      root["default"].release = response.headers.release;
    }
  }
  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    auth["a" /* default */].afterLogout();

    return promise_default.a.reject(error);
  }

  return promise_default.a.reject(error);
});

/* harmony default export */ var js_api = __webpack_exports__["a"] = (api);

/***/ }),

/***/ "1inz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/v-multiselect.vue


/* harmony default export */ var v_multiselect = ({
  props: {
    value: {},
    showLabels: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    placeholder: {
      type: String,
      default: 'Выберите'
    },
    optionHeight: {
      type: Number,
      default: 28
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1a59bbc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/v-multiselect.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',_vm._g(_vm._b({attrs:{"value":_vm.value,"showLabels":_vm.showLabels,"placeholder":_vm.placeholder,"option-height":_vm.optionHeight},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(content,name){return {key:name,fn:function(props){return [_vm._t(name,[_c('vnode',{attrs:{"node":content}})],null,props)]}}})],null,true)},'multiselect',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(content,name){return _c('template',{slot:name},[_vm._t(name,[_c('vnode',{attrs:{"node":content}})])],2)}),_vm._v(" "),_vm._v(" "),(!_vm.$slots['noResult'])?_c('template',{slot:"noResult"},[_vm._v("Не найдено")]):_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/v-multiselect.vue
function injectStyle (context) {
  __webpack_require__("past")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  v_multiselect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_v_multiselect = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1kcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/map.js
var map = __webpack_require__("nSPF");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.min.js
var vuedraggable_umd_min = __webpack_require__("6Top");
var vuedraggable_umd_min_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd_min);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/checklist-modal.vue + 2 modules
var checklist_modal = __webpack_require__("GryE");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/admin/documents/checklists.vue








/* harmony default export */ var checklists = ({
  metaInfo: { title: 'Чек-листы' },
  components: {
    draggable: vuedraggable_umd_min_default.a
  },
  data: function data() {
    return {
      currentChecklist: null,
      selectedMachineType: '',
      selectedTaskType: '',
      moving: null
    };
  },

  methods: {
    checklist: function checklist() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.currentChecklist.length;

      var _this = this;

      var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var elementType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      this.$root.showModal(checklist_modal["default"], {
        machine_type_id: this.selectedMachineType.id,
        task_type_id: this.selectedTaskType.id,
        name_prop: name,
        description_prop: description,
        id: id,
        order_number: order,
        element_type: elementType
      }).then(function (data) {
        if (data !== undefined) {
          var element = _this.currentChecklist.find(function (current) {
            return current.id === id;
          });
          if (element !== undefined) {
            assign_default()(element, data);
          } else {
            _this.currentChecklist.push(data);
          }
        }
      });
    },
    edit: function edit(element) {
      this.checklist(element.name, element.description, element.order_number, element.id, element.type);
    },
    remove: function remove(element) {
      var _this2 = this;

      if (!window.confirm('Подтвердить удаление ?')) return;

      return api["a" /* default */].delete('checklists/' + element.id).then(function () {
        _this2.currentChecklist.splice(_this2.currentChecklist.indexOf(element), 1);
      });
    }
  },
  watch: {
    currentChecklist: function currentChecklist(list) {
      if (list !== undefined) {
        api["a" /* default */].post('checklists/order', {
          ids: map_default()(list, function (current) {
            return current.id;
          })
        });
      }
    }
  },
  asyncComputed: {
    taskTypes: function taskTypes() {
      return api["a" /* default */].get('tasks').then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    },
    machineTypes: function machineTypes() {
      return api["a" /* default */].get('machines/types').then(function (_ref2) {
        var data = _ref2.data;
        return data.data;
      });
    },
    elements: function elements() {
      var _this3 = this;

      if (this.selectedMachineType !== '' && this.selectedTaskType !== '') {
        api["a" /* default */].get('checklists/elements', {
          params: {
            task_type_id: this.selectedTaskType.id,
            machine_type_id: this.selectedMachineType.id
          }
        }).then(function (_ref3) {
          var data = _ref3.data;

          _this3.currentChecklist = data.data;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e1b72a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/documents/checklists.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex flex-column flex-grow-1"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("Чек-листы")]),_vm._v(" "),_c('div',{staticClass:"input-group mr-2",staticStyle:{"max-width":"30em"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMachineType),expression:"selectedMachineType"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedMachineType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Тип автомата...")]),_vm._v(" "),_vm._l((_vm.machineTypes),function(type){return _c('option',{domProps:{"value":type}},[_vm._v(_vm._s(type.name))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTaskType),expression:"selectedTaskType"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTaskType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Тип задачи...")]),_vm._v(" "),_vm._l((_vm.taskTypes),function(type){return _c('option',{domProps:{"value":type}},[_vm._v(_vm._s(type.name))])})],2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.selectedMachineType === '' || _vm.selectedTaskType === ''},on:{"click":function($event){return _vm.checklist()}}},[_vm._v("Добавить элемент")])]),_vm._v(" "),_c('div',{staticClass:"table-full-width flex-grow-1 bg-white d-flex flex-column"},[_vm._m(0),_vm._v(" "),_c('height-tracker',{staticClass:"container-fluid flex-grow-1",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var height = ref.height;
return _c('div',{staticClass:"table-full-width"},[_c('div',{ref:"content",style:('overflow-y: auto; height: ' + height + 'px')},[_c('draggable',{model:{value:(_vm.currentChecklist),callback:function ($$v) {_vm.currentChecklist=$$v},expression:"currentChecklist"}},_vm._l((_vm.currentChecklist),function(element){return _c('div',[_c('div',{staticClass:"d-flex flex-row p-2 washy-bottom"},[_c('div',[_vm._v(_vm._s(element.name))]),_vm._v(" "),_c('div',{staticClass:"ml-auto text-nowrap"},[_c('button',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function($event){return _vm.edit(element)}}},[_vm._v("Редактировать")]),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function () { return _vm.remove(element); }}},[_vm._v("Удалить")])],1)])])}),0),_vm._v(" "),_vm._t("default")],2)])}}],null,true)})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table mb-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Элементы чек-листа")])])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/admin/documents/checklists.vue
function injectStyle (context) {
  __webpack_require__("ZEkr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  checklists,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var documents_checklists = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2D6f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2n6t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3PDc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEOTVBMkMiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTcuMjg3IDEwLjQ2NWgtLjI1M2wtLjcwNS0xLjU3M0MxNS44NSA3Ljg1NyAxNS4zMzQgNyAxMy45MTYgN2gtMy43NzdDOC41NjMgNyA3Ljk3MiA4LjMzNCA3LjcyIDguOWwtLjcwMSAxLjU2NWgtLjMwNmMtMS40OTcgMC0yLjcxNC45NS0yLjcxNCAyLjExOHYuNDgzYzAgMS4zNDQuNjU3IDEuODM1IDEuNDEzIDIuMDE0YTIuMjUzIDIuMjUzIDAgMCAwIDIuMjMgMS45NSAyLjI1NCAyLjI1NCAwIDAgMCAyLjIxMi0xLjg0Nmg0LjQzMmEyLjI1NCAyLjI1NCAwIDAgMCAyLjIxMyAxLjg0NWMxLjE1NiAwIDIuMTEtLjg3NSAyLjIzNi0xLjk5OC42ODQtLjIxNCAxLjI2NC0uNzI4IDEuMjY0LTEuOTY1di0uNDgzYzAtMS4xNjgtMS4yMTctMi4xMTgtMi43MTMtMi4xMTh6bS05LjY3MSA1LjQwOGExLjA4NSAxLjA4NSAwIDEgMSAwLTIuMTcgMS4wODUgMS4wODUgMCAwIDEgMCAyLjE3em0zLjY4LTUuNDA4SDguNWwuNDU1LTEuMDE1Yy4zNjktLjgzMi42NTYtMS4wOTkgMS4xODQtMS4wOTloMS4xNTd2Mi4xMTR6bTEuMzUxIDBWOC4zNTFoMS4yNjljLjUzNyAwIC43MzMuMTMxIDEuMTg1IDEuMTAybC40NTQgMS4wMTJoLTIuOTA4em0zLjgyNiA1LjQwOGExLjA4NSAxLjA4NSAwIDEgMSAwLTIuMTcgMS4wODUgMS4wODUgMCAwIDEgMCAyLjE3eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "3Z56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders/ingredients/index.vue


/* harmony default export */ var ingredients = ({
  metaInfo: { title: 'Заявки на ингредиенты' },
  data: function data() {
    return {
      data: {},
      loading: false,
      hasMore: true,
      filtersValue: null,
      date: {
        min: null,
        max: null
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c798590","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders/ingredients/index.vue
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"orders/ingredients","loading":_vm.loading,"hasMore":_vm.hasMore,"filtersValue":_vm.filtersValue,"date":_vm.date},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("На ингредиенты")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"users","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary ml-2",attrs:{"to":"/orders/ingredients/create"}},[_vm._v("Добавить заявку")])],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"row-click":(function (row) { return this$1.$router.push(("/orders/ingredients/" + (row.id))); })}},[_c('el-table-column',{attrs:{"prop":"","label":"ФИО"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(_vm._f("fullName")(row.user))+"\n        ")]}}],null,false,2039665891)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"№ заявки"}}),_vm._v(" "),_c('table-column-date',{attrs:{"label":"Дата создания"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status.description","label":"Статус заявки"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders/ingredients/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ingredients,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var orders_ingredients = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3ldo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "43gl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dsl-modal.vue





/* harmony default export */ var dsl_modal = ({
  props: ['matrix', 'isCoffee', 'modemUid'],
  data: function data() {
    return {
      selectedProduct: null,
      sugar: 0,
      cup: true
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      var data = {
        product_id: this.selectedProduct.id
      };
      if (this.isCoffee) {
        data = assign_default()(data, {
          sugar: this.sugar,
          cup: this.cup
        });
      }
      return api["a" /* default */].post('modems/' + this.modemUid + '/commands/dsl', data).then(function () {
        return _this.hide();
      });
    },
    hide: function hide() {
      this.$emit('hide');
    }
  },
  computed: {
    options: function options() {
      return this.matrix ? this.matrix.products.map(function (el) {
        return el.product;
      }) : [];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f25d22","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/dsl-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("Выдача продукта")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hide()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group",staticStyle:{"position":"relative","z-index":"2"}},[_c('label',[_vm._v("Продукт")]),_vm._v(" "),_c('v-multiselect',{attrs:{"options":_vm.options,"label":"name"},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}})],1),_vm._v(" "),(_vm.isCoffee)?_c('div',{staticClass:"form-group",staticStyle:{"position":"relative","z-index":"1"}},[_c('label',[_vm._v("Сахар")]),_vm._v(" "),_c('div',{staticClass:"mx-2"},[_c('el-slider',{attrs:{"max":6,"show-tooltip":"","show-stops":""},model:{value:(_vm.sugar),callback:function ($$v) {_vm.sugar=$$v},expression:"sugar"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCoffee)?_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cup),expression:"cup"}],ref:"cup_checkbox",staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"cup-checkbox"},domProps:{"checked":Array.isArray(_vm.cup)?_vm._i(_vm.cup,null)>-1:(_vm.cup)},on:{"change":function($event){var $$a=_vm.cup,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cup=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cup=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cup=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"cup-checkbox"}},[_vm._v("Выдача стакана")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex"},[_c('btn-action',{staticClass:"btn btn-primary ml-auto",attrs:{"disabled":!_vm.selectedProduct},on:{"click":_vm.save}},[_vm._v("Выдать продукт")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/dsl-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  dsl_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_dsl_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4GJc":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrowdown.svg": "vQ9a",
	"./check.svg": "7UNq",
	"./list.svg": "dBND",
	"./map.svg": "t+bR",
	"./person.svg": "YBb2",
	"./phone.svg": "s105",
	"./selection-copy-8.svg": "F186",
	"./service-legend.svg": "ETcG",
	"./sort.svg": "ebhS",
	"./time.svg": "Wo16",
	"./trash.svg": "IhQk",
	"./type.svg": "Xira",
	"./type2.svg": "7Kym",
	"./write.svg": "bNhb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4GJc";

/***/ }),

/***/ "4Ufk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4cw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__("w9Mt");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/modem-command-details.vue





/* harmony default export */ var modem_command_details = ({
  props: {
    command: {
      type: Object
    }
  },
  computed: {
    showData: function showData() {
      return pick_default()(this.command, ['timestamp', 'type', 'status', 'error_code', 'requested_at', 'placed_at', 'modem_deleted_exec_at', 'received_at', 'state']);
    },
    isMedia: function isMedia() {
      return ['jpeg', 'wav'].includes(this.command.type);
    }
  },
  methods: {
    deleteCommand: function deleteCommand() {
      if (window.confirm('Удалить команду?')) {
        return api["a" /* default */].delete('commands/' + this.command.id).then(function () {
          return window.location.reload();
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d291cbe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modem-command-details.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("id")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/commands/" + (_vm.command.id))}},[_vm._v(_vm._s(_vm.command.id))])],1),_vm._v(" "),_c('dt',[_vm._v("modem_uid")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/modems/" + (_vm.command.modem_uid))}},[_vm._v(_vm._s(_vm.command.modem_uid))])],1),_vm._v(" "),(_vm.command.machine_id)?[_c('dt',[_vm._v("machine_id")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/machines/" + (_vm.command.machine_id))}},[_vm._v(_vm._s(_vm.command.machine_id))])],1)]:_vm._e(),_vm._v(" "),(_vm.command.receipts && _vm.command.receipts.length)?[_c('dt',[_vm._v("receipts")]),_vm._v(" "),_vm._l((_vm.command.receipts),function(receipt){return _c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/receipts/" + (receipt.id))}},[_vm._v(_vm._s(receipt.id))])],1)})]:_vm._e(),_vm._v(" "),(_vm.isMedia)?[_c('dt',[_vm._v("content")]),_vm._v(" "),_c('dd',[_c('a',{staticClass:"text-monospace text-muted",attrs:{"href":'/api/admin/commands/' + _vm.command.id + '/download'}},[_vm._v("Скачать")])])]:_vm._e(),_vm._v(" "),_vm._l((_vm.showData),function(value,key){return (value)?[_c('dt',[_vm._v(_vm._s(key))]),_vm._v(" "),_c('dd',{staticClass:"text-monospace text-muted"},[_vm._v(_vm._s(value))])]:_vm._e()}),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-outline-danger",on:{"click":_vm.deleteCommand}},[_vm._v("Удалить команду")])],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.command.data !== undefined)?[_c('strong',[_vm._v("Исходящие данные")]),_vm._v(" "),(_vm.command.data)?_c('pre',{staticClass:"modem-command-data-result mx-0 mt-0 mb-3 p-3"},[_vm._v(_vm._s(_vm.command.data.trim()))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-muted"},[(_vm.command.data === '')?_c('div',[_vm._v("файл с исходящими данными пустой")]):_vm._e(),_vm._v(" "),(_vm.command.data === null)?_c('div',[_vm._v("файл с исходящими данными отсутствует")]):_vm._e()])]:_vm._e(),_vm._v(" "),('data_result' in _vm.command)?[_c('strong',[_vm._v("Входящие данные")]),_vm._v(" "),(_vm.command.data_result)?_c('pre',{staticClass:"modem-command-data-result m-0 p-3"},[_vm._v(_vm._s(_vm.command.data_result.trim()))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-muted"},[(_vm.command.data_result === '')?_c('div',[_vm._v("файл с входящими данными пустой")]):_vm._e(),_vm._v(" "),(_vm.command.data_result === null)?_c('div',[_vm._v("файл с входящими данными отсутствует")]):_vm._e()])]:_vm._e()],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/modem-command-details.vue
function injectStyle (context) {
  __webpack_require__("r6gy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modem_command_details,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_modem_command_details = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4mXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/btn-action.vue + 2 modules
var btn_action = __webpack_require__("K+Zy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/modem.vue





/* harmony default export */ var modem = ({
  components: { BtnAction: btn_action["default"] },
  data: function data() {
    return {
      uid: null,
      firmware: null,
      cfgprg: null,
      evaprg: null,
      display: null,
      validationErrors: {},
      allowToUnbind: ['tech_superior', 'admin', 'branch_admin']
    };
  },

  props: {
    id: {
      required: true
    },
    machine: {
      type: Object
    }
  },
  computed: {
    firmwareName: function firmwareName() {
      if (this.firmware) {
        return this.firmware.name;
      } else {
        return 'Файл не выбран';
      }
    },
    cfgprgName: function cfgprgName() {
      if (this.cfgprg) {
        return this.cfgprg.name;
      } else {
        return 'Файл не выбран';
      }
    },
    evaprgName: function evaprgName() {
      if (this.evaprg) {
        return this.evaprg.name;
      } else {
        return 'Файл не выбран';
      }
    },
    displayName: function displayName() {
      return this.display ? this.display.name : 'Файл не выбран';
    },
    operator: function operator() {
      return get_default()(this.machine.modem, 'data.operator', '');
    },
    signal: function signal() {
      return get_default()(this.machine.modem, 'data.signal', '');
    }
  },
  methods: {
    save: function save() {
      return api["a" /* default */].post('modems', {
        modemUid: this.uid,
        machineId: this.id
      }).then(function (data) {
        window.location.reload();
      }).catch(this.handleValidation);
    },
    handleValidation: function handleValidation(error) {
      if (error.response && error.response.status === 422) {
        this.validationErrors = error.response.data.validation;
      } else {
        throw error;
      }
    },
    resetPassword: function resetPassword() {
      if (window.confirm('Действительно сбросить пароль?')) {
        return api["a" /* default */].put('modems/' + this.machine.modem.id + '/resetPassword');
      }
    },
    sendCommand: function sendCommand(type, data) {
      return api["a" /* default */].post('modems/' + this.machine.modem.uid + '/commands', {
        type: type,
        data: data
      });
    },
    execCamCommand: function execCamCommand() {
      return api["a" /* default */].post('modems/' + this.machine.modem.uid + '/commands/camera').then(alert.bind(null, 'Команда отправлена.')).catch(alert.bind(null, 'Ошибка. Попробуйте еще раз.'));
    },
    execMicCommand: function execMicCommand() {
      return api["a" /* default */].post('modems/' + this.machine.modem.uid + '/commands/microphone').then(alert.bind(null, 'Команда отправлена.')).catch(alert.bind(null, 'Ошибка. Попробуйте еще раз.'));
    },
    uploadFile: function uploadFile(name) {
      var data = new FormData();
      data.append(name, this[name]);
      this[name] = undefined;
      this.$refs[name].reset();
      return api["a" /* default */].post('modems/' + this.machine.modem.id + '/upload' + (name.charAt(0).toUpperCase() + name.slice(1)), data, {
        headers: { 'content-type': 'multipart/form-data' }
      });
    },
    onFileChange: function onFileChange(e, name) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this[name] = files[0];
    },
    unbindModem: function unbindModem() {
      if (window.confirm('Отвязать модем?')) {
        return api["a" /* default */].post('modems/' + this.machine.modem.id + '/dissociate').then(function () {
          window.location.reload();
        });
      }
    },
    canUnbind: function canUnbind() {
      return this.allowToUnbind.includes(get_default()(this.$root.user, 'role.name'));
    }
  },
  asyncComputed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec00d30","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/modem.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machines-show-modem container-fluid"},[(_vm.machine && _vm.machine.modem)?[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("Модем "+_vm._s(_vm.machine.modem.number))]),_vm._v(" "),(_vm.canUnbind())?_c('button',{staticClass:"btn btn-sm btn-outline-danger mr-2",on:{"click":_vm.unbindModem}},[_vm._v("\n        Отвязать\n      ")]):_vm._e(),_vm._v(" "),(_vm.$root.checkPermission('web_modems'))?_c('router-link',{staticClass:"btn btn-outline-light",attrs:{"to":("/modems/" + (_vm.machine.modem.uid))},domProps:{"textContent":_vm._s(("Модем " + (_vm.machine.modem.uid)))}}):_vm._e()],1),_vm._v(" "),_c('hr',{staticClass:"mt-0"}),_vm._v(" "),_c('div',{staticClass:"machines-show-modem-summary"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"row align-items-center mb-3"},[_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"media align-items-center"},[_c('img',{staticClass:"modem-svg-icon d-flex mr-3",attrs:{"src":__webpack_require__("aIlR")}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("Версия ПО:")]),_vm._v(" "+_vm._s(_vm.machine.modem.software_version))]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("Шина MDB:")]),_vm._v(" "),_c('span',{class:_vm.machine.modem.mdb_test ? 'text-success' : 'text-danger'},[_vm._v("\n                      "+_vm._s(_vm.machine.modem.mdb_test ? 'норма' : 'ошибка')+"\n                    ")])]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("ICCID:")]),_vm._v(" "+_vm._s(_vm.machine.modem.iccid))]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("IMSI:")]),_vm._v(" "+_vm._s(_vm.machine.modem.imsi))]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("Оператор:")]),_vm._v(" "+_vm._s(_vm.operator))]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("Уровень сигнала:")]),_vm._v(" "+_vm._s(_vm.signal))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('btn-action',{staticClass:"btn btn-outline-primary btn-block",on:{"click":function () { return _vm.sendCommand('reboot', null); }}},[_vm._v("\n                Перезапустить модем\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"row align-items-end mb-3"},[_c('div',{staticClass:"col-sm"},[_c('h3',[_vm._v("Прошивка модема")]),_vm._v(" "),_c('form',{ref:"firmware"},[_c('label',{staticClass:"btn btn-file btn-outline-danger m-0"},[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.onFileChange($event, 'firmware')}}}),_vm._v("\n                  Выберите файл\n                ")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.firmwareName))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('btn-action',{staticClass:"btn btn-outline-primary btn-block",attrs:{"disabled":!_vm.firmware},on:{"click":function () { return _vm.uploadFile('firmware'); }}},[_vm._v("\n                Загрузить\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row align-items-end mb-3"},[_c('div',{staticClass:"col-sm"},[_c('h3',[_vm._v("Прошивка дисплея")]),_vm._v(" "),_c('form',{ref:"display"},[_c('label',{staticClass:"btn btn-file btn-outline-danger m-0"},[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.onFileChange($event, 'display')}}}),_vm._v("\n                  Выберите файл\n                ")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.displayName))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('btn-action',{staticClass:"btn btn-outline-primary btn-block",attrs:{"disabled":!_vm.display},on:{"click":function () { return _vm.uploadFile('display'); }}},[_vm._v("\n                Загрузить\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row align-items-end mb-3"},[_c('div',{staticClass:"col-sm"},[_c('h3',[_vm._v("Конфигурационный файл модема (cfgprg)")]),_vm._v(" "),_c('form',{ref:"cfgprg"},[_c('label',{staticClass:"btn btn-file btn-outline-danger m-0"},[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.onFileChange($event, 'cfgprg')}}}),_vm._v("\n                  Выберите файл\n                ")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.cfgprgName))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('btn-action',{staticClass:"btn btn-outline-primary btn-block",attrs:{"disabled":!_vm.cfgprg},on:{"click":function () { return _vm.uploadFile('cfgprg'); }}},[_vm._v("\n                Загрузить\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row align-items-end mb-3"},[_c('div',{staticClass:"col-sm"},[_c('h3',[_vm._v("Конфигурационный файл автомата (evaprg)")]),_vm._v(" "),_c('form',{ref:"evaprg"},[_c('label',{staticClass:"btn btn-file btn-outline-danger m-0"},[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.onFileChange($event, 'evaprg')}}}),_vm._v("\n                  Выберите файл\n                ")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.evaprgName))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('btn-action',{staticClass:"btn btn-outline-primary btn-block",attrs:{"disabled":!_vm.evaprg},on:{"click":function () { return _vm.uploadFile('evaprg'); }}},[_vm._v("\n                Загрузить\n              ")])],1)])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"machines-show-modem-details row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('btn-action',{staticClass:"btn btn-outline-danger btn-block",on:{"click":_vm.resetPassword}},[_c('font-awesome-icon',{attrs:{"icon":"unlock-alt"}}),_vm._v("\n          Сбросить пароль\n        ")],1)],1)])]:[_c('h2',{staticClass:"page-heading"},[_vm._v("Модем не подключен")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID модема")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uid),expression:"uid"}],staticClass:"form-control",class:{'is-invalid': _vm.validationErrors.modemUid},staticStyle:{"width":"50%"},attrs:{"type":"text"},domProps:{"value":(_vm.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uid=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.validationErrors.modemUid),function(error){return _c('div',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(error))])})],2),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("Модем:")]),_vm._v(" "),_c('span',{staticClass:"text-success"},[_vm._v("подключен")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/modem.vue
function injectStyle (context) {
  __webpack_require__("nWyn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modem,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _id_modem = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4oW5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiMzQ0NGOEUiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMy43MzMgNWgtMy4yOTlhMS4wMSAxLjAxIDAgMCAwLTEuMDAzLjc4Mi44ODguODg4IDAgMCAwLS4wNS4yOTR2NS4xNUg4LjAyYy0uNTYyIDAtMS4wMjEuNDQtMS4wMjEuOTc4cy40NTkuOTc4IDEuMDIuOTc4aDEuMzZ2MS4wMjZIOC4wMmMtLjU2MSAwLTEuMDIuNDQtMS4wMi45NzhzLjQ1OS45NzggMS4wMi45NzhoMS4zNnYxLjg1OGMwIC41MzguNDYuOTc4IDEuMDIuOTc4LjU2MSAwIDEuMDItLjQ0IDEuMDItLjk3OHYtMS44NThoMy42OWMuNTYgMCAxLjAyLS40NCAxLjAyLS45NzhzLS40Ni0uOTc4LTEuMDItLjk3OGgtMy42NzN2LTEuMDI2aDIuMjk2QzE2LjA3OSAxMy4xODIgMTggMTEuMzQgMTggOS4wOSAxOCA2Ljg0IDE2LjA3OSA1IDEzLjczMyA1em0wIDYuMjI2aC0yLjI5NnYtNC4yN2gyLjI5NmMxLjIyNCAwIDIuMjI3Ljk2MSAyLjIyNyAyLjEzNSAwIDEuMTczLTEuMDAzIDIuMTM1LTIuMjI3IDIuMTM1eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "4v4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var clone = __webpack_require__("rezj");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filters.vue











/* harmony default export */ var filters = ({
  name: 'Filters',
  props: {
    value: {},
    filters: {},
    endpoint: {},
    endpointMethod: {
      default: function _default() {
        return 'get';
      }
    }
  },
  data: function data() {
    return {
      values: clone_default()(this.value || {}),
      hasEvent: false,
      hasStatus: false
    };
  },

  methods: {
    isEmpty: isEmpty_default.a,
    isEvent: function isEvent(filter) {
      if (filter.type.indexOf('event') !== -1) {
        this.hasEvent = true;
      }
      return filter.type.indexOf('event') === -1;
    },
    isStatus: function isStatus(name) {
      if (name.indexOf('status') !== -1) {
        this.hasStatus = true;
      }
      return name.indexOf('status') === -1;
    },
    collapseAll: function collapseAll() {
      jquery_default()('.filters-group-collapse.show', this.$el).collapse('hide');
    },
    isDirty: function isDirty(groupName) {
      var _this = this;

      return entries_default()(this.filters).some(function (filter) {
        return filter[0].indexOf(groupName) !== -1 && !isEmpty_default()(_this.values[filter[0]]);
      });
    }
  },
  computed: {
    cleanValues: function cleanValues() {
      return omitBy_default()(clone_default()(this.values), isEmpty_default.a);
    }
  },
  watch: {
    value: function value(val, oldVal) {
      if (!isEqual_default()(oldVal, val)) {
        this.values = clone_default()(val || {});
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    keys_default()(this.filters).forEach(function (name) {
      _this2.$set(_this2.values, name, _this2.values[name]);
    });

    this.$watch('values', function () {
      _this2.$emit('input', _this2.cleanValues);
    }, { deep: true });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79044a1c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filters.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_vm._l((_vm.filters),function(filter,name){return (_vm.isEvent(filter) && _vm.isStatus(name))?_c('filters-group',{key:name,attrs:{"label":filter.label,"is-dirty":!_vm.isEmpty(_vm.values[name])}},[_c(("filter-" + (filter.type)),_vm._b({tag:"component",attrs:{"filters":_vm.cleanValues,"endpoint":_vm.endpoint,"name":name,"endpointMethod":_vm.endpointMethod},model:{value:(_vm.values[name]),callback:function ($$v) {_vm.$set(_vm.values, name, $$v)},expression:"values[name]"}},'component',filter.params,false))],1):_vm._e()}),_vm._v(" "),(_vm.hasStatus)?_c('filters-group',{attrs:{"label":"По состоянию автомата","is-dirty":_vm.isDirty('status')}},_vm._l((_vm.filters),function(filter,name){return (name.indexOf('status') !== -1)?_c('filters-group',{key:name,attrs:{"label":filter.label,"is-dirty":!_vm.isEmpty(_vm.values[name])}},[_c(("filter-" + (filter.type)),_vm._b({tag:"component",attrs:{"filters":_vm.cleanValues,"endpoint":_vm.endpoint,"name":name,"endpointMethod":_vm.endpointMethod},model:{value:(_vm.values[name]),callback:function ($$v) {_vm.$set(_vm.values, name, $$v)},expression:"values[name]"}},'component',filter.params,false))],1):_vm._e()}),1):_vm._e(),_vm._v(" "),(_vm.hasEvent)?_c('filters-group',{attrs:{"label":"По свойствам событий","is-dirty":_vm.isDirty('event')}},_vm._l((_vm.filters),function(filter,name){return (name.indexOf('event') !== -1)?_c('filters-group',{key:name,attrs:{"label":filter.label,"is-dirty":!_vm.isEmpty(_vm.values[name])}},[_c(("filter-" + (filter.type)),_vm._b({tag:"component",attrs:{"filters":_vm.cleanValues,"endpoint":_vm.endpoint,"name":name,"endpointMethod":_vm.endpointMethod},model:{value:(_vm.values[name]),callback:function ($$v) {_vm.$set(_vm.values, name, $$v)},expression:"values[name]"}},'component',filter.params,false))],1):_vm._e()}),1):_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filters.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filters,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filters = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "56bP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/notifications/index.vue


/* harmony default export */ var notifications = ({
  metaInfo: { title: 'Уведомления' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      sort: null
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var keyword = sort.column.sortable === 'keyword' ? '.keyword' : '';
        this.sort = sort.prop + keyword + ':' + order;
      } else {
        this.$emit('update:sort', null);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f1d3329","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/notifications/index.vue
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"users","filtersValue":_vm.filtersValue,"loading":_vm.loading,"sort":_vm.sort,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Уведомления")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"users"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"sort-change":_vm.sortChange,"row-click":(function (row) { return this$1.$router.push(("/settings/notifications/" + (row.id))); })}},[_c('el-table-column',{attrs:{"sortable":"keyword","prop":"second_name","label":"Фамилия"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"first_name","label":"Имя"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"third_name","label":"Отчество"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.notification_setting && row.notification_setting.event_codes_count>0)?_c('span',{staticClass:"text-danger"},[_vm._v("\n                Настроено уведомлений : "+_vm._s(row.notification_setting.event_codes_count)+"\n              ")]):_c('span',{staticClass:"muted"},[_vm._v("Нет уведомлений")])]}}],null,false,2379470601)}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.notification_setting)?[(row.notification_setting.sms_count)?_c('span',[_c('img',{attrs:{"src":__webpack_require__("6DqF")}}),_vm._v("\n               : "+_vm._s(row.notification_setting.sms_count)+"\n            ")]):_vm._e(),_vm._v(" "),(row.notification_setting.email_count)?_c('span',[_c('img',{attrs:{"src":__webpack_require__("pqFt")}}),_vm._v("\n               : "+_vm._s(row.notification_setting.email_count)+"\n            ")]):_vm._e()]:_vm._e()]}}],null,false,1468234137)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/notifications/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  notifications,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var settings_notifications = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5zbn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6/fc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6DqF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9IiMzNjNCNEUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTIxLjAzIDguMTY1YTQuMTAxIDQuMTAxIDAgMCAxIDAgNS43OTUuMzUuMzUgMCAwIDEtLjUgMCAuMzU0LjM1NCAwIDAgMSAwLS41IDMuMzk1IDMuMzk1IDAgMCAwIDAtNC43OTUuMzU0LjM1NCAwIDAgMSAuNS0uNXoiLz4KICAgICAgICA8cGF0aCBkPSJNMTkuNTQgOC45MmEuMzU1LjM1NSAwIDAgMC0uNS41Yy40MzcuNDM4LjY3OCAxLjAyMi42NzggMS42NDMgMCAuNjItLjI0IDEuMjAyLS42NzkgMS42NGEuMzU0LjM1NCAwIDAgMCAuNS41Yy41NzItLjU3Ljg4Ni0xLjMzMS44ODYtMi4xNCAwLS44MS0uMzE0LTEuNTcxLS44ODYtMi4xNDJNMi42OTkgOC42NjVhLjM1My4zNTMgMCAxIDAtLjUtLjUgNC4xMDEgNC4xMDEgMCAwIDAgMCA1Ljc5NS4zNS4zNSAwIDAgMCAuNSAwIC4zNTIuMzUyIDAgMCAwIDAtLjUgMy4zOTUgMy4zOTUgMCAwIDEgMC00Ljc5NSIvPgogICAgICAgIDxwYXRoIGQ9Ik00LjE5IDguOTIxYS4zNTMuMzUzIDAgMCAwLS41MDEgMCAzLjAwNSAzLjAwNSAwIDAgMC0uODg2IDIuMTQyYzAgLjgwOS4zMTQgMS41Ny44ODYgMi4xNDFhLjM1NC4zNTQgMCAwIDAgLjUtLjUgMi4zMDQgMi4zMDQgMCAwIDEtLjY3OC0xLjY0MWMwLS42MjEuMjQtMS4yMDUuNjc4LTEuNjQyYS4zNTQuMzU0IDAgMCAwIDAtLjVNNi4zMDggMTcuMjc1SDE2LjkyVjMuODNINi4zMDh2MTMuNDQ1em01LjMwNiAzLjg5MWMtLjc4IDAtMS40MTYtLjYzNC0xLjQxNi0xLjQxNWExLjQxNyAxLjQxNyAwIDAgMSAyLjgzMiAwYzAgLjc4LS42MzYgMS40MTUtMS40MTYgMS40MTV6TTE2LjA3IDFINy4xNThDNi4yOTggMSA1LjYgMS43IDUuNiAyLjU1OFYyMC42N2MwIC44Ni42OTkgMS41NiAxLjU1OCAxLjU2aDguOTEyYy44NiAwIDEuNTU5LS43IDEuNTU5LTEuNTZWMi41NmMwLS44Ni0uNy0xLjU2LTEuNTU5LTEuNTZ6Ii8+CiAgICAgICAgPHBhdGggZD0iTTEyLjQ5NyAxMS4wNjNhMS4wNTIgMS4wNTIgMCAxIDEtMi4xMDUgMCAxLjA1MiAxLjA1MiAwIDAgMSAyLjEwNSAwTTE1LjQxNiAxMS4wNjNhMS4wNTIgMS4wNTIgMCAxIDEtMi4xMDQgMCAxLjA1MiAxLjA1MiAwIDAgMSAyLjEwNCAwTTkuNzggMTEuMDYzYTEuMDUyIDEuMDUyIDAgMSAxLTIuMTA0IDAgMS4wNTIgMS4wNTIgMCAwIDEgMi4xMDQgMCIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "6M62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTooltip;

function withTooltip(text) {
  return function renderHeader(h, _ref) {
    var column = _ref.column,
        $index = _ref.$index;

    return [h("help-tooltip", {
      attrs: { title: text }
    }), column.label];
  };
}

/***/ }),

/***/ "6Mbh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQTFDMTkiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTIuOTY2IDEyLjk1MmMwIC40MDQtLjMwNi43MS0uNzEuNzFhLjY5Ni42OTYgMCAwIDEtLjcwOS0uNzFWOS4xM2MwLS40MDMuMzA2LS43MS43MS0uNzEuNDAzIDAgLjcyNi4zNC43MS43Mjd2My44MDZ6bTAgMi4wNjVjMCAuNDAzLS4zMDYuNzEtLjcxLjcxYS42OTYuNjk2IDAgMCAxLS43MDktLjcxdi0uMjQyYzAtLjQwMy4zMDYtLjcxLjcxLS43MS40MDMgMCAuNzI2LjMwNy43MS43MXYuMjQyem02LjI3NS0uMzA3bC01LjE0Ni04LjY0NkEyLjA1IDIuMDUgMCAwIDAgMTIuMjczIDVjLS43NTggMC0xLjQ1Mi4zODctMS44MzkgMS4wNDhsLTUuMTMgOC42NjJhMi4wOSAyLjA5IDAgMCAwLS4wMTYgMi4xNDYgMi4xNTUgMi4xNTUgMCAwIDAgMS44NzEgMS4wOGgxMC4yNDNjLjc5IDAgMS40ODQtLjQwMiAxLjg3Mi0xLjA4YTIuMDU0IDIuMDU0IDAgMCAwLS4wMzMtMi4xNDZ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "71CU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/recipes.vue


/* harmony default export */ var recipes = ({
  data: function data() {
    return {
      subnav: [{
        text: 'Продукты',
        to: '/settings/recipes/products'
      }, {
        text: 'Ингредиенты',
        to: '/settings/recipes/ingredients'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659c54b5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/recipes.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('subnav',{attrs:{"links":_vm.subnav,"heading":"Рецептуры и продукты"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/recipes.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  recipes,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var settings_recipes = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "72xW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/service-modal-performed.vue




/* harmony default export */ var service_modal_performed = ({
  data: function data() {
    return {
      active_task_index: 0,
      show_info: false
    };
  },

  props: ['id'],
  methods: {},
  computed: {
    currentTask: function currentTask() {
      if (this.data && this.data.tasks) {
        return this.data.tasks[this.active_task_index];
      }
    }
  },
  asyncComputed: {
    data: function data() {
      return api["a" /* default */].get('services/performed/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e78d1da","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/service-modal-performed.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Выполненный сервис")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('hide')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"performed-service-nav-pills container-fluid pb-2"},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{active: !_vm.show_info},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.show_info = false}}},[_vm._v("Задачи")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{active: _vm.show_info},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.show_info = true}}},[_vm._v("Информация")])])])]),_vm._v(" "),(!_vm.show_info)?_c('div',[(_vm.data && _vm.data.tasks)?_c('div',{staticClass:"navbar-subnav"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"nav nav-subnav"},_vm._l((_vm.data.tasks),function(task,i){return _c('li',{staticClass:"nav-item pr-3",class:{active: i == _vm.active_task_index}},[_c('a',{staticClass:"nav-link px-0",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.active_task_index = i}}},[_vm._v(_vm._s(task.type.name))])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.currentTask)?_c('div',[(_vm.currentTask.params)?_c('div',{staticClass:"modal-body"},[(_vm.currentTask.params.bag_id)?[_c('h4',{staticClass:"mt-2 mb-0"},[_vm._v("Номер мешка")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.currentTask.params.bag_id))])]:_vm._e(),_vm._v(" "),(_vm.currentTask.params.coins_25)?[_c('h4',{staticClass:"mt-2 mb-0"},[_vm._v("Показатели счетчика монетоприёмника, руб.")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.currentTask.params.coins_25))])]:_vm._e(),_vm._v(" "),(_vm.currentTask.params.coins_25_before)?[_c('h4',{staticClass:"mt-2 mb-0"},[_vm._v("Показатели счетчика монетоприёмника до сервиса, руб.")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.currentTask.params.coins_25_before))])]:_vm._e(),_vm._v(" "),(_vm.currentTask.params.coins_25_after)?[_c('h4',{staticClass:"mt-2 mb-0"},[_vm._v("Показатели счетчика монетоприёмника после сервиса, руб.")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.currentTask.params.coins_25_after))])]:_vm._e(),_vm._v(" "),(_vm.currentTask.params.withdrawn_coins)?[_c('h4',{staticClass:"mt-2 mb-0"},[_vm._v("Сумма изъятых монет, руб.")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.currentTask.params.withdrawn_coins))])]:_vm._e(),_vm._v(" "),(_vm.currentTask.params.inserted_coins)?[_c('h4',{staticClass:"mt-2 mb-0"},[_vm._v("Сумма загруженных монет, руб.")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.currentTask.params.inserted_coins))])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.currentTask.comment)?_c('div',{staticClass:"modal-body"},[_c('h4',[_vm._v("Комментарий")]),_vm._v(" "),_c('div',{staticClass:"performed-service-comment"},[_vm._v(_vm._s(_vm.currentTask.comment))])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table mb-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.currentTask.type.name))]),_vm._v(" "),_c('th')])]),_vm._v(" "),(_vm.currentTask)?_c('tbody',_vm._l((_vm.currentTask.checklist_elements),function(item,index){return _c('tr',[_c('td',[_vm._v("\n              "+_vm._s(index+1)+". "+_vm._s(item.name)+"\n              "),(item.comment)?_c('div',{staticClass:"performed-service-comment mt-2"},[_vm._v(_vm._s(item.comment))]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"width":"1"}},[(item.type === 'check')?_c('div',{staticClass:"squaredThree"},[_c('div',{staticClass:"custom-control custom-checkbox custom-control-no-label"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","disabled":""},domProps:{"checked":item.selected}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label"})])]):_c('div',[_vm._v(_vm._s(item.mark))])])])}),0):_vm._e()])]):_vm._e()]):_c('div',{staticClass:"modal-body performed-service-info-tab"},[(_vm.data && _vm.data.service)?_c('div',[_c('dl',{staticClass:"m-0"},[(_vm.data.service.machine)?[_c('h3',[_vm._v("Автомат")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.data.service.machine.serial_number))])]:_vm._e(),_vm._v(" "),(_vm.data.service.executor)?[_c('h3',[_vm._v("Выполнил")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("fullName")(_vm.data.service.executor)))])]:_vm._e(),_vm._v(" "),[_c('h3',[_vm._v("Время проведения сервиса")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.data.service.date)))])],_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.data.service.hydrated_part_params.parts.new_parts.length || _vm.data.service.hydrated_part_params.parts.removed_parts.length)?_c('div',{staticClass:"col-md"},[_c('h3',[_vm._v("Детали")]),_vm._v(" "),_c('div',[(_vm.data.service.hydrated_part_params.parts.removed_parts.length)?_c('table',{staticClass:"table table-sm performed-service-table-parts"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data.service.hydrated_part_params.parts.removed_parts),function(part){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("get")(part,'part.name')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(part.amount)+" "+_vm._s(_vm._f("get")(part,'part.measure')))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.data.service.hydrated_part_params.parts.new_parts.length)?_c('table',{staticClass:"table table-sm performed-service-table-parts"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.data.service.hydrated_part_params.parts.new_parts),function(part){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("get")(part,'part.name')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(part.amount)+" "+_vm._s(_vm._f("get")(part,'part.measure')))])])}),0)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.data.service.hydrated_part_params.extra_parts.new_parts.length || _vm.data.service.hydrated_part_params.extra_parts.removed_parts.length)?_c('div',{staticClass:"col-md"},[_c('h3',[_vm._v("Оборудование")]),_vm._v(" "),_c('div',[(_vm.data.service.hydrated_part_params.extra_parts.removed_parts.length)?_c('table',{staticClass:"table table-sm performed-service-table-parts"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.data.service.hydrated_part_params.extra_parts.removed_parts),function(part){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("get")(part,'extra_part.name')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(part.amount)+" "+_vm._s(_vm._f("get")(part,'extra_part.measure')))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.data.service.hydrated_part_params.extra_parts.new_parts.length)?_c('table',{staticClass:"table table-sm performed-service-table-parts"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.data.service.hydrated_part_params.extra_parts.new_parts),function(part){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("get")(part,'extra_part.name')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(part.amount)+" "+_vm._s(_vm._f("get")(part,'extra_part.measure')))])])}),0)]):_vm._e()])]):_vm._e()]),_vm._v(" "),(_vm.data.service.kkt_type)?[_c('h3',[_vm._v("Кассовая лента")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.data.service.kkt_type.name))])]:_vm._e(),_vm._v(" "),(_vm.data.service.banknotes_summary)?[_c('h3',[_vm._v("Купюры")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.data.service.banknotes_summary)+"р.")])]:_vm._e()],2)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-light"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Снятые")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-light"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Установленные")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-light"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Снятое")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"table-light"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Установленное")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/service-modal-performed.vue
function injectStyle (context) {
  __webpack_require__("G59m")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  service_modal_performed,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_modal_performed = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7Kym":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path fill=\"#363B4E\" fill-rule=\"evenodd\" d=\"M12.577 8.497c-1.849 0-2.929 3-2.929 4.464 0 1.296.552 2.064 1.512 2.064 1.849 0 2.881-3.528 2.881-4.944 0-.888-.528-1.584-1.464-1.584zm7.056 9.841c-2.496 1.825-4.657 2.569-7.344 2.569-2.641 0-4.873-.793-6.577-2.377C3.96 16.922 3 14.642 3 12.193 3 7.009 7.2 3 12.648 3c4.753 0 8.114 2.976 8.114 7.201 0 3.337-2.329 6.313-4.945 6.313-1.248 0-2.041-.672-2.041-1.752 0-.168 0-.288.049-.48-.673 1.296-1.776 2.232-3.312 2.232-1.945 0-3.265-1.489-3.265-3.673 0-3.12 2.257-5.808 4.824-5.808 1.273 0 2.185.456 2.713 1.632l.336-1.248h2.04L15.6 12.769c-.168.601-.239.984-.239 1.296 0 .6.36.96.984.96 1.56 0 3.072-2.448 3.072-4.944 0-3.456-2.736-5.833-6.744-5.833-4.777 0-8.329 3.409-8.329 8.017 0 4.345 3.312 7.417 8.016 7.417 2.377 0 4.369-.696 6.577-2.304l.696.96z\"/></svg>"

/***/ }),

/***/ "7UNq":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\"><path fill=\"#777\" fill-rule=\"evenodd\" d=\"M10.93 8.25c-.447 0-.893-.446-.893-.892 0-.447.446-.893.893-.893.446 0 .892.446.892.893 0 .446-.446.893-.892.893zm.78 6.363a.763.763 0 0 1-.78.781.763.763 0 0 1-.782-.78v-4.02c0-.446.335-.78.782-.78.446 0 .78.334.78.78v4.02zM10.93 2C6.018 2 2 6.018 2 10.93c0 4.91 4.018 8.93 8.93 8.93 4.91 0 8.93-4.02 8.93-8.93 0-4.912-4.02-8.93-8.93-8.93z\"/></svg>"

/***/ }),

/***/ "81hu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Fg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/btn-action.vue + 2 modules
var btn_action = __webpack_require__("K+Zy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/eva/index.vue





/* harmony default export */ var eva = ({
  components: { BtnAction: btn_action["default"] },
  props: ['id', 'machine'],
  data: function data() {
    return {
      filtersValue: {},
      data: {},
      loading: false,
      hasMore: true
    };
  },

  methods: {
    deleteInvalids: function deleteInvalids() {
      if (window.confirm('Удалить все отчёты с ошибкой?')) {
        return api["a" /* default */].delete('eva/invalid/' + this.id).then(function () {
          return window.alert('Отчёты с ошибкой будут удалены в ближейшее время');
        });
      }
    },
    sendEva: function sendEva() {
      if (window.confirm('\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043E\u0442\u0447\u0435\u0442?')) {
        return api["a" /* default */].post('modems/' + this.machine.modem.uid + '/commands', {
          type: 'eva'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3175f5fa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/eva/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column h-100"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":'machines/' + _vm.id + '/eva',"filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("EVA-DTS отчеты")]),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary mr-2",on:{"click":_vm.sendEva}},[_vm._v("\n      Запросить отчет\n    ")]),_vm._v(" "),(_vm.$root.user.role.name !== 'lessor_pro')?_c('btn-action',{staticClass:"btn btn-outline-danger",on:{"click":_vm.deleteInvalids}},[_vm._v("Удалить все отчёты с ошибкой")]):_vm._e()],1),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"row-click":(function (row) { return _vm.$router.push(("/machines/" + _vm.id + "/eva/" + (row.id))); })}},[_c('table-column-date'),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marker","label":"Маркер"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_valid","label":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(!row.is_valid)?_c('div',{staticClass:"text-danger"},[_vm._v("Ошибка")]):_vm._e()]}}],null,false,1996693611)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/eva/index.vue
function injectStyle (context) {
  __webpack_require__("0mbS")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  eva,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _id_eva = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8YoH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/element-ui/lib/table-column.js
var table_column = __webpack_require__("q4le");
var table_column_default = /*#__PURE__*/__webpack_require__.n(table_column);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/table.js
var table = __webpack_require__("LR6y");
var table_default = /*#__PURE__*/__webpack_require__.n(table);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/scrollmonitor/scrollMonitor.js
var scrollMonitor = __webpack_require__("E1Rp");
var scrollMonitor_default = /*#__PURE__*/__webpack_require__.n(scrollMonitor);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/data-table.vue








vue_runtime_esm["default"].use(table_default.a);
vue_runtime_esm["default"].use(table_column_default.a);

/* harmony default export */ var data_table = ({
  name: 'data-table',
  props: {
    data: {
      type: Array
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    currencySymbol: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableColumnType: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initWaypoint();
    });
  },

  watch: {
    hasMore: function hasMore() {
      if (this.hasMore) {
        this.initWaypoint();
      } else if (this.scrollMonitor) {
        this.scrollMonitor.destroy();
        this.scrollMonitor = null;
      }
    }
  },
  methods: {
    initWaypoint: function initWaypoint() {
      var _this2 = this;

      this.$nextTick(function () {
        setTimeout(function () {
          if (_this2.hasMore && _this2.$refs.table) {
            _this2.containerMonitor = _this2.containerMonitor || scrollMonitor_default.a.createContainer(_this2.$refs.table.$refs.bodyWrapper);
            _this2.scrollMonitor = _this2.containerMonitor.create(_this2.$refs.loadMore);

            _this2.scrollMonitor.enterViewport(function () {
              return _this2.$emit('load-more');
            });
          }
        }, 150);
      });
    },
    getSummaries: function getSummaries(param) {
      var _this3 = this;

      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Сумма';
          return;
        }
        var values = data.map(function (item) {
          return item[column.property];
        });
        var tableColumnType = _this3.tableColumnType[index];
        if (['string', 'date'].includes(tableColumnType)) {
          sums[index] = '';
        } else if (values.some(function (value) {
          return !isNaN(parseFloat(value)) && isFinite(value);
        })) {
          var total = values.reduce(function (prev, curr) {
            var value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);

          var currencySymbol = _this3.currencySymbol[index];
          if (currencySymbol === '₽' || currencySymbol === 'шт.') {
            var value = parseFloat(total);
            total = isNaN(value) ? '' : value.toLocaleString('ru', _this3.options);
          }
          sums[index] = currencySymbol ? total + ' ' + currencySymbol : total;
        } else {
          sums[index] = '';
        }
      });

      return sums;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.scrollMonitor) {
      this.scrollMonitor.destroy();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e0596f0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/data-table.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',_vm._g(_vm._b({ref:"table",attrs:{"data":_vm.data,"summary-method":_vm.getSummaries}},'el-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.hasMore)?_c('button',{ref:"loadMore",staticClass:"btn btn-gray btn-lg btn-block",class:{loading: _vm.loading},staticStyle:{"border-radius":"0","border":"0"},attrs:{"slot":"append"},on:{"click":function($event){return _vm.$emit('load-more')}},slot:"append"},[_vm._v("\n    Еще\n  ")]):_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/data-table.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  data_table,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_data_table = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8nG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/expenditure.vue




/* harmony default export */ var expenditure = ({
  metaInfo: { title: 'Расход продуктов' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      sort: null,
      height: null,
      columns: null,
      date: {
        min: moment_default()().subtract(7, 'days').format('YYYY-MM-DD'),
        max: moment_default()().format('YYYY-MM-DD')
      }
    };
  },


  computed: {
    products: function products() {
      return this.data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2673a3b2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/expenditure.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"expenditure","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"date":_vm.date},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("\n        Расход продуктов\n      ")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"expenditure","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.products && _vm.products.data)?_c('data-table-full-height',{attrs:{"data":_vm.products.data,"default-sort":{prop: 'sum', order: 'descending'}}},[_c('el-table-column',{attrs:{"prop":"name","label":"Продукт","min-width":"200","max-width":"360"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"","prop":"count","label":"Количество продаж","min-width":"64","max-width":"108","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"","prop":"sum","label":"Сумма продаж","min-width":"64","max-width":"108","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Доля в продажах","min-width":"360"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-3",staticStyle:{"width":"3em","text-align":"right"}},[_vm._v("\n            "+_vm._s(Math.round(row.count / (_vm.products.totalSales / 100)))+" %\n          ")]),_vm._v(" "),_c('div',{staticClass:"progress flex-grow-1"},[_c('div',{staticClass:"progress-bar",style:('width:' + Math.round(row.count/(_vm.products.totalSales/100)) +'%;'),attrs:{"role":"progressbar","aria-valuemax":"100"}})])])]}}],null,false,4073710777)})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/expenditure.vue
function injectStyle (context) {
  __webpack_require__("2D6f")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  expenditure,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_expenditure = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8wLD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9/A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/table-column-checkbox.vue


/* harmony default export */ var table_column_checkbox = ({
  props: {
    checked: {
      type: String,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a942550","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-checkbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',_vm._g(_vm._b({attrs:{"align":this.$attrs.align || 'left'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"custom-control custom-checkbox custom-control-no-label"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","disabled":""},domProps:{"checked":_vm.checked.split('.').reduce(function (obj, key){ return obj[key]; }, row)}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label"})])]}}])},'el-table-column',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/table-column-checkbox.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_column_checkbox,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_column_checkbox = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "96Dn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "96X0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/release-modal.vue


/* harmony default export */ var release_modal = ({
  methods: {
    reload: function reload() {
      window.location.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b69a0812","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/release-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Доступно обновление")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('hide')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._v("\n      Требуется перезагрузка страницы для загрузки новой версии\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.reload}},[_vm._v("Перезагрузить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Отмена")])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/release-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  release_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_release_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "A5/I":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQjM5MkEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xNy41ODYgMTcuNmMtMi40MzEgMi40Mi02LjE0NSAzLTkuMTk4IDEuNDM0bDIuOTQzLTIuOTQzYzEuODAyLjUzOCAzLjc1My4wMzkgNS4wNzQtMS4yOTkgMS41MTYtMS41MzUgMS45MjMtMy44NDkgMS4wMjMtNS44MS0uMDc1LS4xNjMtLjIyNi0uMjgtLjQwMy0uMzEzLS4xNzctLjAzMi0uMzYuMDI1LS40ODcuMTUybC0yLjYyNCAyLjYyMy0xLjMzNS0xLjMyNSAyLjYzNC0yLjY5M2MuMTIzLS4xMjYuMTc5LS4zMDMuMTUtLjQ3Ny0uMDMtLjE3NC0uMTQtLjMyMy0uMjk3LS40MDItMS44My0uODUyLTMuOTktLjU1Ni01LjUyMy43NTYtMS41MzQgMS4zMTMtMi4xNiAzLjQtMS42IDUuMzRsLTIuOTggMi45NzdjLTEuODUtMy42LS42OC04LjAxNyAyLjcxLTEwLjIzIDMuMzktMi4yMTIgNy45MDMtMS41MDUgMTAuNDU1IDEuNjM4IDIuNTUxIDMuMTQyIDIuMzE2IDcuNzA1LS41NDYgMTAuNTY4bC4wMDQuMDAzeiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "AA+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders/ingredients/_id.vue




/* harmony default export */ var _id = ({
  metaInfo: { title: 'Заявка на ингредиенты' },
  props: {
    id: {
      required: true
    }
  },
  data: function data() {
    return {};
  },

  asyncComputed: {
    order: function order() {
      return api["a" /* default */].get('orders/ingredients/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254d9b52","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders/ingredients/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order)?_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"mr-auto"},[_c('back-button',{attrs:{"to":"/orders/ingredients"}}),_vm._v("Заявка на ингредиенты")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('div',[_c('strong',[_vm._v("ФИО оператора:")]),_vm._v(" "+_vm._s(_vm._f("fullName")(_vm.order.user)))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Статус:")]),_vm._v(" "+_vm._s(_vm.order.status.description))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Дата оформления:")]),_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.order.date)))])]),_vm._v(" "),_c('div',{staticClass:"table-full-width mt-2"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.order.request),function(component){return _c('tr',[_c('td',[_vm._v(_vm._s(component.ingredient.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("remainder")(component.amount))+" "+_vm._s(component.ingredient.measure))])])}),0)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Ингредиенты")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders/ingredients/_id.vue
function injectStyle (context) {
  __webpack_require__("5zbn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var ingredients__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ai7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ajcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__("6PBa");
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// EXTERNAL MODULE: ./resources/assets/js/components/filter-range.vue + 2 modules
var filter_range = __webpack_require__("gRN3");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-range-date.vue




/* harmony default export */ var filter_range_date = ({
  name: 'FilterRangeDate',
  extends: filter_range["default"],
  computed: {
    preparedInput: function preparedInput() {
      return pickBy_default()(this.input);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4ae0668","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-range-date.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"mr-2"},[_c('label',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('datepicker',{attrs:{"placeholder":_vm.range.min},model:{value:(_vm.input.min),callback:function ($$v) {_vm.$set(_vm.input, "min", $$v)},expression:"input.min"}})],1)]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('datepicker',{attrs:{"placeholder":_vm.range.max},model:{value:(_vm.input.max),callback:function ($$v) {_vm.$set(_vm.input, "max", $$v)},expression:"input.max"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("От")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("До")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-range-date.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_range_date,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_range_date = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AvMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cash-voucher-form.vue




/* harmony default export */ var cash_voucher_form = ({
  name: 'cash-voucher-form',
  props: {
    value: {},
    machine_id: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      cash_voucher_length: this.value ? this.value * 100 : this.value,
      loading: false
    };
  },

  computed: {
    showButton: function showButton() {
      return (this.cash_voucher_length || this.value) && this.cash_voucher_length != this.value * 100;
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      var cash_voucher_length = this.cash_voucher_length / 100;
      this.loading = true;
      api["a" /* default */].post('machines/' + this.machine_id + '/cash_voucher', { cash_voucher_length: cash_voucher_length }).then(function () {
        return _this.$emit('input', _this.cash_voucher_length / 100);
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fdccea","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/cash-voucher-form.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cash_voucher_length),expression:"cash_voucher_length"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"25 (использовать значение по умолчанию)","disabled":_vm.loading,"min":"0"},domProps:{"value":(_vm.cash_voucher_length)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cash_voucher_length=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.showButton)?_c('button',{staticClass:"btn btn-primary mt-2",class:{loading: _vm.loading},attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("Сохранить\n  ")]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text",staticStyle:{"font-size":"inherit"}},[_vm._v("см")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/cash-voucher-form.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  cash_voucher_form,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_cash_voucher_form = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "B5sZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/service.vue







function monthRange() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return [moment_default()().subtract(offset, 'month').startOf('month').format('YYYY-MM-DD'), moment_default()().subtract(offset, 'month').endOf('month').format('YYYY-MM-DD')];
}

function pickerOptionHandler() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function (picker) {
    picker.$emit('pick', monthRange(offset));
  };
}

/* harmony default export */ var service = ({
  metaInfo: { title: 'Обслуживание' },
  data: function data() {
    return {
      filtersValue: null,
      data: null,
      loading: false,
      hasMore: true,
      sort: null,
      date: monthRange(),
      pickerOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Следующий месяц',
          onClick: pickerOptionHandler(-1)
        }, {
          text: 'Текущий месяц',
          onClick: pickerOptionHandler(0)
        }, {
          text: 'Предыдущий месяц',
          onClick: pickerOptionHandler(1)
        }, {
          text: '2 месяца назад',
          onClick: pickerOptionHandler(2)
        }, {
          text: '3 месяца назад',
          onClick: pickerOptionHandler(3)
        }]
      }
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var sortable = sort.column.sortable;

        var prop = sortable === 'keyword' ? sort.prop + '.keyword' : sort.prop;

        this.sort = prop + ':' + order;
      } else {
        this.sort = null;
      }
    },
    save: function save() {
      return api["a" /* default */].post('services/schedule', {
        filters: this.filtersValue
      });
    }
  },
  computed: {
    isAllowedToSave: function isAllowedToSave() {
      return ['service', 'tech_superior', 'service_superior'].includes(get_default()(this.$root.user, 'role.name'));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50585e87","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/service.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"services","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"date":_vm.date},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{ref:"header",staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Обслуживание")]),_vm._v(" "),_c('img',{staticClass:"mr-auto",staticStyle:{"max-width":"900px","width":"100%","margin-bottom":"-3px"},attrs:{"src":__webpack_require__("Zcx+")}}),_vm._v(" "),(_vm.isAllowedToSave)?_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":function($event){return _vm.save()}}},[_vm._v("Сохранить")]):_vm._e(),_vm._v(" "),_c('el-date-picker',{staticClass:"mr-2",attrs:{"type":"daterange","clearable":false,"value-format":"yyyy-MM-dd","align":"right","range-separator":"–","picker-options":_vm.pickerOptions,"size":"small"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"services"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"sort-change":_vm.sortChange}},[_c('table-column-serial-number',{attrs:{"sortable":"keyword","fixed":true}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"Адрес установки","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"services_planned","label":"Плановые сервисы","min-width":"1100"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('machine-service-timeline',{attrs:{"operator":row.operator,"tech":row.technician,"planned_prop":row.services_planned,"performed_prop":row.services_performed,"machine_id":row.id,"region_id":row.region_id,"date":_vm.date}})]}}],null,false,3820294132)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/service.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  service,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_service = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "B8C8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/auth.js
var auth = __webpack_require__("S8OL");

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/index.vue






/* harmony default export */ var components_login = ({
  data: function data() {
    return {
      auth: {
        email: ''
      },
      blocked: false,
      error: '',
      error_new: false
    };
  },

  computed: {
    authData: function authData() {
      return this.auth;
    }
  },
  methods: {
    checkUserStatus: function checkUserStatus() {
      var _this = this;

      if (!this.auth.email) {
        this.$refs.input.focus();
        return;
      }

      api["a" /* default */].post('auth/status', this.authData).then(function (_ref) {
        var data = _ref.data;

        console.log(data);

        if (data.status === 'active') {
          _this.$emit('userActive', _this.authData, data);
        }
      }).catch(function (error) {
        error.response && console.log(error.response);
        _this.error = 'Пользователь не найден';

        _this.error_new = true;
        setTimeout(function () {
          _this.error_new = false;
        }, 100);
      });
    },
    isInputFieldsEmpty: function isInputFieldsEmpty() {
      return this.auth.email === '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9ae0c5c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/login/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card-body",on:{"submit":function($event){$event.preventDefault();return _vm.checkUserStatus()}}},[_c('h2',{staticClass:"card-login-title"},[_vm._v("Вход")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"input-login-email"}},[_vm._v("E-mail адрес")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.auth.email),expression:"auth.email"},{name:"focus",rawName:"v-focus"}],ref:"input",staticClass:"form-control form-control-lg",attrs:{"id":"input-login-email","type":"email","placeholder":"E-mail","name":"email"},domProps:{"value":(_vm.auth.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.auth, "email", $event.target.value)}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger",class:{ 'new': _vm.error_new }},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"submit"}},[_vm._v("Продолжить")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/login/index.vue
function injectStyle (context) {
  __webpack_require__("Bgx6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  components_login,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var js_components_login = (Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/extend.js
var extend = __webpack_require__("Lr25");
var extend_default = /*#__PURE__*/__webpack_require__.n(extend);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/password.vue




/* harmony default export */ var login_password = ({
  props: ['auth', 'password_sent', 'password_debug'],
  data: function data() {
    return {
      password: '',
      error: '',
      error_new: false
    };
  },

  computed: {
    authData: function authData() {
      return extend_default()({ password: this.password }, this.auth);
    }
  },
  methods: {
    login: function login() {
      var _this = this;

      if (!this.password) {
        this.$refs.input.focus();
        return;
      }

      auth["a" /* default */].login(this.authData).then(function (response) {
        if (response == 'sms') {
          _this.$emit('sms', _this.authData);
        } else {
          _this.$router.push('/');
        }
      }).catch(function (error) {
        if (error.response) {
          _this.error = error.response.data.email || 'Неверный пароль';

          _this.error_new = true;
          setTimeout(function () {
            _this.error_new = false;
          }, 100);
        } else {
          alert('Ошибка при выполнении запроса');
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775d384d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/login/password.vue
var password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card-body",on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_c('h2',{staticClass:"card-login-title"},[_vm._v("Введите пароль")]),_vm._v(" "),(_vm.password_sent)?_c('div',{staticClass:"mb-2"},[_vm._v("\n    Новый пароль установлен и отправлен на электронную почту\n    "),(_vm.password_debug)?_c('strong',[_vm._v(_vm._s(_vm.password_debug))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"input-login-password"}},[_vm._v("Пароль")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"},{name:"focus",rawName:"v-focus"}],ref:"input",staticClass:"form-control form-control-lg",attrs:{"id":"input-login-password","type":"password","placeholder":"Пароль"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"submit"}},[_vm._v("Продолжить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger",class:{ 'new': _vm.error_new }},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var password_staticRenderFns = []

// CONCATENATED MODULE: ./resources/assets/js/components/login/password.vue
function password_injectStyle (context) {
  __webpack_require__("qFrg")
}
/* script */


/* template */

/* template functional */
var password___vue_template_functional__ = false
/* styles */
var password___vue_styles__ = password_injectStyle
/* scopeId */
var password___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var password___vue_module_identifier__ = null

var password_Component = Object(component_normalizer["a" /* default */])(
  login_password,
  password_render,
  password_staticRenderFns,
  password___vue_template_functional__,
  password___vue_styles__,
  password___vue_scopeId__,
  password___vue_module_identifier__
)

/* harmony default export */ var components_login_password = (password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/sms.vue



/* harmony default export */ var login_sms = ({
  props: [],
  data: function data() {
    return {
      code: '',
      error: '',
      error_new: false
    };
  },

  methods: {
    sms: function sms() {
      var _this = this;

      if (!this.code) {
        this.$refs.input.focus();
        return;
      }

      auth["a" /* default */].sms({ code: this.code }).then(function () {
        return _this.$router.push('/');
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
          if (error.response.status === 404) {
            _this.$emit('cancel');
          } else if (error.response.status === 401) {
            _this.error = 'Неверный код';
          } else {
            _this.error = 'Ошибка при выполнении запроса';
          }
        } else {
          _this.error = 'Ошибка при выполнении запроса';
        }

        _this.error_new = true;
        setTimeout(function () {
          _this.error_new = false;
        }, 100);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2bf97e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/login/sms.vue
var sms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card-body",on:{"submit":function($event){$event.preventDefault();return _vm.sms()}}},[_c('h2',{staticClass:"card-login-title"},[_vm._v("Введите код")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"input-login-code"}},[_vm._v("Код из сообщения SMS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"},{name:"focus",rawName:"v-focus"}],ref:"input",staticClass:"form-control form-control-lg",attrs:{"id":"input-login-code","type":"text","placeholder":"Код"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"submit"}},[_vm._v("Продолжить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger",class:{ 'new': _vm.error_new }},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var sms_staticRenderFns = []

// CONCATENATED MODULE: ./resources/assets/js/components/login/sms.vue
function sms_injectStyle (context) {
  __webpack_require__("GzLg")
}
/* script */


/* template */

/* template functional */
var sms___vue_template_functional__ = false
/* styles */
var sms___vue_styles__ = sms_injectStyle
/* scopeId */
var sms___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sms___vue_module_identifier__ = null

var sms_Component = Object(component_normalizer["a" /* default */])(
  login_sms,
  sms_render,
  sms_staticRenderFns,
  sms___vue_template_functional__,
  sms___vue_styles__,
  sms___vue_scopeId__,
  sms___vue_module_identifier__
)

/* harmony default export */ var components_login_sms = (sms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/login.vue





/* harmony default export */ var pages_login = ({
  metaInfo: { title: 'Авторизация' },
  data: function data() {
    return {
      step: 'index',
      auth: {},
      password_sent: null,
      password_debug: null
    };
  },

  components: {
    LoginIndex: js_components_login,
    LoginPassword: components_login_password,
    LoginSms: components_login_sms
  },
  methods: {
    onLogin: function onLogin() {
      this.$router.push('/');
    },
    onUserActive: function onUserActive(auth, data) {
      this.auth = auth;
      this.password_sent = data.password_sent;
      this.password_debug = data.password_debug;
      this.step = 'password';
    },
    onSms: function onSms(auth) {
      this.auth = auth;
      this.step = 'sms';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394512cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-login d-flex align-items-center"},[_c('div',{staticClass:"card card-login align-items-stretch"},[_vm._m(0),_vm._v(" "),(_vm.step == 'index')?_c('login-index',{on:{"userActive":_vm.onUserActive}}):_vm._e(),_vm._v(" "),(_vm.step == 'password')?_c('login-password',{attrs:{"auth":_vm.auth,"password_sent":_vm.password_sent,"password_debug":_vm.password_debug},on:{"sms":_vm.onSms,"cancel":function($event){_vm.step = 'index'}}}):_vm._e(),_vm._v(" "),(_vm.step == 'sms')?_c('login-sms',{on:{"cancel":function($event){_vm.step = 'index'}}}):_vm._e()],1)])}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-login-logo text-center pt-4"},[_c('img',{attrs:{"src":__webpack_require__("MJKu")}})])}]

// CONCATENATED MODULE: ./resources/assets/js/pages/login.vue
function login_injectStyle (context) {
  __webpack_require__("2n6t")
}
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null

var login_Component = Object(component_normalizer["a" /* default */])(
  pages_login,
  login_render,
  login_staticRenderFns,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var js_pages_login = __webpack_exports__["default"] = (login_Component.exports);


/***/ }),

/***/ "B8J5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/category-modal.vue + 2 modules
var category_modal = __webpack_require__("SGl8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/categories.vue






/* harmony default export */ var settings_categories = ({
  metaInfo: { title: 'Категории' },
  data: function data() {
    return {
      machineTypes: [{ value: 'coffee', name: 'Кофейный' }, { value: 'snack', name: 'Снековый' }, { value: 'sparka', name: 'Спарка' }],
      selectedMachineType: 'coffee'
    };
  },
  methods: {
    edit: function edit(category) {
      var _this = this;

      this.$root.showModal(category_modal["default"], {
        categoryData: category,
        machineType: this.machineTypes.find(function (el) {
          return el.value == _this.selectedMachineType;
        }).name
      }).then(function (data) {
        if (data) {
          if (category) {
            assign_default()(category, data);
          } else {
            _this.categories.push(data);
          }
        }
      });
    },
    remove: function remove(category) {
      var _this2 = this;

      if (!window.confirm('Подтвердить удаление?')) return;

      return api["a" /* default */].delete('categories/' + category.id).then(function () {
        _this2.categories.splice(_this2.categories.indexOf(category), 1);
      });
    }
  },
  asyncComputed: {
    categories: function categories() {
      return api["a" /* default */].get('categories?type=' + this.selectedMachineType).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c367435c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/categories.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Категории")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMachineType),expression:"selectedMachineType"}],staticClass:"custom-select mt-2",staticStyle:{"max-width":"20em"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedMachineType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.machineTypes),function(type){return _c('option',{domProps:{"value":type.value}},[_vm._v(_vm._s(type.name))])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-primary my-1 mx-2",on:{"click":function($event){return _vm.edit(null)}}},[_vm._v("Добавить категорию")])])]),_vm._v(" "),(_vm.categories)?[_c('data-table',{attrs:{"data":_vm.categories}},[_c('el-table-column',{attrs:{"prop":"name","label":"Название"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"from","label":"От","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"to","label":"До","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"color","label":"Цвет"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"color-preview",style:('background-color: ' + (row.color ? row.color : '#000000') + '!important;')})])]}}],null,false,334111555)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-outline-light mr-1",on:{"click":function($event){return _vm.remove(row)}}},[_vm._v("Удалить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-light",on:{"click":function($event){return _vm.edit(row)}}},[_vm._v("Редактировать")])]}}],null,false,2613422662)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/categories.vue
function injectStyle (context) {
  __webpack_require__("TrY1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  settings_categories,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_settings_categories = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BQMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/table-column-number.vue


/* harmony default export */ var table_column_number = ({
  props: {
    currencySymbol: { type: String, default: null },
    tableColumnType: { type: String, default: 'number' } },
  methods: {
    isNumber: function isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb9029a2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-number.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-column-element',_vm._g(_vm._b({attrs:{"align":this.$attrs.align || 'right'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('number',{attrs:{"number":_vm._f("get")(row,_vm.$attrs.prop),"currencySymbol":_vm.currencySymbol}})]}}])},'table-column-element',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/table-column-number.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_column_number,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_column_number = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BUZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/currency.vue


/* harmony default export */ var currency = ({
  props: {
    value: {
      type: Number
    }
  },
  computed: {
    formatted: function formatted() {
      return this.value + "&nbsp;\u0420.";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c2a098","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/currency.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"currency",domProps:{"innerHTML":_vm._s(_vm.formatted)}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/currency.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  currency,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_currency = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BeKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/admin/receipt-lists.vue



/* harmony default export */ var receipt_lists = ({
  metaInfo: { title: 'Списки чеков' },
  data: function data() {
    return { tabs: [{ type: 'kkt', label: 'ККТ' }, { type: 'payment_type', label: 'Типы оплаты' }, { type: 'status', label: 'Статусы оплаты' }], type: 'kkt', values: [], logs: {}, pageSizes: [25, 50, 100, 500, 1000], perPage: 25, saving: false, form: { value: '', label: '' } };
  },
  created: function created() {
    this.load(1);
  },

  methods: {
    selectType: function selectType(type) {
      this.type = type;this.form = { value: '', label: '' };this.load(1);
    },
    load: function load(page) {
      var _this = this;

      return api["a" /* default */].get('receipt-reference-values', { params: { type: this.type, page: page, per_page: this.perPage } }).then(function (_ref) {
        var data = _ref.data;
        _this.values = data.values;_this.logs = data.logs;_this.pageSizes = data.page_sizes;
      });
    },
    add: function add() {
      if (!this.form.value || this.saving) return;this.save(api["a" /* default */].post('receipt-reference-values', { type: this.type, value: this.form.value, label: this.form.label }));
    },
    remove: function remove(value) {
      if (!this.saving) this.save(api["a" /* default */].delete('receipt-reference-values/' + this.type + '/' + encodeURIComponent(value)));
    },
    save: function save(request) {
      var _this2 = this;

      this.saving = true;request.then(function () {
        _this2.form = { value: '', label: '' };return _this2.load(1);
      }).catch(function () {
        return _this2.$root.showAlert('Не удалось сохранить изменение');
      }).finally(function () {
        _this2.saving = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc8ecdc2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/receipt-lists.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid py-3"},[_c('h1',[_vm._v("Списки чеков")]),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs mb-3"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.type,staticClass:"nav-item"},[_c('a',{class:['nav-link', {active: _vm.type === tab.type}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.selectType(tab.type)}}},[_vm._v(_vm._s(tab.label))])])}),0),_vm._v(" "),_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"d-flex flex-wrap mb-3"},_vm._l((_vm.values),function(item){return _c('span',{key:item.value,staticClass:"reference-tag"},[_vm._v("\n          "+_vm._s(item.label || item.value)),(item.label && item.label !== item.value)?_c('small',{staticClass:"ml-1"},[_vm._v("("+_vm._s(item.value)+")")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"reference-remove",attrs:{"type":"button","disabled":_vm.saving},on:{"click":function($event){return _vm.remove(item.value)}}},[_vm._v("×")])])}),0),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-md-5"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.value),expression:"form.value",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"placeholder":"Значение"},domProps:{"value":(_vm.form.value)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.add($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "value", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.label),expression:"form.label",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"placeholder":"Подпись (необязательно)"},domProps:{"value":(_vm.form.label)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.add($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "label", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"disabled":_vm.saving || !_vm.form.value},on:{"click":_vm.add}},[_vm._v("Добавить")])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('span',[_vm._v("История изменений")]),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.perPage),expression:"perPage",modifiers:{"number":true}}],staticClass:"custom-select custom-select-sm page-size",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.load(1)}]}},_vm._l((_vm.pageSizes),function(size){return _c('option',{key:size,domProps:{"value":size}},[_vm._v(_vm._s(size))])}),0)]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.logs.data || [],"stripe":""}},[_c('el-table-column',{attrs:{"prop":"created_at","label":"Дата","min-width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"Значение"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"label","label":"Подпись"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"action","label":"Действие"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_email","label":"Пользователь"}})],1),_vm._v(" "),(_vm.logs.total)?_c('div',{staticClass:"d-flex justify-content-between p-3"},[_c('span',[_vm._v("Всего: "+_vm._s(_vm.logs.total))]),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"disabled":_vm.logs.current_page <= 1},on:{"click":function($event){return _vm.load(_vm.logs.current_page - 1)}}},[_vm._v("Назад")]),_c('span',{staticClass:"btn btn-light btn-sm disabled"},[_vm._v(_vm._s(_vm.logs.current_page)+" / "+_vm._s(_vm.logs.last_page))]),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"disabled":_vm.logs.current_page >= _vm.logs.last_page},on:{"click":function($event){return _vm.load(_vm.logs.current_page + 1)}}},[_vm._v("Вперёд")])])]):_vm._e()],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/admin/receipt-lists.vue
function injectStyle (context) {
  __webpack_require__("qwhp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc8ecdc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  receipt_lists,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var admin_receipt_lists = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Bgx6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BiDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders/equipment/_id.vue




/* harmony default export */ var _id = ({
  metaInfo: { title: 'Заявка на детали и оборудование' },
  props: {
    id: {
      required: true
    }
  },
  data: function data() {
    return {};
  },

  asyncComputed: {
    order: function order() {
      return api["a" /* default */].get('orders/details/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c63766d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders/equipment/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order)?_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"mr-auto"},[_c('back-button',{attrs:{"to":"/orders/equipment"}}),_vm._v("Заявка на детали и оборудование")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('div',[_c('strong',[_vm._v("ФИО оператора:")]),_vm._v(" "+_vm._s(_vm._f("fullName")(_vm.order.user)))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Статус:")]),_vm._v(" "+_vm._s(_vm.order.status.description))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Дата оформления:")]),_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.order.date)))])]),_vm._v(" "),_c('div',{staticClass:"table-full-width mt-2"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.order.parts_request),function(component){return _c('tr',[_c('td',[_vm._v(_vm._s(component.detail.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(component.amount + ' ' + component.detail.measure))])])}),0)]),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.order.extra_parts_request),function(component){return _c('tr',[_c('td',[_vm._v(_vm._s(component.detail.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(component.amount + ' ' + component.detail.measure))])])}),0)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Детали")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Дополнительное оборудование")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders/equipment/_id.vue
function injectStyle (context) {
  __webpack_require__("tanR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var equipment__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CXEC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/components/filter-terms.vue + 1 modules
var filter_terms = __webpack_require__("HRc9");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-checkboxes.vue




/* harmony default export */ var filter_checkboxes = ({
  extends: filter_terms["default"],
  props: {
    enableCount: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c52cb3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-checkboxes.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-checkboxes"},_vm._l((_vm.terms),function(term){return _c('div',{key:term.value,staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","disabled":term.count === 0 && _vm.selected.indexOf(term.value) === -1,"id":("checkbox-" + _vm._uid + "-" + (term.value))},domProps:{"value":term.value,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,term.value)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=term.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label d-flex align-items-center justify-content-between",attrs:{"for":("checkbox-" + _vm._uid + "-" + (term.value))}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(term.label))]),_vm._v(" "),(_vm.enableCount)?_c('small',{staticClass:"filter-bucket-size font-weight-bold"},[_vm._v(_vm._s(term.count))]):_vm._e()])])}),0)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-checkboxes.vue
function injectStyle (context) {
  __webpack_require__("vczd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_checkboxes,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_checkboxes = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CpOP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-json-pretty/vue-json-pretty.js
var vue_json_pretty = __webpack_require__("RKAd");
var vue_json_pretty_default = /*#__PURE__*/__webpack_require__.n(vue_json_pretty);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/receipt-details.vue





/* harmony default export */ var receipt_details = ({
  components: { VueJsonPretty: vue_json_pretty_default.a },
  props: {
    receipt: {
      type: Object
    }
  },
  data: function data() {
    return { sending: false };
  },

  computed: {
    canResend: function canResend() {
      return !/^2\d\d$/.test(String(this.receipt.status || ''));
    }
  },
  methods: {
    resend: function resend() {
      var _this = this;

      this.sending = true;
      api["a" /* default */].post('receipts/' + this.receipt.id + '/resend').then(function () {
        return _this.$root.showAlert('Чек поставлен в очередь на повторную отправку');
      }).catch(function () {
        return _this.$root.showAlert('Не удалось поставить чек в очередь');
      }).finally(function () {
        _this.sending = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86490998","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/receipt-details.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("id")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/receipts/" + (_vm.receipt.id))}},[_vm._v(_vm._s(_vm.receipt.id))])],1),_vm._v(" "),_c('dt',[_vm._v("modem_command_id")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/commands/" + (_vm.receipt.modem_command_id))}},[_vm._v(_vm._s(_vm.receipt.modem_command_id))])],1),_vm._v(" "),_c('vue-json-pretty',{attrs:{"data":_vm.receipt.request}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md"},[(_vm.receipt.response)?_c('div',{staticClass:"text-monospace"},[_vm._v(_vm._s(_vm.receipt.response))]):_vm._e(),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal mt-3"},[_c('dt',[_vm._v("source")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.receipt.source || '—'))]),_vm._v(" "),_c('dt',[_vm._v("comment")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.receipt.comment || '—'))])]),_vm._v(" "),(_vm.canResend)?_c('button',{staticClass:"btn btn-outline-primary btn-sm mt-3",attrs:{"disabled":_vm.sending},on:{"click":_vm.resend}},[_vm._v(_vm._s(_vm.sending ? 'Отправка…' : 'Отправить снова'))]):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/receipt-details.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  receipt_details,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_receipt_details = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D7iU":
/***/ (function(module, exports) {

module.exports = {"threshold_change":"Достижение порога средств для выдачи сдачи","threshold_change_after_service":"Достижение порога средств для выдачи сдачи после сервиса","threshold_encashment":"Достижение порога средств для инкассации","threshold_encashment_after_service":"Достижение порога средств для инкассации после сервиса","threshold_components":"Достижение порога ингредиентов|Достижение порога ингредиентов (:name)","threshold_kkt":"Достижение порога длины кассовой ленты","threshold_downtime_sales":"Достижение порога времени простоя без продаж","threshold_downtime_banknotes":"Достижение порога времени простоя без купюр","threshold_downtime_coins":"Достижение порога времени простоя без монет","service_fail":"Нарушение периодичности обслуживания","turn_off":"Штатное отключение автомата","turn_off_emergency":"Аварийное отключение автомата","open":"Открытие автомата","shake":"Тряска или перемещение автомата","reed_open":"Размыкание геркона","temperature":"Отклонение температуры","service":"Обслуживание автомата","stop_defect_high":"Остановка автомата по причине неисправности (критичная)|Остановка автомата по причине неисправности (:reason)","stop_defect_medium":"Остановка автомата по причине неисправности (обычная)|Остановка автомата по причине неисправности (:reason)","stop_defect_low":"Остановка автомата по причине неисправности (несущественная)|Остановка автомата по причине неисправности (:reason)","stop_components":"Остановка автомата по причине отсутствия ингредиентов","online_change":"Изменение состояния связи с автоматом","money_in":"Внесение денег|Внесение денег (руб.): купюры - :bills, кэшбокс - :cashbox, тубы - :tubes, безнал - :cashless","change_out":"Выдача сдачи|Выдача сдачи: :coins_summary руб.","sale":"Осуществление продажи|Осуществление продажи: :name, :cost руб., :type","sale_card_rejected":"Отклонена продажа по карте","encashment":"Инкассация","data_conflict":"Несоответствие данных из EVA-DTS и MDB|Несоответствие данных из EVA-DTS (:eva_sale шт./:eva_cost руб.) и MDB (:mdb_sale шт./:mdb_cost руб.) за период :from – :to","comment":"К чек-листу сервиса/задачи добавлен комментарий","case_open":"Вскрытие корпуса модема","low_battery":"Низкий заряд аккумулятора","eva_sales":"Продажи из Eva|Продажи из Eva: :sales шт.(:type)","remote_delivery":"Удалённая выдача продукта|Удалённая выдача продукта: :name"}

/***/ }),

/***/ "Dd/1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders/equipment/index.vue


/* harmony default export */ var equipment = ({
  metaInfo: { title: 'Заявки на детали и оборудование' },
  data: function data() {
    return {
      data: {},
      loading: false,
      hasMore: true,
      filtersValue: null,
      date: {
        min: null,
        max: null
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87867d6c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders/equipment/index.vue
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"orders/details","loading":_vm.loading,"hasMore":_vm.hasMore,"filtersValue":_vm.filtersValue,"date":_vm.date},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("На детали и оборудование")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"users","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary ml-2",attrs:{"to":"/orders/equipment/create"}},[_vm._v("Добавить заявку\n      ")])],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"row-click":(function (row) { return this$1.$router.push(("/orders/equipment/" + (row.id))); })}},[_c('el-table-column',{attrs:{"prop":"","label":"ФИО"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(_vm._f("fullName")(row.user))+"\n        ")]}}],null,false,2039665891)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"№ заявки"}}),_vm._v(" "),_c('table-column-date',{attrs:{"label":"Дата создания"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status.description","label":"Статус заявки"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders/equipment/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  equipment,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var orders_equipment = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DgJe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

__webpack_require__("H1WF");

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  function init($el) {
    $el.inputmask({
      clearIncomplete: true
    });
  }

  init(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(':input'));

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('focus mouseenter', ':input', function () {
    if (!this.inputmask) {
      init(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    }
  });
});

/***/ }),

/***/ "EIOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/tail.js
var tail = __webpack_require__("1r6d");
var tail_default = /*#__PURE__*/__webpack_require__.n(tail);

// EXTERNAL MODULE: ./node_modules/lodash/zip.js
var zip = __webpack_require__("uX6x");
var zip_default = /*#__PURE__*/__webpack_require__.n(zip);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/index.vue







/* harmony default export */ var pages = ({
  metaInfo: { title: 'Обзор' },
  data: function data() {
    return {
      city: null,
      graphData: null,
      selectedRegion: []
    };
  },

  computed: {
    sales: function sales() {
      if (!this.graphData) return [];
      return tail_default()(zip_default()(this.graphData.values, this.graphData.sales, this.graphData.revenue, this.graphData.before_sales, this.graphData.before_revenue)).map(function (day) {
        return {
          dayOfWeek: moment_default()(day[0]).format('dddd'),
          count: day[1] + day[3],
          sum: day[2] + day[4]
        };
      });
    },
    endpointParams: function endpointParams() {
      return {
        regions: this.selectedRegion.map(function (e) {
          return e.id;
        })
      };
    }
  },
  asyncComputed: {
    machinesStatus: function machinesStatus() {
      var data = { params: this.endpointParams };
      return api["a" /* default */].get('index/status', data).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    },
    encashment: function encashment() {
      var data = { params: this.endpointParams };
      return api["a" /* default */].get('index/encashment', data).then(function (_ref2) {
        var data = _ref2.data;
        return data.data;
      });
    },
    machines: function machines() {
      var data = { params: this.endpointParams };
      return api["a" /* default */].get('index/machines', data).then(function (_ref3) {
        var data = _ref3.data;
        return data.data;
      });
    },
    downtimes: function downtimes() {
      var data = { params: this.endpointParams };
      return api["a" /* default */].get('index/downtimes', data).then(function (_ref4) {
        var data = _ref4.data;
        return data.data;
      });
    },
    deviations: function deviations() {
      var data = { params: this.endpointParams };
      return api["a" /* default */].get('index/deviations', data).then(function (_ref5) {
        var data = _ref5.data;
        return data.data;
      });
    },
    stats: function stats() {
      var data = { params: this.endpointParams };
      return api["a" /* default */].get('index/stats', data).then(function (_ref6) {
        var data = _ref6.data;
        return data.data;
      });
    }
  },
  filters: {
    formatDowntimesDuration: function formatDowntimesDuration(seconds) {
      if (!seconds) return seconds;
      return Math.round(seconds / 60 / 60 / 24) + ' дн.';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36bb6cd2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex"},[_vm._m(0),_vm._v(" "),(_vm.$root.canSelectRegion())?[_c('h2',{staticClass:"mr-1 mt-1 align-self-center"},[_vm._v("Организация:")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 pr-0"},[_c('server-select',{staticClass:"my-1 ml-1",attrs:{"label":"name","endpoint":"regions/options","multiple":true,"searchable":false,"lazy":true,"placeholder":"Выберите..."},model:{value:(_vm.selectedRegion),callback:function ($$v) {_vm.selectedRegion=$$v},expression:"selectedRegion"}})],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card h-100"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body d-flex align-items-center px-0"},[_c('graph',{staticClass:"w-100",attrs:{"endpoint":"machines/sales","endpoint-params":this.endpointParams,"period":"week","height":270,"data":_vm.graphData},on:{"update:data":function($event){_vm.graphData=$event}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card h-100 d-flex"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"ml-3 flex-grow-1"},[(_vm.sales)?_c('table',{staticClass:"table table-index-sales table-head-light w-100 table-sm px-0 mb-0",staticStyle:{"height":"250px","table-layout":"fixed"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.sales),function(sale){return _c('tr',[_c('td',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(sale.dayOfWeek))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_c('number',{attrs:{"number":sale.count}})],1)]),_vm._v(" "),_c('td',{staticClass:"text-right pr-5"},[_c('number',{attrs:{"number":sale.sum}})],1)])}),0)]):_vm._e()]),_vm._v(" "),(_vm.$root.checkPermission('web_sales'))?_c('div',{staticClass:"card-body flex-grow-0"},[_c('router-link',{attrs:{"to":"/reports/sales"}},[_vm._v("Подробнее…")])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 d-flex flex-column"},[_c('div',{staticClass:"card"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.machinesStatus)?_c('div',[_c('div',{staticClass:"d-flex align-items-center my-3 mx-2"},[_c('div',{staticClass:"text-large"},[_vm._v(_vm._s(Math.round((_vm.machinesStatus.online * 100) / _vm.machinesStatus.total))+" %")]),_vm._v(" "),_c('div',{staticClass:"progress flex-grow-1 mx-3"},[_c('div',{staticClass:"progress-bar",style:('width:'+((_vm.machinesStatus.online*100) / _vm.machinesStatus.total)+ '%;'),attrs:{"role":"progressbar","aria-valuenow":_vm.machinesStatus.online,"aria-valuemin":"0","aria-valuemax":_vm.machinesStatus.total}})]),_vm._v(" "),_c('div',{staticClass:"text-large"},[_c('strong',[_vm._v(_vm._s(_vm.machinesStatus.online))]),_vm._v(" из "+_vm._s(_vm.machinesStatus.total))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mt-4 flex-grow-1"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card h-100"},[_vm._m(5),_vm._v(" "),(_vm.stats)?_c('div',{staticClass:"card-body d-flex flex-column justify-content-around"},[_c('div',{staticClass:"mb-2"},[_vm._v("Купюр в автоматах "),_c('br'),_c('strong',{staticClass:"text-large"},[_c('number',{attrs:{"number":_vm.stats.banknotes.sum}}),_vm._v(" руб.")],1)]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("Требуют инкассации "),_c('br'),_c('strong',{staticClass:"text-large"},[_c('number',{attrs:{"number":_vm.stats.banknotes.count}})],1)]),_vm._v(" "),(_vm.$root.checkPermission('web_collect'))?_c('router-link',{attrs:{"to":"/reports/encashment"}},[_vm._v("Подробнее…")]):_vm._e()],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card h-100"},[_vm._m(6),_vm._v(" "),(_vm.stats)?_c('div',{staticClass:"card-body d-flex flex-column justify-content-around"},[_c('div',{staticClass:"mb-2"},[_vm._v("Монет на сдачу "),_c('br'),_c('strong',{staticClass:"text-large"},[_c('number',{attrs:{"number":_vm.stats.coins.sum}}),_vm._v(" руб.")],1)]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("Требуют загрузки "),_c('br'),_c('strong',{staticClass:"text-large"},[_c('number',{attrs:{"number":_vm.stats.coins.count}})],1)]),_vm._v(" "),(_vm.$root.checkPermission('web_collect'))?_c('router-link',{attrs:{"to":"/reports/encashment"}},[_vm._v("Подробнее…")]):_vm._e()],1):_vm._e()])])])])]),_vm._v(" "),_c('h2',[_vm._v("Автоматы, требующие обслуживания")]),_vm._v(" "),(_vm.machines)?_c('div',[_c('div',{staticClass:"card mb-5"},[_vm._m(7),_vm._v(" "),_c('div',{attrs:{"id":"machines-accordion","role":"tablist","aria-multiselectable":"true"}},_vm._l((_vm.machines),function(region,name,i){return _c('div',{staticClass:"border-bottom"},[_c('a',{staticClass:"btn btn-lg btn-block text-body text-left",class:Object.keys(_vm.machines).length === 1 ? '' : 'collapsed',attrs:{"data-toggle":"collapse","data-parent":"#machines-accordion","href":'#collapse'+i,"aria-expanded":"true","aria-controls":("collapse" + i),"role":"tab","id":("heading" + i)}},[_c('h5',{staticClass:"mb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_vm._v(_vm._s(name))]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_vm._v(_vm._s(region.length))])])])]),_vm._v(" "),_c('div',{staticClass:"collapse",class:Object.keys(_vm.machines).length === 1 ? 'show' : '',attrs:{"id":("collapse" + i),"role":"tabpanel","aria-labelledby":("heading" + i)}},[_c('table',{staticClass:"table mb-0"},[_vm._m(8,true),_vm._v(" "),_c('tbody',_vm._l((region),function(machine){return _c('tr',[_c('td',[(_vm.$root.checkPermission('web_ta_main'))?_c('router-link',{attrs:{"to":("/machines/" + (machine.id))}},[_vm._v("\n                    "+_vm._s(machine.serial_number)+"\n                  ")]):_c('div',[_vm._v("\n                    "+_vm._s(machine.serial_number)+"\n                  ")])],1),_vm._v(" "),_c('td',[_c('status-images',{attrs:{"value":machine.status,"reasons":machine.downtimes_reasons}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(machine.last_service_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(machine.address))])])}),0)])])])}),0)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"mr-auto"},[_vm._v("Обзор "),_c('small',{staticClass:"text-muted"},[_vm._v("за последние 7 дней")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("График продаж")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header flex-grow-0"},[_c('span',{staticClass:"text-caps"},[_vm._v("Продажи")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("День недели")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Количество")]),_vm._v(" "),_c('th',{staticClass:"text-right pr-5",attrs:{"width":"150"}},[_vm._v("Сумма")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("На связи")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Купюры")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Монеты")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Организация")])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v("Количество автоматов, требующих обслуживания")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("№ автомата")]),_vm._v(" "),_c('th',{attrs:{"width":"180"}},[_vm._v("Состояние")]),_vm._v(" "),_c('th',{attrs:{"width":"220"}},[_vm._v("Посл. обслуживание")]),_vm._v(" "),_c('th',[_vm._v("Место установки")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/index.vue
function injectStyle (context) {
  __webpack_require__("aVmM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  pages,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var js_pages = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ETcG":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"860\" height=\"42\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M92.737 11l11.956 20.696H80.78z\" fill=\"#568ec3\"/><g transform=\"translate(177 4)\"><path d=\"M187.81 8.5h10m-10 17h10m-37-17h10m-10 17h10\" stroke=\"#d8d8d8\" stroke-linecap=\"square\"/><circle cx=\"178.668\" cy=\"17\" r=\"10\" fill=\"#568ec3\"/><circle cx=\"169.668\" cy=\"26\" r=\"5\" fill=\"#db392a\"/><circle cx=\"169.668\" cy=\"8\" r=\"5\" fill=\"#000\"/><circle cx=\"188.668\" cy=\"25.5\" r=\"5\" fill=\"#f5a623\"/><circle cx=\"188.668\" cy=\"8\" r=\"5\" fill=\"#5fa615\"/></g><g transform=\"translate(402 4)\"><path d=\"M334.98 8.5h10m-9.857 17h10m-37-17h10m-10 17h10\" stroke=\"#d8d8d8\" stroke-linecap=\"square\"/><path d=\"M315.98 7h20v20h-20z\" fill=\"#568ec3\"/><circle cx=\"316.98\" cy=\"26\" r=\"5\" fill=\"#db392a\"/><circle cx=\"316.98\" cy=\"8\" r=\"5\" fill=\"#000\"/><circle cx=\"335.98\" cy=\"25.5\" r=\"5\" fill=\"#f5a623\"/><circle cx=\"335.98\" cy=\"8\" r=\"5\" fill=\"#5fa615\"/><path d=\"M370.92 8.5h10\" stroke=\"#d8d8d8\" stroke-linecap=\"square\"/><circle cx=\"371.919\" cy=\"8\" r=\"5\" fill=\"#8b572a\"/><path d=\"M418.234 8.5h10\" stroke=\"#d8d8d8\" stroke-linecap=\"square\"/><circle cx=\"419.234\" cy=\"8\" r=\"5\" fill=\"#bd10e0\"/></g></g><text style=\"line-height:1.25\" x=\"201.139\" y=\"18.121\" font-weight=\"400\" font-size=\"10.667\" font-family=\"sans-serif\" letter-spacing=\"0\" word-spacing=\"0\"/><text style=\"line-height:1.25\" x=\"201.377\" y=\"15.574\" font-weight=\"400\" font-size=\"40\" font-family=\"sans-serif\" letter-spacing=\"0\" word-spacing=\"0\"/><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"235.686\" y=\"15.014\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"235.686\" y=\"15.014\" style=\"-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\">Санитарная обработка</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"224.46\" y=\"31.326\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"224.46\" y=\"31.326\">Выгрузка-загрузка монет</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"377.152\" y=\"14.751\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"377.152\" y=\"14.751\">Загрузка ингредиентов</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"377.284\" y=\"31.493\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"377.284\" y=\"31.493\">Инкассация</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"613.602\" y=\"15.241\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"613.602\" y=\"15.241\">Оперативный ремонт</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"596.717\" y=\"31.651\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"596.717\" y=\"31.651\">Выгрузка-загрузка монет</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"749.863\" y=\"15.201\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"749.863\" y=\"15.201\">ПО</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"749.956\" y=\"32.024\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"749.956\" y=\"32.024\">Инкассация</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"785.416\" y=\"15.893\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"785.416\" y=\"15.893\">ППРт</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"832.647\" y=\"16.223\" font-weight=\"400\" font-size=\"9.333\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#666\"><tspan x=\"832.647\" y=\"16.223\">ППРс</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"5.717\" y=\"26.836\" font-weight=\"400\" font-size=\"12\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#33586c\"><tspan x=\"5.717\" y=\"26.836\">Начальник</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"152.346\" y=\"26.718\" font-weight=\"400\" font-size=\"12\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#33586c\"><tspan x=\"152.346\" y=\"26.718\">Оператор</tspan></text><text style=\"line-height:1.25;-inkscape-font-specification:'Roboto, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start\" x=\"540.774\" y=\"26.638\" font-weight=\"400\" font-size=\"12\" font-family=\"Roboto\" letter-spacing=\"0\" word-spacing=\"0\" fill=\"#33586c\"><tspan x=\"540.774\" y=\"26.638\">Техник</tspan></text></svg>"

/***/ }),

/***/ "Egmp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Erqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/downtime.vue




/* harmony default export */ var downtime = ({
  metaInfo: { title: 'Простои' },
  data: function data() {
    return {
      col: 2,
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      date: {
        min: moment_default()().subtract(7, 'days').format('YYYY-MM-DD'),
        max: moment_default()().format('YYYY-MM-DD')
      },
      sort: null,
      sortColumn: '_term'
    };
  },

  filters: {
    formatStartTime: function formatStartTime(microseconds) {
      return moment_default.a.unix(microseconds / 1000).format('DD.MM.YYYY HH:mm:ss');
    },
    translateReason: function translateReason(reason) {
      if (reason) {
        var reasons = {
          technical: "Техническая",
          ingredients: "Отсутствие ингредиентов",
          money: "Отсутствие сдачи",
          unspecified: "Требует уточнения"
        };
        return reasons[reason];
      }
      return "";
    }
  },
  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var prop = sort.prop + '.keyword';
        this.sort = prop + ':' + order;
      } else {
        this.sort = null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6316e3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/downtime.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"downtimes","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"date":_vm.date,"externalFilters":_vm.sortColumn},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center justify-content-start"},[_c('h1',{staticClass:"mr-4"},[_vm._v("Простои")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"mt-1"},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortColumn),expression:"sortColumn"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"checklist-type-1","value":"_term"},domProps:{"checked":_vm._q(_vm.sortColumn,"_term")},on:{"change":function($event){_vm.sortColumn="_term"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checklist-type-1"}},[_vm._v("Время начала")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortColumn),expression:"sortColumn"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"checklist-type-2","value":"time"},domProps:{"checked":_vm._q(_vm.sortColumn,"time")},on:{"change":function($event){_vm.sortColumn="time"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checklist-type-2"}},[_vm._v("Простой")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortColumn),expression:"sortColumn"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"checklist-type-3","value":"workTime"},domProps:{"checked":_vm._q(_vm.sortColumn,"workTime")},on:{"change":function($event){_vm.sortColumn="workTime"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checklist-type-3"}},[_vm._v("Режим работы")])])])]),_vm._v(" "),_c('btn-filters',{staticClass:"ml-auto",attrs:{"data":_vm.data,"endpoint":"downtimes","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"sort-change":_vm.sortChange}},[_c('table-column-serial-number',{attrs:{"sortable":"keyword"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"Адрес установки"}}),_vm._v(" "),_c('el-table-column',{attrs:{"colspan":_vm.col,"align":"center","label":"Время начала простоя"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return _vm._l((row.downtimes),function(index){return _c('div',{staticClass:"downtimes-item"},[_vm._v("\n            "+_vm._s(_vm._f("formatStartTime")(index.start_time))+"\n          ")])})}}],null,false,1465941392)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Время простоя"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return _vm._l((row.downtimes),function(index){return _c('div',{staticClass:"downtimes-item"},[_vm._v("\n            "+_vm._s(_vm._f("formatDuration")(index.duration))+"\n          ")])})}}],null,false,3195897999)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Простой с учетом режима работы"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return _vm._l((row.downtimes),function(index){return _c('div',{staticClass:"downtimes-item"},[_vm._v("\n            "+_vm._s(_vm._f("formatDuration")(index.durationWorkTime))+"\n          ")])})}}],null,false,3679417947)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Причина простоя"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return _vm._l((row.downtimes),function(index){return _c('div',{staticClass:"downtimes-item"},[_vm._v("\n            "+_vm._s(_vm._f("translateReason")(index.reason))+"\n          ")])})}}],null,false,617529482)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Общее время простоев"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(_vm._f("formatDuration")(row.sum))+"\n        ")]}}],null,false,2330205296)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Общее время простоев с учетом режима работы"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(_vm._f("formatDuration")(row.sumWorkTime))+"\n        ")]}}],null,false,3405746724)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/downtime.vue
function injectStyle (context) {
  __webpack_require__("RefH")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  downtime,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_downtime = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F186":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"46\" height=\"32\"><defs><rect id=\"a\" width=\"42\" height=\"27.375\" rx=\"3\"/><path id=\"b\" d=\"M17.498 6.222h10.207a3.991 3.991 0 0 1 3.993 4V17c0 2.21-1.798 4-3.993 4H17.498l-6.98-7.734 6.98-7.044z\"/></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(2 2)\"><use fill=\"#FFF\" xlink:href=\"#a\"/><rect width=\"41\" height=\"26.375\" x=\".5\" y=\".5\" stroke=\"#E71D28\" rx=\"3\"/></g><g transform=\"translate(2 2)\"><use fill=\"#FFF\" xlink:href=\"#b\"/><path stroke=\"#E71D28\" d=\"M17.706 6.722h9.999a3.491 3.491 0 0 1 3.493 3.5V17a3.502 3.502 0 0 1-3.493 3.499H17.72l-6.513-7.218 6.5-6.56z\"/></g><path d=\"M22.127 12.42l7.052 6.918m-7.052-.112l6.938-6.806\" stroke=\"#E71D28\" stroke-linecap=\"square\"/></g></svg>"

/***/ }),

/***/ "FR0B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FXTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/sample-modal.vue




/* harmony default export */ var sample_modal = ({
  props: ['filters'],
  data: function data() {
    return {
      name: ''
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      return api["a" /* default */].post('samples', {
        filters: this.filters,
        name: this.name,
        path: this.$route.path
      }).then(function (data) {
        _this.hide();
      });
    },
    hide: function hide() {
      this.$emit('hide');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dce6819","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sample-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("Сохранение выборки")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hide()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Название")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex"},[_c('btn-action',{staticClass:"btn btn-primary ml-auto",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/sample-modal.vue
function injectStyle (context) {
  __webpack_require__("IAlo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sample_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sample_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Fd/m":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQjM5MkEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTQuMjg4IDE2LjAxNWExLjgwMyAxLjgwMyAwIDEgMS0zLjYwNiAwIDEuODAzIDEuODAzIDAgMCAxIDMuNjA2IDB6bTMuMzYzLTcuMzgxQTguOTYzIDguOTYzIDAgMCAwIDEyLjQ4NSA3YTguOTYyIDguOTYyIDAgMCAwLTUuMTY2IDEuNjM0cy0uNTk1LjQ3OS0uMTYgMS4xNTVjLjQzNy42NzYgMS4wNDguNDI4IDEuMDQ4LjQyOGE3LjE3MiA3LjE3MiAwIDAgMSA4LjU1MiAwYy4wMDEgMCAuNzk3LjMwNSAxLjEzNS0uMzg1LjMzOS0uNjktLjI0My0xLjE5OC0uMjQzLTEuMTk4ek0xNS44NyAxMS44YTUuMzg0IDUuMzg0IDAgMCAwLTMuMzg0LTEuMTk0QTUuMzkgNS4zOSAwIDAgMCA5LjA5OSAxMS44cy0uNzI3LjUxMS0uMjA2IDEuMjQzYy41Mi43MzMgMS4xMS4zNjcgMS4xMS4zNjcuNjQ3LS42MTcgMS41MTktMSAyLjQ4Mi0xIC45NjMgMCAxLjgzMy4zODMgMi40OCAxIDAgMCAuNzMyLjIyNSAxLjA5OC0uNDUxLjM2Ny0uNjc2LS4xOTQtMS4xNi0uMTk0LTEuMTZ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "G4x5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-delivery-of-change.vue





/* harmony default export */ var filter_event_delivery_of_change = ({
  props: {
    range: { type: Object },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    header: { type: String }
  },
  data: function data() {
    return {
      event: {
        number: this.value.number || {},
        date: this.value.date || {}
      },
      money: this.value.moneyRange || {}
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      return omitBy_default()({
        number: this.event.number,
        date: this.event.date,
        moneyRange: this.money
      }, isEmpty_default.a);
    }
  },

  watch: {
    value: function value(input) {
      this.event = {
        number: input.number || {},
        date: input.date || {}
      };
      this.money = input.moneyRange || {};
    },


    preparedInput: {
      handler: function handler(newVal, oldVal) {
        if (!isEqual_default()(newVal, oldVal)) {
          this.$emit('input', this.preparedInput);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b766c46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-delivery-of-change.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('filter-range',{model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-delivery-of-change.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_delivery_of_change,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_delivery_of_change = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "G59m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GEx1":
/***/ (function(module, exports) {

module.exports = {"EA7":"Скачок напряжения сети электропитания","EA_01":"Ошибка в тубах монетоприемника","EA_02":"В тубах мало монет для сдачи","EAB":"Неисправность системы восстановления","EAR":"Ошибка и/или отсутствие связи с монетоприемником","EBA":"Неисправность поворота туб УВС","EBG":"Ошибка УВС или замятие стакана","EBI":"Неисправна  рука выдачи УВС","EBJ":"Нет стаканов в тубах УВС","EBM":"Неисправен мотор выдачи стаканов","ECO":"Ошибка энергонезависимой памяти ЦПУ","ECS":"Ошибка кнопочной панели","ED_01":"Ошибка узла выдачи размешивателей","ED_02":"Ошибка механизма узла выдачи крышек","ED_03":"Ошибка детектора узла выдачи крышек","ED_04":"Отсутствуют крышки","EDB":"Ошибка механизма выдачи ингредиента","EDI":"Ошибка дозатора кофемолки","EDK":"Ошибка бойлера горячей воды","EDT":"Ошибка кофемолки","EDU":"Ошибка счетчика воды","EEA":"Ошибка мотора кофеварки","EFL":"Нет воды или низкое давление в ЦВС","EFH":"Неисправен клапан подачи воды","EF_01":"Неисправен водораспределитель","EGS":"Открыта дверь","EG_05":"Не обнаружены моторы в ТА","EI_1":"Отсутствует связь с ведомым ТА № 1","EI_2":"Отсутствует связь с ведомым ТА № 2","EJ_01":"Не работает датчик замятия ТА","EJ_02":"Ошибка детектора товара в ТА","EJ_03":"Замыкание фото-сенсора на главном ТА","EJ_04":"Не подключен фото-сенсор на главном ТА","EJ_05":"Замыкание фото-сенсора на 1-ом ведомом ТА","EJ_06":"Замыкание фото-сенсора на 2-ом ведомом ТА","EJ_07":"Не подключен фото-сенсор на 1-ом ведомом ТА","EJ_08":"Не подключен фото-сенсор на 2-ом ведомом ТА","EJ_09":"Продукт под лифтом","EJ_10":"Неисправность электропитания лифта","EJ_11":"Продукт в лифте при включении ТА","EJ_12":"Ошибка мотора лифта ТА","EJ_13":"Ошибка мотора толкателя","EJ_14":"Ошибка детектора корзины выдачи продукта ТА","EJG":"Неисправно устройство открытия  дверцы корзины выдачи продукта","EJH":"Нарушен температурный режим в ТА","EJL":"Ошибка детектора системы  выдачи продукта ТА","EKM":"Ошибка и/или отсутствие связи с оборудованием эквайринга № 1","EK2M":"Ошибка и/или отсутствие связи с оборудованием эквайринга № 2","EL_01":"Продукт не привязан к каналам","EL_02":"Продукт не продан из-за отсутствия сдачи","EL_03":"У продукта истек срок годности","ELB":"Продукт закончился","EM_01":"Не детектируется СВЧ печь","EM_02":"Ошибка мотора лифта подачи в СВЧ печь","EM_03":"Ошибка системы удаления из СВЧ печи забытого продукта","EM_04":"Ошибка позиции лифта подачи в СВЧ печь","EM_05":"Ожидание выдачи продукта","EMC":"Неисправна система управления СВЧ печью","EN_01":"Купюроприемник вышел из строя","ENE":"Стекер для купюр переполнен","ENF":"Стекер для купюр снят или установлен неправильно","ENK":"Ошибка и/или отсутствие связи с купюроприемником","ENU_08":"Замятие купюры","EO_01":"Ошибка связи с датчиком температуры ТА","EOA":"Сбой или неправильное считывание данных датчика температуры ТА","OBI":"Неправильно установлен коллектор или переполнен бак жидких отходов","OBH":"Неправильно установлен или переполнен контейнер для жмыха","OB_01":"Грязный пенообразователь (необходим запуск цикла очистки)"}

/***/ }),

/***/ "GHkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/admin/ffd12-receipt-groups.vue





/* harmony default export */ var ffd12_receipt_groups = ({
  metaInfo: { title: 'ККТ ФФД 1.2' },
  data: function data() {
    return {
      groups: [],
      newGroup: '',
      logs: {},
      pageSizes: [25, 50, 100, 500, 1000],
      perPage: 25,
      loading: false,
      saving: false
    };
  },
  created: function created() {
    this.load(1);
  },

  methods: {
    load: function load() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.loading = true;
      return api["a" /* default */].get('ffd12-receipt-groups', { params: { page: page, per_page: this.perPage } }).then(function (response) {
        _this.groups = response.data.groups;
        _this.logs = response.data.logs;
        _this.pageSizes = response.data.page_sizes;
      }).finally(function () {
        _this.loading = false;
      });
    },
    addGroup: function addGroup() {
      var group = this.newGroup.toLowerCase();
      if (!group || this.saving) return;
      this.save(api["a" /* default */].post('ffd12-receipt-groups', { name: group }));
    },
    removeGroup: function removeGroup(group) {
      if (this.saving) return;
      this.save(api["a" /* default */].delete('ffd12-receipt-groups/' + encodeURIComponent(group)));
    },
    save: function save(request) {
      var _this2 = this;

      this.saving = true;
      request.then(function () {
        _this2.newGroup = '';
        return _this2.load(1);
      }).catch(function (error) {
        var errors = error.response && error.response.data && error.response.data.errors;
        var errorKey = errors ? keys_default()(errors)[0] : null;
        var message = errorKey ? errors[errorKey][0] : 'Не удалось сохранить изменение';
        _this2.$root.showAlert(message);
      }).finally(function () {
        _this2.saving = false;
      });
    },
    changePageSize: function changePageSize() {
      this.load(1);
    },
    userLabel: function userLabel(log) {
      if (!log.user) return log.user_email || '—';
      var name = [log.user.second_name, log.user.first_name, log.user.third_name].filter(Boolean).join(' ');
      return name ? name + ' (' + log.user_email + ')' : log.user_email;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da85d38","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/ffd12-receipt-groups.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid py-3 ffd12-settings"},[_c('h1',[_vm._v("ККТ ФФД 1.2")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n    Группы Orange Data, для которых чеки формируются в формате ФФД 1.2.\n    Введите название и нажмите Enter. Для удаления нажмите крестик на теге.\n  ")]),_vm._v(" "),_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Группы ККТ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"ffd12-tags mb-3"},_vm._l((_vm.groups),function(group){return _c('span',{key:group,staticClass:"ffd12-tag"},[_vm._v("\n          "+_vm._s(group)+"\n          "),_c('button',{staticClass:"ffd12-tag-remove",attrs:{"type":"button","disabled":_vm.saving,"aria-label":("Удалить " + group)},on:{"click":function($event){return _vm.removeGroup(group)}}},[_vm._v("×")])])}),0),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.newGroup),expression:"newGroup",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.saving,"placeholder":"Введите receipt_group, например msk24","maxlength":"64"},domProps:{"value":(_vm.newGroup)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addGroup($event)},"input":function($event){if($event.target.composing){ return; }_vm.newGroup=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.saving || !_vm.newGroup},on:{"click":_vm.addGroup}},[_vm._v("\n            Добавить\n          ")])])]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("Допустимы латинские буквы, цифры, дефис и подчёркивание.")])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header d-flex align-items-center justify-content-between"},[_c('span',[_vm._v("История изменений")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.perPage),expression:"perPage",modifiers:{"number":true}}],staticClass:"custom-select custom-select-sm page-size",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changePageSize]}},_vm._l((_vm.pageSizes),function(size){return _c('option',{key:size,domProps:{"value":size}},[_vm._v(_vm._s(size))])}),0)]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.logs.data || [],"stripe":""}},[_c('el-table-column',{attrs:{"prop":"created_at","label":"Дата","min-width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"group_name","label":"Группа ККТ","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Действие","min-width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{class:['badge', scope.row.action === 'added' ? 'badge-success' : 'badge-danger']},[_vm._v("\n            "+_vm._s(scope.row.action === 'added' ? 'Добавлена' : 'Удалена')+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Пользователь","min-width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.userLabel(scope.row))+"\n        ")]}}])})],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"p-3 text-center text-muted"},[_vm._v("Загрузка…")]):_vm._e(),_vm._v(" "),(_vm.logs.total)?_c('div',{staticClass:"d-flex align-items-center justify-content-between p-3"},[_c('span',[_vm._v("Всего: "+_vm._s(_vm.logs.total))]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"disabled":_vm.logs.current_page <= 1},on:{"click":function($event){return _vm.load(_vm.logs.current_page - 1)}}},[_vm._v("\n          Назад\n        ")]),_vm._v(" "),_c('span',{staticClass:"btn btn-light btn-sm disabled"},[_vm._v(_vm._s(_vm.logs.current_page)+" / "+_vm._s(_vm.logs.last_page))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary btn-sm",attrs:{"disabled":_vm.logs.current_page >= _vm.logs.last_page},on:{"click":function($event){return _vm.load(_vm.logs.current_page + 1)}}},[_vm._v("\n          Вперёд\n        ")])])]):_vm._e()],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/admin/ffd12-receipt-groups.vue
function injectStyle (context) {
  __webpack_require__("Ai7c")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7da85d38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ffd12_receipt_groups,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var admin_ffd12_receipt_groups = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GryE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/checklist-modal.vue




/* harmony default export */ var checklist_modal = ({
  props: ['id', 'task_type_id', 'machine_type_id', 'name_prop', 'description_prop', 'order_number', 'element_type'],
  data: function data() {
    return {
      name: null,
      description: null,
      selectedType: this.element_type ? this.element_type : 'check'
    };
  },

  methods: {
    close: function close() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.id;

      this.$emit('hide', {
        id: id,
        name: this.name,
        description: this.description,
        type: this.selectedType
      });
    },
    save: function save() {
      var _this = this;

      var data = {
        task_type_id: this.task_type_id,
        machine_type_id: this.machine_type_id,
        name: this.name,
        description: this.description,
        type: this.selectedType,
        order_number: this.order_number
      };
      if (this.id === 0) {
        return api["a" /* default */].post('checklists', data).then(function (answer) {
          _this.close(answer.data);
        });
      } else {
        return api["a" /* default */].put('checklists/' + this.id, data).then(function () {
          _this.close();
        });
      }
    }
  },
  mounted: function mounted() {
    this.name = this.name_prop;
    this.description = this.description_prop;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bbbcf82","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/checklist-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body pb-0"},[_c('form',[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Введите название"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"id":"desc","placeholder":"Опишите детали действий, на что обратить внимание, что нужно сделать","rows":"3"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('label',[_vm._v("Тип элемента чек-листа")]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"checklist-type-1","value":"check"},domProps:{"checked":_vm._q(_vm.selectedType,"check")},on:{"change":function($event){_vm.selectedType="check"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checklist-type-1"}},[_vm._v("Сделано")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"checklist-type-2","value":"mark"},domProps:{"checked":_vm._q(_vm.selectedType,"mark")},on:{"change":function($event){_vm.selectedType="mark"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"checklist-type-2"}},[_vm._v("Оценка")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Добавить элемент чек-листа")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("\n            Название элемента чек-листа\n            "),_c('br'),_c('small',[_vm._v("Отображается в списке чек-листа")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"desc"}},[_vm._v("\n            Описание элемента чек-листа\n            "),_c('br'),_c('small',[_vm._v("Отображается на экране «подробнее» элемента чек-листа")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/checklist-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  checklist_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_checklist_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GzLg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HFnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("KBYM");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./resources/assets/js/lang/events.json
var events = __webpack_require__("D7iU");
var events_default = /*#__PURE__*/__webpack_require__.n(events);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/event-modal.vue






/* harmony default export */ var event_modal = ({
  props: ['value'],
  data: function data() {
    return {
      events: events_default.a,
      sms: [],
      email: []
    };
  },
  created: function created() {
    this.sms = this.value.map(function (current) {
      return current.send_sms ? current.event_code : null;
    }).filter(function (a) {
      return a;
    });
    this.email = this.value.map(function (current) {
      return current.send_email ? current.event_code : null;
    }).filter(function (a) {
      return a;
    });
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$emit('hide', this.sms.concat(this.email.filter(function (item) {
        return _this.sms.indexOf(item) < 0;
      })).map(function (current) {
        return {
          event_code: current,
          send_sms: _this.sms.includes(current),
          send_email: _this.email.includes(current)
        };
      }));
    },
    smsOn: function smsOn(event) {
      return this.sms.indexOf(event) !== -1;
    },
    emailOn: function emailOn(event) {
      return this.email.indexOf(event) !== -1;
    },
    anyOn: function anyOn(event) {
      return this.smsOn(event) || this.emailOn(event);
    },
    formatLabel: function formatLabel(label) {
      return label.split('|')[0];
    }
  },
  computed: {
    availableEvents: function availableEvents() {
      var _this2 = this;

      var obj = {};
      sortBy_default()(keys_default()(this.events), function (key) {
        return _this2.events[key];
      }).forEach(function (o) {
        obj[o] = _this2.events[o];
      });
      return obj;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eeccc07","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/event-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.events)?[_c('table',{staticClass:"px-0"},_vm._l((_vm.availableEvents),function(label,event){return _c('tr',[_c('td',[_c('div',{staticClass:"btn-group-toggle"},[_c('label',{staticClass:"notification-channel-btn btn btn-link btn-sm",class:{active: _vm.smsOn(event)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms),expression:"sms"}],attrs:{"type":"checkbox","autocomplete":"off"},domProps:{"value":event,"checked":Array.isArray(_vm.sms)?_vm._i(_vm.sms,event)>-1:(_vm.sms)},on:{"change":function($event){var $$a=_vm.sms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=event,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.sms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.sms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.sms=$$c}}}}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"comment-alt"}}),_vm._v("\n                  SMS\n                ")],1)])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-group-toggle"},[_c('label',{staticClass:"notification-channel-btn btn btn-link btn-sm",class:{active: _vm.emailOn(event)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"checkbox","autocomplete":"off"},domProps:{"value":event,"checked":Array.isArray(_vm.email)?_vm._i(_vm.email,event)>-1:(_vm.email)},on:{"change":function($event){var $$a=_vm.email,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=event,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.email=$$a.concat([$$v]))}else{$$i>-1&&(_vm.email=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.email=$$c}}}}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"at"}}),_vm._v("\n                  EMAIL\n                ")],1)])]),_vm._v(" "),_c('td',{staticClass:"pl-2",class:_vm.anyOn(event) ? 'font-weight-bold' : 'text-muted'},[_vm._v(_vm._s(_vm.formatLabel(label)))])])}),0)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v("Сохранить")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Выберите события")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/event-modal.vue
function injectStyle (context) {
  __webpack_require__("XzG3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  event_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_event_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HRc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/each.js
var each = __webpack_require__("9uKM");
var each_default = /*#__PURE__*/__webpack_require__.n(each);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("kvU2");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("BUAs");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-terms.vue








/* harmony default export */ var filter_terms = ({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preselected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: this.preselected && isEmpty_default()(this.value) ? this.options.map(function (o) {
        return o.value;
      }) : this.value,
      terms: this.options
    };
  },

  watch: {
    value: function value(selected) {
      this.selected = selected;
    },
    selected: function selected(value) {
      this.$emit('input', value);
    },
    options: function options(newOptions) {
      var _this = this;

      this.terms = map_default()(cloneDeep_default()(this.terms), function (term) {
        var option = find_default()(newOptions, { value: term.value });
        if (!option) {
          term.count = 0;
        } else {
          assign_default()(term, option);
        }
        return term;
      });

      each_default()(newOptions, function (option) {
        var term = find_default()(_this.terms, { value: option.value });
        if (!term) {
          _this.terms.push(option);
        }
      });
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-terms.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_terms,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_terms = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HVhr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/event-modal.vue + 2 modules
var event_modal = __webpack_require__("HFnY");

// EXTERNAL MODULE: ./resources/assets/js/components/machines-modal.vue + 2 modules
var machines_modal = __webpack_require__("ndU7");

// EXTERNAL MODULE: ./resources/assets/js/filters.js
var filters = __webpack_require__("rm9P");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/notifications/_id.vue







/* harmony default export */ var _id = ({
  metaInfo: function metaInfo() {
    var userName = this.setting && this.setting.user ? filters["a" /* default */].fullName(this.setting.user) : '';
    return { title: '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F: ' + userName };
  },

  props: {
    id: { required: true }
  },
  methods: {
    save: function save() {
      return api["a" /* default */].put('notification_settings/' + this.id, {
        event_codes: this.setting.event_codes || [],
        machine_ids: this.setting.machines ? this.setting.machines.map(function (machine) {
          return machine.id;
        }) : []
      });
    },
    deleteEvent: function deleteEvent(index) {
      this.setting.event_codes.splice(index, 1);
    },
    deleteMachine: function deleteMachine(index) {
      this.setting.machines.splice(index, 1);
    },
    editEvent: function editEvent() {
      var _this = this;

      this.$root.showModal(event_modal["default"], {
        value: this.setting.event_codes
      }).then(function (data) {
        if (data) _this.setting.event_codes = data;
      });
    },
    editMachines: function editMachines() {
      var _this2 = this;

      this.$root.showModal(machines_modal["default"], {
        checked: this.setting.machines.map(function (machine) {
          return machine.id;
        })
      }).then(function (value) {
        if (value) {
          _this2.setting.machines = _this2.setting.machines.concat(value);
        }
      });
    }
  },
  asyncComputed: {
    setting: function setting() {
      return api["a" /* default */].get('notification_settings/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96812bd4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/notifications/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.setting)?[_c('div',{staticClass:"d-flex align-items-center my-2"},[_c('back-button',{attrs:{"to":"/settings/notifications"}}),_vm._v(" "),_c('h1',{staticClass:"mr-auto my-0"},[_vm._v("\n        Настройка уведомлений\n        "),(_vm.setting && _vm.setting.user)?_c('span',[_vm._v("для пользователя: "+_vm._s(_vm._f("fullName")(_vm.setting.user)))]):_vm._e()]),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить изменения")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-header d-flex align-items-center"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.editMachines}},[_vm._v("Добавить автомат")])]),_vm._v(" "),_c('table',{staticClass:"table table-sm m-0"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.setting.machines),function(machine,index){return _c('tr',[_c('td',[_vm._v(_vm._s(machine.serial_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(machine.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("fullName")(machine.technician)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("fullName")(machine.operator)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("fullName")(machine.manager)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(machine.region && machine.region.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-outline-danger btn-sm",on:{"click":function($event){return _vm.deleteMachine(index)}}},[_c('font-awesome-icon',{staticClass:"m-0",attrs:{"icon":"trash-alt"}})],1)])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-header d-flex align-items-center"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.editEvent}},[_vm._v("Выбрать")])]),_vm._v(" "),_c('table',{staticClass:"table table-sm m-0"},_vm._l((_vm.setting.event_codes),function(event,index){return _c('tr',[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm._f("eventName")(event.event_code)))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('font-awesome-icon',{class:event.send_sms? 'active_icon' : 'inactive_icon',attrs:{"icon":"comment-alt"}})],1),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('font-awesome-icon',{class:event.send_email? 'active_icon' : 'inactive_icon',attrs:{"icon":"at"}})],1),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_c('button',{staticClass:"btn btn-outline-danger btn-sm",on:{"click":function($event){return _vm.deleteEvent(index)}}},[_c('font-awesome-icon',{staticClass:"m-0",attrs:{"icon":"trash-alt"}})],1)])])}),0)])])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"my-0 mr-auto"},[_c('span',{staticClass:"text-caps"},[_vm._v("Список автоматов")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("№")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v("Адрес")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v("Техник")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v("Оператор")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v("Менеджер")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"},[_vm._v("Организация")]),_vm._v(" "),_c('td',{staticClass:"font-weight-bold"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"my-0 mr-auto"},[_c('span',{staticClass:"text-caps"},[_vm._v("Список событий")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/notifications/_id.vue
function injectStyle (context) {
  __webpack_require__("gtZC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var notifications__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HfmO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGZpbGw9IiM1NjhFQzMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDNDOC4zNzEgMyAzIDguMzcxIDMgMTVzNS4zNzEgMTIgMTIgMTIgMTItNS4zNzEgMTItMTJTMjEuNjI5IDMgMTUgM3ptNS41NDcgMTEuMDg3bC02LjA1NyA1LjcxNWMtLjQ1Ny40LTEuMTQzLjQtMS42LS4wNThsLTMuMDg2LTMuMTQyYy0uNDU3LS40NTgtLjQ1Ny0xLjIgMC0xLjYuNDU4LS40IDEuMi0uNDU4IDEuNiAwbDIuMjg2IDIuMzQyIDUuMjU3LTQuOTE0Yy41MTUtLjM0MyAxLjItLjIyOCAxLjYuMjI5LjM0My40LjM0My45NzEgMCAxLjQyOHoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "I/hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tooltip.vue




/* harmony default export */ var tooltip = ({
  name: 'tooltip',
  props: {
    title: {
      type: String
    },
    placement: {
      type: String,
      default: 'right'
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    options: function options() {
      return {
        animation: false,
        title: this.title,
        placement: this.placement,
        delay: {
          show: this.delay,
          hide: 0
        }
      };
    }
  },
  methods: {
    init: function init() {
      if (this.options.title) {
        jquery_default()(this.$refs.tooltip).tooltip(this.options);
      } else {
        this.destroy();
      }
    },
    destroy: function destroy() {
      jquery_default()(this.$refs.tooltip).tooltip('dispose');
    },
    refresh: function refresh() {
      var _this = this;

      this.$nextTick(function () {
        _this.destroy();
        _this.init();
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },

  watch: {
    options: function options() {
      this.refresh();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fa43ae5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tooltip.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"tooltip",staticStyle:{"display":"inline-block"}},[_vm._t("default")],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/tooltip.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  tooltip,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tooltip = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "I3/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/recipes/ingredients.vue


/* harmony default export */ var ingredients = ({
  metaInfo: { title: 'Ингредиенты' },
  data: function data() {
    return {
      data: {},
      loading: false,
      hasMore: true
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93f7f232","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/recipes/ingredients.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-grow-1"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"components","loading":_vm.loading,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore}},[_c('el-table-column',{attrs:{"label":"Наименование","prop":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Единица измерения","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(row.measure))])]}}],null,false,991990343)})],1)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("Ингредиенты")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/recipes/ingredients.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ingredients,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var recipes_ingredients = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IAlo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "INd1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQjM5MkEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xNC42ODkgMTYuOGMuMTc4IDAgLjMzMy4xNTYuMjg5LjMzM3YxLjExMWMwIC4xNzgtLjE1Ni4zMzQtLjMzNC4zMzRoLS45MWMtLjA5LjcxLS42OSAxLjI0NC0xLjQyMyAxLjI0NC0uNzExIDAtMS4zMTEtLjUzMy0xLjQyMi0xLjI0NGgtLjkxMWMtLjE3OCAwLS4zMzQtLjE1Ni0uMzM0LS4zMzR2LTEuMTFjMC0uMTc4LjE1Ni0uMzM0LjMzNC0uMzM0ek0xMS4wNjcgNC4yODljMy40NDQtLjggNi41MSAxLjc3OCA2LjUzMyA1LjA4OSAwIDEuNjg5LS44MjIgMy4yLTIuMDY3IDQuMTU1LS4zMzMuMjY3LS41MS42NjctLjUxIDEuMDl2LjhjMCAuMjY2LS4yLjQ2Ni0uNDY3LjQ2NmgtMS43Nzh2LTUuMDY3TDE0LjUxIDljLjE3OC0uMTc4LjE3OC0uNDg5LS4wMjItLjY2Ny0uMTc4LS4xNzctLjQ4OS0uMTc3LS42NjcuMDIzbC0xLjUxIDEuNi0xLjUxMi0xLjZjLS4xNzgtLjItLjQ2Ny0uMi0uNjY3LS4wMjMtLjIuMTc4LS4yLjQ2Ny0uMDIyLjY2N2wxLjczMyAxLjgyMnY1LjA5aC0xLjczM2MtLjI2NyAwLS40NjctLjItLjQ2Ny0uNDY4di0uNzU1YzAtLjQ0NS0uMTc3LS44NjctLjUxLTEuMTMzLTEuNTU2LTEuMi0yLjQ0NS0zLjI2Ny0xLjg5LTUuNDkuNDY3LTEuODY2IDEuOTc4LTMuMzU1IDMuODIzLTMuNzc3eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "IWqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/back-button.vue


/* harmony default export */ var back_button = ({
  props: ['to'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ee5b65","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/back-button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-link py-0 btn-back",attrs:{"to":_vm.to,"exact":""}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left","size":"lg"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/back-button.vue
function injectStyle (context) {
  __webpack_require__("/zYu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  back_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_back_button = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IhQk":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\"><g fill=\"#DB392A\" fill-rule=\"evenodd\"><path d=\"M21.638 25.31a.952.952 0 0 1-.946.919H9.078a.952.952 0 0 1-.946-.918L7.295 7.673h15.18l-.837 17.638zM11.995 4.35h5.807c.217 0 .405.19.405.406v1.566H11.59V4.756c0-.216.162-.406.405-.406zm13.1 1.972H19.53V4.756c0-.973-.783-1.756-1.756-1.756h-5.78c-.972 0-1.756.783-1.756 1.756v1.566H4.675A.669.669 0 0 0 4 6.998c0 .378.297.675.675.675h1.27l.837 17.691a2.296 2.296 0 0 0 2.296 2.216h11.588a2.295 2.295 0 0 0 2.295-2.216l.865-17.691h1.269a.669.669 0 0 0 .675-.675.669.669 0 0 0-.675-.676z\"/><path d=\"M14.885 11.454a.669.669 0 0 0-.675.675v9.454a.67.67 0 0 0 .675.676.669.669 0 0 0 .675-.676v-9.454a.686.686 0 0 0-.675-.675m-3.187.189a.65.65 0 0 0-.486-.189v.135-.135a.578.578 0 0 0-.46.217.652.652 0 0 0-.188.485l.324 9.454c0 .378.324.648.702.648.189 0 .351-.08.46-.216a.651.651 0 0 0 .188-.486l-.324-9.454a.619.619 0 0 0-.216-.459m6.861-.189v.135-.135a.688.688 0 0 0-.703.648l-.324 9.454c0 .19.054.351.19.486a.678.678 0 0 0 .486.217.663.663 0 0 0 .675-.65l.324-9.452a.65.65 0 0 0-.19-.487c-.107-.135-.27-.189-.458-.216\"/></g></svg>"

/***/ }),

/***/ "JIqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/filters.js
var filters = __webpack_require__("rm9P");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/table-column-date.vue




var formatDate = filters["a" /* default */].formatDate,
    formatDateFromNow = filters["a" /* default */].formatDateFromNow;


/* harmony default export */ var table_column_date = ({
  props: {
    label: {
      type: String,
      default: 'Дата'
    },
    width: {
      default: 220
    },
    fromNow: {
      type: Boolean,
      default: false
    },
    fromNowRemoveSuffix: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dateFormatter: function dateFormatter(row, column, cellValue, index) {
      return cellValue ? this.fromNow ? formatDateFromNow(cellValue, this.fromNowRemoveSuffix) : formatDate(cellValue) : '–';
    },
    getNestedValue: function getNestedValue(obj, path) {
      return path.split('.').reduce(function (acc, part) {
        return acc && acc[part];
      }, obj);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f2b2f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-date.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-column-element',_vm._g(_vm._b({attrs:{"label":_vm.label,"width":_vm.width,"prop":_vm.$attrs.prop || 'date',"formatter":_vm.dateFormatter},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(_vm.dateFormatter(scope.row, scope.column, _vm.getNestedValue(scope.row, scope.column.property), scope.$index))+"\n  ")]}}])},'table-column-element',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/table-column-date.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_column_date,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_column_date = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JR9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/components/tooltip.vue + 2 modules
var tooltip = __webpack_require__("I/hk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/index.vue




/* harmony default export */ var machines = ({
  components: { Tooltip: tooltip["default"] },
  metaInfo: { title: 'Автоматы' },
  data: function data() {
    return {
      filtersValue: null,
      data: null,
      loading: false,
      hasMore: true,
      sort: null
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var sortable = sort.column.sortable;
        var prop = sortable === 'keyword' ? sort.prop + '.keyword' : sortable === 'custom' ? sort.prop : sortable;
        this.sort = prop + ':' + order;
      } else {
        this.sort = null;
      }
    },
    loadMore: function loadMore() {
      this.$refs.data.loadMore();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b02921b2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machines-index d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"machines","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("\n        Автоматы\n      ")]),_vm._v(" "),(_vm.data)?_c('machine-list-map-tabs',{staticClass:"mx-2"}):_vm._e(),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"machines"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"sort-change":_vm.sortChange,"load-more":_vm.loadMore}},[_c('table-column-serial-number',{attrs:{"sortable":"keyword","fixed":true}}),_vm._v(" "),(_vm.$root.checkPermission('web_modems'))?_c('el-table-column',{attrs:{"prop":"modem.uid","label":"","width":"30"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.modem)?_c('tooltip',{attrs:{"title":("" + (row.modem.uid))}},[_c('router-link',{staticClass:"text-body",attrs:{"to":("/modems/" + (row.modem.uid))}},[_c('font-awesome-icon',{attrs:{"icon":"wifi"}})],1)],1):_vm._e()]}}],null,false,3248743306)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"Состояние","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('status-images',{attrs:{"value":row.status,"reasons":row.downtimes_reasons}})]}}],null,false,252078816)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modem.battery","sortable":"custom","label":"Оператор","align":"left","min-width":"105"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.modem && row.modem.data && row.modem.data.operator && row.modem.data.signal)?_c('div',[_vm._v("\n            "+_vm._s(row.modem.data.operator)+" ("+_vm._s(row.modem.data.signal)+")\n          ")]):_c('div',[_vm._v("unknown")])]}}],null,false,2441012397)}),_vm._v(" "),_c('table-column-date',{attrs:{"prop":"downtimes_since.sales","label":"Без продаж","min-width":"120","width":"","from-now":"","from-now-remove-suffix":true,"sortable":"last_sale_at"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"model.name","sortable":"keyword","label":"Модель","min-width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","sortable":"keyword","label":"Адрес","show-overflow-tooltip":true,"min-width":"260"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modem.battery","sortable":"custom","label":"Батарея","align":"center","min-width":"105"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.modem)?_c('div',[(row.modem.battery !== null)?_c('div',{class:row.modem.battery < 40 ? 'text-danger' : ''},[_vm._v("\n              "+_vm._s(row.modem.battery)+" %\n            ")]):_c('div',[_vm._v("–")])]):_c('div',[_vm._v("модем не подключен")])]}}],null,false,2672546910)}),_vm._v(" "),_c('table-column-number',{attrs:{"prop":"coins_sum","sortable":"custom","label":"Монеты","align":"center","min-width":"100"}}),_vm._v(" "),_c('table-column-number',{attrs:{"prop":"banknotes_sum","sortable":"custom","label":"Купюры","align":"center","min-width":"100"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  machines,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_machines = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JiJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-json-pretty/vue-json-pretty.js
var vue_json_pretty = __webpack_require__("RKAd");
var vue_json_pretty_default = /*#__PURE__*/__webpack_require__.n(vue_json_pretty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/modems/index/broadcasts/index.vue




/* harmony default export */ var broadcasts = ({
  metaInfo: { title: 'Рассылки' },
  components: { VueJsonPretty: vue_json_pretty_default.a },
  data: function data() {
    return {
      data: {},
      loading: false,
      hasMore: true,
      filtersValue: {}
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca59184","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/modems/index/broadcasts/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-grow-1"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"modems/broadcasts","loading":_vm.loading,"hasMore":_vm.hasMore,"filtersValue":_vm.filtersValue},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('vue-json-pretty',{attrs:{"data":row.filters}})]}}],null,false,3511669576)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Тип","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/modems/broadcasts/" + (row.id))},domProps:{"textContent":_vm._s(row.type)}})]}}],null,false,1557721738)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"Пользователь","min-width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm._f("fullName")(row.user)))]}}],null,false,1019226531)}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","prop":"commands_count","label":"Отправлено команд","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"Дата рассылки","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.requested_at)?_c('div',[_vm._v(_vm._s(_vm._f("formatDate")(row.requested_at)))]):_c('div',[_vm._v("В ожидании")])]}}],null,false,2431329442)}),_vm._v(" "),_c('table-column-date',{attrs:{"label":"Назначенная дата"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/modems/index/broadcasts/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  broadcasts,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var index_broadcasts = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JohW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K+Zy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/btn-action.vue



/* harmony default export */ var btn_action = ({
  name: 'BtnAction',
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    success: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    error: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    delay: {
      type: Number,
      default: function _default() {
        return 1000;
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    handleClick: function handleClick() {
      var _$listeners,
          _this = this;

      var res = (_$listeners = this.$listeners).click.apply(_$listeners, arguments);

      if (!(res instanceof promise_default.a)) {
        this.loading = false;
        return this.success();
      }

      this.loading = true;
      res.then(function () {
        setTimeout(function () {
          _this.loading = false;
        }, _this.delay);
        _this.success();
      }, function (e) {
        setTimeout(function () {
          _this.loading = false;
        }, _this.delay);
        _this.error();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4618609a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/btn-action.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{loading: _vm.loading},attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/btn-action.vue
function injectStyle (context) {
  __webpack_require__("gezW")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  btn_action,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_btn_action = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K1AT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/select2/dist/js/select2.js
var select2 = __webpack_require__("hv7s");
var select2_default = /*#__PURE__*/__webpack_require__.n(select2);

// EXTERNAL MODULE: ./node_modules/select2/dist/js/i18n/ru.js
var ru = __webpack_require__("i1lH");
var ru_default = /*#__PURE__*/__webpack_require__.n(ru);

// EXTERNAL MODULE: ./resources/assets/js/components/filter-terms.vue + 1 modules
var filter_terms = __webpack_require__("HRc9");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-select.vue










/* harmony default export */ var filter_select = ({
  name: 'FilterSelect',
  extends: filter_terms["default"],
  data: function data() {
    return {
      select2Defaults: {
        escapeMarkup: function escapeMarkup(markup) {
          return markup;
        },
        templateResult: function templateResult(item) {
          if (item.loading) return item.text;
          if (item.label && item.count !== undefined) {
            return '<div class="d-flex align-items-center justify-content-between">\n                      <span class="mr-2">' + item.label + '</span>\n                      <small class="filter-bucket-size font-weight-bold">' + item.count + '</small>\n                    </div>';
          }
          if (item.element) {
            return item.element.innerHTML;
          }
        },
        templateSelection: function templateSelection(item) {
          if (item.label && item.count !== undefined) {
            return '<div class="d-flex align-items-center justify-content-between">\n                      <span class="mr-2">' + item.label + '</span>\n                      <small class="filter-bucket-size font-weight-bold">' + item.count + '</small>\n                    </div>';
          }
          if (item.element) {
            return item.element.innerHTML;
          }
        }
      }
    };
  },
  computed: {
    $$el: function $$el() {
      return jquery_default()(this.$el);
    },
    select2Options: function select2Options() {
      return this.select2Defaults;
    }
  },
  mounted: function mounted() {
    this.initSelect2();
    this.$$el.on('change', this.onChange);
  },

  methods: {
    initSelect2: function initSelect2() {
      this.$$el.select2(this.select2Options);
    },
    destroySelect2: function destroySelect2() {
      this.$$el.select2('destroy');
    },
    onTermsChange: function onTermsChange(newTerms, oldTerms) {
      var _this = this;

      if (!isEqual_default()(newTerms, oldTerms)) {
        this.$nextTick(function () {
          var keepHeight = _this.$$el.parent().css('height');
          var restoreHeight = _this.$el.parentNode.style.height;
          _this.$$el.parent().css('height', keepHeight);
          _this.destroySelect2();
          _this.initSelect2();
          _this.$$el.parent().css('height', restoreHeight);
        });
      }
    },
    onChange: function onChange() {
      this.updateSelected();
    },

    updateSelected: debounce_default()(function () {
      this.selected = this.$$el.val();
    }, 10)
  },
  watch: {
    value: function value(input) {
      if (input.length === 0) {
        this.$$el.empty().trigger('change');
      }
    },
    terms: function terms(newTerms, oldTerms) {
      this.onTermsChange(newTerms, oldTerms);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroySelect2();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc3239fc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-select.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"filter-select form-control",attrs:{"multiple":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.terms),function(term){return _c('option',{key:term.value,attrs:{"disabled":term.count === 0 && _vm.selected.indexOf(term.value) === -1},domProps:{"selected":_vm.selected.indexOf(term.value) !== -1,"value":term.value}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(term.label))]),_vm._v(" "),_c('small',{staticClass:"filter-bucket-size font-weight-bold"},[_vm._v(_vm._s(term.count))])])}),0)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-select.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_select,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_select = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K2Id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/limits/edit-modal.vue




/* harmony default export */ var edit_modal = ({
  props: ['value', 'currentMachine', 'ids'],
  watch: {},
  computed: {
    machine: function machine() {
      return this.currentMachine || {};
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      return api["a" /* default */].post('limits/', {
        ids: this.ids || [this.machine.id],
        banknotes_count_threshold: this.machine.banknotes_count_threshold,
        coins_tube_threshold: this.machine.coins_tube_threshold,
        coins_tube_threshold_after_service: this.machine.coins_tube_threshold_after_service,
        coins_summary_threshold: this.machine.coins_summary_threshold,
        coins_summary_threshold_after_service: this.machine.coins_summary_threshold_after_service,
        service_interval_threshold: this.machine.service_interval_threshold,
        no_sales_time_threshold: this.machine.no_sales_time_threshold,
        no_banknote_time_threshold: this.machine.no_banknote_time_threshold,
        no_coin_time_threshold: this.machine.no_coin_time_threshold,
        temperature_low_threshold: this.machine.temperature_low_threshold,
        temperature_high_threshold: this.machine.temperature_high_threshold
      }).then(function () {
        return _this.$emit('hide', _this.machine);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff90c8c2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/limits/edit-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-settings-limits-edit modal-dialog modal-dialog-centered modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Лимиты")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('hide')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог количества купюр в автомате, шт.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.banknotes_count_threshold),expression:"machine.banknotes_count_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.banknotes_count_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "banknotes_count_threshold", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог монет на тубу, шт.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.coins_tube_threshold),expression:"machine.coins_tube_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.coins_tube_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "coins_tube_threshold", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог монет на тубу после сервиса, шт.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.coins_tube_threshold_after_service),expression:"machine.coins_tube_threshold_after_service"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.coins_tube_threshold_after_service)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "coins_tube_threshold_after_service", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на сумму монет, руб.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.coins_summary_threshold),expression:"machine.coins_summary_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.coins_summary_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "coins_summary_threshold", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на сумму монет после сервиса, руб.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.coins_summary_threshold_after_service),expression:"machine.coins_summary_threshold_after_service"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.coins_summary_threshold_after_service)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "coins_summary_threshold_after_service", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Минимальная периодичность обслуживания, дни.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.service_interval_threshold),expression:"machine.service_interval_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.service_interval_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "service_interval_threshold", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на простой без продаж, ч.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.no_sales_time_threshold),expression:"machine.no_sales_time_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.no_sales_time_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "no_sales_time_threshold", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на простой без купюр, ч.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.no_banknote_time_threshold),expression:"machine.no_banknote_time_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.no_banknote_time_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "no_banknote_time_threshold", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на простой без монет, ч.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.no_coin_time_threshold),expression:"machine.no_coin_time_threshold"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.machine.no_coin_time_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "no_coin_time_threshold", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на низкую температуру, C.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.temperature_low_threshold),expression:"machine.temperature_low_threshold"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.machine.temperature_low_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "temperature_low_threshold", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Порог на высокую температуру, C.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.machine.temperature_high_threshold),expression:"machine.temperature_high_threshold"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.machine.temperature_high_threshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.machine, "temperature_high_threshold", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Отмена")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/limits/edit-modal.vue
function injectStyle (context) {
  __webpack_require__("rXtC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  edit_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var limits_edit_modal = (Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/admin/limits.vue





/* harmony default export */ var limits = ({
  metaInfo: { title: 'Пороговые значения' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      moment: __webpack_require__("PJh5"),
      selected: [],
      sort: null
    };
  },

  methods: {
    edit: function edit(machine) {
      this.$root.showModal(limits_edit_modal, {
        currentMachine: machine
      });
    },
    editGroup: function editGroup(ids) {
      var _this = this;

      this.$root.showModal(limits_edit_modal, {
        ids: this.selected.map(function (o) {
          return o['id'];
        }),
        currentMachine: this.getLimitForSelected()
      }).then(function (newLimit) {
        newLimit && _this.selected.forEach(function (machine) {
          for (var key in newLimit) {
            machine[key] = newLimit[key];
          }
        });
      });
    },
    getLimitForSelected: function getLimitForSelected() {
      var limit = {
        banknotes_count_threshold: true,
        coins_tube_threshold: true,
        coins_tube_threshold_after_service: true,
        coins_summary_threshold: true,
        coins_summary_threshold_after_service: true,
        service_interval_threshold: true,
        no_sales_time_threshold: true,
        no_banknote_time_threshold: true,
        no_coin_time_threshold: true,
        temperature_low_threshold: true,
        temperature_high_threshold: true
      };
      for (var i = 1; i < this.selected.length; i++) {
        for (var key in limit) {
          limit[key] = limit[key] && isEqual_default()(this.selected[i][key], this.selected[i - 1][key]);
        }
      }

      var sameLimit = {};
      for (var key in limit) {
        if (limit[key]) {
          sameLimit[key] = this.selected[0][key];
        }
      }
      return sameLimit;
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var keyword = sort.column.sortable === 'keyword' ? '.keyword' : '';
        this.sort = sort.prop + keyword + ':' + order;
      } else {
        this.$emit('update:sort', null);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738c3648","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/limits.vue
var limits_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"limits","filtersValue":_vm.filtersValue,"loading":_vm.loading,"sort":_vm.sort,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h1',{staticClass:"mr-3"},[_vm._v("Пороговые значения")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected && _vm.selected.length),expression:"selected && selected.length"}],staticClass:"btn btn-outline-secondary btn-sm mr-auto",on:{"click":function($event){return _vm.editGroup()}}},[_vm._v("\n        Редактировать выбранные\n        "),_c('span',{staticClass:"badge badge-dark"},[_vm._v(_vm._s(_vm.selected.length))])]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"limits"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"sort-change":_vm.sortChange,"selection-change":function (selection) {this$1.selected = selection},"row-click":function (row) { return _vm.edit(row); }}},[_c('table-column-serial-number',{attrs:{"sortable":"keyword"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","type":"selection"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"coins_tube_threshold","label":"Монет на тубу, шт."}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"coins_tube_threshold_after_service","label":"Монет на тубу после сервиса, шт."}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"coins_summary_threshold","label":"Сумма монет, руб."}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"coins_summary_threshold_after_service","label":"Сумма монет после сервиса, руб."}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"no_sales_time_threshold","label":"Простой без продаж, ч"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"no_banknote_time_threshold","label":"Простой без купюр, ч"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"no_coin_time_threshold","label":"Простой без монет, ч"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"banknotes_count_threshold","label":"Количество купюр, шт."}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"temperature_low_threshold","label":"Низкая температура, C"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"temperature_high_threshold","label":"Высокая температура, C"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"service_interval_threshold","label":"Мин. период обслуж-я, дни"}})],1)]:_vm._e()],2)}
var limits_staticRenderFns = []

// CONCATENATED MODULE: ./resources/assets/js/pages/admin/limits.vue
/* script */


/* template */

/* template functional */
var limits___vue_template_functional__ = false
/* styles */
var limits___vue_styles__ = null
/* scopeId */
var limits___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var limits___vue_module_identifier__ = null

var limits_Component = Object(component_normalizer["a" /* default */])(
  limits,
  limits_render,
  limits_staticRenderFns,
  limits___vue_template_functional__,
  limits___vue_styles__,
  limits___vue_scopeId__,
  limits___vue_module_identifier__
)

/* harmony default export */ var admin_limits = __webpack_exports__["default"] = (limits_Component.exports);


/***/ }),

/***/ "K5eC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-depositing-money.vue





/* harmony default export */ var filter_event_depositing_money = ({
  props: {
    range: { type: Object },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    header: { type: String }
  },
  data: function data() {
    return {
      event: {
        number: this.value.number || {},
        date: this.value.date || {}
      },
      money: this.value.moneyRange || {}
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      return omitBy_default()({
        number: this.event.number,
        date: this.event.date,
        moneyRange: this.money
      }, isEmpty_default.a);
    }
  },
  watch: {
    value: function value(input) {
      this.event = {
        number: input.number || {},
        date: input.date || {}
      };
      this.money = input.moneyRange || {};
    },

    preparedInput: {
      handler: function handler(newVal, oldVal) {
        if (!isEqual_default()(newVal, oldVal)) {
          this.$emit('input', this.preparedInput);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21cffcc0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-depositing-money.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('filter-range',{model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-depositing-money.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_depositing_money,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_depositing_money = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KAfx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KBW/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KyxZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNERDQzMzYiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNi4wNDIgMTIuMzA4YzAgLjMwNiA0LjkyNSAxLjc5MyA0LjkyNSAxLjc5M1M5IDIyLjI4IDkuMjk3IDIyLjI4Yy4yOTggMCA1LjU5LTYuMjAyIDUuNTktNi4yMDJMOC4zOTcgOS42MDZTNi4wNDIgMTIgNi4wNDIgMTIuMzA4ek05LjU0OCA4LjI4bDYuNDY0IDYuNTEyczIuNjExLTIuNjQ2IDIuNDY1LTIuODQ4Yy0uMTQ2LS4yMDEtNS4wNjktMS4wOTgtNS4wNjktMS4wOThzMS43NDEtOC4zNTMgMS41MTItOC40OTdjLS4yMjgtLjE0NC01LjM3MiA1LjkzLTUuMzcyIDUuOTN6TTYgNi40NzRsMTEuNzkgMTEuODE3LjU4Ni0uNTg2TDYuNTg2IDUuODg4eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "L4zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("kvU2");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/receipts/index.vue







/* harmony default export */ var receipts = ({
  metaInfo: { title: 'Чеки' },
  data: function data() {
    return {
      filtersValue: extends_default()({}, this.$route.query.missed ? { missed: this.$route.query.missed } : { missed: false }, this.$route.query.machine_id ? { machine_id: this.$route.query.machine_id } : {}),
      data: {},
      loading: false,
      hasMore: true,
      sort: null,
      date: [moment_default()().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment_default()().endOf('day').format('YYYY-MM-DDTHH:mm:ss')],
      pickerOptions: {
        firstDayOfWeek: 1
      },
      inn: null,
      fsNumber: null,
      external: null
    };
  },

  computed: {
    statusFilters: function statusFilters() {
      return 'allow_statuses' in this.data ? cloneDeep_default()(this.data.allow_statuses) : [];
    },
    externalData: function externalData() {
      var data = {};
      if (this.inn) data.inn = this.inn;
      if (this.fsNumber) data.fs_number = this.fsNumber;
      return data;
    }
  },
  methods: {
    filterChange: function filterChange(filter) {
      this.filtersValue = assign_default()({}, this.filtersValue, filter);
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.sort = sort.prop + ':' + order;
      } else {
        this.sort = null;
      }
    },
    save: function save() {
      this.external = this.externalData;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2de96c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/receipts/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"receipts","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"date":_vm.date,"externalFilters":_vm.external},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid d-flex align-items-center"},[_c('h1',{staticClass:"page-heading mr-auto"},[_vm._v("Чеки")]),_vm._v(" "),_c('div',{staticClass:"input-group mr-1",staticStyle:{"max-width":"15em"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inn),expression:"inn"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.inn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mr-1",staticStyle:{"max-width":"27em"}},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fsNumber),expression:"fsNumber"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.fsNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fsNumber=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary mr-3",on:{"click":_vm.save}},[_vm._v("Применить")]),_vm._v(" "),_c('el-date-picker',{staticClass:"mr-2",attrs:{"type":"datetimerange","clearable":false,"value-format":"yyyy-MM-ddTHH:mm:ss","default-time":['00:00:00', '23:59:59'],"align":"right","range-separator":"–","picker-options":_vm.pickerOptions,"size":"small"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"filter-change":_vm.filterChange,"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('receipt-details',{attrs:{"receipt":row}})]}}],null,false,3273149258)}),_vm._v(" "),_c('table-column-serial-number',{attrs:{"sortable":"custom","machine-prop":"machine"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Статус","filters":_vm.data.allow_statuses,"filter-placement":"bottom-start","column-key":"status","width":"120","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"check_data.payment_type","label":"Тип оплаты","filters":_vm.data.payment.types,"filter-placement":"bottom-start","column-key":"payment_type","width":"120","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"kkt","label":"ККТ","filters":_vm.data.kkt,"filter-placement":"bottom-start","column-key":"kkt","width":"120","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"custom","prop":"product_name","label":"Продукт"}}),_vm._v(" "),_c('table-column-number',{attrs:{"sortable":"custom","prop":"price","label":"Цена, руб.","align":"center"}}),_vm._v(" "),_c('table-column-date',{attrs:{"prop":"created_at","label":"Время","align":"right"}})],1)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("ИНН")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Номер фискального накопителя")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/receipts/index.vue
function injectStyle (context) {
  __webpack_require__("4Ufk")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  receipts,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_receipts = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LY4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/schedule/editor.vue + 2 modules
var editor = __webpack_require__("m44z");

// EXTERNAL MODULE: ./resources/assets/js/components/btn-action.vue + 2 modules
var btn_action = __webpack_require__("K+Zy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/cards.vue








/* harmony default export */ var cards = ({
  components: { BtnAction: btn_action["default"], ScheduleEditor: editor["a" /* default */] },
  props: {
    id: {
      required: true
    },
    machine: {
      type: Object
    }
  },
  data: function data() {
    return {
      selected: this.machine.cards || '',
      schedule: this.machine.cards_schedule
    };
  },

  asyncComputed: {
    options: function options() {
      return api["a" /* default */].get('cards').then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  },
  computed: {
    formattedSelected: function formattedSelected() {
      return this.selected || null;
    },
    isDirty: function isDirty() {
      return this.formattedSelected !== this.machine.cards || this.selected && !isEqual_default()(this.schedule, this.machine.cards_schedule);
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      var data = { cards: this.formattedSelected };
      if (data.cards) data.cards_schedule = this.schedule;

      return api["a" /* default */].put('machines/' + this.id, data).then(function () {
        _this.machine.cards = _this.formattedSelected;
        _this.machine.cards_schedule = _this.schedule;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137bfeae","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/cards.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"page-heading"},[_vm._v("Магнитные карты")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.options)?_c('div',[_c('div',{staticClass:"form-group",staticStyle:{"max-width":"20em"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control custom-select",attrs:{"id":"select-cards"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Нет")]),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option}},[_vm._v(_vm._s(option))])})],2)]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"card mb-4"},[_c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Расписание отправки")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('schedule-editor',{attrs:{"withMinutes":"true"},model:{value:(_vm.schedule),callback:function ($$v) {_vm.schedule=$$v},expression:"schedule"}})],1)]):_vm._e(),_vm._v(" "),_c('btn-action',{staticClass:"btn",class:{'btn-primary': _vm.isDirty},attrs:{"disabled":!_vm.isDirty},domProps:{"textContent":_vm._s('Сохранить')},on:{"click":_vm.save}})],1):_vm._e()])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/cards.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  cards,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _id_cards = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LaBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/maxBy.js
var maxBy = __webpack_require__("K1hn");
var maxBy_default = /*#__PURE__*/__webpack_require__.n(maxBy);

// EXTERNAL MODULE: ./resources/assets/js/components/filter-range.vue + 2 modules
var filter_range = __webpack_require__("gRN3");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-range-slider.vue




/* harmony default export */ var filter_range_slider = ({
  name: 'FilterRangeSlider',
  extends: filter_range["default"],
  props: {
    histogram: {}
  },
  data: function data() {
    return {
      sliderInput: [this.range.min, this.range.max]
    };
  },

  computed: {
    histogramMax: function histogramMax() {
      if (this.histogram) {
        var bucket = maxBy_default()(this.histogram, 'doc_count');
        return bucket.doc_count;
      }
    }
  },
  methods: {
    histogramBucketHeight: function histogramBucketHeight(bucket) {
      return bucket.doc_count / this.histogramMax * 100 + '%';
    }
  },
  watch: {
    sliderInput: function sliderInput(input) {
      this.input = { min: input[0], max: input[1] };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6faf1b76","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-range-slider.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-range-slider"},[(_vm.histogram)?_c('div',{staticClass:"filter-range-slider-histogram d-flex align-items-end"},_vm._l((_vm.histogram),function(bucket){return _c('div',{staticClass:"bg-light col",style:({ height: _vm.histogramBucketHeight(bucket) })})}),0):_vm._e(),_vm._v(" "),_c('el-slider',{attrs:{"range":"","min":_vm.range.min,"max":_vm.range.max,"height":"0px"},model:{value:(_vm.sliderInput),callback:function ($$v) {_vm.sliderInput=$$v},expression:"sliderInput"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-range-slider.vue
function injectStyle (context) {
  __webpack_require__("0Utu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_range_slider,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_range_slider = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LiQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/recipes/products/_id.vue




/* harmony default export */ var _id = ({
  metaInfo: function metaInfo() {
    var productName = this.product ? this.product.name : '';
    return { title: '\u0420\u0435\u0446\u0435\u043F\u0442\u0443\u0440\u0430 ' + productName };
  },
  data: function data() {
    return {};
  },

  asyncComputed: {
    product: function product() {
      return api["a" /* default */].get('products/' + this.$route.params.id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68a19458","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/recipes/products/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.product)?[_c('div',{staticClass:"d-flex align-items-center"},[_c('back-button',{staticClass:"mr-2",attrs:{"to":"/settings/recipes/products"}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.product.name))])],1),_vm._v(" "),_c('div',{staticClass:"table-full-width"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.product.components),function(component){return _c('tr',[(component.component)?[_c('td',[_vm._v(_vm._s(component.component.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(component.amount)+" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(component.component.measure))])])]:_c('td',{attrs:{"colspan":"2"}},[_c('small',[_c('samp',{staticClass:"text-muted",attrs:{"data-title":"Некорректная ссылка","data-toggle":"tooltip","data-placement":"right"}},[_vm._v("\n              "+_vm._s(component.component_id)+"\n            ")])])])],2)}),0)])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Ингредиент")]),_vm._v(" "),_c('th',[_vm._v("Количество")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/recipes/products/_id.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LoEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/help-tooltip.vue


/* harmony default export */ var help_tooltip = ({
  name: 'help-tooltip',
  props: {
    title: {
      type: String
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19416360","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/help-tooltip.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{staticClass:"help-tooltip",attrs:{"title":_vm.title,"placement":_vm.placement}},[_c('img',{staticClass:"help-tooltip-img",attrs:{"src":__webpack_require__("rtCK")}})])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/help-tooltip.vue
function injectStyle (context) {
  __webpack_require__("s7J1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  help_tooltip,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_help_tooltip = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MCn0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/query-encoder.js
var query_encoder = __webpack_require__("jhtD");

// EXTERNAL MODULE: ./resources/assets/js/components/btn-action.vue + 2 modules
var btn_action = __webpack_require__("K+Zy");

// EXTERNAL MODULE: ./resources/assets/js/components/dsl-modal.vue + 2 modules
var dsl_modal = __webpack_require__("43gl");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/index.vue








/* harmony default export */ var _id = ({
  components: { BtnAction: btn_action["default"] },
  props: {
    id: {
      required: true
    },
    machine: {
      type: Object
    }
  },
  data: function data() {
    return {
      sendReceipts: this.machine.send_cash_receipts,
      moment: moment_default.a,
      showGraph: 'week'
    };
  },

  methods: {
    close: function close(event) {
      var _this = this;

      return api["a" /* default */].put('events/' + event.id, {
        approved: true
      }).then(function (data) {
        _this.machine.special_events[event.code] = data.data;
      });
    },
    approveStopDefects: function approveStopDefects() {
      var _this2 = this;

      return api["a" /* default */].put('events/approve', {
        machine_id: this.machine.id
      }).then(function (data) {
        _this2.machine.special_events.stop = false;
      });
    },
    openDslModal: function openDslModal() {
      this.$root.showModal(dsl_modal["default"], {
        matrix: this.machine.matrix,
        isCoffee: this.machine.model ? this.machine.model.type.name !== 'Снековый' : false,
        modemUid: this.machine.modem.uid
      });
    },
    categoryColor: function categoryColor() {
      var color = get_default()(this.machine, 'category.color', false);
      var style = "";
      if (color) {
        style = "color: " + color + ";";
      }
      return style;
    },
    saveSendReceipts: function saveSendReceipts() {
      var _this3 = this;

      var data = { send_cash_receipts: this.sendReceipts };

      return api["a" /* default */].post('machines/' + this.id + '/send_cash_receipts', data).then(function () {
        _this3.machine.send_cash_receipts = _this3.sendReceipts;
      });
    }
  },
  computed: {
    filterQuery: function filterQuery() {
      return '?filters=' + Object(query_encoder["b" /* encode */])({
        serial_number: [{
          label: this.machine.serial_number,
          value: this.machine.serial_number
        }]
      });
    },
    canDsl: function canDsl() {
      return ['admin', 'service_superior'].includes(get_default()(this.$root.user, 'role.name'));
    }
  },
  asyncComputed: {
    services: function services() {
      return api["a" /* default */].get('services/last/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  },
  watch: {
    sendReceipts: function sendReceipts() {
      this.saveSendReceipts();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a1355d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"page-heading"},[_c('back-button',{attrs:{"to":"/machines"}}),_vm._v("\n    Общее\n    "),_c('status-images',{staticClass:"ml-3",staticStyle:{"display":"inline-block","vertical-align":"middle","margin-top":"-15px","margin-bottom":"-15px"},attrs:{"value":_vm.machine.status,"reasons":_vm.machine.downtimes_reasons}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Номер")]),_vm._v("\n              "+_vm._s(_vm.machine.serial_number + ' (' + _vm.machine.number + ')')+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Тип")]),_vm._v("\n              "+_vm._s(_vm._f("get")(_vm.machine,'model.type.name', '-'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Производитель")]),_vm._v("\n              "+_vm._s(_vm._f("get")(_vm.machine,'creator.name', '-'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Модель")]),_vm._v("\n              "+_vm._s(_vm._f("get")(_vm.machine,'model.name', '-'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Передача чеков")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row"},[_c('div',{staticClass:"mr-3"},[_vm._v("\n              "+_vm._s(_vm._f("get")(_vm.machine,'creator.name', 'JOFEMAR') != 'JOFEMAR' ? 'Да' : 'Нет')+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"ml-3"},[(_vm.$root.isAdmin())?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendReceipts),expression:"sendReceipts"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.sendReceipts)?_vm._i(_vm.sendReceipts,null)>-1:(_vm.sendReceipts)},on:{"change":function($event){var $$a=_vm.sendReceipts,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.sendReceipts=$$a.concat([$$v]))}else{$$i>-1&&(_vm.sendReceipts=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.sendReceipts=$$c}}}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Группа ККТ")]),_vm._v("\n              "+_vm._s(_vm._f("get")(_vm.machine,'receipt_group', '-'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Тип места установки")]),_vm._v("\n              "+_vm._s(_vm._f("get")(_vm.machine,'location_type.name', '-'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2 col-sm-6"},[_c('label',[_vm._v("Дата ввода в эксплуатацию")]),_vm._v("\n              "+_vm._s(_vm._f("formatDate")(_vm.machine.start_time,'DD.MM.YYYY'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-4"},[_c('label',[_vm._v("Адрес")]),_vm._v("\n              "+_vm._s(_vm.machine.address)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2"},[_c('label',[_vm._v("Локация")]),_vm._v("\n              "+_vm._s(_vm.machine.situation_label)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-2"},[_c('label',[_vm._v("Категория")]),_vm._v(" "),_c('div',{style:(_vm.categoryColor())},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'category.name', '-')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('router-link',{staticClass:"field-show col-md-4",class:{'field-show-link': _vm.$root.checkPermission('web_downtime')},attrs:{"to":_vm.$root.checkPermission('web_downtime') ? '/reports/downtime' + _vm.filterQuery : '',"tag":_vm.$root.checkPermission('web_downtime') ? 'a' : 'div'}},[_c('label',[_c('span',[_vm._v("Простой без продаж")]),_vm._v(" "),(_vm.$root.checkPermission('web_downtime'))?_c('font-awesome-icon',{staticClass:"field-show-link-icon",attrs:{"icon":"angle-right"}}):_vm._e()],1),_vm._v(" "),_c('date-from-now',{attrs:{"date":_vm.machine.downtimes_since.sales,"no-suffix":true}})],1),_vm._v(" "),_c('div',{staticClass:"field-show col-md-4"},[_c('label',[_vm._v("Простой без купюр")]),_vm._v(" "),_c('date-from-now',{attrs:{"date":_vm.machine.downtimes_since.banknotes,"no-suffix":true}})],1),_vm._v(" "),_c('div',{staticClass:"field-show col-md-4"},[_c('label',[_vm._v("Простой без монет")]),_vm._v(" "),_c('date-from-now',{attrs:{"date":_vm.machine.downtimes_since.coins,"no-suffix":true}})],1)],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3",staticStyle:{"min-width":"20em"}},[(_vm.machine.modem)?_c('div',[_c('div',{staticClass:"alert",class:_vm.machine.is_online? 'alert-success' : 'alert-danger'},[_c('strong',[_vm._v("Связь:")]),_vm._v(" "+_vm._s(_vm.machine.is_online ? 'есть' : 'нет')+"\n          "),_c('strong',{staticClass:"ml-3"},[_vm._v("Тип:")]),_vm._v(" "+_vm._s(_vm.machine.modem.netinterface)+"\n          "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Пинг:")]),_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.machine.last_ping_at))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('strong',[_vm._v("Заряд батареи:")]),_vm._v(" "),(_vm.machine.modem.battery !== null)?_c('span',[_vm._v(_vm._s(_vm.machine.modem.battery)+" %")]):_c('span',[_vm._v("–")])]),_vm._v(" "),(_vm.machine.modem.made_in === 'russia')?_c('div',{staticClass:"alert",class:_vm.machine.modem.case ? 'alert-success' : 'alert-danger'},[_c('strong',[_vm._v("Корпус модема")]),_vm._v(" "+_vm._s(_vm.machine.modem.case ? 'закрыт' : 'открыт')+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.machine.modem.electricity)?_c('div',{staticClass:"alert alert-danger"},[_c('strong',[_vm._v("Ошибка питания 220В")])]):_vm._e()]):_c('div',{staticClass:"alert alert-danger"},[_vm._v(" модем не подключен")]),_vm._v(" "),(_vm.machine.special_events.shake)?_c('div',{staticClass:"alert alert-danger alert-dismissible"},[_c('btn-action',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function () { return _vm.close(_vm.machine.special_events.shake); }}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('strong',[_vm._v("Автомат трясли")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.machine.special_events.shake.date)))])],1):_vm._e(),_vm._v(" "),(_vm.machine.special_events.temperature)?_c('div',{staticClass:"alert alert-danger alert-dismissible"},[_c('btn-action',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function () { return _vm.close(_vm.machine.special_events.temperature); }}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('strong',[_vm._v("Отклонение от норм температуры")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.machine.special_events.temperature.date)))])],1):_vm._e(),_vm._v(" "),(_vm.machine.special_events.stop)?_c('div',{staticClass:"alert alert-danger alert-dismissible"},[_c('btn-action',{staticClass:"close",attrs:{"aria-label":"Close"},on:{"click":function () { return _vm.approveStopDefects(); }}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('strong',[_vm._v("Остановка автомата по причине неисправности")]),_vm._v(" "),_c('br')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9 mb-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header d-flex align-items-center mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-light",class:{'active': _vm.showGraph==='hour'},on:{"click":function($event){_vm.showGraph='hour'}}},[_vm._v("24 часа")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light",class:{'active': _vm.showGraph==='week'},on:{"click":function($event){_vm.showGraph='week'}}},[_vm._v("7 дней")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light",class:{'active': _vm.showGraph==='month'},on:{"click":function($event){_vm.showGraph='month'}}},[_vm._v("30 дней")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"machine show-graphs"},[(_vm.showGraph)?_c('graph',{attrs:{"endpoint":("machines/" + (this.id) + "/sales"),"period":_vm.showGraph}}):_vm._e()],1),_vm._v(" "),(_vm.$root.checkPermission('web_sales'))?_c('div',[_c('router-link',{attrs:{"to":'/reports/sales' + _vm.filterQuery}},[_vm._v("Подробнее…")])],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 mb-4"},[_c('div',{staticClass:"card h-100 d-flex"},[_c('h3',{staticClass:"card-header d-flex align-items-center"},[_c('span',{staticClass:"text-caps"},[_vm._v("События")]),_vm._v(" "),(_vm.canDsl)?_c('button',{staticClass:"btn btn-sm btn-outline-primary ml-auto",attrs:{"disabled":!_vm.machine.modem},on:{"click":_vm.openDslModal}},[_vm._v("Выдача продукта")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 position-relative",staticStyle:{"min-height":"220px"}},[_c('div',{staticClass:"h-100 w-100",staticStyle:{"position":"absolute","overflow-y":"auto","max-height":"100%"}},[_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"w-100 table-sm px-0"},_vm._l((_vm.machine.last_events),function(event){return _c('tr',[_c('td',{staticClass:"border-bottom"},[_c('strong',[_vm._v(_vm._s(event.message))])]),_vm._v(" "),_c('td',{staticClass:"border-bottom text-right",attrs:{"width":"100","valign":"top"}},[_c('small',[_c('date-from-now',{attrs:{"date":event.date,"no-suffix":true}})],1)])])}),0),_vm._v(" "),(_vm.$root.checkPermission('web_events'))?_c('div',[_c('router-link',{attrs:{"to":'/reports/events' + _vm.filterQuery}},[_vm._v("Подробнее…")])],1):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.services)?_c('div',{staticClass:"card mb-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('machine-service-timeline',{attrs:{"operator":_vm.machine.operator,"tech":_vm.machine.technician,"planned_prop":_vm.services.services_planned,"performed_prop":_vm.services.services_performed,"machine_id":_vm.machine.id,"region_id":_vm.machine.region_id}})],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"field-show col-lg-4 col-sm-6"},[_c('label',[_vm._v("Оператор автомата")]),_vm._v("\n              "+_vm._s(_vm._f("fullName")(_vm.machine.operator))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-4 col-sm-6"},[_c('label',[_vm._v("Техник автомата")]),_vm._v("\n              "+_vm._s(_vm._f("fullName")(_vm.machine.technician))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"field-show col-lg-4 col-sm-6"},[_c('label',[_vm._v("Менеджер, ответственный за автомат")]),_vm._v("\n              "+_vm._s(_vm._f("fullName")(_vm.machine.manager))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"my-0 mr-auto"},[_c('span',{staticClass:"text-caps"},[_vm._v("График продаж")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Обслуживание")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/index.vue
function injectStyle (context) {
  __webpack_require__("aZu/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var machines__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MJKu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/app/img/vendoscope-logo.b5d46f6.png";

/***/ }),

/***/ "N05c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NGsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/commands/_id.vue




/* harmony default export */ var _id = ({
  metaInfo: function metaInfo() {
    var commandType = this.command ? this.command.type : '';
    return { title: '\u041A\u043E\u043C\u0430\u043D\u0434\u0430 ' + commandType };
  },

  props: {
    id: {}
  },
  data: function data() {
    return {};
  },

  asyncComputed: {
    command: function command() {
      return api["a" /* default */].get('commands/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fafa8f9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/commands/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.command)?_c('modem-command-details',{attrs:{"command":_vm.command}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/commands/_id.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var commands__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NLu6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQjM5MkEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMiAxNy4wNDNjLjU0NSAwIC45ODcuNDM4Ljk4Ny45NzhTMTIuNTQ1IDE5IDEyIDE5YS45ODMuOTgzIDAgMCAxLS45ODctLjk3OWMwLS41NC40NDItLjk3OC45ODctLjk3OHptMi43NTQtMS43MzljLjIyMS4yMi4yMjEuNTcgMCAuNzlhLjU2My41NjMgMCAwIDEtLjc5NSAwIDIuNzgxIDIuNzgxIDAgMCAwLTMuOTAzIDAgLjU3Mi41NzIgMCAwIDEtLjc5NiAwIC41NTIuNTUyIDAgMCAxIDAtLjc5YzEuNTAzLTEuNDkgMy45NzctMS41MDQgNS40OTQgMHptLS4wNTktMy40MzJhNi41NyA2LjU3IDAgMCAxIDIuMDkyIDEuNDAyYy4yMi4yMDUuMjIuNTcgMCAuNzg5YS41NjMuNTYzIDAgMCAxLS43OTUgMCA1LjYzIDUuNjMgMCAwIDAtMi41MDQtMS40MzIgMy44MzQgMy44MzQgMCAwIDAgMS4yMDctLjc2em0tNS4zOSAwYy4zNTMuMzIxLjc2NS41ODQgMS4yMDcuNzZhNS42MyA1LjYzIDAgMCAwLTIuNTA0IDEuNDMuNTcyLjU3MiAwIDAgMS0uMzk3LjE2Mi41MzYuNTM2IDAgMCAxLS4zOTgtLjE2MS41NTIuNTUyIDAgMCAxIDAtLjc4OSA2LjU3IDYuNTcgMCAwIDEgMi4wOTItMS40MDJ6bS0xLjI1Mi0yLjZjLjAzLjM5NC4xMTcuNzc0LjI1IDEuMTQtLjg1NC4zOTQtMS42NS45NDktMi4zNDIgMS42MzVhLjYuNiAwIDAgMS0uMzk4LjE2LjUzNi41MzYgMCAwIDEtLjM5Ny0uMTYuNTUyLjU1MiAwIDAgMSAwLS43ODkgOS44NzcgOS44NzcgMCAwIDEgMi44ODctMS45ODZ6bTcuODggMGE5LjY2OSA5LjY2OSAwIDAgMSAyLjkwMSAxLjk4NmMuMjIxLjIwNS4yMjEuNTU1IDAgLjc3NWEuNTYzLjU2MyAwIDAgMS0uNzk1IDAgOC40NTYgOC40NTYgMCAwIDAtMi4zNTctMS42NTFjLjEzMy0uMzUuMjIxLS43MTYuMjUtMS4xMXpNMTIgNmMxLjY2NCAwIDMuMDIgMS4zNDQgMy4wMiAyLjk5NCAwIDEuNjUtMS4zNTYgMi45OTUtMy4wMiAyLjk5NXMtMy4wMi0xLjMzLTMuMDItMi45OTVDOC45OCA3LjM0NCAxMC4zMzcgNiAxMiA2em0tLjY5MiAxLjc5N2EuMzc2LjM3NiAwIDAgMC0uNTMgMCAuMzY4LjM2OCAwIDAgMCAwIC41MjVsLjY5Mi42ODctLjY5My42ODdhLjM2OC4zNjggMCAwIDAgMCAuNTI1LjM1Ny4zNTcgMCAwIDAgLjI2Ni4xMDNjLjEwMyAwIC4xOTEtLjAzLjI2NS0uMTAzTDEyIDkuNTM1bC42OTIuNjg2YS4zNTcuMzU3IDAgMCAwIC4yNjUuMTAzYy4xMDMgMCAuMTkyLS4wMy4yNjYtLjEwM2EuMzY4LjM2OCAwIDAgMCAwLS41MjVsLS42OTMtLjY4Ny42OTMtLjY4N2EuMzY4LjM2OCAwIDAgMCAwLS41MjUuMzc2LjM3NiAwIDAgMC0uNTMgMEwxMiA4LjQ4M3oiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "NPbj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O3TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/events/_id.vue




/* harmony default export */ var _id = ({
  metaInfo: function metaInfo() {
    var eventCode = this.event ? this.event.code : '';
    return { title: '\u0421\u043E\u0431\u044B\u0442\u0438\u0435 ' + eventCode };
  },

  props: {
    id: {}
  },
  data: function data() {
    return {};
  },

  asyncComputed: {
    event: function event() {
      return api["a" /* default */].get('events/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3ed4876","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/events/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.event)?_c('event-details',{attrs:{"event":_vm.event}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/events/_id.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var events__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OGCL":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app-alert.vue": "nPTs",
	"./app-filters.vue": "XnKq",
	"./app-modals.vue": "eqfu",
	"./back-button.vue": "IWqY",
	"./balloon.vue": "oW9E",
	"./btn-action.vue": "K+Zy",
	"./btn-filters.vue": "wSWk",
	"./cash-voucher-form.vue": "AvMT",
	"./category-modal.vue": "SGl8",
	"./checklist-modal.vue": "GryE",
	"./currency.vue": "BUZT",
	"./data-table-full-height.vue": "uVgm",
	"./data-table.vue": "8YoH",
	"./date-from-now.vue": "tG1Q",
	"./datepicker.vue": "azZb",
	"./documents-modal.vue": "rygB",
	"./dsl-modal.vue": "43gl",
	"./event-details.vue": "wNbr",
	"./event-modal.vue": "HFnY",
	"./filter-checkboxes.vue": "CXEC",
	"./filter-event-delivery-of-change.vue": "G4x5",
	"./filter-event-depositing-money.vue": "K5eC",
	"./filter-event-downtime.vue": "ST9j",
	"./filter-event-encashment.vue": "fnbT",
	"./filter-event-sale.vue": "dIAz",
	"./filter-event-service.vue": "emf1",
	"./filter-event-stop-defect.vue": "stzI",
	"./filter-event.vue": "d/nd",
	"./filter-range-date.vue": "Ajcq",
	"./filter-range-slider.vue": "LaBP",
	"./filter-range.vue": "gRN3",
	"./filter-search.vue": "s3Ie",
	"./filter-select.vue": "K1AT",
	"./filter-terms.vue": "HRc9",
	"./filtered-data.vue": "QNc/",
	"./filters-group.vue": "kFb+",
	"./filters.vue": "4v4d",
	"./graph.vue": "OR9P",
	"./height-tracker.vue": "s4cC",
	"./help-tooltip.vue": "LoEv",
	"./machine-list-map-tabs.vue": "ery0",
	"./machine-service-timeline.vue": "dlFG",
	"./machines-modal.vue": "ndU7",
	"./modem-command-details.vue": "4cw7",
	"./monthpicker.vue": "0sks",
	"./navbar.vue": "jele",
	"./number.vue": "m5rk",
	"./progress-bar.vue": "a11f",
	"./receipt-details.vue": "CpOP",
	"./release-modal.vue": "96X0",
	"./reports-schedule-edit-modal.vue": "vRDl",
	"./reports-schedule.vue": "/FCt",
	"./sample-modal-edit.vue": "uQuk",
	"./sample-modal.vue": "FXTC",
	"./server-select.vue": "UB8P",
	"./service-modal-performed.vue": "7DFl",
	"./service-modal-planned.vue": "dHI1",
	"./status-images.vue": "smib",
	"./subnav.vue": "lOTn",
	"./table-column-checkbox.vue": "9/A4",
	"./table-column-date.vue": "JIqk",
	"./table-column-element.vue": "f/S2",
	"./table-column-number.vue": "BQMX",
	"./table-column-serial-number.vue": "rG/2",
	"./table-column-string.vue": "0fXn",
	"./tooltip.vue": "I/hk",
	"./v-multiselect.vue": "1inz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OGCL";

/***/ }),

/***/ "OJ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/query-encoder.js
var query_encoder = __webpack_require__("jhtD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/service.vue





/* harmony default export */ var service = ({
  metaInfo: { title: 'Сервисы' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      sort: null,
      date: [moment_default()().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment_default()().endOf('day').format('YYYY-MM-DDTHH:mm:ss')],
      pickerOptions: {
        firstDayOfWeek: 1
      },
      inn: null,
      fsNumber: null
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.sort = sort.prop + ':' + order;
      } else {
        this.sort = null;
      }
    },
    makeQuery: function makeQuery(serial_number) {
      return Object(query_encoder["b" /* encode */])({ serial_number: [{ label: serial_number, value: serial_number }] });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d111b1e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/service.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"services-reports","filtersValue":_vm.filtersValue,"sort":_vm.sort,"date":_vm.date},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Обслуживание")]),_vm._v(" "),_c('el-date-picker',{staticClass:"mr-2",attrs:{"type":"datetimerange","clearable":false,"value-format":"yyyy-MM-ddTHH:mm:ss","default-time":['00:00:00', '23:59:59'],"align":"right","range-separator":"–","picker-options":_vm.pickerOptions,"size":"small"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"services-reports"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?_c('data-table-full-height',{attrs:{"data":_vm.data.data,"show-summary":""},on:{"sort-change":_vm.sortChange}},[_c('table-column-serial-number',{attrs:{"fixed":true}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"Адрес установки","show-overflow-tooltip":true,"min-width":"300"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","prop":"services_planned_count","label":"Количество плановых сервисов","min-width":"120"}}),_vm._v(" "),_c('table-column-number',{attrs:{"sortable":"custom","align":"center","prop":"planned","label":"Количество выполненных плановых сервисов","min-width":"120"}}),_vm._v(" "),_c('table-column-number',{attrs:{"sortable":"custom","align":"center","prop":"casual","label":"Количество выполненных внеплановых сервисов","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"custom","align":"center","prop":"late","label":"Количество сервисов, выполненных с нарушением плановых сроков","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":'/service?filters=' + _vm.makeQuery(row.serial_number)}},[_c('number',{attrs:{"number":row.late}})],1)]}}],null,false,3124577749)})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/service.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  service,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_service = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OR9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/c3/c3.js
var c3 = __webpack_require__("g1pc");
var c3_default = /*#__PURE__*/__webpack_require__.n(c3);

// EXTERNAL MODULE: ./node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("TYWu");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/graph.vue








/* harmony default export */ var graph = ({
  data: function data() {
    return {};
  },
  props: {
    endpoint: String,
    endpointParams: null,
    period: String,
    height: null
  },
  methods: {
    showGraph: function showGraph(data) {
      var _this = this;

      var dataGraph = data || this.dataGraph;
      this.chart = c3_default.a.generate({
        color: {
          pattern: ['#08588f', '#00a0e3', '#bf3030', '#fd7e14', '#7db22d', '#dbc942', '#e83e8c', '#6610f2', '#6f42c1', '#20c997']
        },
        bindto: this.$refs.graph,
        size: {
          height: this.height || 0
        },
        data: {
          x: 'x',
          xFormat: '%Y-%m-%dT%H:%M:%S',
          columns: [dataGraph.values, dataGraph.sales, dataGraph.revenue, dataGraph.before_sales, dataGraph.before_revenue],
          names: {
            sales: 'Кол-во (dex)',
            revenue: 'Сумма (dex)',
            before_sales: 'Кол-во (mdb)',
            before_revenue: 'Сумма (mdb)'
          },
          axes: {
            revenue: 'y2',
            before_revenue: 'y2'
          },
          type: 'bar',
          groups: [['sales', 'before_sales'], ['revenue', 'before_revenue']],
          order: function order(t1, t2) {
            return false;
          }
        },
        grid: {
          y: {
            show: true
          }
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              fit: true,
              format: dataGraph.formatPrint
            }
          },
          y: {
            label: {
              text: 'Кол-во продаж, шт.',
              position: 'outer-middle'
            },
            padding: { top: 0, bottom: 0 }
          },
          y2: {
            label: {
              text: 'Выручка, руб.',
              position: 'outer-middle'
            },
            show: true,
            padding: { top: 0, bottom: 0 }
          }
        },
        bar: {
          width: {
            ratio: 1 / 1.61803398875
          }
        }
      });
      visibilityjs_default.a.onVisible(function () {
        _this.chart.flush();
      });
    }
  },
  asyncComputed: {
    dataGraph: function dataGraph() {
      var _this2 = this;

      return api["a" /* default */].get(this.endpoint, {
        params: assign_default()({
          period: this.period
        }, this.endpointParams)
      }).then(function (_ref) {
        var data = _ref.data;

        var $container = jquery_default()(_this2.$refs.container);
        $container.height($container.height());
        _this2.chart && _this2.chart.destroy();
        _this2.showGraph(data.data);
        $container.css('height', '');

        return data.data;
      });
    }
  },
  watch: {
    dataGraph: function dataGraph(data) {
      this.$emit('update:data', data);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.chart && this.chart.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96495b26","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/graph.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"graph"},[_c('div',{ref:"graph"})])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/graph.vue
function injectStyle (context) {
  __webpack_require__("Egmp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  graph,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_graph = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PQq+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QCIs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQjM5MkEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03Ljk2OCA4Ljk3NWwtMS45OTgtLjk4TDUgNi4wMzggNi4wODUgNWwxLjk0LjkyMi45NyAyLjAxNiAyLjIyNyAyLjE5LTEuMDg0IDEuMDk0LTIuMTctMi4yNDd6bTYuNDg1IDMuODAzbDMuNDI0IDMuNDI0Yy40Ni40Ni40NiAxLjE3NSAwIDEuNjM1bC0uODE3LjgxOGMtLjQ2LjQ2LTEuMTc2LjQ2LTEuNjM2IDBMMTIgMTUuMjMxbDIuNDUzLTIuNDUzem0tNi4zNjggMS4yODhsNS45ODEtNS45ODFjLS4yMTctLjgxNiAwLTEuNjg2LjY1My0yLjMzOS43MDctLjcwNiAxLjc0LS45MjQgMi42MS0uNTk4bC0xLjQ2OCAxLjQ2OSAxLjUyMiAxLjUyMiAxLjQ2OS0xLjQ2OGEyLjQ2MiAyLjQ2MiAwIDAgMS0uNTk4IDIuNjFjLS41OTkuNjUzLTEuNTIzLjg3LTIuMzM5LjY1M2wtNS45ODEgNS45ODFjLjIxNy44MTYgMCAxLjY4Ni0uNjUzIDIuMzM5LS43MDcuNzA2LTEuNzQuOTI0LTIuNjEuNTk4bDEuNDY4LTEuNDY5LTEuNTIyLTEuNTIyLTEuNDY5IDEuNDY4YTIuNDYyIDIuNDYyIDAgMCAxIC41OTgtMi42MWMuNTk5LS42NTMgMS41MjMtLjg3IDIuMzM5LS42NTN6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "QDYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/difference.js
var difference = __webpack_require__("WlNK");
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
var script = __webpack_require__("zhAq");
var script_default = /*#__PURE__*/__webpack_require__.n(script);

// CONCATENATED MODULE: ./resources/assets/js/ymap.js



/* harmony default export */ var ymap = (function () {
  return new promise_default.a(function (resolve, reject) {
    script_default()('https://api-maps.yandex.ru/2.1/?lang=ru_RU', function () {
      var sleep = function sleep(ms) {
        return new promise_default.a(function (resolve) {
          return setTimeout(resolve, ms);
        });
      };
      var getYmaps = function getYmaps() {
        return new promise_default.a(function (resolve, reject) {
          return window.ymaps ? resolve(window.ymaps) : reject(new Error('ymaps is not defined'));
        });
      };
      var retry = function retry(fn) {
        var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
        var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

        function recurse(i) {
          return fn().catch(function (e) {
            if (i < retries) {
              return sleep(delay).then(function () {
                return recurse(++i);
              });
            }
            throw e;
          });
        }

        return recurse(0);
      };

      var result = retry(getYmaps).then(function (ymaps) {
        return new promise_default.a(function (resolve) {
          return ymaps.ready(function () {
            return resolve(ymaps);
          });
        });
      });

      resolve(result);
    });
  });
});
// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/map.vue











/* harmony default export */ var machines_map = ({
  metaInfo: { title: 'Карта' },
  data: function data() {
    return {
      map: null,
      placemarks: {},
      bounds: null,
      machine: null,
      filtersValue: null,
      data: null,
      loading: false,
      hasMore: true,
      sort: null,
      mapBounds: null
    };
  },

  watch: {
    data: function data() {
      this.renderPlacemarks();
    }
  },
  methods: {
    renderPlacemarks: function renderPlacemarks() {
      var _this = this;

      ymap().then(function (ymaps) {
        var placedIds = keys_default()(_this.placemarks);
        var currentIds = map_default()(_this.data.data, function (m) {
          return String(m.id);
        });

        difference_default()(placedIds, currentIds).forEach(function (idToRemove) {
          _this.map.geoObjects.remove(_this.placemarks[idToRemove]);
          delete _this.placemarks[idToRemove];
        });

        _this.$nextTick(function () {
          _this.data.data.forEach(function (machine, index) {
            if (_this.placemarks[machine.id]) return;
            if (!machine.location) return;

            _this.placemarks[machine.id] = new ymaps.Placemark([machine.location.lat, machine.location.lon], {
              hintContent: machine.serial_number,
              balloonContent: 'Загрузка...',
              balloonPane: 'outerBalloon',
              machineId: machine.id
            }, {
              preset: 'islands#' + machine.map_color + 'Icon'
            });

            _this.placemarks[machine.id].events.add('balloonopen', function (e) {
              _this.placemarks[machine.id].properties.set('balloonContent', 'Загрузка...');
              api["a" /* default */].get('machines/' + machine.id, {}).then(function (_ref) {
                var data = _ref.data;

                _this.machine = data.data;
                _this.$nextTick(function () {
                  _this.placemarks[machine.id].properties.set('balloonContent', _this.$refs.balloonContent.innerHTML);
                });
              });
            });

            _this.map.geoObjects.add(_this.placemarks[machine.id]);
          });
        });
      });
    },
    getCenter: function getCenter() {
      return window.localStorage.getItem('ymapCenter') !== null ? window.localStorage.getItem('ymapCenter').split(' ') : [55.711863, 37.388753];
    },
    getZoom: function getZoom() {
      return window.localStorage.getItem('ymapZoom') !== null ? window.localStorage.getItem('ymapZoom') : 11;
    },

    newBounds: debounce_default()(function (bounds) {
      this.mapBounds = bounds;
    }, 250)
  },
  mounted: function mounted() {
    var _this2 = this;

    var self = this;
    jquery_default()(this.$refs.map).on('click', '.btn', function (e) {
      e.preventDefault();
      self.$router.push(jquery_default()(this).data('href'));
    });

    ymap().then(function (ymaps) {
      _this2.map = new ymaps.Map(_this2.$refs.map, {
        center: _this2.getCenter(),
        zoom: _this2.getZoom(),
        controls: ['fullscreenControl', 'geolocationControl', 'zoomControl']
      }, { searchControlProvider: 'yandex#search' });

      _this2.map.events.add('boundschange', function (e) {
        _this2.bounds = e.get('newBounds');
        _this2.newBounds(e.get('newBounds'));
        window.localStorage.setItem('ymapCenter', e.get('newCenter').join(' '));
        window.localStorage.setItem('ymapZoom', e.get('newZoom'));
      });
      _this2.bounds = _this2.map.getBounds();
      _this2.newBounds(_this2.map.getBounds());

      _this2.renderPlacemarks();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.map) this.map.destroy();
    this.newBounds(null);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a575da90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/map.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machines-index d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"machines/map","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"map":_vm.mapBounds},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("\n        Автоматы\n      ")]),_vm._v(" "),(_vm.data)?_c('machine-list-map-tabs',{staticClass:"mx-2"}):_vm._e(),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"machines/map"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),_c('div',{staticClass:"machines-index-map bg-light flex-grow-1"},[_c('div',{ref:"map",staticClass:"machines-index-map-map"}),_vm._v(" "),_c('div',{ref:"balloonContent",staticClass:"d-none"},[_c('balloon',{attrs:{"machine":_vm.machine}})],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/map.vue
function injectStyle (context) {
  __webpack_require__("FR0B")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  machines_map,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_machines_map = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QNc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filtered-data.vue




/* harmony default export */ var filtered_data = ({
  name: 'FilteredData',
  render: function render(h) {
    return h();
  },
  props: {
    value: {},
    map: {},
    endpoint: {},
    filtersValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    endpointMethod: {
      default: function _default() {
        return 'get';
      }
    },
    sort: {},
    date: {},
    exclude: null,
    externalFilters: null,
    refresh: false
  },
  data: function data() {
    return {
      data: {},
      page: 1,
      loading: false,
      hasMore: true
    };
  },

  watch: {
    refresh: function refresh(need) {
      if (need) {
        this.refreshData();
      }
    },
    hasMore: function hasMore() {
      this.$emit('update:hasMore', this.hasMore);
    },
    loading: function loading() {
      this.$emit('update:loading', this.loading);
    },
    sort: function sort(newSort, oldSort) {
      if (!isEqual_default()(newSort, oldSort)) {
        this.updateData();
      }
    },
    filtersValue: function filtersValue(newFiltersValue, oldFiltersValue) {
      if (!isEqual_default()(newFiltersValue, oldFiltersValue)) {
        this.updateData();
      }
    },
    map: function map() {
      var _this = this;

      if (this.map == null) {
        return this.getData().then(function (data) {
          _this.data = data;
          _this.$emit('input', _this.data);
        });
      } else {

        return this.getDataForMap().then(function (data) {
          _this.data = data;
          _this.$emit('input', _this.data);
        });
      }
    },

    date: {
      handler: function handler() {
        var _this2 = this;

        this.page = 1;
        return this.getData().then(function (data) {
          _this2.data = data;
          _this2.$emit('input', _this2.data);
        });
      },
      deep: true
    },
    externalFilters: function externalFilters(newFiltersValue, oldFiltersValue) {
      if (!isEqual_default()(newFiltersValue, oldFiltersValue)) {
        this.updateData();
      }
    }
  },

  methods: {
    updateData: function updateData() {
      var _this3 = this;

      this.page = 1;
      return this.getData().then(function (data) {
        _this3.data = data;
        _this3.$emit('input', _this3.data);
      });
    },
    loadMore: function loadMore() {
      var _this4 = this;

      this.page++;
      return this.getData().then(function (data) {
        data.data.forEach(function (item) {
          return _this4.data.data.push(item);
        });

        _this4.$emit('input', _this4.data);
      });
    },
    getData: function getData() {
      var _this5 = this;

      this.loading = true;

      if (this.map != null) {
        this.filtersValue.map = this.map;
      } else {
        if (this.filtersValue.map) {
          delete this.filtersValue.map;
        }
      }

      var params = {
        page: this.page,
        filters: this.filtersValue,
        sort: this.sort,
        date: this.date
      };
      if (this.exclude) params.exclude = this.exclude;
      if (this.externalFilters) params.external = this.externalFilters;

      var conf = {
        method: this.endpointMethod,
        url: this.endpoint
      };

      if (conf.method === 'get') {
        conf.params = params;
      } else {
        conf.data = params;
      }

      return api["a" /* default */].request(conf).then(function (_ref) {
        var data = _ref.data;

        _this5.loading = false;

        if (data.next_page_url === null) {
          _this5.hasMore = false;
        } else if (data.hasMore) {
          _this5.hasMore = data.hasMore;
        } else {
          if (data.per_page) {
            _this5.hasMore = !!(data && data.data && data.data.length && data.data.length >= data.per_page);
          } else {
            _this5.hasMore = !!(data && data.data && data.data.length);
          }
        }

        return data;
      });
    },
    getDataForMap: function getDataForMap() {
      var _this6 = this;

      this.loading = true;

      if (this.map != null) {
        this.filtersValue.map = this.map;
      } else {
        if (this.filtersValue.map) {
          delete this.filtersValue.map;
        }
      }

      return api["a" /* default */].get('machines/map', {
        params: {
          page: this.page,
          filters: this.filtersValue,
          sort: this.sort,
          date: this.date
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this6.loading = false;

        if (data && data.data && data.data.length) {
          _this6.hasMore = true;
        } else {
          _this6.hasMore = false;
        }

        return data;
      });
    },
    refreshData: function refreshData() {
      this.updateData();
      this.$emit('update:refresh', false);
    }
  },
  mounted: function mounted() {
    if (this.filtersValue) {
      this.updateData();
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filtered-data.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filtered_data,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filtered_data = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RTB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RefH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S5Mx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGZpbGw9IiM2MTYxNjEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjU1NiA3LjI0OGwyLjY3NiAzLjI5Mi0yLjg1NiAyLjYyMUwxNyAxNi4wMThzLTMuMTMgMi42ODktMy44IDIuNjg5Yy0uNjcxIDAgMi4xNzUtMi42OSAyLjE3NS0yLjY5TDEyLjggMTIuOTAybDEuNjI1LTIuNTg3TDEyLjggNy4yNDggMTMuMTAxIDNDNy4zNzUgMy45MyAzIDguOTMxIDMgMTQuOTM3IDMgMjEuNTk3IDguMzc2IDI3IDE1IDI3YzYuNjI1IDAgMTItNS40MDMgMTItMTIuMDYzQzI3IDguOTU3IDIyLjY1IDMuOTggMTYuOTc1IDMuMDVsLTEuNDIgNC4xOTh6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "S8OL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__root__ = __webpack_require__("je9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__("H0LK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird__ = __webpack_require__("0Qa9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bluebird__);










var Auth = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Auth, _EventEmitter);

  function Auth() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Auth);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Auth.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Auth)).call(this));

    _this.check_promise = null;

    _this.check().catchReturn();

    window.addEventListener('storage', function (e) {
      if (e.key === 'logged_in' && e.newValue === '0') {
        _this.afterLogout();
      }
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Auth, [{
    key: 'login',
    value: function login(credentials) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/api/admin/auth/login', credentials).then(function (response) {
        if (response.data.status === 'sms') {
          if (response.data.code) window.alert(response.data.code);
          return response.data.status;
        } else {
          _this2.clearAuth();
          return _this2.check(true);
        }
      });
    }
  }, {
    key: 'sms',
    value: function sms(credentials) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/api/admin/auth/sms', credentials).then(function (response) {
        _this3.clearAuth();
        return _this3.check(true);
      });
    }
  }, {
    key: 'clearAuth',
    value: function clearAuth() {
      __WEBPACK_IMPORTED_MODULE_5__root__["default"].user = null;
      this.check_promise = null;
    }
  }, {
    key: 'checkPermission',
    value: function checkPermission(permission) {
      return __WEBPACK_IMPORTED_MODULE_5__root__["default"].checkPermission(permission);
    }
  }, {
    key: 'isAdmin',
    value: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_5__root__["default"].isAdmin();
    }
  }, {
    key: 'logout',
    value: function logout() {
      localStorage.setItem('logged_in', '0');
      this.afterLogout();

      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/api/admin/auth/logout');
    }
  }, {
    key: 'afterLogout',
    value: function afterLogout() {
      this.clearAuth();
      this.check_promise = __WEBPACK_IMPORTED_MODULE_8_bluebird___default.a.reject(new Error('Требуется авторизация'));
      __WEBPACK_IMPORTED_MODULE_5__root__["default"].$router.push('/login');
    }
  }, {
    key: 'check',
    value: function check() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!force) {
        if (this.check_promise) {
          return this.check_promise;
        }
      }

      this.check_promise = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/api/admin/user').then(function (response) {
        __WEBPACK_IMPORTED_MODULE_5__root__["default"].user = response.data;
        localStorage.setItem('logged_in', '1');

        return response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5__root__["default"].user = null;
        localStorage.setItem('logged_in', '0');

        throw error;
      });

      return this.check_promise;
    }
  }]);

  return Auth;
}(__WEBPACK_IMPORTED_MODULE_7_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new Auth());

/***/ }),

/***/ "SGl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vue-color/dist/vue-color.min.js
var vue_color_min = __webpack_require__("Zzkc");
var vue_color_min_default = /*#__PURE__*/__webpack_require__.n(vue_color_min);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/category-modal.vue






/* harmony default export */ var category_modal = ({
  components: {
    'compact-picker': vue_color_min["Compact"]
  },
  props: ['categoryData', 'machineType'],
  data: function data() {
    return {
      category: this.categoryData ? assign_default()({}, this.categoryData) : { color: '#000000' }
    };
  },

  methods: {
    saveCategory: function saveCategory() {
      var _this = this;

      var data = {
        name: this.category.name,
        color: this.category.color,
        from: this.category.from,
        to: this.category.to,
        type: this.machineType
      };
      if (this.isEditing()) {
        return api["a" /* default */].put('categories/' + this.categoryData.id, data).then(function (_ref) {
          var data = _ref.data;
          _this.hide(data);
        });
      } else {
        return api["a" /* default */].post('categories', data).then(function (_ref2) {
          var data = _ref2.data;
          _this.hide(data);
        });
      }
    },
    hide: function hide(data) {
      this.$emit('hide', data);
    },
    onColorInput: function onColorInput(value) {
      this.category.color = value.hex;
    },
    editColor: function editColor(color) {},
    isEditing: function isEditing() {
      return !!this.categoryData;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfa80852","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/category-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.isEditing() ? 'Редактирование категории' : 'Создание категории'))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hide()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Название")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.name),expression:"category.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.category.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"mt-3"},[_vm._v("Промежуток")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.from),expression:"category.from"}],staticClass:"form-control",attrs:{"aria-describedby":"input-from","type":"number"},domProps:{"value":(_vm.category.from)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "from", $event.target.value)}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.to),expression:"category.to"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.category.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "to", $event.target.value)}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('label',{staticClass:"mt-3"},[_vm._v("Цвет")]),_vm._v(" "),_c('div',{staticClass:"btn-toolbar"},[_c('div',{staticClass:"input-group mr-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.color),expression:"category.color"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.category.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.category, "color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('div',{staticClass:"color-preview",style:('background-color: ' + (_vm.category.color ? _vm.category.color : '#ac2925') + '!important;'),attrs:{"data-toggle":"dropdown"},on:{"click":function($event){return _vm.editColor(_vm.category.color)}}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('compact-picker',{attrs:{"value":_vm.category.color},on:{"input":_vm.onColorInput}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex"},[_c('btn-action',{staticClass:"btn btn-primary ml-auto",on:{"click":_vm.saveCategory}},[_vm._v("Сохранить")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text",attrs:{"id":"input-from"}},[_vm._v("От")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("руб.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend ml-3"},[_c('span',{staticClass:"input-group-text"},[_vm._v("До")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("руб.")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/category-modal.vue
function injectStyle (context) {
  __webpack_require__("ZhMh")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  category_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_category_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ST9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/components/filter-event-service.vue + 2 modules
var filter_event_service = __webpack_require__("emf1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-downtime.vue



/* harmony default export */ var filter_event_downtime = ({
  name: 'FilterEventDowntime',
  extends: filter_event_service["default"]
});
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-downtime.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_downtime,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_downtime = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SVaF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TIl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/modems/edit-modal.vue + 2 modules
var edit_modal = __webpack_require__("VY79");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css
var bootstrap_datetimepicker = __webpack_require__("PQq+");
var bootstrap_datetimepicker_default = /*#__PURE__*/__webpack_require__.n(bootstrap_datetimepicker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/modems/broadcast-modal.vue







/* harmony default export */ var broadcast_modal = ({
  props: ['filters', 'total'],
  data: function data() {
    return {
      commandTypes: [{ type: 'inf', withData: false }, { type: 'cfg', withData: false }, { type: 'eva', withData: false }, { type: 'log', withData: true }, { type: 'jlog', withData: true }, { type: 'ping', withData: false }, { type: 'reboot', withData: false }, { type: 'bin', withData: true }, { type: 'cfgprg', withData: true }, { type: 'evaprg', withData: true }, { type: 'qrbin', withData: true }, { type: 'eva(i)', withData: false }, { type: 'eva(pr1)', withData: false }],
      options: { format: 'YYYY-MM-DD hh:mm' },
      selectedType: null,
      dataTypeText: true,
      commandData: null,
      file: null,
      dateNow: true,
      date: null,
      sortColumn: true
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      var data = {
        type: this.selectedType.type,
        data: this.dataTypeText ? this.commandData : null,
        now: this.dateNow,
        date: this.date,
        filters: stringify_default()(this.filters)
      };
      if (this.dataTypeText) {
        return api["a" /* default */].post('modems/broadcast', data).then(function () {
          _this.$emit('hide');
        });
      } else {
        return this.uploadFile(data);
      }
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
    },
    uploadFile: function uploadFile(obj) {
      var _this2 = this;

      var data = new FormData();
      data.append('file', this.file);
      entries_default()(obj).forEach(function (prop) {
        data.append(prop[0], prop[1]);
      });
      return api["a" /* default */].post('modems/broadcast', data, {
        headers: { 'content-type': 'multipart/form-data' }
      }).then(function () {
        _this2.$emit('hide');
      });
    }
  },
  computed: {
    fileName: function fileName() {
      if (this.file) {
        return this.file.name;
      } else {
        return 'Файл не выбран';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026499c0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modems/broadcast-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Рассылка команд")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('hide')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"alert alert-primary rounded-0 m-0"},[_vm._v("\n      Команды будут отправлены на "),_c('strong',[_vm._v(_vm._s(_vm.total)+" автоматов")]),_vm._v(" "),_c('br'),_c('small',{staticClass:"text-muted"},[_vm._v("Используйте фильтры, чтобы выбрать автоматы")])]),_vm._v(" "),_c('div',{staticClass:"modal-body pb-0"},[_c('div',{staticClass:"form-group mb-4"},[_c('label',{staticClass:"mb-2"},[_vm._v("Тип команды")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedType),expression:"selectedType"}],staticClass:"custom-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.commandTypes),function(type){return _c('option',{domProps:{"value":type}},[_vm._v(_vm._s(type.type))])}),0)]),_vm._v(" "),(_vm.selectedType)?_c('div',{staticClass:"form-group mb-4"},[_c('label',{staticClass:"mb-2 mr-3"},[_vm._v("Время отправки")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateNow),expression:"dateNow"}],staticClass:"custom-control-input",attrs:{"id":"date-type-1","type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.dateNow,true)},on:{"change":function($event){_vm.dateNow=true}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"date-type-1"}},[_vm._v("Сейчас")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateNow),expression:"dateNow"}],staticClass:"custom-control-input",attrs:{"id":"date-type-2","type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.dateNow,false)},on:{"change":function($event){_vm.dateNow=false}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"date-type-2"}},[_vm._v("Указать время")])]),_vm._v(" "),(!_vm.dateNow)?_c('datetime-picker',{attrs:{"config":_vm.options},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.selectedType && _vm.selectedType.withData)?_c('div',{staticClass:"mt-4"},[_c('label',{staticClass:"mb-2 mr-3"},[_vm._v("Данные")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataTypeText),expression:"dataTypeText"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"input-type-1"},domProps:{"value":true,"checked":_vm._q(_vm.dataTypeText,true)},on:{"change":function($event){_vm.dataTypeText=true}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"input-type-1"}},[_vm._v("Текст команды ")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataTypeText),expression:"dataTypeText"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"input-type-2"},domProps:{"value":false,"checked":_vm._q(_vm.dataTypeText,false)},on:{"change":function($event){_vm.dataTypeText=false}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"input-type-2"}},[_vm._v("Загрузить файл")])]),_vm._v(" "),(_vm.dataTypeText)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.commandData),expression:"commandData"}],staticClass:"form-control mt-2",attrs:{"rows":"3"},domProps:{"value":(_vm.commandData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commandData=$event.target.value}}}):_c('div',{staticClass:"form-group mt-2"},[_c('label',{staticClass:"btn btn-file btn-outline-primary"},[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.onFileChange($event)}}}),_vm._v("\n            Выберите файл\n          ")]),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.fileName))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer mt-2"},[_c('btn-action',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.selectedType || (_vm.selectedType.withData && !_vm.dataTypeText && !_vm.file)},on:{"click":_vm.save}},[_vm._v("Создать рассылку")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Отмена")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/modems/broadcast-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  broadcast_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modems_broadcast_modal = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/modems/index/index.vue






/* harmony default export */ var index = ({
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      sort: { prop: 'uid', order: 'asc' },
      updateList: 0,
      uidFilter: null,
      external: null
    };
  },

  computed: {
    modems: function modems() {
      return this.data.data;
    }
  },
  methods: {
    newModem: function newModem() {
      var _this = this;

      this.$root.showModal(edit_modal["a" /* default */], { id: null, uid: null, newModem: true }).then(function (value) {
        if (value) {
          _this.modems.unshift({
            id: value.modemId,
            uid: value.uid,
            machine: {
              id: value.machineId,
              serial_number: value.serial_number
            }
          });
        }
      });
    },
    edit: function edit(modem) {
      var _this2 = this;

      var noCommands = modem.last_command_at === null;
      this.$root.showModal(edit_modal["a" /* default */], {
        id: modem.id,
        currentMachineId: modem.machine ? modem.machine.id : undefined,
        currentMachineSerialNumber: modem.machine ? modem.machine.serial_number : undefined,
        uid: modem.uid,
        noCommands: noCommands,
        number: modem.number
      }).then(function (value) {
        if (value) {
          _this2.modems.forEach(function (item) {
            if (item.id === value.modemId) {
              if (!item.machine) {
                item.machine = {};
              }
              item.machine.id = value.machineId;
              item.machine.serial_number = value.serial_number;
              if (noCommands) {
                item.number = value.number;
              }
            }
          });
        }
      });
    },
    commandsBroadcast: function commandsBroadcast() {
      this.$root.showModal(modems_broadcast_modal, {
        filters: this.filtersValue,
        total: this.data.total
      });
    },
    loadMore: function loadMore() {
      this.$refs.data.loadMore();
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.sort = {
          prop: sort.prop,
          order: order
        };
      } else {
        this.sort = null;
      }
    },
    save: function save() {
      var data = {};
      if (this.uidFilter) data.uid = this.uidFilter;
      this.external = data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297882a6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/modems/index/index.vue
var index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"modems","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"externalFilters":_vm.external},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("Активные модемы")]),_vm._v(" "),_c('div',{staticClass:"input-group mr-1",staticStyle:{"max-width":"27em"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uidFilter),expression:"uidFilter"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.uidFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uidFilter=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary mr-2",on:{"click":_vm.save}},[_vm._v("Применить")]),_vm._v(" "),(_vm.data && _vm.$root.isAdmin())?_c('button',{staticClass:"btn btn-outline-primary mr-2",on:{"click":function($event){return _vm.commandsBroadcast()}}},[_vm._v("Рассылка команд")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":function($event){return _vm.newModem()}}},[_vm._v("Добавить модем")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"modems"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.modems,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"sort-change":_vm.sortChange,"load-more":_vm.loadMore}},[_c('el-table-column',{attrs:{"prop":"uid","label":"№ модема","sortable":"custom","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":("/modems/" + (row.uid))}},[_c('div',[_vm._v(_vm._s(row.number))]),_vm._v(" "),_c('div',[_c('small',[_vm._v(_vm._s(row.uid))])])])]}}],null,false,1519275648)}),_vm._v(" "),_c('table-column-serial-number',{attrs:{"prop":"machines.serial_number","machine-prop":"machine","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SIM"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.data && row.data.sim)?_c('div',[_vm._v("SIM-карта: "+_vm._s(row.data.sim))]):_vm._e(),_vm._v(" "),(row.data && row.data.simchip)?_c('div',[_vm._v("SIM-чип: "+_vm._s(row.data.simchip))]):_vm._e()]}}],null,false,1896615150)}),_vm._v(" "),_c('table-column-date',{attrs:{"prop":"last_command_at","label":"Последняя команда","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Редактировать","width":"180","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function($event){$event.stopPropagation();return _vm.edit(row)}}},[_vm._v("Редактировать")])]}}],null,false,3985894192)})],1)]:_vm._e()],2)}
var index_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("UID модема")])])}]

// CONCATENATED MODULE: ./resources/assets/js/pages/modems/index/index.vue
function injectStyle (context) {
  __webpack_require__("UBKx")
}
/* script */


/* template */

/* template functional */
var index___vue_template_functional__ = false
/* styles */
var index___vue_styles__ = injectStyle
/* scopeId */
var index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var index___vue_module_identifier__ = null

var index_Component = Object(component_normalizer["a" /* default */])(
  index,
  index_render,
  index_staticRenderFns,
  index___vue_template_functional__,
  index___vue_styles__,
  index___vue_scopeId__,
  index___vue_module_identifier__
)

/* harmony default export */ var modems_index = __webpack_exports__["default"] = (index_Component.exports);


/***/ }),

/***/ "TcLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders.vue


/* harmony default export */ var orders = ({
  data: function data() {
    return {
      subnav: [{
        text: 'Детали и оборудование',
        to: '/orders/equipment'
      }, {
        text: 'Ингредиенты',
        to: '/orders/ingredients'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-982b556a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders-container d-flex flex-column"},[_c('subnav',{attrs:{"links":_vm.subnav,"heading":"Заявки"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  orders,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_orders = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TrY1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U3z9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNEQjM5MkEiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMy4yNDMgNC4xMjljMS40NDguMDc4IDQuODUyIDIuNzYzIDQuNzU1IDcuODQ1LS4wMDQuMDUxLS4wMDkuMDk4LS4wMDkuMTUyLjAwMy4wNDQgMCAuMDk1IDAgLjE0My0uMDk5IDUuMDc1LTIuNDg1IDcuNTQ0LTQuOTUxIDcuNzItMS41MTQuMTEtMS4xNzMtLjYyMi0uOTg0LS45NTIuODA1LTEuNjc3Ljk0MS0yLjgzNy45NDktMy44ODguMDA1LS44ODgtLjAzMy0xLjYzNi0uNC0zLjIzMS0uNjgtMi45NDItLjU4Mi01LjE3LS41ODItNS4xN2wuMDAxLS4wMTNjLjAxMS0uMTk3LjE3Ni0yLjY2MyAxLjIyMS0yLjYwNnpNMTEuMDcyIDRzLjI1My0uMDI2LjQ3NC4xNThjLS43MTQgMS42MDQtMS4zODEgMy45OTgtLjYwOCA2LjQzMiAxLjA4MyAzLjQzMy43MTggNy4xNTEtLjQxMyA5LjE3Ny0yLjA4My0uMjI3LTQuNjE4LTIuOTI3LTQuNTIyLTcuODIyIDAtLjA1MS4wMS0uMS4wMS0uMTQ1LjAwMS0uMDU2LS4wMDctLjA5OC0uMDA1LS4xNTVDNi4xMSA2LjU2OSA4Ljk1MSAzLjk1OSAxMS4wNzIgNHoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "UB8P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/server-select.vue







/* harmony default export */ var server_select = ({
  props: {
    value: {},
    placeholder: {
      type: String,
      default: 'Поиск'
    },
    trackBy: {
      type: String,
      default: function _default() {
        return 'id';
      }
    },
    debounceDelay: {
      type: Number,
      default: function _default() {
        return 300;
      }
    },
    endpoint: {
      type: String,
      required: true
    },
    endpointParams: {
      type: Object,
      default: function _default() {}
    },
    modifyOptions: {
      type: Function,
      default: function _default(options) {
        return options;
      }
    },
    lazy: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      options: [],
      firstOpen: true
    };
  },

  methods: {
    onSearch: function onSearch(term) {
      this.isLoading = true;
      this.debouncedSearch(term);
    },
    search: function search(term) {
      var _this = this;

      this.isLoading = true;
      var params = assign_default()({}, this.endpointParams, { term: term });
      api["a" /* default */].get(this.endpoint, { params: params }).then(function (_ref) {
        var data = _ref.data;

        _this.options = _this.modifyOptions(data.data);
        _this.isLoading = false;
      });
    },
    onOpen: function onOpen() {
      if (this.lazy && this.firstOpen) {
        this.firstOpen = false;
        this.search('');
      }
    }
  },
  watch: {
    endpointParams: function endpointParams(nv, ov) {
      if (!isEqual_default()(nv, ov)) {
        this.search('');
      }
    }
  },
  computed: {
    debouncedSearch: function debouncedSearch() {
      return debounce_default()(this.search, this.debounceDelay);
    }
  },
  mounted: function mounted() {
    if (!this.lazy) this.search('');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b561af","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/server-select.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-multiselect',_vm._g(_vm._b({attrs:{"value":_vm.value,"options":_vm.options,"searchable":true,"loading":_vm.isLoading,"internal-search":false,"track-by":_vm.trackBy,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)},"search-change":_vm.onSearch,"open":_vm.onOpen},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(content,name){return {key:name,fn:function(props){return [_vm._t(name,[_c('vnode',{attrs:{"node":content}})],null,props)]}}})],null,true)},'v-multiselect',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(content,name){return _c('template',{slot:name},[_vm._t(name,[_c('vnode',{attrs:{"node":content}})])],2)})],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/server-select.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  server_select,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_server_select = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UBKx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UO4r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1gp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/help.vue


/* harmony default export */ var help = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a428ef","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/help.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h1',[_vm._v("Помощь")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/help.vue
function injectStyle (context) {
  __webpack_require__("t+VF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  help,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_help = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VY79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/modems/edit-modal.vue




/* harmony default export */ var edit_modal = ({
  props: ['id', 'newModem', 'currentMachineId', 'currentMachineSerialNumber', 'uid', 'noCommands', 'number'],
  watch: {},
  data: function data() {
    return {
      emptyOption: { id: null, serial_number: 'Не привязывать' },
      currentOption: { id: this.currentMachineId, serial_number: this.currentMachineSerialNumber },
      machine: null,
      inputValue: this.uid,
      validationErrors: {},
      machines: []
    };
  },

  methods: {
    resetPassword: function resetPassword() {
      if (window.confirm('Действительно сбросить пароль?')) {
        return api["a" /* default */].put('modems/' + this.id + '/resetPassword');
      }
    },
    handleValidationError: function handleValidationError(error) {
      if (error.response && error.response.status === 422) {
        this.validationErrors = error.response.data.validation;
      } else {
        throw error;
      }
    },
    save: function save() {
      var _this = this;

      var data = {
        modemUid: this.newModem ? this.inputValue : this.uid,
        machineId: this.machine.id
      };
      var emitData = {
        modemId: this.id,
        uid: this.newModem ? this.inputValue : this.uid,
        machineId: this.machine.id,
        serial_number: this.machine.id ? this.machine.serial_number : ''
      };
      if (this.newModem) {
        return api["a" /* default */].post('modems/', data).then(function (data) {
          emitData.modemId = data.data.id;
          _this.$emit('hide', emitData);
        }).catch(this.handleValidationError);
      } else {
        if (this.noCommands) {
          data.modemUid = this.inputValue;
        }
        return api["a" /* default */].put('modems/' + this.id, data).then(function (_ref) {
          var data = _ref.data;

          emitData.number = data.number;
          _this.$emit('hide', emitData);
        }).catch(this.handleValidationError);
      }
    },
    deleteModem: function deleteModem() {
      if (window.confirm('Удалить модем?')) {
        return api["a" /* default */].put('/modems/' + this.uid + '/delete').then(function () {
          return window.location.reload();
        });
      }
    },
    modifyOptions: function modifyOptions(options) {
      return [this.emptyOption].concat(this.currentMachineId ? [this.currentOption] : []).concat(options);
    }
  },
  mounted: function mounted() {
    this.machine = this.currentMachineId ? this.currentOption : this.emptyOption;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330078dc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modems/edit-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[(_vm.newModem)?_c('h2',{staticClass:"modal-title"},[_vm._v("Добавить модем")]):_c('h2',{staticClass:"modal-title"},[_vm._v("Редактирование модема "+_vm._s(_vm.uid))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('hide')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body pb-0"},[(_vm.newModem || _vm.noCommands)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"edit-modem-uid"}},[_vm._v(_vm._s(_vm.newModem ? 'ID модема' : 'Номер модема'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],staticClass:"form-control",class:{'is-invalid': _vm.validationErrors.modemUid},attrs:{"type":"text","id":"edit-modem-uid"},domProps:{"value":(_vm.inputValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.validationErrors.modemUid),function(error){return _c('div',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(error))])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Привязать автомат")]),_vm._v(" "),_c('server-select',{attrs:{"endpoint":"modems/machines","label":"serial_number","modifyOptions":_vm.modifyOptions},model:{value:(_vm.machine),callback:function ($$v) {_vm.machine=$$v},expression:"machine"}})],1),_vm._v(" "),(!_vm.newModem)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Сбросить пароль")]),_c('br'),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-outline-danger",on:{"click":_vm.resetPassword}},[_vm._v("Сбросить пароль")])],1):_vm._e(),_vm._v(" "),(!_vm.newModem && _vm.noCommands)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Удалить модем")]),_c('br'),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-outline-danger",on:{"click":_vm.deleteModem}},[_vm._v("Удалить модем")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Отмена\n      ")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/modems/edit-modal.vue
function injectStyle (context) {
  __webpack_require__("dzOB")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  edit_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modems_edit_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vet1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/emulator.vue




/* harmony default export */ var emulator = ({
  data: function data() {
    return {
      jlinkCommands: ['ping', 'inf', 'cfg', 'eva', 'mdb', 'jinfo', 'jconfig', 'jlog'],
      starpCommands: ['cfgprg', 'man', 'evaprg', 'mdb', 'bin', 'gsmstatus', 'gsmexplore', 'jconfigprg', 'jlogreset', 'reboot', 'jstatreset', 'jfabreset', 'wait1s', 'wait5s', 'wait30s', 'wait1m', 'wait5m', 'wait1h'],
      jlinkSelected: '',
      starpSelected: '',
      jlinkFile: null,
      starpFile: null
    };
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      return files[0];
    },
    onDocJlinkChange: function onDocJlinkChange(e) {
      this.jlinkFile = this.onFileChange(e);
    },
    onDocStarpChange: function onDocStarpChange(e) {
      this.starpFile = this.onFileChange(e);
    },
    jlinkSave: function jlinkSave() {
      if (this.jlinkSelected !== '') {
        var data = new FormData();
        data.append('doc', this.jlinkFile);
        data.append('command', this.jlinkSelected);
        var config = {
          headers: { 'content-type': 'multipart/form-data' }
        };
        api["a" /* default */].post('emulator/jlink', data, config);
      }
    },
    starpSave: function starpSave() {
      if (this.starpSelected !== '') {
        var data = new FormData();
        data.append('doc', this.starpFile);
        data.append('command', this.starpSelected);
        var config = {
          headers: { 'content-type': 'multipart/form-data' }
        };
        api["a" /* default */].post('emulator/starp', data, config);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d6fc3f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/emulator.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n    JLINK\n  ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"jlink-select"}},[_vm._v("Тип команды")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.jlinkSelected),expression:"jlinkSelected"}],staticClass:"custom-select select-width",attrs:{"id":"jlink-select"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.jlinkSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Выберите ...")]),_vm._v(" "),_vm._l((_vm.jlinkCommands),function(command){return _c('option',{domProps:{"value":command}},[_vm._v("\n          "+_vm._s(command)+"\n        ")])})],2)]),_vm._v(" "),_c('form',[_c('input',{staticClass:"mb-3",attrs:{"type":"file"},on:{"change":_vm.onDocJlinkChange}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.jlinkSave}},[_vm._v("Отправить")])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n    STARP\n  ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"starp-select"}},[_vm._v("Тип команды")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.starpSelected),expression:"starpSelected"}],staticClass:"custom-select select-width",attrs:{"id":"starp-select"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.starpSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Выберите ...")]),_vm._v(" "),_vm._l((_vm.starpCommands),function(command){return _c('option',{domProps:{"value":command}},[_vm._v("\n          "+_vm._s(command)+"\n        ")])})],2)]),_vm._v(" "),_c('form',[_c('input',{staticClass:"mb-3",attrs:{"type":"file"},on:{"change":_vm.onDocStarpChange}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.starpSave}},[_vm._v("Отправить")])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/emulator.vue
function injectStyle (context) {
  __webpack_require__("Wrob")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  emulator,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_emulator = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "W1Ba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WRGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raven__ = __webpack_require__("Zozg");




window.$ = __webpack_provided_window_dot_jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.Vue = __WEBPACK_IMPORTED_MODULE_1_vue__["default"];

__webpack_require__("//Fk").default = __webpack_require__("0Qa9");
window.Promise = __webpack_require__("0Qa9");

window.Popper = __webpack_require__("Zgw8").default;
__webpack_require__("Og9d");
__webpack_require__("0OnO");
__webpack_require__("5UFK");
__webpack_require__("XMH8");
__webpack_require__("mPbY");
__webpack_require__("GSvq");

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).tooltip({
  selector: '[data-toggle="tooltip"]',
  animation: false
});

var moment = __webpack_require__("PJh5");
moment.locale('ru');
moment.updateLocale('ru', {
  relativeTime: {
    h: '%d час',
    d: '%d день',
    M: '%d месяц',
    y: '%d год'
  }
});

__webpack_require__("DgJe");
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Wo16":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\"><g fill=\"#3A81BA\" fill-rule=\"evenodd\"><path d=\"M18.825 12.555a8.01 8.01 0 0 1-.763 2.13 8.11 8.11 0 0 1-3.86 3.612 8.016 8.016 0 0 1-3.89.668 7.983 7.983 0 0 1-2.828-.75 8.096 8.096 0 0 1-3.728-3.617 8.014 8.014 0 0 1-.747-2.191 8.134 8.134 0 0 1-.05-2.652c.12-.818.368-1.616.731-2.359a8.104 8.104 0 0 1 4.243-3.945 7.992 7.992 0 0 1 3.103-.576 8.092 8.092 0 0 1 3.075.652 8.09 8.09 0 0 1 4.125 4.001 7.99 7.99 0 0 1 .688 2.377c.112.88.08 1.78-.099 2.65m.944-2.927a8.903 8.903 0 0 0-2.715-5.197A8.89 8.89 0 0 0 10.816 2a8.862 8.862 0 0 0-3.41.723 8.97 8.97 0 0 0-4.57 4.434 8.892 8.892 0 0 0-.764 2.637 8.986 8.986 0 0 0 .11 2.935c.172.84.467 1.654.872 2.41a8.984 8.984 0 0 0 4.253 3.955 8.882 8.882 0 0 0 4.254.746 8.891 8.891 0 0 0 5.57-2.483 8.975 8.975 0 0 0 1.779-2.41 8.88 8.88 0 0 0 .813-2.437c.17-.95.185-1.928.046-2.883\"/><path d=\"M14.682 12.552l-3.278-1.893V4.666c0-.293-.212-.53-.472-.53s-.472.238-.472.532v6.264c0 .174.095.326.236.408l3.515 2.03a.472.472 0 0 0 .471-.818\"/></g></svg>"

/***/ }),

/***/ "Wrob":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WzgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/users.vue




/* harmony default export */ var users = ({
  metaInfo: { title: 'Пользователи' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      sort: null,
      hasMore: true
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var keyword = sort.column.sortable === 'keyword' ? '.keyword' : '';
        this.sort = sort.prop + keyword + ':' + order;
      } else {
        this.sort = null;
      }
    },
    resendPassword: function resendPassword(id, email) {
      if (window.confirm('\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F ' + email + '?')) {
        return api["a" /* default */].put('auth/resend/' + id);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528fcb42","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/users.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"users","filtersValue":_vm.filtersValue,"loading":_vm.loading,"sort":_vm.sort,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Пользователи")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"users"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"sort-change":_vm.sortChange,"load-more":_vm.$refs.data.loadMore}},[_c('el-table-column',{attrs:{"sortable":"keyword","prop":"second_name","label":"Фамилия"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"first_name","label":"Имя"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"third_name","label":"Отчество"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"role.label","label":"Роль"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"email","label":"E-mail"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"phone","label":"Телефон"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"division.name","label":"Подразделение"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"division.region.name","label":"Организация"}}),_vm._v(" "),_c('table-column-date',{attrs:{"sortable":"custom","prop":"last_activity_at","label":"Последний сеанс","from-now":"","width":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('btn-action',{staticClass:"btn btn-sm btn-outline-danger",on:{"click":function () { return _vm.resendPassword(row.id, row.email); }}},[_vm._v("Сбросить пароль")])]}}],null,false,125034940)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/users.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  users,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var settings_users = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XYPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xd6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./resources/assets/js/lang/events.json
var events = __webpack_require__("D7iU");
var events_default = /*#__PURE__*/__webpack_require__.n(events);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/notifications.vue








/* harmony default export */ var notifications = ({
  metaInfo: { title: 'Уведомления' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      date: {
        min: moment_default()().subtract(7, 'days').format('YYYY-MM-DD'),
        max: moment_default()().format('YYYY-MM-DD')
      },
      externalFilters: null
    };
  },

  methods: {
    refreshFilters: function refreshFilters(event) {
      this.externalFilters = values_default()(event);
    }
  },
  computed: {
    codeFilters: function codeFilters() {
      return entries_default()(events_default.a).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          value: key,
          text: value.split('|')[0]
        };
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f0c4a7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/notifications.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"notifications-reports","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"date":_vm.date,"externalFilters":_vm.externalFilters},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Уведомления")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"users","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"filter-change":_vm.refreshFilters}},[_c('table-column-serial-number',{attrs:{"machine-prop":"machine"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"Пользователь","min-width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var user = ref.row.user;
return [_vm._v(_vm._s(_vm._f("fullName")(user)))]}}],null,false,162423082)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Тип","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.email)?_c('img',{attrs:{"src":__webpack_require__("uRG0"),"alt":""}}):_vm._e(),_vm._v(" "),(row.sms)?_c('img',{attrs:{"src":__webpack_require__("6DqF"),"alt":""}}):_vm._e()]}}],null,false,4224718099)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"text","label":"Текст уведомления","min-width":"400","filters":_vm.codeFilters,"filter-placement":"bottom-start"}}),_vm._v(" "),_c('table-column-date')],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/notifications.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  notifications,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_notifications = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Xira":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path fill=\"#DB3928\" fill-rule=\"evenodd\" d=\"M12.577 8.497c-1.849 0-2.929 3-2.929 4.464 0 1.296.552 2.064 1.512 2.064 1.849 0 2.881-3.528 2.881-4.944 0-.888-.528-1.584-1.464-1.584zm7.056 9.841c-2.496 1.825-4.657 2.569-7.344 2.569-2.641 0-4.873-.793-6.577-2.377C3.96 16.922 3 14.642 3 12.193 3 7.009 7.2 3 12.648 3c4.753 0 8.114 2.976 8.114 7.201 0 3.337-2.329 6.313-4.945 6.313-1.248 0-2.041-.672-2.041-1.752 0-.168 0-.288.049-.48-.673 1.296-1.776 2.232-3.312 2.232-1.945 0-3.265-1.489-3.265-3.673 0-3.12 2.257-5.808 4.824-5.808 1.273 0 2.185.456 2.713 1.632l.336-1.248h2.04L15.6 12.769c-.168.601-.239.984-.239 1.296 0 .6.36.96.984.96 1.56 0 3.072-2.448 3.072-4.944 0-3.456-2.736-5.833-6.744-5.833-4.777 0-8.329 3.409-8.329 8.017 0 4.345 3.312 7.417 8.016 7.417 2.377 0 4.369-.696 6.577-2.304l.696.96z\"/></svg>"

/***/ }),

/***/ "XnKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./resources/assets/js/components/sample-modal.vue + 2 modules
var sample_modal = __webpack_require__("FXTC");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/app-filters.vue






/* harmony default export */ var app_filters = ({
  name: 'AppFilters',
  props: {
    value: {},
    data: {},
    endpoint: {}
  },
  data: function data() {
    return {
      visible: false,
      resolve: null,
      values: this.value
    };
  },

  watch: {
    value: function value() {
      this.values = this.value;
    },

    values: {
      deep: true,
      handler: function handler(values) {
        this.$emit('input', values);
      }
    }
  },
  methods: {
    reset: function reset() {
      this.values = {};
      this.$refs.filters.collapseAll();
      jquery_default()(this.$refs.scrollContainer).animate({ scrollTop: 0 }, 300);
    },
    show: function show() {
      var _this = this;

      return new promise_default.a(function (resolve) {
        _this.visible = true;
        _this.resolve = resolve;
      });
    },
    hide: function hide(value) {
      this.visible = false;
      this.resolve(value);
      this.resolve = null;
    },
    apply: function apply() {
      this.hide();
    },
    openSampleModal: function openSampleModal() {
      this.$root.showModal(sample_modal["default"], { filters: this.values });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff97e07","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/app-filters.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-filters"},[(_vm.data && _vm.data.filters)?[_c('transition',{attrs:{"name":"slide-right","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"app-filters-content flex-column"},[_c('div',{staticClass:"app-filters-header modal-header d-flex align-items-center"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Фильтры")]),_vm._v(" "),_c('span',[_vm._v("Найдено "+_vm._s(_vm.data.total))]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm mr-1",on:{"click":function($event){return _vm.openSampleModal()}}},[_vm._v("В выборки")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-sm",on:{"click":_vm.reset}},[_vm._v("Сбросить")])])]),_vm._v(" "),_c('div',{ref:"scrollContainer",staticClass:"modal-body app-filters-scroll"},[_c('div',{staticClass:"app-filters-body modal-body"},[_c('filters',{ref:"filters",attrs:{"filters":_vm.data.filters,"endpoint":_vm.endpoint},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"app-filters-backdrop",on:{"click":_vm.hide}})])]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/app-filters.vue
function injectStyle (context) {
  __webpack_require__("tOq2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  app_filters,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_app_filters = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XzG3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBb2":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path fill=\"#DB392A\" fill-rule=\"evenodd\" d=\"M2 21.849c0-.321.096-1.035.21-1.56.649-3.002 2.81-5.554 5.756-6.799a10.431 10.431 0 0 1 3.14-.775c.443-.04 1.349-.04 1.79 0 1.888.174 3.595.799 5.084 1.861 1.953 1.395 3.324 3.447 3.814 5.712.114.526.21 1.24.21 1.561v.111H2v-.111zm9.568-10.56a5.236 5.236 0 0 1-2.124-.682 4.907 4.907 0 0 1-1.567-1.502c-.526-.811-.792-1.837-.717-2.763a4.538 4.538 0 0 1 1.413-2.975c.839-.804 1.896-1.266 3.104-1.355a5.096 5.096 0 0 1 2.883.687 4.89 4.89 0 0 1 1.566 1.502c.178.273.377.685.483.995.501 1.464.226 3.032-.752 4.284-.2.255-.64.678-.907.87a5.05 5.05 0 0 1-3.382.939z\"/></svg>"

/***/ }),

/***/ "YIXM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zcx+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/app/img/service-legend.6045c93.svg";

/***/ }),

/***/ "ZhMh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zozg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");


var Raven = null;

if (true) {
  Raven = __webpack_require__("/Hyb");
  var RavenVue = __webpack_require__("6fN7");

  Raven.config("http://bde961dc8f0e4b815db4c50d27d5d3fe@45.145.66.188:9000/2");
  Raven.addPlugin(RavenVue, __WEBPACK_IMPORTED_MODULE_0_vue__["default"]);

  if (window.env && window.env.RELEASE) {
    Raven.setRelease(window.env.RELEASE);
  }
  if (window.env && window.env.APP_ENV) {
    Raven.setEnvironment(window.env.APP_ENV);
  }

  Raven.install();
}

/* harmony default export */ __webpack_exports__["a"] = (Raven);

/***/ }),

/***/ "a11f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/components/tooltip.vue + 2 modules
var tooltip = __webpack_require__("I/hk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/progress-bar.vue




/* harmony default export */ var progress_bar = ({
  name: 'ProgressBar',
  components: { Tooltip: tooltip["default"] },
  props: {
    value: {
      type: Number
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    threshold: {
      type: Number
    },
    thresholdTitle: {
      type: String,
      default: 'Порог'
    },
    state: {
      type: String
    }
  },
  computed: {
    realMax: function realMax() {
      return Math.max(this.max, this.value, this.threshold);
    },
    valuePercentage: function valuePercentage() {
      return Math.round((this.value - this.min) / (this.realMax - this.min) * 100);
    },
    thresholdPercentage: function thresholdPercentage() {
      return Math.round((this.threshold - this.min) / (this.realMax - this.min) * 100);
    },
    stateClass: function stateClass() {
      return this.state ? 'bg-' + this.state : undefined;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214031b6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/progress-bar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrapper"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",class:_vm.stateClass,style:({ width: (_vm.valuePercentage + "%") }),attrs:{"role":"progressbar"}})]),_vm._v(" "),(_vm.threshold)?_c('tooltip',{staticClass:"progress-threshold",style:({ left: (_vm.thresholdPercentage + "%") }),attrs:{"data-toggle":"tooltip","title":_vm.thresholdTitle,"placement":"top"}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/progress-bar.vue
function injectStyle (context) {
  __webpack_require__("/8cq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  progress_bar,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_progress_bar = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "a7Ie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__("tVBY");
var range_default = /*#__PURE__*/__webpack_require__.n(range);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/schedule.vue








/* harmony default export */ var schedule = ({
  props: {
    id: {
      required: true
    },
    machine: {
      type: Object
    }
  },
  data: function data() {
    return {
      weekdays: []
    };
  },

  methods: {
    weekdayLabel: function weekdayLabel(i) {
      return moment_default()().weekday(i).format('dddd');
    },
    saveSchedule: function saveSchedule() {
      var _this = this;

      var workTime = this.weekdays.map(function (day, index) {
        if (!day.enabled) return null;

        var _day$range$map = day.range.map(_this.formatToDate),
            _day$range$map2 = slicedToArray_default()(_day$range$map, 2),
            from = _day$range$map2[0],
            till = _day$range$map2[1];

        return {
          day_of_week: index + 1,
          open_time: from,
          close_time: till
        };
      }).filter(function (item) {
        return item;
      });

      return api["a" /* default */].put('machines/' + this.id, {
        work_time: workTime
      }).then(function () {
        _this.machine.work_time = workTime;
      });
    },
    formatToDate: function formatToDate(value) {
      var minutes = parseInt(value);
      if (minutes === 24 * 60) {
        return '24:00';
      }
      if (isNaN(minutes)) return null;
      return moment_default()().hour(0).minute(minutes).format('HH:mm');
    }
  },
  created: function created() {
    var _this2 = this;

    this.weekdays = range_default()(1, 8).map(function (index) {
      var day = _this2.machine.work_time.find(function (day) {
        return day.day_of_week === index;
      });
      return day === undefined ? {
        enabled: false,
        range: [480, 1200]
      } : {
        enabled: true,
        range: [day.open_time, day.close_time].map(function (time) {
          var _time$split = time.split(':'),
              _time$split2 = slicedToArray_default()(_time$split, 2),
              hours = _time$split2[0],
              minutes = _time$split2[1];

          return 60 * hours + Number(minutes);
        })
      };
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02212594","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/schedule.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"page-heading"},[_vm._v("Режим работы")]),_vm._v(" "),_c('div',{staticClass:"table-full-width"},[(_vm.machine)?_c('table',{staticClass:"table-machine-schedule table"},_vm._l((_vm.weekdays),function(weekday,index){return _c('tr',{class:{'text-gray': !weekday.enabled}},[_c('td',{staticClass:"weekday-label"},[_vm._v(_vm._s(_vm.weekdayLabel(index)))]),_vm._v(" "),_c('td',{staticClass:"day-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(weekday.enabled),expression:"weekday.enabled"}],staticClass:"form-check-inline m-0",attrs:{"type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(weekday.enabled)?_vm._i(weekday.enabled,null)>-1:(weekday.enabled)},on:{"change":function($event){var $$a=weekday.enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(weekday, "enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(weekday, "enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(weekday, "enabled", $$c)}}}})]),_vm._v(" "),_c('td',{staticClass:"schedule-display"},[_vm._v("\n          "+_vm._s(_vm.formatToDate(weekday.range[0]))+" – "+_vm._s(_vm.formatToDate(weekday.range[1]))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"pr-5"},[_c('el-slider',{attrs:{"range":"","showTooltip":"","formatTooltip":_vm.formatToDate,"max":24 * 60,"step":15,"disabled":true},model:{value:(weekday.range),callback:function ($$v) {_vm.$set(weekday, "range", $$v)},expression:"weekday.range"}})],1)])}),0):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/schedule.vue
function injectStyle (context) {
  __webpack_require__("3ldo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  schedule,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _id_schedule = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aIlR":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "aVmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aZu/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ail4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./resources/assets/js/components/reports-schedule-edit-modal.vue + 2 modules
var reports_schedule_edit_modal = __webpack_require__("vRDl");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/schedule.vue





/* harmony default export */ var settings_schedule = ({
  metaInfo: { title: 'Расписание отчетов' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      selected: [],
      sort: null
    };
  },

  methods: {
    getScheduleForSelected: function getScheduleForSelected() {
      var sameSchedule = map_default()(this.selected, 'reports_schedule').every(function (schedule, index, schedules) {
        if (index === 0) return true;
        var previous = schedules[index - 1];
        return isEqual_default()(schedule, previous);
      });

      return sameSchedule ? this.selected[0].reports_schedule : {};
    },
    edit: function edit() {
      var _this = this;

      var ids = map_default()(this.selected, 'id');
      var value = this.getScheduleForSelected();

      this.$root.showModal(reports_schedule_edit_modal["default"], { ids: ids, value: value }).then(function (newSchedule) {
        newSchedule && _this.selected.forEach(function (machine) {
          machine.reports_schedule = newSchedule;
        });
      });
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var keyword = sort.column.sortable === 'keyword' ? '.keyword' : '';
        this.sort = sort.prop + keyword + ':' + order;
      } else {
        this.$emit('update:sort', null);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a493c6ce","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/schedule.vue
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"schedules","filtersValue":_vm.filtersValue,"loading":_vm.loading,"sort":_vm.sort,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h1',{staticClass:"mr-3"},[_vm._v("Расписание отчетов")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected && _vm.selected.length),expression:"selected && selected.length"}],staticClass:"btn btn-outline-secondary btn-sm mr-auto",on:{"click":function($event){return _vm.edit()}}},[_vm._v("\n        Редактировать выбранные\n        "),_c('span',{staticClass:"badge badge-dark"},[_vm._v(_vm._s(_vm.selected.length))])]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"schedules"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"sort-change":_vm.sortChange,"selection-change":function (selection) {this$1.selected = selection}}},[_c('table-column-serial-number',{attrs:{"sortable":"keyword"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"keyword","prop":"address","label":"Адрес установки","min-width":"100","show-overflow-tooltip":true}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reports_schedule","label":"Расписание"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('reports-schedule',{attrs:{"id":row.id},model:{value:(row.reports_schedule),callback:function ($$v) {_vm.$set(row, "reports_schedule", $$v)},expression:"row.reports_schedule"}})]}}],null,false,2403300453)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/schedule.vue
function injectStyle (context) {
  __webpack_require__("W1Ba")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  settings_schedule,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_settings_schedule = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "avEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/queue.vue


/* harmony default export */ var queue = ({
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69051f7d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/queue.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('iframe',{staticStyle:{"position":"absolute","left":"0","top":"0","width":"100%","height":"100%"},attrs:{"src":"/horizon","frameborder":"0"}})])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/queue.vue
function injectStyle (context) {
  __webpack_require__("6/fc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  queue,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_queue = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "azZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/dom-events/index.js
var dom_events = __webpack_require__("Fn2p");
var dom_events_default = /*#__PURE__*/__webpack_require__.n(dom_events);

// EXTERNAL MODULE: ./node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js
var bootstrap_datepicker = __webpack_require__("71lI");
var bootstrap_datepicker_default = /*#__PURE__*/__webpack_require__.n(bootstrap_datepicker);

// EXTERNAL MODULE: ./node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.ru.js
var bootstrap_datepicker_ru = __webpack_require__("xaR9");
var bootstrap_datepicker_ru_default = /*#__PURE__*/__webpack_require__.n(bootstrap_datepicker_ru);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/datepicker.vue








jquery_default.a.fn.datepicker.defaults.language = 'ru';

/* harmony default export */ var datepicker = ({
  name: 'datepicker',
  props: {
    value: {
      type: String
    }
  },
  data: function data() {
    return {
      date: this.valueToDate(this.value)
    };
  },

  watch: {
    value: function value(newValue) {
      var _this = this;

      this.date = this.valueToDate(newValue);
      this.$nextTick(function () {
        return _this.$input.datepicker('update');
      });
    },
    date: function date(newDate) {
      var value = this.dateToValue(newDate);
      if (!newDate || newDate && value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    valueToDate: function valueToDate(value) {
      var m = moment_default()(value, 'YYYY-MM-DD', true);
      if (m.isValid()) {
        return m.format('DD.MM.YYYY');
      }
    },
    dateToValue: function dateToValue(date) {
      var m = moment_default()(date, 'DD.MM.YYYY', true);
      if (m.isValid()) {
        return m.format('YYYY-MM-DD');
      }
    }
  },
  computed: {
    $input: function $input() {
      return jquery_default()(this.$refs.input);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var config = {
      todayHighlight: true,
      autoclose: true
    };
    this.$input.datepicker(config);

    this.$input.on('change clearDate cleared blur', function (e) {
      _this2.$nextTick(function () {
        return dom_events_default.a.emit(_this2.$refs.input, 'input');
      });
    });
    this.$input.trigger('change');
  },
  beforeDestroy: function beforeDestroy() {
    this.$input.datepicker('destroy');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013d7c64","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/datepicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],ref:"input",staticClass:"form-control",attrs:{"type":"text","data-inputmask-alias":"dd.mm.yyyy"},domProps:{"value":(_vm.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value}}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/datepicker.vue
function injectStyle (context) {
  __webpack_require__("72xW")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  datepicker,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_datepicker = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bK5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bNhb":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"46\" height=\"32\"><defs><path id=\"a\" d=\"M19.897 14.997H0V0h19.897v14.997z\"/></defs><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(2 2)\"><rect width=\"42\" height=\"27.891\" fill=\"#F78F45\" rx=\"3\"/><rect width=\"35\" height=\"22.907\" x=\"3.5\" y=\"2.5\" stroke=\"#FFF\" rx=\"3\"/><g transform=\"translate(11 7)\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask><path fill=\"#FFF\" d=\"M6.48 14.068a.463.463 0 0 0 0 .926h12.955a.463.463 0 1 0 0-.926H6.48zm4.128-11.632l1.952 1.952-9.377 9.384-2.198.238.239-2.197 9.384-9.377zm1.308-1.308l1.952 1.952-.65.65-1.952-1.952.65-.65zM11.91 0a.453.453 0 0 0-.05.007.462.462 0 0 0-.275.13L.458 11.263a.463.463 0 0 0-.13.275l-.326 2.95a.463.463 0 0 0 .514.506l2.942-.326a.462.462 0 0 0 .275-.13L14.859 3.412a.463.463 0 0 0 .003-.654l-.003-.004L12.242.137A.462.462 0 0 0 11.909 0z\" mask=\"url(#b)\"/></g></g></svg>"

/***/ }),

/***/ "baBi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/nd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event.vue





/* harmony default export */ var filter_event = ({
  props: {
    range: { type: Object },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      input: {
        number: this.value.number || {},
        date: this.value.date || {}
      }
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      return omitBy_default()(this.input, isEmpty_default.a);
    }
  },
  watch: {
    value: function value(input) {
      this.input = {
        number: input.number || {},
        date: input.date || {}
      };
    },

    preparedInput: {
      handler: function handler(newVal, oldVal) {
        if (!isEqual_default()(newVal, oldVal)) {
          this.$emit('input', this.preparedInput);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b83176","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Количество событий")]),_vm._v(" "),_c('filter-range',{attrs:{"range":_vm.range},model:{value:(_vm.input.number),callback:function ($$v) {_vm.$set(_vm.input, "number", $$v)},expression:"input.number"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("Даты событий")]),_vm._v(" "),_c('filter-range-date',{model:{value:(_vm.input.date),callback:function ($$v) {_vm.$set(_vm.input, "date", $$v)},expression:"input.date"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "d0UM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d9c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/filters.js
var filters = __webpack_require__("rm9P");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/orders/equipment/create.vue





/* harmony default export */ var create = ({
  metaInfo: { title: 'Новая заявка на детали и оборудование' },
  data: function data() {
    return {
      selectedEquipment: null,
      selectedDetail: null,
      selectedEquipments: [],
      selectedDetails: [],
      selectedTechnician: null
    };
  },

  methods: {
    fullName: filters["a" /* default */].fullName,
    deleteEquipment: function deleteEquipment(index) {
      this.equipments.push(this.selectedEquipments[index].data);
      this.selectedEquipments.splice(index, 1);
    },
    deleteDetail: function deleteDetail(index) {
      this.details.push(this.selectedDetails[index].data);
      this.selectedDetails.splice(index, 1);
    },
    save: function save() {
      var _this = this;

      return api["a" /* default */].post('orders/details', {
        user_id: this.selectedTechnician.id,
        parts_request: this.selectedDetails.map(function (current) {
          return {
            amount: current.count,
            part_id: current.data.id
          };
        }),
        extra_parts_request: this.selectedEquipments.map(function (current) {
          return {
            amount: current.count,
            extra_part_id: current.data.id
          };
        })
      }).then(function () {
        _this.$router.push('/orders/equipment');
      });
    }
  },
  watch: {
    selectedEquipment: function selectedEquipment(value) {
      if (value) {
        this.selectedEquipments.push({
          count: 1,
          data: value
        });
        this.equipments.splice(this.equipments.indexOf(value), 1);
        this.selectedEquipment = null;
      }
    },
    selectedDetail: function selectedDetail(value) {
      if (value) {
        this.selectedDetails.push({
          count: 1,
          data: value
        });
        this.details.splice(this.details.indexOf(value), 1);
        this.selectedDetail = null;
      }
    }
  },
  asyncComputed: {
    equipments: function equipments() {
      return api["a" /* default */].get('parts').then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    },
    details: function details() {
      return api["a" /* default */].get('details').then(function (_ref2) {
        var data = _ref2.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96d56efc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/orders/equipment/create.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_c('back-button',{attrs:{"to":"/orders/equipment"}}),_vm._v("Новая заявка")],1),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.selectedTechnician === null},on:{"click":_vm.save}},[_vm._v("Оформить заявку")])],1),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"max-width":"28rem"}},[_c('server-select',{attrs:{"custom-label":_vm.fullName,"endpoint":"users_by_role","endpoint-params":{role: ['tech']}},model:{value:(_vm.selectedTechnician),callback:function ($$v) {_vm.selectedTechnician=$$v},expression:"selectedTechnician"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.equipments)?_c('v-multiselect',{attrs:{"options":_vm.equipments,"label":"name","placeholder":"Выберите..."},model:{value:(_vm.selectedEquipment),callback:function ($$v) {_vm.selectedEquipment=$$v},expression:"selectedEquipment"}}):_vm._e(),_vm._v(" "),(_vm.selectedEquipments && _vm.selectedEquipments.length)?_c('table',{staticClass:"table table-sm px-0 mt-2 mb-0"},_vm._l((_vm.selectedEquipments),function(equipment,index){return _c('tr',[_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(equipment.data.name))])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"},attrs:{"width":"1"}},[_c('div',{staticClass:"input-group input-group-sm",staticStyle:{"width":"8em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(equipment.count),expression:"equipment.count"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(equipment.count)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(equipment, "count", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(equipment.data.measure))])]),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-danger",on:{"click":function($event){return _vm.deleteEquipment(index)}}},[_vm._v("×")])])])])])}),0):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.details)?_c('v-multiselect',{attrs:{"options":_vm.details,"label":"name","placeholder":"Выберите..."},model:{value:(_vm.selectedDetail),callback:function ($$v) {_vm.selectedDetail=$$v},expression:"selectedDetail"}}):_vm._e(),_vm._v(" "),(_vm.selectedDetails && _vm.selectedDetails.length)?_c('table',{staticClass:"table table-sm px-0 mt-2 mb-0"},_vm._l((_vm.selectedDetails),function(detail,index){return _c('tr',[_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(detail.data.name))])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"},attrs:{"width":"1"}},[_c('div',{staticClass:"input-group input-group-sm",staticStyle:{"width":"8em"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(detail.count),expression:"detail.count"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(detail.count)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(detail, "count", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(detail.data.measure))])]),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-danger",on:{"click":function($event){return _vm.deleteDetail(index)}}},[_vm._v("×")])])])])])}),0):_vm._e()],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Техник")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Дополнительное оборудование")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Детали")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/orders/equipment/create.vue
function injectStyle (context) {
  __webpack_require__("NPbj")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  create,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var equipment_create = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dBND":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><path d=\"M12.984 5.12a.62.62 0 0 1-.62.62H4.513a.62.62 0 0 1 0-1.24h7.85a.62.62 0 0 1 .62.62M2.033 4.086a1.033 1.033 0 1 1 0 2.066 1.033 1.033 0 0 1 0-2.066m10.951 3.823a.62.62 0 0 1-.62.62H4.513a.62.62 0 0 1 0-1.24h7.85a.62.62 0 0 1 .62.62M2.033 6.876a1.033 1.033 0 1 1 0 2.066 1.033 1.033 0 0 1 0-2.066m10.951 3.822a.62.62 0 0 1-.62.62H4.513a.62.62 0 0 1 0-1.24h7.85a.62.62 0 0 1 .62.62M2.033 9.665a1.033 1.033 0 1 1 0 2.066 1.033 1.033 0 0 1 0-2.066\" fill=\"#FFF\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "dHI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__("RyI1");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./node_modules/lodash/matches.js
var matches = __webpack_require__("vJjG");
var matches_default = /*#__PURE__*/__webpack_require__.n(matches);

// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__("KgVm");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/service-modal-planned.vue











/* harmony default export */ var service_modal_planned = ({
  props: ['machine_id', 'date', 'service', 'default_tech', 'default_operator', 'region_id', 'date_range'],
  data: function data() {
    return {
      selectedOperator: null,
      selectedTask: '',
      term: null,
      service_id: this.service.id,
      is_recommended: this.service.is_recommended,
      executor: this.service.executor,
      done: this.service.done,
      recommendation: this.service.recommendation,
      service_date: this.date,
      error: null,
      comment: null,
      editPermissions: {
        date: true,
        executor: true,
        tasks: true,
        remove: false,
        save: true
      }
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      if (this.selectedTasks.length === 0) {
        return this.remove();
      } else {
        var data = {
          task_types: map_default()(this.selectedTasks, function (current) {
            return current.id;
          }),
          date: this.service_date,
          machine_id: this.machine_id,
          executor_id: this.selectedOperator.id,
          date_range: this.date_range,
          comment: this.comment
        };
        var query = void 0;
        if (this.service_id) {
          query = api["a" /* default */].put('services/planned/' + this.service_id, data);
        } else {
          query = api["a" /* default */].post('services/planned', data);
        }
        return query.then(function (data) {
          _this.$emit('hide', assign_default()(data.data, { deleted: false }));
        }).catch(function (error) {
          if (error.response) {
            _this.error = 'Неподходящая дата';
          }
        });
      }
    },
    applyMoveRecommendation: function applyMoveRecommendation() {
      var _this2 = this;

      return api["a" /* default */].put('services/planned/' + this.service_id, { date: this.recommendation.recommended_date, date_range: this.date_range }).then(function (data) {
        _this2.$emit('hide', assign_default()(data.data, { deleted: false }));
      });
    },
    remove: function remove() {
      var _this3 = this;

      if (window.confirm('Удалить сервис?')) {
        return api["a" /* default */].delete('services/planned/' + this.service_id).then(function () {
          _this3.$emit('hide', { deleted: true });
        });
      }
    },
    addTask: function addTask() {
      var _this4 = this;

      if (this.selectedTask !== '' && !find_default()(this.selectedTasks, function (current) {
        return _this4.selectedTask.id === current.id;
      })) {
        this.selectedTasks.push(this.selectedTask);
      }
      this.selectedTask = '';
    },
    deleteTask: function deleteTask(index) {
      this.selectedTasks.splice(index, 1);
    },
    isDisabledTask: function isDisabledTask(task) {
      var tasksTypes = ['Плановое обслуживание', 'Смена матрицы', 'Профилактическое обслуживание на складе (ППРс)'];
      var checkTask = 'Проверка качества обслуживание и ремонта';
      return this.disableSomeTasks && tasksTypes.includes(task.name) || this.selectedTasks.length > 0 && (this.selectedTasks[0].name !== checkTask && task.name === checkTask || this.selectedTasks[0].name === checkTask && task.name !== checkTask);
    },
    formatLabel: function formatLabel(option) {
      if (option) {
        return (this.default_operator && option.id === this.default_operator.id ? 'Назначенный оператор: ' : this.default_tech && option.id === this.default_tech.id ? 'Назначенный техник: ' : '') + Vue.options.filters.fullName(option);
      }
    },
    modifyOptions: function modifyOptions(options) {
      if (!this.selectedOperator && this.executor) {
        this.selectedOperator = this.executor;
      }
      if (this.default_tech) {
        var index = findIndex_default()(options, matches_default()({ id: this.default_tech.id }));
        if (index !== -1) {
          options.splice(index, 1);
          options.unshift(this.default_tech);
        }
      }
      if (this.default_operator) {
        var _index = findIndex_default()(options, matches_default()({ id: this.default_operator.id }));
        if (_index !== -1) {
          options.splice(_index, 1);
          options.unshift(this.default_operator);
        }
      }
      return options;
    }
  },
  watch: {
    selectedOperator: function selectedOperator(newOperator, oldOperator) {
      if (oldOperator !== null) {
        this.selectedTasks = [];
      }
    }
  },
  asyncComputed: {
    allTasksTypes: function allTasksTypes() {
      return api["a" /* default */].get('tasks').then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    },

    selectedTasks: {
      get: function get() {
        var _this5 = this;

        if (this.service_id) {
          return api["a" /* default */].get('services/planned/' + this.service_id).then(function (_ref2) {
            var data = _ref2.data;

            _this5.editPermissions = data.data.editPermissions;
            _this5.comment = data.data.comment;
            return data.data.tasks.map(function (current) {
              return {
                id: current.type.id,
                name: current.type.name
              };
            });
          });
        } else {
          return [];
        }
      },

      default: []
    }
  },
  computed: {
    tasksTypes: function tasksTypes() {
      if (!this.selectedOperator) return;

      if (this.selectedOperator.role) {
        var serviceTasks = ['Инкассация', 'Загрузка ингредиентов', 'Выгрузка-загрузка монет', 'Санитарная обработка', 'Смена матрицы'];
        var techTasks = ['Инкассация', 'Оперативный ремонт', 'Плановое обслуживание', 'Смена матрицы', 'Профилактическое обслуживание на складе (ППРс)', 'Выгрузка-загрузка монет'];

        var availableTasks = ['Проверка качества обслуживание и ремонта'];
        switch (this.selectedOperator.role.name) {
          case 'service':
            availableTasks = serviceTasks;
            break;
          case 'tech':
            availableTasks = techTasks;
            break;
          case 'service_superior':
            availableTasks = availableTasks.concat(serviceTasks);
            break;
          case 'tech_superior':
            availableTasks = availableTasks.concat(techTasks);
        }

        return filter_default()(this.allTasksTypes, function (task) {
          return availableTasks.includes(task.name);
        });
      }

      return this.allTasksTypes;
    },
    disabled: function disabled() {
      return this.done || this.selectedOperator === null || this.service_id === null && this.selectedTasks.length === 0;
    },
    disableSomeTasks: function disableSomeTasks() {
      var tasksTypes = ['Плановое обслуживание', 'Смена матрицы', 'Профилактическое обслуживание на складе (ППРс)'];
      return this.selectedTasks.some(function (task) {
        return tasksTypes.includes(task.name);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217e1465","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/service-modal-planned.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("Добавить задачу в плановый сервис")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.date))])]),_vm._v(" "),(_vm.selectedTasks)?_c('div',{staticClass:"modal-body pb-0"},[(_vm.recommendation && _vm.editPermissions.date)?_c('div',{staticClass:"alert alert-success d-flex align-items-center",attrs:{"role":"alert"}},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("Рекомендуется перенести сервис на "+_vm._s(_vm.recommendation.recommended_date))]),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-sm btn-success ml-auto",on:{"click":_vm.applyMoveRecommendation}},[_vm._v("Перенести")])],1):_vm._e(),_vm._v(" "),(_vm.is_recommended)?_c('div',{staticClass:"alert alert-success d-flex align-items-center",attrs:{"role":"alert"}},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("Рекомендуется назначить этот сервис")])]):_vm._e(),_vm._v(" "),_c('el-date-picker',{staticClass:"mb-2",attrs:{"type":"date","clearable":false,"value-format":"yyyy-MM-dd","align":"right","size":"small","disabled":!_vm.editPermissions.date},model:{value:(_vm.service_date),callback:function ($$v) {_vm.service_date=$$v},expression:"service_date"}}),_vm._v(" "),_c('server-select',{staticClass:"mb-2",attrs:{"disabled":!_vm.editPermissions.executor,"custom-label":_vm.formatLabel,"placeholder":"Выберите исполнителя...","endpoint":"users_by_role","endpoint-params":{region_id: _vm.region_id},"modifyOptions":_vm.modifyOptions},model:{value:(_vm.selectedOperator),callback:function ($$v) {_vm.selectedOperator=$$v},expression:"selectedOperator"}}),_vm._v(" "),(_vm.tasksTypes && _vm.editPermissions.tasks)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTask),expression:"selectedTask"}],staticClass:"custom-select mb-2",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTask=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.addTask]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Выберите задачу...")]),_vm._v(" "),_vm._l((_vm.tasksTypes),function(task){return _c('option',{attrs:{"disabled":_vm.isDisabledTask(task)},domProps:{"value":task}},[_vm._v(_vm._s(task.name))])})],2):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.selectedTasks),function(task,index){return _c('li',[_c('strong',[_vm._v(_vm._s(task.name))]),_vm._v(" "),(_vm.editPermissions.tasks)?_c('button',{staticClass:"btn btn-sm btn-outline-danger ml-1 py-0",on:{"click":function($event){return _vm.deleteTask(index)}}},[_vm._v("× Удалить")]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"form-control",attrs:{"placeholder":"Добавить комментарий к задаче","disabled":!_vm.editPermissions.save,"rows":"3"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger mt-2"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',[(_vm.editPermissions.save)?_c('btn-action',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled},on:{"click":_vm.save}},[_vm._v("Назначить")]):_vm._e(),_vm._v(" "),(_vm.editPermissions.remove)?_c('btn-action',{staticClass:"btn btn-outline-danger ml-2",attrs:{"disabled":_vm.done},on:{"click":_vm.remove}},[_vm._v("Удалить сервис")]):_vm._e()],1),_vm._v(" "),_c('button',{staticClass:"btn btn-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Отмена")])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/service-modal-planned.vue
function injectStyle (context) {
  __webpack_require__("N05c")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  service_modal_planned,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_service_modal_planned = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dIAz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/components/filter-event-service.vue + 2 modules
var filter_event_service = __webpack_require__("emf1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-sale.vue



/* harmony default export */ var filter_event_sale = ({
  name: 'FilterEventSale',
  extends: filter_event_service["default"]
});
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-sale.vue
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_sale,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_sale = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dlFG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/find-index.js
var find_index = __webpack_require__("EZFi");
var find_index_default = /*#__PURE__*/__webpack_require__.n(find_index);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/each.js
var each = __webpack_require__("9uKM");
var each_default = /*#__PURE__*/__webpack_require__.n(each);

// EXTERNAL MODULE: ./resources/assets/js/components/service-modal-planned.vue + 2 modules
var service_modal_planned = __webpack_require__("dHI1");

// EXTERNAL MODULE: ./resources/assets/js/components/service-modal-performed.vue + 2 modules
var service_modal_performed = __webpack_require__("7DFl");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/machine-service-timeline.vue












/* harmony default export */ var machine_service_timeline = ({
  name: 'MachineServiceTimeline',
  props: {
    planned_prop: {
      type: Array,
      required: true
    },
    performed_prop: {
      type: Array,
      required: true
    },
    machine_id: {
      required: true
    },
    operator: {
      required: true
    },
    tech: {
      required: true
    },
    region_id: {
      required: true
    },
    date: {
      default: function _default() {
        return [moment_default()().startOf('month').format('YYYY-MM-DD'), moment_default()().endOf('month').format('YYYY-MM-DD')];
      }
    }
  },
  data: function data() {
    return {
      dragging: false,
      selectedService: null,
      draggingOver: null,
      error: false,
      planned: this.planned_prop
    };
  },

  methods: {
    serviceModalPlanned: function serviceModalPlanned(day, service, func) {
      var _this = this;

      this.$root.showModal(service_modal_planned["default"], {
        machine_id: this.machine_id,
        date: day.fullDate,
        service: service,
        default_operator: this.operator,
        default_tech: this.tech,
        region_id: this.region_id,
        date_range: this.date
      }).then(function (data) {
        if (data) {
          if (data.deleted) {
            var index = find_index_default()(_this.planned, function (current) {
              return current.id === service.id;
            });
            _this.planned.splice(index, 1);
          } else {
            func(data.data);
          }
        }
      });
    },
    showPerformed: function showPerformed(current) {
      this.$root.showModal(service_modal_performed["default"], {
        executor: current.executor,
        id: current.id
      });
    },
    edit: function edit(day, service) {
      var _this2 = this;

      this.serviceModalPlanned(day, service, function (data) {
        _this2.planned = data;
      });
    },
    create: function create(day) {
      var _this3 = this;

      if (this.$root.canCreateService() && moment_default()().diff(moment_default()(day.fullDate), 'days') <= 0) {
        var serviceParam = { done: false, is_recommended: false };
        this.serviceModalPlanned(day, serviceParam, function (data) {
          _this3.planned.push(data);
        });
      }
    },
    drag: function drag(service, event) {
      if (this.$root.canCreateService()) {
        if (service.planned_service_id === null) {
          event.dataTransfer.setData('text/plain', '');
          this.dragging = true;
          this.selectedService = service;
        }
      } else {
        event.preventDefault();
      }
    },
    drop: function drop(service) {
      if (service.planned_service_id === null) {
        this.dragging = false;
        this.selectedService = null;
      }
    },
    dragenter: function dragenter($e, service) {
      this.draggingOver = service.id;
    },
    dragleave: function dragleave($e, service) {
      this.draggingOver = null;
    },
    leave: function leave(service) {
      var _this4 = this;

      if (this.withoutPerformed(service) && this.dragging) {
        var buf = this.selectedService;
        api["a" /* default */].post('services/bind', {
          planned_service_id: service.id,
          id: buf.id
        }).then(function () {
          buf.planned_service_id = service.id;
          service.done = true;
        }).catch(function (error) {
          if (error.response) {
            _this4.error = true;
            setTimeout(function () {
              _this4.error = false;
            }, 3000);
          }
        });
      }
    },
    trColor: function trColor(number) {
      switch (number) {
        case 1:
          return '';
        case 2:
          return 'brown';
        case 3:
          return 'purple';
      }
    },
    withoutPerformed: function withoutPerformed(service) {
      return !service.done && !service.is_recommended && this.selectedService && stringify_default()(service.circles) === stringify_default()(this.selectedService.circles) && moment_default()(this.selectedService.date).diff(moment_default()(service.date), 'days', true) >= 0;
    },
    markerClass: function markerClass(service, isPlanned) {
      var classes = [];
      if (isPlanned && this.withoutPerformed(service)) {
        classes.push('without-performed');
        if (this.draggingOver === service.id) {
          classes.push('drop-target');
        }
      }
      if (service.circles.triangle) {
        if (isPlanned || service.planned_service_id !== null) {
          classes.push('triangle');
        }

        if (isPlanned) {
          classes.push('triangle-planned');
        } else if (service.late) {
          classes.push('triangle-late');
        } else {
          classes.push('triangle-performed');
        }
      } else {
        if (['service', 'service_superior'].includes(get_default()(service, 'executor.role.name'))) {
          classes.push('circle');
        }
        classes.push('circle-container');

        if (isPlanned) {
          classes.push('bg-primary');
        } else if (service.late) {
          classes.push('bg-danger');
        } else {
          classes.push('green');
        }
      }
      if (!isPlanned && service.planned_service_id === null) {
        if (service.circles.triangle) {
          classes.push('triangle-without-planned');
        } else {
          classes.push('without-planned');
        }
      }
      if (service.is_recommended || service.recommendation) {
        classes.push('has-recommendation');
      }
      return classes;
    }
  },
  computed: {
    performed: function performed() {
      return this.performed_prop;
    },

    daysComputed: function daysComputed() {
      var days = [];
      var data = [];
      each_default()(this.planned, function (date) {
        var str = date.date;
        if (data[str] === undefined) {
          data[str] = {
            performed: [],
            planned: []
          };
        }
        data[str].planned.push(date);
      });
      each_default()(this.performed, function (date) {
        var str = moment_default.a.parseZone(date.date).format('YYYY-MM-DD');
        if (data[str] === undefined) {
          data[str] = {
            performed: [],
            planned: []
          };
        }
        data[str].performed.push(date);
      });
      var from = moment_default()(this.date[0]);
      var to = moment_default()(this.date[1]);
      for (var m = from; m.diff(to, 'days') <= 0; m.add(1, 'days')) {
        var planned = [];
        var performed = [];
        var str = m.format('YYYY-MM-DD');
        if (str in data) {
          planned = data[str].planned;
          performed = data[str].performed;
        }
        days.push({
          day: m.date(),
          planned: planned,
          performed: performed,
          fullDate: str,
          weekday: m.day()
        });
      }

      return days;
    }
  },
  watch: {
    planned_prop: function planned_prop(nv, ov) {
      if (nv !== ov) {
        this.planned = this.planned_prop;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7229282a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/machine-service-timeline.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger width-100"},[_c('strong',[_vm._v("Ошибка!")])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"machine-service-timeline table table-settings-service",class:{'dragging-container': _vm.dragging},on:{"click":function($event){$event.stopPropagation();}}},[_c('tbody',[_c('tr',[_vm._m(0),_vm._v(" "),_vm._l((_vm.daysComputed),function(day){return _c('td',{staticClass:"circle-td"},_vm._l((day.planned),function(service){return _c('div',{staticClass:"planned mx-auto mb-2",class:_vm.markerClass(service, true),on:{"dragenter":function($event){return _vm.dragenter($event, service)},"dragleave":function($event){return _vm.dragleave($event, service)},"drop":function($event){return _vm.leave(service)},"click":function($event){return _vm.edit(day, service)},"dragover":function($event){$event.preventDefault();}}},[(service.circles.tl)?_c('div',{staticClass:"circle small-circle top-left-circle"}):_vm._e(),_vm._v(" "),(service.circles.tr)?_c('div',{staticClass:"circle small-circle top-right-circle",class:_vm.trColor(service.circles.tr)}):_vm._e(),_vm._v(" "),(service.circles.bl)?_c('div',{staticClass:"circle small-circle bottom-left-circle"}):_vm._e(),_vm._v(" "),(service.circles.br)?_c('div',{staticClass:"circle small-circle bottom-right-circle"}):_vm._e()])}),0)})],2),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_vm._l((_vm.daysComputed),function(day){return _c('td',{on:{"click":function($event){return _vm.create(day)}}},[_c('div',{class:'number-container mx-auto ' + (day.weekday == 0 ? 'sunday' : (day.weekday == 6 ? 'saturday' : ''))},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(day.day))])])])})],2),_vm._v(" "),_c('tr',[_vm._m(1),_vm._v(" "),_vm._l((_vm.daysComputed),function(day){return _c('td',_vm._l((day.performed),function(service){return _c('div',{staticClass:"mx-auto mb-2",class:_vm.markerClass(service, false),attrs:{"draggable":!service.planned_service_id},on:{"dragstart":function($event){return _vm.drag(service, $event)},"dragend":function($event){return _vm.drop(service)},"click":function($event){return _vm.showPerformed(service)}}},[(service.circles.tl)?_c('div',{staticClass:"circle small-circle top-left-circle"}):_vm._e(),_vm._v(" "),(service.circles.tr)?_c('div',{staticClass:"circle small-circle top-right-circle",class:_vm.trColor(service.circles.tr)}):_vm._e(),_vm._v(" "),(service.circles.bl)?_c('div',{staticClass:"circle small-circle bottom-left-circle"}):_vm._e(),_vm._v(" "),(service.circles.br)?_c('div',{staticClass:"circle small-circle bottom-right-circle"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"empty"})])}),0)})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('small',{staticStyle:{"color":"#719dc6"}},[_vm._v("План")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('small',{staticStyle:{"color":"#5fa615"}},[_vm._v("Факт")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/machine-service-timeline.vue
function injectStyle (context) {
  __webpack_require__("d0UM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  machine_service_timeline,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_machine_service_timeline = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dwQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./resources/assets/js/components/cash-voucher-form.vue + 2 modules
var cash_voucher_form = __webpack_require__("AvMT");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/money.vue






/* harmony default export */ var money = ({
  components: { CashVoucherForm: cash_voucher_form["default"] },
  props: {
    id: {
      required: true
    },
    machine: {
      type: Object
    }
  },
  data: function data() {
    return {
      full_count_coins: 0
    };
  },

  computed: {
    coins: function coins() {
      var _this = this;

      if (isEmpty_default()(this.machine.coins)) return;

      this.full_count_coins = 0;
      return this.machine.coins.map(function (coin) {
        var full = get_default()(_this.machine, 'coins_machine.full_count_coin' + coin.nominal, 0);
        _this.full_count_coins += full * coin.nominal;
        return {
          nominal: coin.nominal,
          count: coin.count,
          sum: coin.nominal === 'token' ? coin.count : coin.count * coin.nominal,
          max: full
        };
      });
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db75f72","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/money.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"page-heading"},[_vm._v("Денежные средства")]),_vm._v(" "),(_vm.machine)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card mb-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.machine.money_machines_eva_data)?_c('dl',{staticClass:"row mb-0"},[_c('dt',{staticClass:"col-xl-5"},[_vm._v("Модель")]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7"},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'money_machines_eva_data.banknotes_machine.model')))]),_vm._v(" "),_c('dt',{staticClass:"col-xl-5"},[_vm._v("Серийный №")]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7"},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'money_machines_eva_data.banknotes_machine.serial_number')))]),_vm._v(" "),_c('dt',{staticClass:"col-xl-5"},[_vm._v("Версия ПО")]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7"},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'money_machines_eva_data.banknotes_machine.software_version')))])]):_c('div',{staticClass:"text-muted text-center"},[_vm._v("Не задан")])])]),_vm._v(" "),_c('div',{staticClass:"card mb-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.machine.money_machines_eva_data)?_c('dl',{staticClass:"row mb-0"},[_c('dt',{staticClass:"col-xl-5"},[_vm._v("Модель")]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7"},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'money_machines_eva_data.coins_machine.model')))]),_vm._v(" "),_c('dt',{staticClass:"col-xl-5"},[_vm._v("Серийный №")]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7"},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'money_machines_eva_data.coins_machine.serial_number')))]),_vm._v(" "),_c('dt',{staticClass:"col-xl-5"},[_vm._v("Версия ПО")]),_vm._v(" "),_c('dd',{staticClass:"col-xl-7"},[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'money_machines_eva_data.coins_machine.software_version')))])]):_c('div',{staticClass:"text-muted text-center"},[_vm._v("Не задан")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card mb-4"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.coins)?_c('table',{staticClass:"w-100 table-sm px-0"},[_vm._m(3),_vm._v(" "),_c('tbody',[_vm._l((_vm.coins),function(coin){return _c('tr',[_c('td',[_c('number',{attrs:{"number":coin.nominal}}),_vm._v(" руб.")],1),_vm._v(" "),_c('td',[_c('number',{attrs:{"number":coin.count}}),_vm._v(" шт.")],1),_vm._v(" "),_c('td',[_c('number',{attrs:{"number":coin.sum}}),_vm._v(" руб.")],1),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('progress-bar',{staticClass:"ml-3",staticStyle:{"min-width":"100px","width":"10vw"},attrs:{"value":coin.count,"max":coin.max,"threshold":_vm.machine.coins_tube_threshold,"state":coin.count > _vm.machine.coins_tube_threshold ? 'success' : 'danger',"threshold-title":'Порог на тубу: ' + _vm.machine.coins_tube_threshold}})],1)])}),_vm._v(" "),_c('tr',[_vm._m(4),_vm._v(" "),_c('td',[_c('number',{attrs:{"number":_vm.machine.coins_count}}),_vm._v(" шт.")],1),_vm._v(" "),_c('td',[_c('number',{attrs:{"number":_vm.machine.coins_sum}}),_vm._v(" руб.")],1),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('progress-bar',{staticClass:"ml-3",staticStyle:{"min-width":"100px","width":"10vw"},attrs:{"value":_vm.machine.coins_sum,"max":_vm.full_count_coins,"threshold":_vm.machine.coins_summary_threshold,"state":_vm.machine.coins_sum > _vm.machine.coins_summary_threshold ? 'success' : 'danger',"threshold-title":'Общий порог: ' + _vm.machine.coins_summary_threshold}})],1)])],2)]):_c('div',{staticClass:"text-muted text-center"},[_vm._v("Нет данных")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card mb-4"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('p',[_c('number',{attrs:{"number":_vm.machine.banknotes_sum}}),_vm._v(" руб.,\n            "),_c('number',{attrs:{"number":_vm.machine.banknotes_count}}),_vm._v(" шт.\n          ")],1),_vm._v(" "),_c('div',{staticClass:"media align-items-center"},[(_vm.machine.banknotes_machine)?_c('progress-bar',{staticClass:"ml-3 media-body",staticStyle:{"min-width":"100px","width":"10vw"},attrs:{"value":_vm.machine.banknotes_count,"max":_vm.machine.banknotes_machine.full_count_banknotes,"threshold":_vm.machine.banknotes_count_threshold,"state":_vm.machine.banknotes_count < _vm.machine.banknotes_count_threshold ? 'success' : 'danger',"threshold-title":'Общий порог: ' + _vm.machine.banknotes_count_threshold}}):_c('div',{staticClass:"media-body text-muted text-center"},[_vm._v("Купюроприемник не задан")])],1)])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Купюроприемник")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Монетоприемник")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Монеты на сдачу")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Номинал")]),_vm._v(" "),_c('th',[_vm._v("Остаток")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Всего")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Купюр в автомате")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/money.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  money,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _id_money = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dzOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ebhS":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"46\" height=\"32\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(2 2)\"><rect width=\"42\" height=\"27.891\" fill=\"#F78F45\" rx=\"3\"/><rect width=\"35\" height=\"22.907\" x=\"3.5\" y=\"2.5\" stroke=\"#FFF\" rx=\"3\"/><path d=\"M22.726 11.392c0 .992-.798 1.801-1.777 1.801-.98 0-1.778-.81-1.778-1.8 0-.992.798-1.802 1.778-1.802.979 0 1.777.79 1.777 1.801M20.21 7.183v1.275c-1.278.324-2.257 1.538-2.257 2.934 0 1.397.96 2.59 2.257 2.935v7.366c0 .425.32.749.74.749a.73.73 0 0 0 .739-.749v-7.387c1.278-.323 2.257-1.538 2.257-2.914 0-1.376-.96-2.59-2.257-2.934V7.183a.73.73 0 0 0-.74-.749.743.743 0 0 0-.739.75m-6.992 10.239c0-.991.8-1.801 1.778-1.801.979 0 1.778.81 1.778 1.801 0 .992-.8 1.801-1.778 1.801-.979 0-1.778-.81-1.778-1.801m2.517 4.25v-1.336c1.278-.323 2.258-1.538 2.258-2.934a3.05 3.05 0 0 0-2.258-2.935V7.183a.73.73 0 0 0-.739-.749.73.73 0 0 0-.739.749v7.306C12.98 14.813 12 16.027 12 17.423c0 1.396.959 2.59 2.257 2.934v1.336c0 .425.32.75.74.75.419 0 .738-.365.738-.77m12.944-4.25c0 .992-.8 1.801-1.778 1.801-.979 0-1.778-.81-1.778-1.801 0-.991.8-1.801 1.778-1.801.979 0 1.778.79 1.778 1.801m-2.517-10.24v7.306c-1.278.324-2.258 1.538-2.258 2.934 0 1.396.96 2.59 2.258 2.934v1.336c0 .425.32.75.739.75a.73.73 0 0 0 .739-.75v-1.336c1.279-.323 2.257-1.538 2.257-2.934 0-1.396-.959-2.59-2.257-2.934V7.183a.73.73 0 0 0-.739-.749c-.42 0-.74.344-.74.749\" fill=\"#FFF\"/></g></svg>"

/***/ }),

/***/ "emf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-service.vue





/* harmony default export */ var filter_event_service = ({
  props: {
    range: { type: Object },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      event: {
        number: this.value.number || {},
        date: this.value.date || {}
      },
      selected: this.value.valueCheckbox || []
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      return omitBy_default()({
        number: this.event.number,
        date: this.event.date,
        valueCheckbox: this.selected
      }, isEmpty_default.a);
    }
  },
  watch: {
    value: function value(input) {
      this.event = {
        number: input.number || {},
        date: input.date || {}
      };
      this.selected = input.valueCheckbox || [];
    },

    preparedInput: {
      handler: function handler(newVal, oldVal) {
        if (!isEqual_default()(newVal, oldVal)) {
          this.$emit('input', this.preparedInput);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf0d4520","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-service.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('filter-checkboxes',{attrs:{"options":_vm.options,"enableCount":false},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-service.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_service,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_service = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eqfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/app-modals.vue





/* harmony default export */ var app_modals = ({
  name: 'AppModals',
  props: {
    modals: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  computed: {
    isOpen: function isOpen() {
      return !!this.modals.length;
    },
    topModal: function topModal() {
      return this.modals[this.modals.length - 1];
    }
  },
  watch: {
    isOpen: function isOpen(_isOpen) {
      var $modal = jquery_default()(this.$refs.modal);
      if (_isOpen) {
        jquery_default()('.modal-backdrop').show();
        $modal.show();
        this.visible = true;
        $modal.on('hide.bs.modal.modal-stack', this.onBootstrapHide);
      } else {
        $modal.off('hide.bs.modal.modal-stack', this.onBootstrapHide);
        this.visible = false;
        $modal.hide();
        jquery_default()('.modal-backdrop').hide();
      }
    },
    modals: function modals() {
      var _this = this;

      this.$nextTick(function () {
        jquery_default()(_this.$refs.modal).scrollTop(0);
      });
    }
  },
  methods: {
    show: function show(component, props) {
      var _this2 = this;

      return new promise_default.a(function (resolve) {
        _this2.modals.push({
          component: component,
          resolve: resolve,
          props: props
        });
      });
    },
    onHide: function onHide(value) {
      var _this3 = this;

      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var modalInstance = this.$refs.modals[this.$refs.modals.length - 1];

      var hideModal = function hideModal() {
        _this3.modals[_this3.modals.length - 1].resolve(value);
        _this3.modals.splice(_this3.modals.length - 1, 1);
      };

      if (!force && typeof modalInstance.beforeHide === 'function') {
        var hidePromise = new promise_default.a(function (resolve, reject) {
          promise_default.a.resolve(modalInstance.beforeHide(reject)).then(resolve).catch(reject);
        });

        hidePromise.then(hideModal).catch(function () {});
      } else {
        hideModal();
      }
    },
    onForceHide: function onForceHide(value) {
      this.onHide(value, true);
    },
    onBootstrapHide: function onBootstrapHide(e) {
      if (e.namespace === 'bs.modal') {
        e.preventDefault();
        this.onHide();
      }
    },
    closeAll: function closeAll() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d079ed0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/app-modals.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"app-backdrop",on:{"click":function($event){return _vm.onHide()}}})]),_vm._v(" "),_c('div',{ref:"modal",staticClass:"modal app-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onHide()}}},_vm._l((_vm.modals),function(modal,index){return _c(modal.component,_vm._b({directives:[{name:"show",rawName:"v-show",value:(index == (_vm.modals.length - 1)),expression:"index == (modals.length - 1)"}],key:index,ref:"modals",refInFor:true,tag:"component",staticClass:"app-modal-content",on:{"hide":_vm.onHide,"forceHide":_vm.onForceHide}},'component',modal.props,false))}),1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/app-modals.vue
function injectStyle (context) {
  __webpack_require__("u3Bg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  app_modals,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_app_modals = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ery0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/machine-list-map-tabs.vue


/* harmony default export */ var machine_list_map_tabs = ({
  name: 'MachineListMapTabs'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3182bb0e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/machine-list-map-tabs.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machine-view-tabs btn-group",attrs:{"role":"group"}},[_c('router-link',{staticClass:"btn btn-outline-light ",attrs:{"tag":"button","to":"/machines/"}},[_c('small',[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" Списком\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-outline-light ",attrs:{"tag":"button","to":"/map/"}},[_c('small',[_c('font-awesome-icon',{attrs:{"icon":"map-marker-alt"}})],1),_vm._v(" На карте\n  ")])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/machine-list-map-tabs.vue
function injectStyle (context) {
  __webpack_require__("UO4r")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  machine_list_map_tabs,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_machine_list_map_tabs = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "evSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/receipts/_id.vue




/* harmony default export */ var _id = ({
  props: {
    id: {}
  },
  data: function data() {
    return {};
  },

  asyncComputed: {
    receipt: function receipt() {
      return api["a" /* default */].get('receipts/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa96d42","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/receipts/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.receipt)?_c('receipt-details',{attrs:{"receipt":_vm.receipt}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/receipts/_id.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var receipts__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "f/S2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/table-column-element.vue


/* harmony default export */ var table_column_element = ({
  props: {
    currencySymbol: { type: String, default: null },
    tableColumnType: { type: String, default: 'default' } },
  methods: {
    isNumber: function isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f5d0c71","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-element.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t("default",null,null,scope)]}}],null,true)},'el-table-column',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/table-column-element.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_column_element,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_column_element = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fajZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__("kvU2");
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/documents-modal.vue + 2 modules
var documents_modal = __webpack_require__("rygB");

// EXTERNAL MODULE: ./resources/assets/js/components/table-column-checkbox.vue + 2 modules
var table_column_checkbox = __webpack_require__("9/A4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/admin/documents/index.vue








/* harmony default export */ var admin_documents = ({
  metaInfo: { title: 'Документы' },
  components: {
    TableColumnCheckbox: table_column_checkbox["default"]
  },
  data: function data() {
    return {
      updateList: 0,
      filtersValue: {},
      data: {},
      loading: false,
      hasMore: true,
      sort: null,
      needRefresh: false
    };
  },

  methods: {
    deleteDoc: function deleteDoc(id) {
      var _this = this;

      if (!window.confirm('Действительно удалить файл?')) return;
      var findDoc = this.findDocById(id);
      return api["a" /* default */].delete('documents/' + id, { 'params': findDoc.find }).then(function () {
        _this.refreshData();
      });
    },
    editDoc: function editDoc(id) {
      var _this2 = this;

      this.$root.showModal(documents_modal["default"], {
        currentDoc: cloneDeep_default()(this.findDocById(id).find)
      }).then(function (saved) {
        if (saved) {
          _this2.refreshData();
        }
      });
    },
    documents: function documents() {
      var _this3 = this;

      this.$root.showModal(documents_modal["default"]).then(function (saved) {
        if (saved) {
          _this3.refreshData();
        }
      });
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var sortable = sort.column.sortable;

        var prop = sortable === 'keyword' ? sort.prop + '.keyword' : sort.prop;
        this.sort = prop + ':' + order;
      } else {
        this.sort = null;
      }
    },
    findDocById: function findDocById(id) {
      var index = 0;

      var find = this.data.data.find(function (doc, idx) {
        index = idx;
        return doc.id === id;
      });

      return { index: index, find: find };
    },
    refreshData: function refreshData() {
      this.needRefresh = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47eadf9a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/admin/documents/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-grow-1"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"documents","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"refresh":_vm.needRefresh},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("Документы")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.documents}},[_vm._v("Добавить документ")])]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":function($event){return _vm.$refs.data.loadMore()},"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"prop":"name","sortable":"keyword","align":"center","label":"Название"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"text-left"},[_c('a',{attrs:{"href":row.url}},[_vm._v(_vm._s(row.name))])])]}}],null,false,3366779189)}),_vm._v(" "),_c('table-column-checkbox',{attrs:{"align":"center","label":"Оператор","checked":"roles.service"}}),_vm._v(" "),_c('table-column-checkbox',{attrs:{"align":"center","label":"Техник","checked":"roles.tech"}}),_vm._v(" "),_c('table-column-checkbox',{attrs:{"align":"center","label":"Руководитель операторов","checked":"roles.service_superior"}}),_vm._v(" "),_c('table-column-checkbox',{attrs:{"align":"center","label":"Руководитель техников","checked":"roles.tech_superior"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Действие"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.editDoc(row.id)}}},[_vm._v("Редактировать")]),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-sm btn-outline-danger",on:{"click":function () { return _vm.deleteDoc(row.id); }}},[_vm._v("Удалить")])]}}],null,false,423212657)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/admin/documents/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  admin_documents,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_admin_documents = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fnbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-encashment.vue





/* harmony default export */ var filter_event_encashment = ({
  props: {
    range: { type: Object },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      event: {
        number: this.value.number || {},
        date: this.value.date || {}
      },
      deliveryMoney: this.value.deliveryMoney || {},
      depositMoney: this.value.depositMoney || {}
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      return omitBy_default()({
        number: this.event.number,
        date: this.event.date,
        depositMoney: this.depositMoney,
        deliveryMoney: this.deliveryMoney
      }, isEmpty_default.a);
    }
  },

  watch: {
    value: function value(input) {
      this.event = {
        number: input.number || {},
        date: input.date || {}
      };
      this.deliveryMoney = input.deliveryMoney || {};
      this.depositMoney = input.depositMoney || {};
    },


    preparedInput: {
      handler: function handler(newVal, oldVal) {
        if (!isEqual_default()(newVal, oldVal)) {
          this.$emit('input', this.preparedInput);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46667594","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-encashment.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v(" Уточните изъятую сумму")]),_vm._v(" "),_c('filter-range',{model:{value:(_vm.deliveryMoney),callback:function ($$v) {_vm.deliveryMoney=$$v},expression:"deliveryMoney"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v(" Уточните внесенную сумму для сдачи")]),_vm._v(" "),_c('filter-range',{model:{value:(_vm.depositMoney),callback:function ($$v) {_vm.depositMoney=$$v},expression:"depositMoney"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-encashment.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_encashment,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_encashment = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fv+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/with-tooltip.js
var with_tooltip = __webpack_require__("6M62");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/encashment.vue





/* harmony default export */ var encashment = ({
  metaInfo: { title: 'Инкассации' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      date: {
        min: moment_default()().subtract(7, 'days').format('YYYY-MM-DD'),
        max: moment_default()().format('YYYY-MM-DD')
      },
      sort: null
    };
  },

  methods: {
    withTooltip: with_tooltip["a" /* default */],
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        var sortable = sort.column.sortable;

        var prop = sortable === 'keyword' ? sort.prop + '.keyword' : sort.prop;

        prop = prop.replace(/params/gi, 'params_encashment');

        this.sort = prop + ':' + order;
      } else {
        this.sort = null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758a24e9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/encashment.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"encashment","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"date":_vm.date,"sort":_vm.sort},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Инкассации")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"encashment","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"sort-change":_vm.sortChange}},[_c('table-column-date'),_vm._v(" "),_c('table-column-serial-number',{attrs:{"prop":"machine.serial_number","sortable":"keyword","machine-prop":"machine"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"machine.address","label":"Адрес","show-overflow-tooltip":true,"min-width":"220"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.sales_count","sortable":"custom","label":"Количество продаж","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.sales_sum","sortable":"custom","label":"Сумма продаж","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.delivery","sortable":"custom","label":"Загружено сдачи","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.inserted_coins_summary","sortable":"custom","label":"Монет","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.inserted_banknotes_summary","sortable":"custom","label":"Купюр","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.inserted_tokens_summary","sortable":"custom","label":"Жетонов","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","prop":"params.inserted_money_summary","sortable":"custom","label":"Всего","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"params.bag_id","sortable":"keyword","label":"Номер мешка"}})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/encashment.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  encashment,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_encashment = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gRN3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__("J009");
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);

// EXTERNAL MODULE: ./node_modules/lodash/isFinite.js
var lodash_isFinite = __webpack_require__("du7g");
var isFinite_default = /*#__PURE__*/__webpack_require__.n(lodash_isFinite);

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__("JDN0");
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// EXTERNAL MODULE: ./node_modules/lodash/pickBy.js
var pickBy = __webpack_require__("6PBa");
var pickBy_default = /*#__PURE__*/__webpack_require__.n(pickBy);

// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__("94Kh");
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);

// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("BUAs");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-range.vue










function emptyRange() {
  return { min: null, max: null };
}

/* harmony default export */ var filter_range = ({
  props: {
    range: { type: Object, default: emptyRange },
    value: { type: Object, default: emptyRange }
  },
  data: function data() {
    return {
      input: assign_default()(emptyRange(), this.value)
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      var strings = pickBy_default()(this.input, function (value) {
        return isString_default()(value) && value.length || isFinite_default()(value);
      });
      return omitBy_default()(mapValues_default()(strings, parseFloat), isNaN);
    },
    precision: function precision() {
      var precision = 2;
      return Math.pow(10, precision);
    },
    fromPlaceholder: function fromPlaceholder() {
      if (!isNumber_default()(this.range.min)) {
        return this.range.min;
      }
      return Math.round(this.range.min * this.precision) / this.precision;
    },
    toPlaceholder: function toPlaceholder() {
      if (!isNumber_default()(this.range.max)) {
        return this.range.max;
      }
      return Math.round(this.range.max * this.precision) / this.precision;
    }
  },
  methods: {
    update: debounce_default()(function () {
      this.$emit('input', this.preparedInput);
    }, 250)
  },
  watch: {
    value: function value(val) {
      this.input.min = val.min;
      this.input.max = val.max;
    },

    input: {
      handler: function handler() {
        this.update();
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3cf836","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-range.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"mr-3"},[_c('label',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.min),expression:"input.min"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.fromPlaceholder,"min":"0"},domProps:{"value":(_vm.input.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "min", $event.target.value)}}})])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.max),expression:"input.max"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.toPlaceholder,"min":"0"},domProps:{"value":(_vm.input.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "max", $event.target.value)}}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("От")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("До")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-range.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_range,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_range = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gcqA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gezW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gtZC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/filter-range-date.vue + 2 modules
var filter_range_date = __webpack_require__("Ajcq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/modems/_uid/index.vue







/* harmony default export */ var _uid = ({
  metaInfo: function metaInfo() {
    return { title: '\u041C\u043E\u0434\u0435\u043C ' + this.uid };
  },

  components: { FilterRangeDate: filter_range_date["default"] },
  props: {
    uid: {}
  },
  data: function data() {
    return {
      filtersValue: {},
      data: {},
      loading: false,
      hasMore: true,
      date: {},
      typeFilters: [{ text: 'actrep', value: 'actrep' }, { text: 'bin', value: 'bin' }, { text: 'cardprg', value: 'cardprg' }, { text: 'check', value: 'check' }, { text: 'cfg', value: 'cfg' }, { text: 'cfgprg', value: 'cfgprg' }, { text: 'dsl', value: 'dsl' }, { text: 'eva', value: 'eva' }, { text: 'evar', value: 'evar' }, { text: 'inf', value: 'inf' }, { text: 'jlog', value: 'jlog' }, { text: 'jpeg', value: 'jpeg' }, { text: 'log', value: 'log' }, { text: 'loglist', value: 'loglist' }, { text: 'man', value: 'man' }, { text: 'mic', value: 'mic' }, { text: 'mdb', value: 'mdb' }, { text: 'ping', value: 'ping' }, { text: 'qrcode', value: 'qrcode' }, { text: 'reboot', value: 'reboot' }, { text: 'transfer', value: 'transfer' }, { text: 'wav', value: 'wav' }],
      stateFilters: [{ value: 'ok', text: 'ok' }, { value: 'error', text: 'error' }, { value: 'queued', text: 'queued' }, { value: 'placed', text: 'placed' }, { value: 'in_progress', text: 'in_progress' }]
    };
  },

  asyncComputed: {
    modem: function modem() {
      return api["a" /* default */].get('modems/' + this.uid).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    }
  },
  filters: {
    timestamp: function timestamp(ts) {
      return moment_default()(ts).format('DD.MM.YYYY HH:mm:ss');
    }
  },
  methods: {
    sendCommand: function sendCommand(type) {
      if (window.confirm('\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0443 ' + type + '?')) {
        return api["a" /* default */].post('modems/' + this.uid + '/commands', {
          type: type
        }).then(function () {
          window.location.reload();
        });
      }
    },
    resetPassword: function resetPassword() {
      if (window.confirm('Действительно сбросить пароль?')) {
        return api["a" /* default */].put('modems/' + this.modem.id + '/resetPassword');
      }
    },
    deleteModem: function deleteModem() {
      var _this = this;

      if (window.confirm('Удалить модем?')) {
        return api["a" /* default */].put('/modems/' + this.uid + '/delete').then(function () {
          return _this.$router.push('/modems/deleted');
        });
      }
    },
    refreshFilters: function refreshFilters(event) {
      this.filtersValue = assign_default()({}, this.filtersValue, event);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b2e36e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/modems/_uid/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":("modems/" + (this.uid) + "/commands"),"filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"date":_vm.date},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-auto"},[_c('h1',[_vm._v(_vm._s(this.uid))])]),_vm._v(" "),_c('filter-range-date',{staticClass:"mr-2",staticStyle:{"max-width":"26em"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('div',{staticClass:"btn-group"},[(this.modem && this.modem.machine && _vm.$root.checkPermission('web_ta_modem'))?_c('router-link',{staticClass:"btn btn-outline-light",attrs:{"to":("/machines/" + (this.modem.machine.id) + "/modem")},domProps:{"textContent":_vm._s(("Автомат " + (this.modem.machine.serial_number)))}}):(this.modem && this.modem.machine)?_c('div',{staticClass:"btn btn-outline-light"},[_vm._v("\n          "+_vm._s(("Автомат " + (this.modem.machine.serial_number)))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-light dropdown-toggle dropdown-toggle-split",attrs:{"type":"button","data-toggle":"dropdown"}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('h6',{staticClass:"dropdown-header"},[_vm._v("Отправить команду")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('inf'); }}},[_vm._v("inf")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('cfg'); }}},[_vm._v("cfg")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('eva'); }}},[_vm._v("eva")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('log'); }}},[_vm._v("log")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('jlog'); }}},[_vm._v("jlog")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('ping'); }}},[_vm._v("ping")]),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('reboot'); }}},[_vm._v("reboot")]),_vm._v(" "),(_vm.$root.isAdmin())?_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('eva(i)'); }}},[_vm._v("eva(i)")]):_vm._e(),_vm._v(" "),(_vm.$root.isAdmin())?_c('btn-action',{staticClass:"dropdown-item",on:{"click":function () { return _vm.sendCommand('eva(pr1)'); }}},[_vm._v("eva(pr1)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item dropdown-item-danger",on:{"click":_vm.resetPassword}},[_c('font-awesome-icon',{attrs:{"icon":"unlock-alt"}}),_vm._v("\n            Сбросить пароль\n          ")],1),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('btn-action',{staticClass:"dropdown-item dropdown-item-danger",on:{"click":_vm.deleteModem}},[_c('font-awesome-icon',{attrs:{"icon":"trash-alt"}}),_vm._v("\n            Удалить модем\n          ")],1)],1)],1)],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"filter-change":_vm.refreshFilters}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"modem-command-details-expand"},[_c('modem-command-details',{attrs:{"command":row}})],1)]}}],null,false,1854883838)}),_vm._v(" "),_c('table-column-date'),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Тип","width":"150","filters":_vm.typeFilters,"filter-placement":"bottom-start","column-key":"type","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"state","label":"Статус","width":"150","filters":_vm.stateFilters,"filter-placement":"bottom-start","column-key":"state","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(row.state)+"\n          "),(row.error_code)?_c('div',{staticClass:"text-danger"},[_vm._v("Ошибка "+_vm._s(row.error_code))]):_vm._e()]}}],null,false,1194376577)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"data_result","label":"Ответ"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.data_result)?_c('pre',{staticClass:"modem-command-data-result-preview m-0"},[_vm._v(_vm._s(row.data_result.trim()))]):_vm._e()]}}],null,false,4048390997)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/modems/_uid/index.vue
function injectStyle (context) {
  __webpack_require__("SVaF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _uid,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modems__uid = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hVME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hrl2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ru": "ulq9",
	"./ru.js": "ulq9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hrl2";

/***/ }),

/***/ "iLmC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGZpbGw9IiM1NTFCMEUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDI3QzguMzczIDI3IDMgMjEuNjI3IDMgMTVTOC4zNzMgMyAxNSAzczEyIDUuMzczIDEyIDEyLTUuMzczIDEyLTEyIDEyem0uODE4LTE3LjY0NmExLjE2MyAxLjE2MyAwIDAgMC0xLjY3Ny4wMDZsLTMuOTcgNC4wODhjLTEuMTI3IDEuMTMxLjU2NSAyLjgyOSAxLjY5MyAxLjY5N2wxLjM3My0xLjM4MmMuMzEzLS4zMTQuNTY3LS4yMDcuNTY3LjIzNHY1LjUwMmExLjE5OCAxLjE5OCAwIDAgMCAyLjM5MyAwdi01LjUwMmMwLS40NDQuMjUzLS41NDguNTY2LS4yMzRsMS4zNzMgMS4zODJjMS4xMjggMS4xMzIgMi44Mi0uNTY2IDEuNjkyLTEuNjk3bC00LjAxLTQuMDk0eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "iY2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/receipts.vue




/* harmony default export */ var receipts = ({
  metaInfo: { title: 'Чеки' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      sort: null,
      date: [moment_default()().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment_default()().endOf('day').format('YYYY-MM-DDTHH:mm:ss')],
      pickerOptions: {
        firstDayOfWeek: 1
      },
      inn: null,
      fsNumber: null,
      external: null
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.sort = sort.prop + ':' + order;
      } else {
        this.sort = null;
      }
    },
    save: function save() {
      this.external = this.externalData;
    }
  },
  computed: {
    externalData: function externalData() {
      var data = {};
      if (this.inn) data.inn = this.inn;
      if (this.fsNumber) data.fs_number = this.fsNumber;
      return data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8fc949","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/receipts.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"receipts-reports","filtersValue":_vm.filtersValue,"sort":_vm.sort,"date":_vm.date,"externalFilters":_vm.external},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Чеки")]),_vm._v(" "),_c('div',{staticClass:"input-group mr-1",staticStyle:{"max-width":"15em"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inn),expression:"inn"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.inn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inn=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mr-1",staticStyle:{"max-width":"27em"}},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fsNumber),expression:"fsNumber"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.fsNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fsNumber=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary mr-3",on:{"click":_vm.save}},[_vm._v("Применить")]),_vm._v(" "),_c('el-date-picker',{staticClass:"mr-2",attrs:{"type":"datetimerange","clearable":false,"value-format":"yyyy-MM-ddTHH:mm:ss","default-time":['00:00:00', '23:59:59'],"align":"right","range-separator":"–","picker-options":_vm.pickerOptions,"size":"small"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"receipts-reports"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?_c('data-table-full-height',{attrs:{"data":_vm.data.data,"show-summary":""},on:{"sort-change":_vm.sortChange}},[_c('table-column-serial-number',{attrs:{"fixed":true}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"Адрес установки","show-overflow-tooltip":true,"min-width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"custom","prop":"count","label":"Всего чеков","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{ path: '/receipts', query: { machine_id: row.id }}}},[_c('number',{attrs:{"number":row.count}})],1)]}}],null,false,47814172)}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"successful","label":"Удачных","min-width":"120"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"center","sortable":"custom","prop":"unsuccessful","label":"Неудачных","min-width":"120"}}),_vm._v(" "),_c('table-column-date',{attrs:{"prop":"last_receipt","label":"Последний чек","align":"right"}})],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("ИНН")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Номер фискального накопителя")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/receipts.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  receipts,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_receipts = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j+LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/settings/recipes/products/index.vue


/* harmony default export */ var products = ({
  metaInfo: { title: 'Продукты' },
  data: function data() {
    return {
      filtersValue: {},
      data: {},
      loading: false,
      hasMore: true
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56bda298","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/settings/recipes/products/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-grow-1"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"products","loading":_vm.loading,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore}},[_c('el-table-column',{attrs:{"label":"Идентификатор","prop":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Наименование","prop":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Подробнее","align":"center","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('router-link',{staticClass:"btn btn-sm btn-outline-light",attrs:{"to":("/settings/recipes/products/" + (row.id))}},[_vm._v("\n            Подробнее\n          ")])]}}],null,false,1116405295)})],1)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex align-items-center"},[_c('h2',{staticClass:"page-heading"},[_vm._v("Продукты")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/settings/recipes/products/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  products,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var recipes_products = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j2Kt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "je9+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vue-async-computed/dist/vue-async-computed.esm.js
var vue_async_computed_esm = __webpack_require__("JJ92");

// EXTERNAL MODULE: ./node_modules/v-hotkey/index.js
var v_hotkey = __webpack_require__("K97M");
var v_hotkey_default = /*#__PURE__*/__webpack_require__.n(v_hotkey);

// EXTERNAL MODULE: ./node_modules/vue-meta/lib/vue-meta.js
var vue_meta = __webpack_require__("p3jY");
var vue_meta_default = /*#__PURE__*/__webpack_require__.n(vue_meta);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// EXTERNAL MODULE: ./node_modules/vue-bootstrap-datetimepicker/dist/vue-bootstrap-datetimepicker.js
var vue_bootstrap_datetimepicker = __webpack_require__("fv+1");
var vue_bootstrap_datetimepicker_default = /*#__PURE__*/__webpack_require__.n(vue_bootstrap_datetimepicker);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__("w9Mt");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./resources/assets/js/auth.js
var auth = __webpack_require__("S8OL");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./resources/assets/js/routes.js



var routes_authGuard = function authGuard(to, from, next) {
  return auth["a" /* default */].check().then(function () {
    return next();
  }).catch(function () {
    return next('/login');
  });
};
var routes_guestGuard = function guestGuard(to, from, next) {
  return auth["a" /* default */].check().then(function () {
    return next('/');
  }).catch(function () {
    return next();
  });
};

var routes_permissionGuard = function permissionGuard(permission) {
  return function (to, from, next) {
    if (auth["a" /* default */].checkPermission(permission)) {
      next();
    } else {
      next(false);
    }
  };
};

var routes_mainPageGuard = function mainPageGuard(to, from, next) {
  if (auth["a" /* default */].checkPermission('web_main')) {
    return next();
  }
  if (auth["a" /* default */].checkPermission('web_sales')) {
    return next('/reports/sales');
  }
  if (auth["a" /* default */].checkPermission('web_service')) {
    return next('/service');
  }
};

var routes_adminGuard = function adminGuard(to, from, next) {
  if (auth["a" /* default */].isAdmin()) {
    next();
  } else {
    next(false);
  }
};

/* harmony default export */ var routes = ([{
  path: '/login',
  component: __webpack_require__("B8C8").default,
  beforeEnter: routes_guestGuard
}, {
  path: '/',
  component: __webpack_require__("EIOz").default,
  beforeEnter: routes_mainPageGuard
}, {
  path: '/index',
  component: __webpack_require__("EIOz").default,
  beforeEnter: routes_mainPageGuard
}, {
  path: '/machines',
  component: __webpack_require__("JR9S").default,
  beforeEnter: routes_permissionGuard('web_ta')
}, {
  path: '/map',
  component: __webpack_require__("QDYB").default,
  beforeEnter: routes_permissionGuard('web_ta')
}, {
  path: '/machines/:id',
  component: __webpack_require__("u0Qr").default,
  props: true,
  children: [{
    path: '/',
    component: __webpack_require__("MCn0").default,
    beforeEnter: routes_permissionGuard('web_ta_main')
  }, {
    path: 'money',
    component: __webpack_require__("dwQK").default,
    beforeEnter: routes_permissionGuard('web_ta_main')
  }, {
    path: 'matrix',
    component: __webpack_require__("yhQ7").default,
    beforeEnter: routes_permissionGuard('web_ta_matrix')
  }, {
    path: 'modem',
    component: __webpack_require__("4mXe").default,
    beforeEnter: routes_permissionGuard('web_ta_modem')
  }, {
    path: 'schedule',
    component: __webpack_require__("a7Ie").default,
    beforeEnter: routes_permissionGuard('web_ta_schedule')
  }, {
    path: 'cards',
    component: __webpack_require__("LY4e").default,
    beforeEnter: routes_permissionGuard('web_ta_magnet')
  }, {
    path: 'eva',
    component: __webpack_require__("8Fg5").default,
    beforeEnter: routes_permissionGuard('web_ta_eva')
  }, {
    path: 'eva/:eva_id',
    component: __webpack_require__("sLOf").default,
    beforeEnter: routes_permissionGuard('web_ta_eva'),
    props: true
  }]
}, {
  path: '/reports',
  redirect: '/reports/sales'
}, {
  path: '/reports/sales',
  component: __webpack_require__("qdlZ").default,
  beforeEnter: routes_permissionGuard('web_sales')
}, {
  path: '/reports/expenditure',
  component: __webpack_require__("8nG6").default,
  beforeEnter: routes_permissionGuard('web_rate')
}, {
  path: '/reports/encashment',
  component: __webpack_require__("fv+i").default,
  beforeEnter: routes_permissionGuard('web_collect')
}, {
  path: '/reports/events',
  component: __webpack_require__("wPD/").default,
  beforeEnter: routes_permissionGuard('web_events')
}, {
  path: '/reports/events/:id',
  component: __webpack_require__("O3TP").default,
  beforeEnter: routes_permissionGuard('web_events'),
  props: true
}, {
  path: '/reports/downtime',
  component: __webpack_require__("Erqu").default,
  beforeEnter: routes_permissionGuard('web_downtime')
}, {
  path: '/reports/notifications',
  component: __webpack_require__("Xd6e").default,
  beforeEnter: routes_permissionGuard('web_alerts')
}, {
  path: '/reports/receipts',
  component: __webpack_require__("iY2M").default,
  beforeEnter: routes_permissionGuard('web_bills')
}, {
  path: '/reports/service',
  component: __webpack_require__("OJ8R").default,
  beforeEnter: routes_permissionGuard('web_service')
}, {
  path: '/reports/samples',
  component: __webpack_require__("xb9M").default
}, {
  path: '/service',
  component: __webpack_require__("B5sZ").default,
  beforeEnter: routes_permissionGuard('web_service')
}, {
  path: '/settings',
  redirect: '/settings/recipes/products'
}, {
  path: '/settings/recipes',
  redirect: '/settings/recipes/products'
}, {
  path: '/settings/recipes',
  component: __webpack_require__("71CU").default,
  beforeEnter: routes_permissionGuard('web_matrix'),
  children: [{
    path: 'products',
    component: __webpack_require__("j+LJ").default
  }, {
    path: 'products/:id',
    component: __webpack_require__("LiQ1").default
  }, {
    path: 'ingredients',
    component: __webpack_require__("I3/h").default
  }]
}, {
  path: '/settings/schedule',
  component: __webpack_require__("ail4").default,
  beforeEnter: routes_permissionGuard('web_schedule')
}, {
  path: '/settings/notifications',
  component: __webpack_require__("56bP").default,
  beforeEnter: routes_permissionGuard('web_alert_settings')
}, {
  path: '/settings/notifications/:id',
  props: true,
  component: __webpack_require__("HVhr").default,
  beforeEnter: routes_permissionGuard('web_alert_settings')
}, {
  path: '/settings/users',
  component: __webpack_require__("WzgT").default,
  beforeEnter: routes_permissionGuard('web_users')
}, {
  path: '/settings/categories',
  component: __webpack_require__("B8J5").default
}, {
  path: '/admin',
  redirect: '/admin/limits'
}, {
  path: '/admin/ffd12',
  component: __webpack_require__("GHkq").default,
  beforeEnter: routes_permissionGuard('web_admin_ffd12')
}, {
  path: '/admin/lists',
  component: __webpack_require__("BeKs").default,
  beforeEnter: routes_permissionGuard('web_admin_ffd12')
}, {
  path: '/admin/limits',
  component: __webpack_require__("K2Id").default,
  beforeEnter: routes_permissionGuard('web_thresholds')
}, {
  path: '/admin/documents',
  component: __webpack_require__("0wIx").default,
  beforeEnter: routes_permissionGuard('web_checklist'),
  children: [{
    path: '/',
    component: __webpack_require__("fajZ").default
  }, {
    path: 'checklists',
    component: __webpack_require__("1kcq").default
  }]
}, {
  path: '/help',
  component: __webpack_require__("V1gp").default
}, {
  path: '/orders',
  component: __webpack_require__("TcLK").default,
  beforeEnter: routes_permissionGuard('web_requests'),
  children: [{
    path: '/',
    redirect: '/orders/equipment'
  }, {
    path: 'equipment',
    component: __webpack_require__("Dd/1").default
  }, {
    path: 'ingredients',
    component: __webpack_require__("3Z56").default
  }, {
    path: 'ingredients/create',
    component: __webpack_require__("/yjs").default
  }, {
    path: 'equipment/create',
    component: __webpack_require__("d9c6").default
  }, {
    path: 'equipment/:id',
    props: true,
    component: __webpack_require__("BiDs").default
  }, {
    path: 'ingredients/:id',
    props: true,
    component: __webpack_require__("AA+w").default
  }]
}, {
  path: '/emulator',
  component: __webpack_require__("Vet1").default
}, {
  path: '/modems',
  component: __webpack_require__("nqUA").default,
  beforeEnter: routes_permissionGuard('web_modems'),
  children: [{
    path: '/',
    component: __webpack_require__("TIl+").default
  }, {
    path: 'deleted',
    component: __webpack_require__("pk7w").default
  }, {
    path: 'broadcasts',
    component: __webpack_require__("JiJn").default,
    beforeEnter: routes_adminGuard
  }]
}, {
  path: '/modems/broadcasts/:id',
  props: true,
  component: __webpack_require__("zPUz").default,
  beforeEnter: routes_adminGuard
}, {
  path: '/modems/:uid',
  props: true,
  component: __webpack_require__("hLQs").default,
  beforeEnter: routes_permissionGuard('web_modems')
}, {
  path: '/commands/:id',
  props: true,
  component: __webpack_require__("NGsC").default,
  beforeEnter: routes_permissionGuard('web_modems')
}, {
  path: '/receipts',
  component: __webpack_require__("L4zg").default,
  beforeEnter: routes_permissionGuard('web_bills')
}, {
  path: '/receipts/:id',
  props: true,
  component: __webpack_require__("evSF").default,
  beforeEnter: routes_permissionGuard('web_bills')
}, {
  path: '/queue',
  component: __webpack_require__("avEM").default
}].concat(toConsumableArray_default()( false ? [{
  path: '/dev',
  component: require('./pages/dev.vue').default
}] : []), [{
  path: '*',
  component: __webpack_require__("/Rpq").default
}]));
// CONCATENATED MODULE: ./resources/assets/js/router.js



var router = new vue_router_esm["a" /* default */]({
  routes: routes,
  mode: 'history',
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  if (to.path !== '/login') {
    routes_authGuard(to, from, next);
  } else {
    next();
  }
});

/* harmony default export */ var js_router = (router);
// EXTERNAL MODULE: ./resources/assets/js/raven.js
var raven = __webpack_require__("Zozg");

// EXTERNAL MODULE: ./resources/assets/js/components/app-alert.vue + 3 modules
var app_alert = __webpack_require__("nPTs");

// EXTERNAL MODULE: ./resources/assets/js/components/release-modal.vue + 2 modules
var release_modal = __webpack_require__("96X0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/app.vue









/* harmony default export */ var app = ({
  metaInfo: {
    title: 'Vendoscope',
    titleTemplate: '%s – Vendoscope'
  },
  data: function data() {
    return {
      isDev: "production" === 'development',
      user: null,
      init: false,
      release: null,
      store: {},
      serviceRoles: ['tech_superior', 'service_superior', 'tech_chief', 'service_chief', 'admin', 'director', 'branch_admin', 'superior'],
      indexPageRoles: ['admin', 'dev_chief', 'service_chief', 'tech_chief', 'fin_chief', 'accountant_chief', 'branch_chief', 'analyst', 'director']
    };
  },

  router: js_router,
  methods: {
    showModal: function showModal(component, props) {
      return this.$refs.modals.show(component, props);
    },
    closeAllModals: function closeAllModals(component, props) {},
    showAlert: function showAlert(message) {
      return this.showModal(app_alert["default"], { header: message });
    },
    checkPermission: function checkPermission(permission) {
      return this.user.permissions.includes(permission);
    },
    canCreateService: function canCreateService() {
      return this.serviceRoles.includes(get_default()(this.user, 'role.name'));
    },
    canSelectRegion: function canSelectRegion() {
      return this.indexPageRoles.includes(get_default()(this.user, 'role.name'));
    },
    isAdmin: function isAdmin() {
      return this.checkPermission('admin_access');
    }
  },
  mounted: function mounted() {
    var _this = this;

    auth["a" /* default */].check().then(function (user) {
      _this.user = user;
    }).catch(function () {
      _this.user = null;
    }).finally(function () {
      _this.init = true;
    });
  },

  watch: {
    user: function user() {
      if (raven["a" /* default */]) {
        raven["a" /* default */].setUserContext(this.user ? pick_default()(this.user, ['id', 'email']) : null);
      }
    },
    release: function release(oldRelease, newRelease) {
      if (oldRelease && newRelease) {
        this.showModal(release_modal["default"]);
      }
    }
  },
  computed: {
    classes: function classes() {
      var path = this.$route.path.replace(/\//g, '-');
      if (path === '-') path = '-index';
      return 'page' + path;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbdda57","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/app.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.init)?_c('div',{staticClass:"app d-flex flex-column",class:_vm.classes,staticStyle:{"overflow-x":"hidden"},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.$root.user)?_c('navbar'):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view',{staticClass:"page-content flex-grow-1"})],1),_vm._v(" "),_c('app-modals',{ref:"modals"})],1):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/app.vue
function injectStyle (context) {
  __webpack_require__("j2Kt")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  app,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_app = (Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/slider.js
var slider = __webpack_require__("g2bL");
var slider_default = /*#__PURE__*/__webpack_require__.n(slider);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/time-picker.js
var time_picker = __webpack_require__("4ZDJ");
var time_picker_default = /*#__PURE__*/__webpack_require__.n(time_picker);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/date-picker.js
var date_picker = __webpack_require__("tLa+");
var date_picker_default = /*#__PURE__*/__webpack_require__.n(date_picker);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/table-column.js
var table_column = __webpack_require__("q4le");
var table_column_default = /*#__PURE__*/__webpack_require__.n(table_column);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/table.js
var table = __webpack_require__("LR6y");
var table_default = /*#__PURE__*/__webpack_require__.n(table);

// CONCATENATED MODULE: ./resources/assets/js/element-ui.js









vue_runtime_esm["default"].use(table_default.a);
vue_runtime_esm["default"].use(table_column_default.a);
vue_runtime_esm["default"].use(date_picker_default.a);

vue_runtime_esm["default"].use(time_picker_default.a);

vue_runtime_esm["default"].use(slider_default.a);
// CONCATENATED MODULE: ./resources/assets/js/components.js


vue_runtime_esm["default"].component('vnode', {
  functional: true,
  render: function render(h, context) {
    return context.props.node;
  }
});

function registerAllComponents(req) {
  req.keys().forEach(function (moduleName) {
    var componentName = moduleName.slice(2, -4);
    vue_runtime_esm["default"].component(componentName, req(moduleName).default);
  });
}

registerAllComponents(__webpack_require__("OGCL"));
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/dom-events/index.js
var dom_events = __webpack_require__("Fn2p");
var dom_events_default = /*#__PURE__*/__webpack_require__.n(dom_events);

// CONCATENATED MODULE: ./resources/assets/js/directives.js





vue_runtime_esm["default"].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

vue_runtime_esm["default"].directive('on-jquery', {
  inserted: function inserted(el, _ref) {
    var modifiers = _ref.modifiers,
        arg = _ref.arg;

    var $el = jquery_default()(el);
    var eventName = keys_default()(modifiers).join(' ');
    var emitEvent = arg || 'input';

    $el.on(eventName, function (e) {
      var isTriggeredWithJquery = !e.originalEvent;
      if (isTriggeredWithJquery) {
        dom_events_default.a.emit(el, emitEvent);
      }
    });
  }
});
// EXTERNAL MODULE: ./resources/assets/js/filters.js
var filters = __webpack_require__("rm9P");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__("C/JF");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__("fhbW");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/faCircle.js
var faCircle = __webpack_require__("Eia3");
var faCircle_default = /*#__PURE__*/__webpack_require__.n(faCircle);

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var vue_fontawesome_index_es = __webpack_require__("1e6/");

// CONCATENATED MODULE: ./resources/assets/js/font-awesome.js






index_es["c" /* library */].add(free_solid_svg_icons_index_es["a" /* faAngleRight */], free_solid_svg_icons_index_es["b" /* faArrowLeft */], free_solid_svg_icons_index_es["c" /* faAt */], free_solid_svg_icons_index_es["d" /* faCheckCircle */], free_solid_svg_icons_index_es["e" /* faCommentAlt */], free_solid_svg_icons_index_es["f" /* faFilter */], free_solid_svg_icons_index_es["g" /* faList */], free_solid_svg_icons_index_es["h" /* faMapMarkerAlt */], free_solid_svg_icons_index_es["i" /* faTrashAlt */], free_solid_svg_icons_index_es["j" /* faUnlockAlt */], free_solid_svg_icons_index_es["k" /* faWifi */], faCircle["faCircle"]);

vue_runtime_esm["default"].component('font-awesome-icon', vue_fontawesome_index_es["a" /* FontAwesomeIcon */]);
// CONCATENATED MODULE: ./resources/assets/js/root.js
















vue_runtime_esm["default"].use(vue_router_esm["a" /* default */]);
vue_runtime_esm["default"].use(vue_async_computed_esm["a" /* default */]);
vue_runtime_esm["default"].use(v_hotkey_default.a);
vue_runtime_esm["default"].use(vue_meta_default.a);
vue_runtime_esm["default"].component('v-select', vue_select_default.a);
vue_runtime_esm["default"].component('multiselect', vue_multiselect_min_default.a);
vue_runtime_esm["default"].component('datetime-picker', vue_bootstrap_datetimepicker_default.a);

vue_runtime_esm["default"].config.productionTip = false;

/* harmony default export */ var root = __webpack_exports__["default"] = (new vue_runtime_esm["default"](pages_app));

/***/ }),

/***/ "jele":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-avatar/dist/vue-avatar.min.js
var vue_avatar_min = __webpack_require__("Y50r");
var vue_avatar_min_default = /*#__PURE__*/__webpack_require__.n(vue_avatar_min);

// EXTERNAL MODULE: ./resources/assets/js/auth.js
var auth = __webpack_require__("S8OL");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/navbar.vue





/* harmony default export */ var navbar = ({
  name: 'Navbar',
  components: { Avatar: vue_avatar_min_default.a },
  methods: {
    logout: function logout() {
      auth["a" /* default */].logout();
    }
  },
  data: function data() {
    return {
      navElements: [{ route: '/admin',
        label: 'Админка',
        permission: 'web_admin_ffd12',
        dropdown: [{ route: '/ffd12', label: 'ККТ ФФД 1.2', permission: 'web_admin_ffd12' }, { route: '/lists', label: 'Списки', permission: 'web_admin_ffd12' }] }, { route: '/machines', label: 'Автоматы', permission: 'web_ta' }, { route: '/reports',
        label: 'Отчеты',
        dropdown: [{ route: '/sales', label: 'Продажи', permission: 'web_sales' }, { route: '/expenditure', label: 'Расход продуктов', permission: 'web_rate' }, { route: '/encashment', label: 'Инкассации', permission: 'web_collect' }, { route: '/events', label: 'События', permission: 'web_events' }, { route: '/downtime', label: 'Простои', permission: 'web_downtime' }, { route: '/notifications', label: 'Уведомления', permission: 'web_alerts' }, { route: '/receipts', label: 'Чеки', permission: 'web_bills' }, { route: '/service', label: 'Обслуживание', permission: 'web_service' }, { route: '/samples', label: 'Мои выборки' }] }, { route: '/service', label: 'Обслуживание', permission: 'web_service' }, { route: '/settings',
        label: 'Настройки',
        dropdown: [{ route: '/recipes', label: 'Рецептуры и продукты', permission: 'web_matrix' }, { route: '/schedule', label: 'Расписание отчетов', permission: 'web_schedule' }, { route: '/notifications', label: 'Уведомления', permission: 'web_alert_settings' }, { route: '/users', label: 'Пользователи', permission: 'web_users' }, { route: '/categories', label: 'Категории' }] }, { route: '/orders', label: 'Заявки', permission: 'web_requests' }, { route: '/modems', label: 'Модемы', permission: 'web_modems' }, { route: '/receipts', label: 'Чеки', permission: 'web_bills' }, { route: '/admin',
        label: 'Еще',
        dropdown: [{ route: '/limits', label: 'Пороговые значения', permission: 'web_thresholds' }, { route: '/documents', label: 'Документы и чек-листы', permission: 'web_checklist' }] }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408f1537","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/navbar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navbar-wrapper"},[_c('nav',{staticClass:"navbar navbar-expand-md navbar-light"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand text-hide",attrs:{"to":'/',"exact":""}},[_vm._v("Vendoscope")]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbar-content"}},[_c('ul',{staticClass:"navbar-nav mr-auto"},[_vm._l((_vm.navElements),function(section){return [(!section.dropdown && _vm.$root.checkPermission(section.permission))?_c('router-link',{staticClass:"nav-item",attrs:{"tag":"li","to":section.route}},[_c('a',{staticClass:"nav-link"},[_vm._v(_vm._s(section.label))])]):(section.dropdown && section.dropdown.some(function (item) { return _vm.$root.checkPermission(item.permission); }))?_c('li',{staticClass:"nav-item dropdown"},[_c('router-link',{staticClass:"nav-link dropdown-toggle",attrs:{"to":section.route,"event":"","data-toggle":"dropdown"}},[_vm._v("\n              "+_vm._s(section.label)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},_vm._l((section.dropdown),function(subsection){return (!subsection.hasOwnProperty('permission') || _vm.$root.checkPermission(subsection.permission))?_c('router-link',{key:subsection.route,staticClass:"dropdown-item",attrs:{"to":("" + (section.route) + (subsection.route))},domProps:{"textContent":_vm._s(subsection.label)}}):_vm._e()}),1)],1):_vm._e()]})],2),_vm._v(" "),(_vm.$root.user)?[_c('ul',{staticClass:"navbar-nav navbar-user"},[(_vm.$root.isDev)?_c('router-link',{staticClass:"nav-item",attrs:{"tag":"li","to":"/dev"}},[_c('a',{staticClass:"nav-link"},[_vm._v("Dev")])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('avatar',{staticClass:"navbar-avatar-wrapper",attrs:{"username":((_vm.$root.user.second_name) + " " + (_vm.$root.user.first_name)),"size":30}})],1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_c('h6',{staticClass:"dropdown-header"},[_vm._v("\n                "+_vm._s(((_vm.$root.user.second_name) + " " + (_vm.$root.user.first_name)))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("Выйти")]),_vm._v(" "),(_vm.$root.release)?_c('div',{staticClass:"small text-muted mt-2",staticStyle:{"padding-left":"1.3rem"}},[_vm._v("\n                Версия "+_vm._s(_vm.$root.release)+"\n              ")]):_vm._e()])])],1)]:_vm._e()],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbar-content","aria-controls":"navbar-content","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/navbar.vue
function injectStyle (context) {
  __webpack_require__("8wLD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  navbar,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_navbar = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jhtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (immutable) */ __webpack_exports__["b"] = encode;
/* harmony export (immutable) */ __webpack_exports__["a"] = decode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base64_js__ = __webpack_require__("EKta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base64_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base64_js__);



function encode(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_base64_js__["fromByteArray"])(Buffer.from(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), 'utf8'));
}

function decode(string) {
  return JSON.parse(Buffer.from(Object(__WEBPACK_IMPORTED_MODULE_1_base64_js__["toByteArray"])(string)).toString('utf8'));
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "jsJX":
/***/ (function(module, exports) {

module.exports = {"initEvent":["type","bubbles","cancelable"],"initUIEvent":["type","bubbles","cancelable","view","detail"],"initMouseEvent":["type","bubbles","cancelable","view","detail","screenX","screenY","clientX","clientY","ctrlKey","altKey","shiftKey","metaKey","button","relatedTarget"],"initMutationEvent":["type","bubbles","cancelable","relatedNode","prevValue","newValue","attrName","attrChange"],"initKeyboardEvent":["type","bubbles","cancelable","view","ctrlKey","altKey","shiftKey","metaKey","keyCode","charCode"],"initKeyEvent":["type","bubbles","cancelable","view","ctrlKey","altKey","shiftKey","metaKey","keyCode","charCode"]}

/***/ }),

/***/ "jwWS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kFb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filters-group.vue


/* harmony default export */ var filters_group = ({
  name: 'FiltersGroup',
  props: {
    isDirty: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31efc0ff","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filters-group.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters-group form-group"},[_c('button',{staticClass:"filters-group-heading collapsed",attrs:{"data-toggle":"collapse","href":("#collapse-" + _vm._uid)}},[_c('span',{staticClass:"collapse-triangle"}),_vm._v(" "),_c('span',{staticClass:"filters-group-title"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.isDirty)?_c('span',{staticClass:"filters-group-dirty-indicator"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"filters-group-collapse collapse",attrs:{"id":("collapse-" + _vm._uid)}},[_c('div',{staticClass:"filters-group-collapse-content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filters-group.vue
function injectStyle (context) {
  __webpack_require__("81hu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filters_group,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filters_group = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lOTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/subnav.vue


/* harmony default export */ var subnav = ({
  name: 'subnav',
  props: {
    links: { type: Array },
    heading: { type: String },
    showLinks: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      slide: false,
      has_active: false,
      active: {
        left: 0,
        width: 0
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36dfab5c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/subnav.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-subnav"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{ref:"ul",staticClass:"nav nav-subnav",class:{'has-underline': _vm.has_active}},[(_vm.heading)?_c('li',{staticClass:"nav-subnav-heading d-flex align-items-center pr-3"},[_c('h1',[_vm._v(_vm._s(_vm.heading))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.links),function(link){return (_vm.showLinks && (!link.permission || _vm.$root.checkPermission(link.permission)) && (!link.adminOnly || _vm.$root.isAdmin()))?_c('router-link',{key:link.to,staticClass:"nav-item pr-3",attrs:{"to":link.to,"exact":link.exact || false,"tag":"li"}},[_c('a',{staticClass:"nav-link px-0"},[_vm._v(_vm._s(link.text))])]):_vm._e()}),_vm._v(" "),(!_vm.showLinks)?_c('li',{staticClass:"nav-item pr-3",staticStyle:{"opacity":"0"}},[_c('a',{staticClass:"nav-link px-0"},[_vm._v(" ")])]):_vm._e()],2),_vm._v(" "),(_vm.has_active)?_c('div',{staticClass:"nav-subnav-active-underline",style:(_vm.underline_style)}):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/subnav.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  subnav,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_subnav = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "m44z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__("Dc7M");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__("w9Mt");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__("tVBY");
var range_default = /*#__PURE__*/__webpack_require__.n(range);

// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("BUAs");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/schedule/editor.vue










/* harmony default export */ var editor = ({
  props: ['value', 'withMinutes'],
  data: function data() {
    console.log(omit_default()(this.value, ['every', 'every_unit']));
    return {
      interval: assign_default()({
        every: 1,
        every_unit: 'hour'
      }, pick_default()(this.value, ['every', 'every_unit'])),
      schedule: assign_default()({
        days: [],
        from: '23:00',
        till: '23:00'
      }, omit_default()(this.value, ['every', 'every_unit'])),
      oldVal: null
    };
  },

  methods: {
    range: range_default.a,
    weekdayLabel: function weekdayLabel(i) {
      return moment_default()().weekday(i).format('dd');
    },
    formatHour: function formatHour(hour) {
      hour = parseInt(hour);
      return (hour < 10 ? '0' + hour : '' + hour) + ':00';
    },
    formatInterval: function formatInterval(interval) {
      var labels = {
        hour: 'ч',
        minute: 'мин'
      };
      return interval.every + ' ' + labels[interval.every_unit];
    }
  },
  watch: {
    preparedSchedule: {
      handler: function handler() {
        if (isEqual_default()(this.preparedSchedule, this.oldVal)) return;
        this.preparedSchedule.days.sort();
        this.$emit('input', this.preparedSchedule);
        this.oldVal = this.preparedSchedule;
      },

      deep: true
    }
  },
  computed: {
    preparedSchedule: function preparedSchedule() {
      return assign_default()({}, this.schedule, this.interval);
    },
    intervals: function intervals() {
      var intervals = range_default()(1, 13).map(function (hour) {
        return {
          every: hour,
          every_unit: 'hour'
        };
      });

      if (this.withMinutes) {
        var intervalsMinutes = [10, 15, 20, 30].map(function (minute) {
          return {
            every: minute,
            every_unit: 'minute'
          };
        });
        intervals = intervalsMinutes.concat(intervals);
      }

      return intervals;
    },
    reportTimes: function reportTimes() {
      if (!(this.preparedSchedule && this.preparedSchedule.from && this.preparedSchedule.till && this.preparedSchedule.every)) return [];
      var fromTime = moment_default()(this.preparedSchedule.from, 'HH:mm');
      var tillTime = moment_default()(this.preparedSchedule.till, 'HH:mm');
      var times = [];
      while (fromTime.isSameOrBefore(tillTime)) {
        times.push(fromTime.format('HH:mm'));
        fromTime.add(this.preparedSchedule.every, this.preparedSchedule.every_unit);
      }
      return times;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fadf778e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/schedule/editor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"schedule-edit-weekdays btn-group btn-group-sm btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.range(0,7)),function(i){return _c('label',{staticClass:"btn btn-outline-secondary text-capitalize",class:{active: _vm.schedule.days.indexOf(i) !== -1}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.schedule.days),expression:"schedule.days"}],attrs:{"type":"checkbox","autocomplete":"off"},domProps:{"value":i,"checked":Array.isArray(_vm.schedule.days)?_vm._i(_vm.schedule.days,i)>-1:(_vm.schedule.days)},on:{"change":function($event){var $$a=_vm.schedule.days,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=i,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.schedule, "days", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.schedule, "days", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.schedule, "days", $$c)}}}}),_vm._v("\n      "+_vm._s(_vm.weekdayLabel(i))+"\n    ")])}),0),_vm._v(" "),_c('ul',{staticClass:"schedule-edit-shortcuts list-inline"},[_c('li',{staticClass:"list-inline-item",on:{"click":function($event){_vm.schedule.days = _vm.range(0,0)}}},[_vm._v("никогда")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item",on:{"click":function($event){_vm.schedule.days = _vm.range(0,5)}}},[_vm._v("будни")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item",on:{"click":function($event){_vm.schedule.days = _vm.range(5,7)}}},[_vm._v("выходные")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item",on:{"click":function($event){_vm.schedule.days = _vm.range(0,7)}}},[_vm._v("ежедневно")])]),_vm._v(" "),(_vm.schedule.days.length > 0)?_c('div',{staticClass:"schedule-edit-form form-inline align-items-baseline"},[_vm._v("\n    С\n    "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.schedule.from),expression:"schedule.from"}],staticClass:"custom-select mx-2",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.schedule, "from", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.range(0,24)),function(i){return _c('option',{domProps:{"value":_vm.formatHour(i)}},[_vm._v(_vm._s(_vm.formatHour(i)))])}),0),_vm._v("\n    по\n    "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.schedule.till),expression:"schedule.till"}],staticClass:"custom-select mx-2",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.schedule, "till", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.range(0,24)),function(i){return _c('option',{domProps:{"value":_vm.formatHour(i)}},[_vm._v(_vm._s(_vm.formatHour(i)))])}),0),_vm._v("\n    каждые\n    "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.interval),expression:"interval"}],staticClass:"custom-select mx-2",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.interval=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.intervals),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(_vm.formatInterval(i)))])}),0)]):_vm._e(),_vm._v(" "),(_vm.schedule && _vm.schedule.days && _vm.schedule.days.length > 0)?[_c('hr'),_vm._v(" "),_c('h5',[_vm._v("Отчеты будут отправляться в")]),_vm._v(" "),_vm._l((_vm.schedule.days),function(i){return _c('ul',{staticClass:"list-inline m-0"},[_c('li',{staticClass:"list-inline-item text-capitalize font-weight-bold"},[_vm._v(_vm._s(_vm._f("weekdayLabel")(i)))]),_vm._v(" "),_vm._l((_vm.reportTimes),function(time){return _c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(time))])})],2)})]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/schedule/editor.vue
function injectStyle (context) {
  __webpack_require__("sjvy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  editor,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var schedule_editor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m5rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__("GDZS");
var isNaN_default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/number.vue




/* harmony default export */ var components_number = ({
  name: 'number',
  props: {
    number: { required: true }
  },
  computed: {
    parts: function parts() {
      return this.formatNumber(this.number).split('\xA0');
    }
  },
  methods: {
    formatNumber: function formatNumber(number) {
      var value = parseFloat(number);
      return isNaN_default()(value) ? '' : value.toLocaleString('ru');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5c72c7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/number.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"number-formatted"},[(+_vm.number === 0)?_c('span',[_vm._v("–")]):_vm._l((_vm.parts),function(part){return _c('span',{domProps:{"textContent":_vm._s(part)}})}),_vm._v(" "),(_vm.currencySymbol && +_vm.number !== 0)?_c('span',[_vm._v(" "+_vm._s(_vm.currencySymbol))]):_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/number.vue
function injectStyle (context) {
  __webpack_require__("JohW")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  components_number,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var js_components_number = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nPTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./resources/assets/js/svg.js
var requireSvg = __webpack_require__("4GJc");

/* harmony default export */ var svg = (function (name) {
  return requireSvg('./' + name + '.svg');
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/app-alert.vue




/* harmony default export */ var app_alert = ({
  props: {
    type: {
      default: 'alert' },
    header: {},
    message: {}
  },
  methods: {
    svg: svg,
    is: function is(type) {
      return type === this.type;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2130700a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/app-alert.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered modal-alert modal-narrow"},[_c('div',{staticClass:"modal-content modal-feedback"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"pull-right",attrs:{"data-dismiss":"modal","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.svg('close-gray'))}}),_vm._v("\n      "+_vm._s(_vm.header)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"text-left",class:{norm:_vm.is('message')}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")]),_vm._v(" "),(_vm.is('alert')||_vm.is('message'))?_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-dismiss":"modal"}},[_vm._v("Ок")])]):_vm._e(),_vm._v(" "),(_vm.type == 'confirm')?_c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Отмена")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.$emit('hide', true)}}},[_vm._v("Ок")])]):_vm._e()])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/app-alert.vue
function injectStyle (context) {
  __webpack_require__("YIXM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  app_alert,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_app_alert = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nWyn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ncSl":
/***/ (function(module, exports) {

module.exports = {"MouseEvent":["click","mousedown","mouseup","mouseover","mousemove","mouseout"],"KeyboardEvent":["keydown","keyup","keypress"],"MutationEvent":["DOMSubtreeModified","DOMNodeInserted","DOMNodeRemoved","DOMNodeRemovedFromDocument","DOMNodeInsertedIntoDocument","DOMAttrModified","DOMCharacterDataModified"],"HTMLEvents":["load","unload","abort","error","select","change","submit","reset","focus","blur","resize","scroll"],"UIEvent":["DOMFocusIn","DOMFocusOut","DOMActivate"]}

/***/ }),

/***/ "ndU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/machines-modal.vue


/* harmony default export */ var machines_modal = ({
  props: {
    checked: {}
  },
  data: function data() {
    return {
      filtersValue: {},
      data: {},
      loading: false,
      hasMore: true,
      list: []
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      var list = this.list.map(function (item) {
        return item.id;
      });
      this.$emit('hide', this.data.data.filter(function (value) {
        return list.indexOf(value.id) !== -1 && _this.checked.indexOf(value.id) === -1;
      }));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487c93a0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/machines-modal.vue
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body p-0"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"notification_settings/machines","endpointMethod":"post","exclude":_vm.checked,"filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 pr-0"},[(_vm.data && _vm.data.data)?[_c('data-table',{attrs:{"height":600,"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore,"selection-change":function (selection) {this$1.list = selection}}},[_c('el-table-column',{attrs:{"type":"selection"}}),_vm._v(" "),_c('table-column-serial-number'),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"Адрес"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"technician","label":"Техник"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm._f("fullName")(row.technician)))]}}],null,false,4270105674)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operator","label":"Оператор"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm._f("fullName")(row.operator)))]}}],null,false,4073844338)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"manager","label":"Менеджер"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm._f("fullName")(row.manager)))]}}],null,false,31770849)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"region.name","label":"Организация"}})],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-4 pl-0 border-left"},[_c('div',{staticStyle:{"overflow-y":"scroll","height":"600px"}},[(_vm.data.filters)?_c('filters',{attrs:{"filters":_vm.data.filters,"endpoint":"notification_settings/machines","endpointMethod":"post"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}}):_vm._e()],1)])])],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v("Добавить")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Выберите автоматы")])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/machines-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  machines_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_machines_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nqUA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/modems/index.vue


/* harmony default export */ var modems = ({
  metaInfo: { title: 'Модемы' },
  data: function data() {
    return {
      subnav: [{
        text: 'Активные',
        to: '/modems',
        exact: true
      }, {
        text: 'Удаленные',
        to: '/modems/deleted'
      }, {
        text: 'Рассылки',
        to: '/modems/broadcasts',
        adminOnly: true
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-329ee246","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/modems/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('subnav',{attrs:{"links":_vm.subnav,"heading":"Модемы"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/modems/index.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modems,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_modems = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oW9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/balloon.vue




/* harmony default export */ var balloon = ({
  data: function data() {
    return {};
  },
  props: {
    machine: {}
  },
  watch: {},
  methods: {
    date: function date(value) {
      if (value !== null) {
        return moment_default.a.duration(value, 'seconds').humanize();
      } else {
        return 'Неизвестно';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fac00a96","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/balloon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-balloon-content p-2"},[(_vm.machine)?_c('div',[_c('h2',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.machine.serial_number))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm._f("get")(_vm.machine,'model.name')))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.machine.address))]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('status-images',{staticClass:"my-1",attrs:{"value":_vm.machine.status}})],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Связь: ")]),_vm._v(" "),(_vm.machine.is_online)?_c('span',[_vm._v("\n        "+_vm._s(_vm._f("get")(_vm.machine,'modem.netinterface'))+"\n      ")]):_c('span',{staticClass:"text-danger"},[_vm._v("нет")])]),_vm._v(" "),(_vm.machine.modem)?[_c('div',[_c('strong',[_vm._v("Состояние двери: ")]),_vm._v(" "),_c('span',{class:(_vm.machine.modem.door_closed ? _vm.machine.is_online : !_vm.machine.is_online) ? 'text-success' : 'text-danger'},[_vm._v("\n          "+_vm._s(_vm.machine.modem.door_closed ? 'закрыта' : 'открыта')+"\n        ")])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Питание 220 В: ")]),_vm._v(" "),_c('span',{class:_vm.machine.modem.electricity ? '' : 'text-danger'},[_vm._v("\n          "+_vm._s(_vm.machine.modem.electricity ? 'есть' : 'ошибка')+"\n        ")])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Заряд батареи: ")]),_vm._v(" "),_c('span',{class:_vm.machine.modem.battery < 40 ? 'text-danger' : ''},[_vm._v(_vm._s(_vm.machine.modem.battery)+" %")])])]:_vm._e(),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Монет на сдачу: ")]),_vm._v(" "),_c('number',{attrs:{"number":_vm.machine.coins_sum}}),_vm._v(" руб.\n    ")],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Купюр в автомате: ")]),_vm._v(" "),_c('number',{attrs:{"number":_vm.machine.banknotes_sum}}),_vm._v(" руб.,\n      "),_c('number',{attrs:{"number":_vm.machine.banknotes_count}}),_vm._v(" шт.\n    ")],1),_vm._v(" "),(_vm.$root.checkPermission('web_ta_main'))?_c('a',{staticClass:"btn btn-outline-primary btn-sm mt-2",attrs:{"data-href":("/machines/" + (_vm.machine.id)),"href":("/machines/" + (_vm.machine.id))}},[_vm._v("Перейти к карточке автомата »")]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/balloon.vue
function injectStyle (context) {
  __webpack_require__("96Dn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  balloon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_balloon = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "past":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pk7w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/modems/edit-modal.vue + 2 modules
var edit_modal = __webpack_require__("VY79");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/modems/index/deleted.vue





/* harmony default export */ var deleted = ({
  metaInfo: { title: 'Удаленные модемы' },
  data: function data() {
    return {
      filtersValue: {},
      data: {},
      loading: false,
      hasMore: true,
      sort: { prop: 'uid', order: 'asc' },
      updateList: 0
    };
  },

  watch: {},
  computed: {
    modems: function modems() {
      return this.data.data;
    }
  },
  methods: {
    restoreModem: function restoreModem(uid) {
      var _this = this;

      return api["a" /* default */].put('/modems/' + uid + '/restore').then(function () {
        return _this.$router.push('/modems');
      });
    },
    loadMore: function loadMore() {
      this.$refs.data.loadMore();
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.sort = {
          prop: sort.prop,
          order: order
        };
      } else {
        this.sort = null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290b08cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/modems/index/deleted.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-grow-1"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"modems/deleted","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.modems,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"sort-change":_vm.sortChange,"load-more":_vm.loadMore}},[_c('el-table-column',{attrs:{"prop":"uid","label":"№ модема","sortable":"custom","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(_vm._s(row.number))]),_vm._v(" "),_c('div',[_c('small',[_vm._v(_vm._s(row.uid))])])]}}],null,false,485764357)}),_vm._v(" "),_c('table-column-date',{attrs:{"prop":"last_command_at","label":"Последняя команда","sortable":"custom","width":"auto"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Восстановить","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('btn-action',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.restoreModem(row.uid); })($event)}}},[_vm._v("Восстановить")])]}}],null,false,1393325937)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/modems/index/deleted.vue
function injectStyle (context) {
  __webpack_require__("jwWS")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  deleted,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var index_deleted = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pqFt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiMzNjNCNEUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjU3NyA4LjQ5N2MtMS44NDkgMC0yLjkyOSAzLTIuOTI5IDQuNDY0IDAgMS4yOTYuNTUyIDIuMDY0IDEuNTEyIDIuMDY0IDEuODQ5IDAgMi44ODEtMy41MjggMi44ODEtNC45NDQgMC0uODg4LS41MjgtMS41ODQtMS40NjQtMS41ODR6bTcuMDU2IDkuODQxYy0yLjQ5NiAxLjgyNS00LjY1NyAyLjU2OS03LjM0NCAyLjU2OS0yLjY0MSAwLTQuODczLS43OTMtNi41NzctMi4zNzdDMy45NiAxNi45MjIgMyAxNC42NDIgMyAxMi4xOTMgMyA3LjAwOSA3LjIgMyAxMi42NDggM2M0Ljc1MyAwIDguMTE0IDIuOTc2IDguMTE0IDcuMjAxIDAgMy4zMzctMi4zMjkgNi4zMTMtNC45NDUgNi4zMTMtMS4yNDggMC0yLjA0MS0uNjcyLTIuMDQxLTEuNzUyIDAtLjE2OCAwLS4yODguMDQ5LS40OC0uNjczIDEuMjk2LTEuNzc2IDIuMjMyLTMuMzEyIDIuMjMyLTEuOTQ1IDAtMy4yNjUtMS40ODktMy4yNjUtMy42NzMgMC0zLjEyIDIuMjU3LTUuODA4IDQuODI0LTUuODA4IDEuMjczIDAgMi4xODUuNDU2IDIuNzEzIDEuNjMybC4zMzYtMS4yNDhoMi4wNEwxNS42IDEyLjc2OWMtLjE2OC42MDEtLjIzOS45ODQtLjIzOSAxLjI5NiAwIC42LjM2Ljk2Ljk4NC45NiAxLjU2IDAgMy4wNzItMi40NDggMy4wNzItNC45NDQgMC0zLjQ1Ni0yLjczNi01LjgzMy02Ljc0NC01LjgzMy00Ljc3NyAwLTguMzI5IDMuNDA5LTguMzI5IDguMDE3IDAgNC4zNDUgMy4zMTIgNy40MTcgOC4wMTYgNy40MTcgMi4zNzcgMCA0LjM2OS0uNjk2IDYuNTc3LTIuMzA0bC42OTYuOTZ6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "qFrg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qdlZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/sales.vue




/* harmony default export */ var sales = ({
  metaInfo: { title: 'Продажи' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      sort: null,
      date: [moment_default()().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment_default()().endOf('day').format('YYYY-MM-DDTHH:mm:ss')],
      pickerOptions: {
        firstDayOfWeek: 1
      },
      pageSizes: [100, 250, 500, 1000, 2500, 5000, 10000],
      pageSize: 100
    };
  },

  methods: {
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.sort = sort.prop + ':' + order;
      } else {
        this.sort = null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aa36577","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/sales.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"sales","filtersValue":_vm.filtersValue,"sort":_vm.sort,"date":_vm.date,"externalFilters":_vm.pageSize},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("Продажи")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageSize),expression:"pageSize"}],staticClass:"custom-select mr-2",staticStyle:{"max-width":"6em"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pageSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.pageSizes),function(size){return _c('option',{domProps:{"value":size}},[_vm._v(_vm._s(size))])}),0),_vm._v(" "),_c('el-date-picker',{staticClass:"mr-2",attrs:{"type":"datetimerange","clearable":false,"value-format":"yyyy-MM-ddTHH:mm:ss","default-time":['00:00:00', '23:59:59'],"align":"right","range-separator":"–","picker-options":_vm.pickerOptions,"size":"small"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"sales"},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?_c('data-table-full-height',{attrs:{"data":_vm.data.data,"default-sort":{prop: 'sum', order: 'descending'},"show-summary":""},on:{"sort-change":_vm.sortChange}},[_c('table-column-serial-number',{attrs:{"fixed":true}}),_vm._v(" "),_c('table-column-string',{attrs:{"prop":"address","label":"Адрес установки","show-overflow-tooltip":true,"min-width":"275","tableColumnType":"string"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"count","label":"Всего продаж","min-width":"122","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"cash","label":"За наличные","min-width":"120","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"cashless","label":"По безналу","min-width":"120","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"free","label":"Бесплатных","min-width":"115","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"test","label":"Тестовых","min-width":"110","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"token","label":"За жетоны","min-width":"110","currencySymbol":"шт.","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"sum_cash","label":"Сумма налич","min-width":"118","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"sum_cashless","label":"Сумма безнал","min-width":"124","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-number',{attrs:{"align":"right","sortable":"custom","prop":"sum","label":"Сумма общая","min-width":"120","currencySymbol":"₽","tableColumnType":"number"}}),_vm._v(" "),_c('table-column-date',{attrs:{"prop":"last_sale_at","label":"Последняя продажа","align":"right"}})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/sales.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sales,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_sales = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qwhp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r6gy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rG/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/trimStart.js
var trimStart = __webpack_require__("z6ge");
var trimStart_default = /*#__PURE__*/__webpack_require__.n(trimStart);

// EXTERNAL MODULE: ./resources/assets/js/with-tooltip.js
var with_tooltip = __webpack_require__("6M62");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/table-column-serial-number.vue






/* harmony default export */ var table_column_serial_number = ({
  props: {
    prop: {
      type: String,
      default: 'serial_number'
    },
    label: {
      type: String,
      default: '№ ТА'
    },
    width: {
      type: Number,
      default: 100
    },
    idProp: {
      type: String,
      default: 'id'
    },
    machineProp: {
      type: String,
      default: ''
    }
  },
  methods: {
    withTooltip: with_tooltip["a" /* default */],
    to: function to(row) {
      var id = get_default()(row, trimStart_default()(this.machineProp + '.id', '.'));
      return '/machines/' + id;
    },
    serialNumber: function serialNumber(row) {
      return get_default()(row, trimStart_default()(this.machineProp + '.serial_number', '.'));
    },
    colorStyle: function colorStyle(row) {
      var color = get_default()(row, trimStart_default()(this.machineProp + '.category.color', '.'), false);
      var style = "";
      if (color) {
        style = "color: " + color + ";";
      }
      return style;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-945c706e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/table-column-serial-number.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',_vm._g(_vm._b({attrs:{"prop":_vm.prop,"label":_vm.label,"width":_vm.width,"render-header":_vm.withTooltip('Номер автомата')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(_vm.$root.checkPermission('web_ta_main'))?_c('router-link',{style:(_vm.colorStyle(row)),attrs:{"to":_vm.to(row)}},[_vm._v("\n      "+_vm._s(_vm.serialNumber(row))+"\n    ")]):_c('div',[_vm._v("\n      "+_vm._s(_vm.serialNumber(row))+"\n    ")])]}}])},'el-table-column',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/table-column-serial-number.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  table_column_serial_number,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_table_column_serial_number = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rXtC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rm9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




__webpack_require__("jBeJ");
var EVENT_TYPES = __webpack_require__("D7iU");

var filters = {
  get: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default.a,
  fullName: function fullName(user) {
    if (!user) return '–';
    return user.second_name + ' ' + user.first_name + ' ' + user.third_name;
  },
  formatDate: function formatDate(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY HH:mm:ss (Z)';

    return date ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(date).format(format) : date;
  },
  formatDateFromNow: function formatDateFromNow(date) {
    var removeSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return date ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.parseZone(date).fromNow(removeSuffix) : date;
  },
  formatDuration: function formatDuration(seconds) {
    if (!seconds) return '0';
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(seconds, 'seconds').fromNow(true);
  },
  weekdayLabel: function weekdayLabel(i) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()().weekday(i).format('dd');
  },
  formatRub: function formatRub(number) {
    return number + ' \u0420.';
  },
  eventName: function eventName(code) {
    return EVENT_TYPES[code].split('|')[0];
  },
  simChannel: function simChannel(channel) {
    var messages = { chip: 'SIM-чип', card: 'SIM-карта' };
    return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(messages, channel);
  },
  round: function round(value, precision) {
    var m = Math.pow(10, precision);
    return Math.round(parseFloat(value) * m) / m;
  },
  remainder: function remainder(value) {
    return filters.round(value, 4);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (filters);

for (var filter in filters) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(filter, filters[filter]);
}

/***/ }),

/***/ "rtCK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICAgIDxwYXRoIGZpbGw9IiM3NzciIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjkzIDguMjVjLS40NDcgMC0uODkzLS40NDYtLjg5My0uODkyIDAtLjQ0Ny40NDYtLjg5My44OTMtLjg5My40NDYgMCAuODkyLjQ0Ni44OTIuODkzIDAgLjQ0Ni0uNDQ2Ljg5My0uODkyLjg5M3ptLjc4IDYuMzYzYS43NjMuNzYzIDAgMCAxLS43OC43ODEuNzYzLjc2MyAwIDAgMS0uNzgyLS43OHYtNC4wMmMwLS40NDYuMzM1LS43OC43ODItLjc4LjQ0NiAwIC43OC4zMzQuNzguNzh2NC4wMnpNMTAuOTMgMkM2LjAxOCAyIDIgNi4wMTggMiAxMC45M2MwIDQuOTEgNC4wMTggOC45MyA4LjkzIDguOTMgNC45MSAwIDguOTMtNC4wMiA4LjkzLTguOTMgMC00LjkxMi00LjAyLTguOTMtOC45My04LjkzeiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "rygB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/documents-modal.vue





/* harmony default export */ var documents_modal = ({
  data: function data() {
    return {
      doc: {
        name: '',
        file: {},
        roles: {
          service: false,
          service_superior: false,
          tech: false,
          tech_superior: false
        }
      }
    };
  },
  props: ['currentDoc'],
  mounted: function mounted() {
    if (this.currentDoc != null) {
      this.doc = this.currentDoc;
    }
  },

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.doc.file = files[0];
    },
    save: function save() {
      var _this = this;

      if (this.doc.name === '') {
        alert('Введите имя');
        return;
      }
      if (this.doc.id == null) {
        var data = new FormData();
        data.append('doc', this.doc.file);
        data.append('name', this.doc.name);
        data.append('roles', stringify_default()(this.doc.roles));

        var headers = { 'content-type': 'multipart/form-data' };
        return api["a" /* default */].post('documents', data, { headers: headers }).then(function () {
          return _this.$emit('hide', true);
        });
      } else {
        return api["a" /* default */].put('documents/' + this.doc.id, {
          'id': this.doc.id,
          'roles': this.doc.roles,
          'name': this.doc.name
        }).then(function () {
          return _this.$emit('hide', true);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cccb352","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/documents-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[(_vm.doc.url)?_c('h2',{staticClass:"modal-title"},[_vm._v("Редактировать инструкцию")]):_c('h2',{staticClass:"modal-title"},[_vm._v("Добавить инструкцию")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',[(!_vm.doc.url)?_c('input',{staticClass:"mb-3",attrs:{"type":"file"},on:{"change":_vm.onFileChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doc.name),expression:"doc.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":_vm.doc.name ?  _vm.doc.name :'Введите название'},domProps:{"value":(_vm.doc.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.doc, "name", $event.target.value)}}})]),_vm._v(" "),_c('h6',[_vm._v("Отображать для:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doc.roles.service),expression:"doc.roles.service"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","value":"","id":("checkbox-" + _vm._uid + "-service")},domProps:{"checked":Array.isArray(_vm.doc.roles.service)?_vm._i(_vm.doc.roles.service,"")>-1:(_vm.doc.roles.service)},on:{"change":function($event){var $$a=_vm.doc.roles.service,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.doc.roles, "service", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.doc.roles, "service", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.doc.roles, "service", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("checkbox-" + _vm._uid + "-service")}},[_vm._v("Оператор")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doc.roles.service_superior),expression:"doc.roles.service_superior"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","value":"","id":("checkbox-" + _vm._uid + "-service_superior")},domProps:{"checked":Array.isArray(_vm.doc.roles.service_superior)?_vm._i(_vm.doc.roles.service_superior,"")>-1:(_vm.doc.roles.service_superior)},on:{"change":function($event){var $$a=_vm.doc.roles.service_superior,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.doc.roles, "service_superior", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.doc.roles, "service_superior", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.doc.roles, "service_superior", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("checkbox-" + _vm._uid + "-service_superior")}},[_vm._v("Руководитель операторов")])])]),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doc.roles.tech),expression:"doc.roles.tech"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","value":"","id":("checkbox-" + _vm._uid + "-tech")},domProps:{"checked":Array.isArray(_vm.doc.roles.tech)?_vm._i(_vm.doc.roles.tech,"")>-1:(_vm.doc.roles.tech)},on:{"change":function($event){var $$a=_vm.doc.roles.tech,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.doc.roles, "tech", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.doc.roles, "tech", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.doc.roles, "tech", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("checkbox-" + _vm._uid + "-tech")}},[_vm._v("Техник")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doc.roles.tech_superior),expression:"doc.roles.tech_superior"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","value":"","id":("checkbox-" + _vm._uid + "-tech_superior")},domProps:{"checked":Array.isArray(_vm.doc.roles.tech_superior)?_vm._i(_vm.doc.roles.tech_superior,"")>-1:(_vm.doc.roles.tech_superior)},on:{"change":function($event){var $$a=_vm.doc.roles.tech_superior,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.doc.roles, "tech_superior", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.doc.roles, "tech_superior", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.doc.roles, "tech_superior", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("checkbox-" + _vm._uid + "-tech_superior")}},[_vm._v("Руководитель техников")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/documents-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  documents_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_documents_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s105":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><g fill=\"#363B4E\" fill-rule=\"evenodd\"><path d=\"M21.03 8.165a4.101 4.101 0 0 1 0 5.795.35.35 0 0 1-.5 0 .354.354 0 0 1 0-.5 3.395 3.395 0 0 0 0-4.795.354.354 0 0 1 .5-.5z\"/><path d=\"M19.54 8.92a.355.355 0 0 0-.5.5c.437.438.678 1.022.678 1.643 0 .62-.24 1.202-.679 1.64a.354.354 0 0 0 .5.5 3 3 0 0 0 .886-2.14c0-.81-.314-1.571-.886-2.142m-16.84-.256a.353.353 0 1 0-.5-.5 4.101 4.101 0 0 0 0 5.795.35.35 0 0 0 .5 0 .352.352 0 0 0 0-.5 3.395 3.395 0 0 1 0-4.795\"/><path d=\"M4.19 8.921a.353.353 0 0 0-.501 0 3.005 3.005 0 0 0-.886 2.142c0 .809.314 1.57.886 2.141a.354.354 0 0 0 .5-.5 2.304 2.304 0 0 1-.678-1.641c0-.621.24-1.205.678-1.642a.354.354 0 0 0 0-.5m2.119 8.354H16.92V3.83H6.308v13.445zm5.306 3.891c-.78 0-1.416-.634-1.416-1.415a1.417 1.417 0 0 1 2.832 0c0 .78-.636 1.415-1.416 1.415zM16.07 1H7.158C6.298 1 5.6 1.7 5.6 2.558V20.67c0 .86.699 1.56 1.558 1.56h8.912c.86 0 1.559-.7 1.559-1.56V2.56c0-.86-.7-1.56-1.559-1.56z\"/><path d=\"M12.497 11.063a1.052 1.052 0 1 1-2.105 0 1.052 1.052 0 0 1 2.105 0m2.919 0a1.052 1.052 0 1 1-2.104 0 1.052 1.052 0 0 1 2.104 0m-5.636 0a1.052 1.052 0 1 1-2.104 0 1.052 1.052 0 0 1 2.104 0\"/></g></svg>"

/***/ }),

/***/ "s3Ie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__("O4Lo");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("BUAs");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: ./resources/assets/js/components/filter-terms.vue + 1 modules
var filter_terms = __webpack_require__("HRc9");

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-search.vue






/* harmony default export */ var filter_search = ({
  name: 'FilterSearch',
  extends: filter_terms["default"],
  props: {
    name: { type: String },
    filters: { type: Object },
    endpoint: { type: String },
    minimum_input_length: { type: Number },
    endpointMethod: { type: String }
  },
  data: function data() {
    return {
      isLoading: false,
      firstOpen: true,
      termLength: 0
    };
  },

  computed: {
    debouncedSearch: function debouncedSearch() {
      return debounce_default()(this.search, this.debounceDelay);
    },
    charactersRemainder: function charactersRemainder() {
      return (this.minimum_input_length || 0) - this.termLength;
    }
  },
  methods: {
    onSearch: function onSearch(term) {
      this.isLoading = true;
      this.debouncedSearch(term);
    },
    search: function search(term) {
      var _this = this;

      this.termLength = term.length;
      if (this.termLength < (this.minimum_input_length || 0)) {
        this.isLoading = false;
        this.options = [];
        return;
      }

      this.isLoading = true;
      var params = {
        filters: assign_default()({}, this.filters, {
          _search: {
            term: term,
            name: this.name
          }
        })
      };

      var conf = {
        method: this.endpointMethod,
        url: this.endpoint
      };

      if (conf.method === 'get') {
        conf.params = params;
      } else {
        conf.data = params;
      }

      api["a" /* default */].request(conf).then(function (_ref) {
        var data = _ref.data;

        _this.options = data.filters;
        _this.isLoading = false;
      });
    },
    onOpen: function onOpen() {
      if (this.firstOpen) {
        if ((this.minimum_input_length || 0) === 0) {
          this.onSearch('');
        }
        this.firstOpen = false;
      }
    }
  },
  watch: {
    options: function options(newOptions) {
      this.terms = newOptions;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c579268","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-search.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-multiselect',{attrs:{"options":_vm.terms,"searchable":true,"loading":_vm.isLoading,"internal-search":false,"track-by":"value","label":"label","multiple":"","placeholder":""},on:{"search-change":_vm.onSearch,"open":_vm.onOpen},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(props.option.label))]),_vm._v(" "),_c('small',{staticClass:"filter-bucket-size font-weight-bold"},[_vm._v(_vm._s(props.option.count))])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_c('template',{slot:"beforeList"},[(_vm.charactersRemainder > 0)?_c('div',[_vm._v("\n      Пожалуйста, введите еще хотя бы "+_vm._s(_vm.charactersRemainder)+" символ\n    ")]):_vm._e()])],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-search.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_search,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_search = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s4cC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__("+X65");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/height-tracker.vue





/* harmony default export */ var height_tracker = ({
  name: 'HeightTracker',
  data: function data() {
    return {
      height: null,
      interval: null
    };
  },
  mounted: function mounted() {
    this.updateHeight();
    jquery_default()(window).on('resize', this.throttledUpdateHeight);
    this.interval = setInterval(this.throttledUpdateHeight, 1500);
  },

  methods: {
    updateHeight: function updateHeight() {
      if (this.$refs.container) {
        this.height = this.$refs.container.clientHeight;
      }
    },

    throttledUpdateHeight: throttle_default()(function () {
      this.updateHeight();
    }, 300)
  },
  beforeDestroy: function beforeDestroy() {
    jquery_default()(window).off('resize', this.throttledUpdateHeight);
    this.interval && clearInterval(this.interval);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7578f962","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/height-tracker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"height-tracker flex-grow-1"},[(_vm.height)?_vm._t("default",null,{"height":_vm.height}):_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/height-tracker.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  height_tracker,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_height_tracker = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s7J1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sLOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/btn-action.vue + 2 modules
var btn_action = __webpack_require__("K+Zy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/eva/_eva_id.vue





/* harmony default export */ var _eva_id = ({
  components: { BtnAction: btn_action["default"] },
  metaInfo: { title: 'Отчет EVA-DTS' },
  props: ['id', 'eva_id'],
  data: function data() {
    return {};
  },

  asyncComputed: {
    evaData: function evaData() {
      return api["a" /* default */].get('eva/' + this.eva_id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  },
  computed: {
    keymap: function keymap() {
      return {
        'alt+left': this.goPreviousUrl,
        'alt+right': this.goNextUrl
      };
    },
    previousUrl: function previousUrl() {
      return this.evaData.previous_id ? '/machines/' + this.id + '/eva/' + this.evaData.previous_id : null;
    },
    nextUrl: function nextUrl() {
      return this.evaData.next_id ? '/machines/' + this.id + '/eva/' + this.evaData.next_id : null;
    },
    siblingUrl: function siblingUrl() {
      return this.previousUrl || this.nextUrl;
    }
  },
  methods: {
    productName: function productName(productId) {
      return this.evaData.products[productId] || productId;
    },
    deleteEva: function deleteEva() {
      var _this = this;

      if (window.confirm('Удалить отчет?')) {
        return api["a" /* default */].delete('eva/' + this.eva_id).then(function () {
          return _this.siblingUrl && _this.$router.push(_this.siblingUrl);
        });
      }
    },
    goPreviousUrl: function goPreviousUrl() {
      if (this.previousUrl) {
        this.$router.push(this.previousUrl);
      }
    },
    goNextUrl: function goNextUrl() {
      if (this.nextUrl) {
        this.$router.push(this.nextUrl);
      }
    },
    downloadEva: function downloadEva() {
      var url = window.URL.createObjectURL(new Blob([this.evaData.raw]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'eva-' + this.evaData.date + '.txt');
      document.body.appendChild(link);
      link.click();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a64aeb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/eva/_eva_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.evaData)?_c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}]},[_c('div',{staticClass:"eva-header container-fluid"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-inline-flex align-items-center"},[_c('div',{staticClass:"btn-group mr-4"},[_c('router-link',{staticClass:"btn btn-outline-primary",class:{disabled: !_vm.evaData.previous_id},attrs:{"to":("/machines/" + _vm.id + "/eva/" + (_vm.evaData.previous_id))}},[_vm._v("«")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-outline-primary",class:{disabled: !_vm.evaData.next_id},attrs:{"to":("/machines/" + _vm.id + "/eva/" + (_vm.evaData.next_id))}},[_vm._v("»")])],1),_vm._v(" "),_c('h2',{staticClass:"page-heading"},[_vm._v("Отчет от "+_vm._s(_vm.evaData.date))])]),_vm._v(" "),(_vm.$root.user.role.name !== 'lessor_pro')?_c('btn-action',{staticClass:"btn btn-outline-danger",on:{"click":_vm.deleteEva}},[_vm._v("Удалить отчет")]):_vm._e()],1)]),_vm._v(" "),(_vm.evaData.html)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.evaData.html)}}),_vm._v(" "),_c('h2',{staticClass:"page-heading container-fluid"},[_vm._v("Продажи из EVA")]),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.evaData.eva_sales),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.params.sales))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.params.cost))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sale_type))])])}),0)]),_vm._v(" "),_c('h2',{staticClass:"page-heading container-fluid"},[_vm._v("Продукты из EVA")]),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.evaData.eva_product),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.productName(item.params.product_id)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.params.sales))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.params.cost))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sale_type))])])}),0)]),_vm._v(" "),_c('h2',{staticClass:"page-heading container-fluid"},[_vm._v("Отмеченные события")]),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.evaData.sale),function(item){return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":("/reports/events/" + (item.id))}},[_vm._v(_vm._s(item.id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.params.product_name == '' ? item.params.product_id : item.params.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.params.cost))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sale_type))])])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('h2',{staticClass:"page-heading container-fluid"},[_vm._v("Исходный текст отчета")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-auto mr-2",on:{"click":_vm.downloadEva}},[_vm._v("Скачать")])]),_vm._v(" "),_c('pre',{staticClass:"p-2 eva-raw bg-white"},[_vm._v(_vm._s(_vm.evaData.raw))])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Количество продаж")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th',[_vm._v("Тип продажи")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Продукт")]),_vm._v(" "),_c('th',[_vm._v("Количество продаж")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th',[_vm._v("Тип продажи")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("id")]),_vm._v(" "),_c('th',[_vm._v("Продукт")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th',[_vm._v("Тип продажи")])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/eva/_eva_id.vue
function injectStyle (context) {
  __webpack_require__("/tRM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _eva_id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var eva__eva_id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sV/x":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("WRGp");
var $root = __webpack_require__("je9+").default;
$root.$mount('#app');

/***/ }),

/***/ "sjvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "smib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/status-images.vue


/* harmony default export */ var status_images = ({
  name: 'status-images',
  props: {
    value: {},
    reasons: []
  },
  methods: {
    hasReason: function hasReason(reason) {
      return this.reasons.includes(reason);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7393ae","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/status-images.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-images"},[(_vm.value)?[(_vm.value.ok)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"ОК","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("HfmO")}})]):_vm._e(),_vm._v(" "),(_vm.value.network)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Нет связи","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("Fd/m")}})]):_vm._e(),_vm._v(" "),(_vm.value.products)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Требуется загрузка","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("iLmC")}})]):_vm._e(),_vm._v(" "),(_vm.value.money)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Требуется инкассация","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("4oW5")}})]):_vm._e(),_vm._v(" "),(_vm.value.shake)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Тряска","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("S5Mx")}})]):_vm._e(),_vm._v(" "),(_vm.value.temperature)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Достижение порогового значения температуры внутри автомата","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("vmUq")}})]):_vm._e(),_vm._v(" "),(_vm.value.electricity)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Отсутствие электропитания от сети 220В","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("KyxZ")}})]):_vm._e(),_vm._v(" "),(_vm.value.eva)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Большое кол-во отчетов EVA-DTS с ошибками","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("6Mbh")}})]):_vm._e(),_vm._v(" "),(_vm.value.service)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Невыполненный сервис","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("3PDc")}})]):_vm._e(),_vm._v(" "),(_vm.value.stop)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Остановка по причине неисправности","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("QCIs")}})]):_vm._e(),_vm._v(" "),(_vm.value.ignore)?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Давно не на связи","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("NLu6")}})]):_vm._e(),_vm._v(" "),(_vm.hasReason('technical'))?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Простой: Технический","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("A5/I")}})]):_vm._e(),_vm._v(" "),(_vm.hasReason('ingredients'))?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Простой: отсутствие ингредиентов","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("U3z9")}})]):_vm._e(),_vm._v(" "),(_vm.hasReason('money'))?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Простой: отсутствие сдачи","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("vvWA")}})]):_vm._e(),_vm._v(" "),(_vm.hasReason('unspecified'))?_c('tooltip',{staticClass:"status-image",attrs:{"title":"Простой: требует уточнения","placement":"right"}},[_c('img',{attrs:{"src":__webpack_require__("INd1")}})]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/status-images.vue
function injectStyle (context) {
  __webpack_require__("XYPa")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  status_images,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_status_images = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "stzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("uN7r");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// EXTERNAL MODULE: ./resources/assets/js/components/filter-search.vue + 2 modules
var filter_search = __webpack_require__("s3Ie");

// EXTERNAL MODULE: ./resources/assets/js/lang/defects.json
var defects = __webpack_require__("GEx1");
var defects_default = /*#__PURE__*/__webpack_require__.n(defects);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/filter-event-stop-defect.vue









/* harmony default export */ var filter_event_stop_defect = ({
  components: { FilterSearch: filter_search["default"] },
  props: {
    range: { type: Object },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      event: {
        number: this.value.number || {},
        date: this.value.date || {}
      },
      selected: this.value.valueCheckbox || [],
      reason: this.prepareReason(this.value.valueSearch || [])
    };
  },

  computed: {
    preparedInput: function preparedInput() {
      return omitBy_default()({
        number: this.event.number,
        date: this.event.date,
        valueCheckbox: this.selected,
        valueSearch: this.reason.map(function (o) {
          return o['value'];
        })
      }, isEmpty_default.a);
    },
    stopReasons: function stopReasons() {
      return entries_default()(defects_default.a).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          label: value,
          value: key
        };
      });
    }
  },
  methods: {
    prepareReason: function prepareReason(value) {
      return value.map(function (v) {
        return { label: defects_default.a[v], value: v };
      });
    }
  },
  watch: {
    value: function value(input) {
      this.event = {
        number: input.number || {},
        date: input.date || {}
      };
      this.selected = input.valueCheckbox || [];
    },

    preparedInput: {
      handler: function handler(newVal, oldVal) {
        if (!isEqual_default()(newVal, oldVal)) {
          this.$emit('input', this.preparedInput);
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185fb5a8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-stop-defect.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('filter-checkboxes',{attrs:{"options":_vm.options,"enableCount":false},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('label',{staticClass:"mt-1 mb-0"},[_vm._v("Причина неисправности")]),_vm._v(" "),_c('v-multiselect',{attrs:{"options":_vm.stopReasons,"searchable":true,"internal-search":true,"track-by":"value","label":"label","multiple":"","placeholder":""},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('span',[_vm._v(_vm._s(props.option.label))])])]}}]),model:{value:(_vm.reason),callback:function ($$v) {_vm.reason=$$v},expression:"reason"}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/filter-event-stop-defect.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  filter_event_stop_defect,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_filter_event_stop_defect = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "t+VF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t+bR":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><path fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M6.435 7.94h2.86v4.635l-2.86.442V7.94zm-3.577 0h2.718v5.077l-2.718-.438V7.94zm8.727-2.717c.777 0 1.43.718 1.43 1.399 0 .062-.067.406-.237.733-.169.327-.43.662-.777.88a.428.428 0 0 0-.17.206l-.246.616-.242-.616a.43.43 0 0 0-.174-.206c-.348-.218-.609-.553-.778-.88a2.291 2.291 0 0 1-.237-.733c0-.68.653-1.399 1.43-1.399zm0-.858c-1.276 0-2.29 1.067-2.29 2.257 0 .323.113.696.336 1.126.2.387.516.786.948 1.1l.608 1.537a.43.43 0 0 0 .8 0l.613-1.547c.426-.312.745-.707.943-1.09.223-.43.33-.803.33-1.126 0-1.19-1.012-2.257-2.288-2.257zm-6.009-2.36v5.077H2.858V2.44l2.718-.434zM13.731 1l-.497.08-3.513.563-3.648-.563-.067-.013-.068.013-3.576.572L2 1.711v11.596l.362.059 3.576.572.063.013.067-.013 3.653-.563 3.513.563.497.08V7.686c-.02.042-.04.085-.063.13-.178.344-.439.7-.796 1.005v4.192l-2.718-.434V8.691c-.284-.274-.5-.58-.653-.876a3.367 3.367 0 0 1-.29-.733H6.435V2.001l2.86.438v3.392c.166-.454.466-.852.86-1.14V2.44l2.717-.433v2.592c.361.227.658.541.859.911V1z\"/></svg>"

/***/ }),

/***/ "tG1Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/components/tooltip.vue + 2 modules
var tooltip = __webpack_require__("I/hk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/date-from-now.vue



/* harmony default export */ var date_from_now = ({
  components: { Tooltip: tooltip["default"] },
  data: function data() {
    return {};
  },
  props: {
    date: {},
    noSuffix: { default: false }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57870c4c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/date-from-now.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"title":_vm.date,"delay":300}},[_vm._v("\n  "+_vm._s(_vm._f("formatDateFromNow")(_vm.date,this.noSuffix) || '–')+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/date-from-now.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  date_from_now,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_date_from_now = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tOq2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tanR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u0Qr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id.vue




/* harmony default export */ var _id = ({
  metaInfo: function metaInfo() {
    return { title: '\u0410\u0432\u0442\u043E\u043C\u0430\u0442 ' + this.serial_number };
  },

  props: {
    id: {
      required: true
    }
  },
  data: function data() {
    return {
      subnav: [{
        text: 'Общее',
        to: '/machines/' + this.id,
        exact: true,
        permission: 'web_ta_main'
      }, {
        text: 'Денежные средства',
        to: '/machines/' + this.id + '/money',
        permission: 'web_ta_money'
      }, {
        text: 'Матрица',
        to: '/machines/' + this.id + '/matrix',
        permission: 'web_ta_matrix'
      }, {
        text: 'Модем',
        to: '/machines/' + this.id + '/modem',
        permission: 'web_ta_modem'
      }, {
        text: 'Режим работы',
        to: '/machines/' + this.id + '/schedule',
        permission: 'web_ta_schedule'
      }, {
        text: 'Магнитные карты',
        to: '/machines/' + this.id + '/cards',
        permission: 'web_ta_magnet'
      }, {
        text: 'EVA-DTS',
        to: '/machines/' + this.id + '/eva',
        permission: 'web_ta_eva'
      }, {
        text: 'Доотправка чеков',
        to: '/machines/' + this.id + '/matrixSendReceipts',
        permission: 'web_matrix_send_receipts'
      }]
    };
  },

  computed: {
    serial_number: function serial_number() {
      return this.machine && this.machine.serial_number || this.$root.store.serial_number || '';
    }
  },
  asyncComputed: {
    machine: function machine() {
      return api["a" /* default */].get('machines/' + this.id).then(function (_ref) {
        var data = _ref.data;
        return data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8d5b6d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('subnav',{attrs:{"links":_vm.subnav,"heading":("Автомат " + _vm.serial_number),"show-links":!!_vm.serial_number}}),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 position-relative"},[_c('div',{staticClass:"overflow-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.machine)?_c('router-view',{attrs:{"id":_vm.id,"machine":_vm.machine}}):_vm._e()],1)],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var machines__id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "u3Bg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uQuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/sample-modal-edit.vue




/* harmony default export */ var sample_modal_edit = ({
  props: ['id', 'name'],
  data: function data() {
    return {
      sampleName: this.name
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      var tmp = { name: this.sampleName };
      return api["a" /* default */].put('/samples/' + this.id, tmp).then(function (data) {
        _this.hide(tmp);
      });
    },
    hide: function hide(data) {
      this.$emit('hide', data);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b4c918c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sample-modal-edit.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("Редактирование выборки")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hide()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Название")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sampleName),expression:"sampleName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.sampleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sampleName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex"},[_c('btn-action',{staticClass:"btn btn-primary ml-auto",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/sample-modal-edit.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sample_modal_edit,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_sample_modal_edit = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uRG0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNEQjM5MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjU3NyA4LjQ5N2MtMS44NDkgMC0yLjkyOSAzLTIuOTI5IDQuNDY0IDAgMS4yOTYuNTUyIDIuMDY0IDEuNTEyIDIuMDY0IDEuODQ5IDAgMi44ODEtMy41MjggMi44ODEtNC45NDQgMC0uODg4LS41MjgtMS41ODQtMS40NjQtMS41ODR6bTcuMDU2IDkuODQxYy0yLjQ5NiAxLjgyNS00LjY1NyAyLjU2OS03LjM0NCAyLjU2OS0yLjY0MSAwLTQuODczLS43OTMtNi41NzctMi4zNzdDMy45NiAxNi45MjIgMyAxNC42NDIgMyAxMi4xOTMgMyA3LjAwOSA3LjIgMyAxMi42NDggM2M0Ljc1MyAwIDguMTE0IDIuOTc2IDguMTE0IDcuMjAxIDAgMy4zMzctMi4zMjkgNi4zMTMtNC45NDUgNi4zMTMtMS4yNDggMC0yLjA0MS0uNjcyLTIuMDQxLTEuNzUyIDAtLjE2OCAwLS4yODguMDQ5LS40OC0uNjczIDEuMjk2LTEuNzc2IDIuMjMyLTMuMzEyIDIuMjMyLTEuOTQ1IDAtMy4yNjUtMS40ODktMy4yNjUtMy42NzMgMC0zLjEyIDIuMjU3LTUuODA4IDQuODI0LTUuODA4IDEuMjczIDAgMi4xODUuNDU2IDIuNzEzIDEuNjMybC4zMzYtMS4yNDhoMi4wNEwxNS42IDEyLjc2OWMtLjE2OC42MDEtLjIzOS45ODQtLjIzOSAxLjI5NiAwIC42LjM2Ljk2Ljk4NC45NiAxLjU2IDAgMy4wNzItMi40NDggMy4wNzItNC45NDQgMC0zLjQ1Ni0yLjczNi01LjgzMy02Ljc0NC01LjgzMy00Ljc3NyAwLTguMzI5IDMuNDA5LTguMzI5IDguMDE3IDAgNC4zNDUgMy4zMTIgNy40MTcgOC4wMTYgNy40MTcgMi4zNzcgMCA0LjM2OS0uNjk2IDYuNTc3LTIuMzA0bC42OTYuOTZ6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "uVgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/data-table-full-height.vue


/* harmony default export */ var data_table_full_height = ({
  name: 'data-table-full-height',
  methods: {
    getCurrencySymbols: function getCurrencySymbols() {
      var symbols = [];
      this.$slots.default.forEach(function (vnode) {
        if (vnode.componentOptions && vnode.componentOptions.propsData) {
          symbols.push(vnode.componentOptions.propsData.currencySymbol);
        }
      });
      return symbols;
    },
    getTableColumnTypes: function getTableColumnTypes() {
      var types = [];
      this.$slots.default.forEach(function (vnode) {
        if (vnode.componentOptions && vnode.componentOptions.propsData) {
          types.push(vnode.componentOptions.propsData.tableColumnType);
        }
      });
      return types;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9354d06e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/data-table-full-height.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('height-tracker',{staticClass:"container-fluid",staticStyle:{"overflow":"hidden"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var height = ref.height;
return _c('div',{staticClass:"table-full-width"},[_c('data-table',_vm._g(_vm._b({staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0"},attrs:{"height":height,"currency-symbol":_vm.getCurrencySymbols(),"table-column-type":_vm.getTableColumnTypes()}},'data-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}}],null,true)})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/data-table-full-height.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  data_table_full_height,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_data_table_full_height = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vQ9a":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\"><path fill-rule=\"evenodd\" d=\"M9.996 13.14L15.993 7H4z\"/></svg>"

/***/ }),

/***/ "vRDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__("tVBY");
var range_default = /*#__PURE__*/__webpack_require__.n(range);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/schedule/editor.vue + 2 modules
var editor = __webpack_require__("m44z");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports-schedule-edit-modal.vue







/* harmony default export */ var reports_schedule_edit_modal = ({
  props: ['value', 'ids'],
  components: { ScheduleEditor: editor["a" /* default */] },
  data: function data() {
    return {
      schedule: this.value
    };
  },

  methods: {
    range: range_default.a,
    save: function save() {
      var _this = this;

      return api["a" /* default */].post('schedules', {
        reports_schedule: this.schedule,
        ids: this.ids
      }).then(function () {
        _this.$emit('hide', _this.schedule);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6870e6ae","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/reports-schedule-edit-modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-reports-schedule-edit modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title"},[_vm._v("Расписание отчетов")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('hide')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('schedule-editor',{model:{value:(_vm.schedule),callback:function ($$v) {_vm.schedule=$$v},expression:"schedule"}})],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-light",staticStyle:{"border-color":"transparent"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Отмена\n      ")])],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/reports-schedule-edit-modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  reports_schedule_edit_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_reports_schedule_edit_modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vczd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vmUq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9IiMyREEwQ0QiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTE0Ljg2IDIzLjA3M2MtMS4zIDAtMi4zNTMtMS4wMzYtMi4zNTMtMi4zMTNhMi4zIDIuMyAwIDAgMSAxLjA5MS0xLjk1di0zLjQ3M2gyLjV2My40NTlhMi4zIDIuMyAwIDAgMSAxLjExNiAxLjk2NGMwIDEuMjc3LTEuMDU0IDIuMzEzLTIuMzUzIDIuMzEzbTEuOS00LjUxNWwtLjA4Mi0uMDY3VjcuOTVjMC0uOTg2LS44MTYtMS43ODgtMS44MTgtMS43ODgtMS4wMDQgMC0xLjgyLjgwMi0xLjgyIDEuNzg4di40ODZoMS41Njd2LjQ0OWgtMS41Njd2MS40NzFoMi41MjV2LjQ0OWgtMi41MjR2MS40NzFoMS41Njd2LjQ0OWgtMS41Njd2MS40NzFoMi41MjR2LjQ0OGgtMi41MjR2My44NDdsLS4wODIuMDY3YTIuODgxIDIuODgxIDAgMCAwLTEuMDU4IDIuMjI2YzAgMS42MDMgMS4zMjcgMi45MDcgMi45NTkgMi45MDcgMS42MzEgMCAyLjk1OC0xLjMwNCAyLjk1OC0yLjkwNyAwLS44Ni0uMzg2LTEuNjcxLTEuMDU4LTIuMjI2Ii8+CiAgICAgICAgPHBhdGggZD0iTTE0Ljg2IDI0LjE0Yy0xLjg4MyAwLTMuNDE1LTEuNTA2LTMuNDE1LTMuMzU2IDAtLjk1OC40MTQtMS44NjMgMS4xNC0yLjVWNy45NDljMC0xLjIzMiAxLjAyLTIuMjM1IDIuMjc2LTIuMjM1IDEuMjU0IDAgMi4yNzUgMS4wMDMgMi4yNzUgMi4yMzV2MTAuMzM1YTMuMzIyIDMuMzIyIDAgMCAxIDEuMTQgMi41YzAgMS44NS0xLjUzMiAzLjM1NS0zLjQxNSAzLjM1NW0wLTIwLjg2NUM4LjMxIDMuMjc0IDMgOC40OSAzIDE0LjkyN2MwIDYuNDM1IDUuMzEgMTEuNjUyIDExLjg2IDExLjY1MnMxMS44Ni01LjIxNyAxMS44Ni0xMS42NTJjMC02LjQzNi01LjMxLTExLjY1My0xMS44Ni0xMS42NTMiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "vvWA":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "wNbr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__("w9Mt");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/event-details.vue




/* harmony default export */ var event_details = ({
  props: {
    event: {
      type: Object
    }
  },
  computed: {
    showData: function showData() {
      return pick_default()(this.event, ['message', 'date', 'card_key', 'sale_type']);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406af587","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/event-details.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("команда модема")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/commands/" + (this.event.modem_command_id))}},[_vm._v(_vm._s(_vm.event.modem_command_id))])],1),_vm._v(" "),_c('dt',[_vm._v("id")]),_vm._v(" "),_c('dd',[_c('router-link',{staticClass:"text-monospace text-muted",attrs:{"to":("/reports/events/" + (this.event.id))}},[_vm._v(_vm._s(_vm.event.id))])],1),_vm._v(" "),_vm._l((_vm.showData),function(value,key){return (value)?[_c('dt',[_vm._v(_vm._s(key))]),_vm._v(" "),_c('dd',{staticClass:"text-monospace text-muted"},[_vm._v(_vm._s(value))])]:_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.event.params)?_c('pre',{staticClass:"event-data-result m-0 p-3"},[_vm._v(_vm._s(_vm.event.params))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-muted"},[(_vm.event.params === null)?_c('div',[_vm._v("параметры отсутствуют")]):_vm._e()])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/event-details.vue
function injectStyle (context) {
  __webpack_require__("bK5o")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  event_details,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_event_details = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wPD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("KBYM");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./resources/assets/js/lang/events.json
var events = __webpack_require__("D7iU");
var events_default = /*#__PURE__*/__webpack_require__.n(events);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/events/index.vue









/* harmony default export */ var reports_events = ({
  metaInfo: { title: 'События' },
  data: function data() {
    return {
      filtersValue: null,
      data: {},
      loading: false,
      hasMore: true,
      sort: null,
      date: {
        min: moment_default()().subtract(1, 'days').format('YYYY-MM-DD'),
        max: moment_default()().format('YYYY-MM-DD')
      },
      externalFilters: null
    };
  },

  methods: {
    loadMore: function loadMore() {
      this.$refs.data.loadMore();
    },
    sortChange: function sortChange(sort) {
      if (sort.prop) {
        var order = sort.order === 'ascending' ? 'asc' : 'desc';
        this.$emit('update:sort', sort.prop + ':' + order);
      } else {
        this.$emit('update:sort', null);
      }
    },
    refreshFilters: function refreshFilters(event) {
      this.externalFilters = values_default()(event);
    }
  },
  computed: {
    codeFilters: function codeFilters() {
      return sortBy_default()(entries_default()(events_default.a).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return {
          value: key,
          text: value.split('|')[0]
        };
      }), 'text');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aecd71d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/events/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":"events","filtersValue":_vm.filtersValue,"loading":_vm.loading,"hasMore":_vm.hasMore,"sort":_vm.sort,"date":_vm.date,"externalFilters":_vm.externalFilters},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h1',{staticClass:"mr-auto"},[_vm._v("События")]),_vm._v(" "),_c('btn-filters',{attrs:{"data":_vm.data,"endpoint":"events","range":true,"date":_vm.date},on:{"update:date":function($event){_vm.date=$event}},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}})],1)]),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"sort-change":_vm.sortChange,"load-more":_vm.loadMore,"filter-change":_vm.refreshFilters}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"event-details-expand"},[_c('event-details',{attrs:{"event":row}})],1)]}}],null,false,4066619733)}),_vm._v(" "),_c('table-column-serial-number',{attrs:{"prop":"machine.serial_number","machine-prop":"machine"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"machine.address","label":"Адрес установки","show-overflow-tooltip":true,"min-width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Тип события","min-width":"200","filters":_vm.codeFilters,"filter-placement":"bottom-start"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.message))]}}],null,false,280528596)}),_vm._v(" "),_c('table-column-date')],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/events/index.vue
function injectStyle (context) {
  __webpack_require__("RTB2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  reports_events,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_reports_events = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wSWk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("hygk");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("lHK6");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./resources/assets/js/components/filter-range-date.vue + 2 modules
var filter_range_date = __webpack_require__("Ajcq");

// EXTERNAL MODULE: ./resources/assets/js/query-encoder.js
var query_encoder = __webpack_require__("jhtD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/btn-filters.vue







/* harmony default export */ var btn_filters = ({
  name: 'BtnFilters',
  components: { FilterRangeDate: filter_range_date["default"] },
  props: {
    value: {},
    endpoint: {},
    data: {},
    date: {},
    range: false
  },
  data: function data() {
    return {
      filterDate: this.date,
      filtersValue: null
    };
  },

  computed: {
    hasFilters: function hasFilters() {
      for (var key in this.value) {
        if (this.value.hasOwnProperty(key) && key !== 'map') {
          return true;
        }
      }
      return false;
    },
    queryFilters: function queryFilters() {
      return this.$route.query.filters ? Object(query_encoder["a" /* decode */])(this.$route.query.filters) : {};
    }
  },
  watch: {
    filterDate: function filterDate() {
      this.$emit('update:date', this.filterDate);
    },
    value: function value() {
      var query = assign_default()({}, this.$route.query);
      if (isEmpty_default()(this.value)) {
        delete query.filters;
      } else {
        query.filters = Object(query_encoder["b" /* encode */])(this.value);
      }

      this.$router.replace({ query: query });
    },
    queryFilters: function queryFilters(newValue) {
      if (!isEqual_default()(newValue, this.value)) {
        this.filtersValue = newValue;
      }
    },
    filtersValue: function filtersValue() {
      this.$emit('input', this.filtersValue);
    }
  },
  mounted: function mounted() {
    this.filtersValue = this.queryFilters;
  },

  methods: {
    showFilters: function showFilters() {
      return this.$refs.filters.show();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328fedbe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/btn-filters.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.filters)?_c('div',{staticClass:"d-flex"},[(_vm.data)?_c('app-filters',{ref:"filters",attrs:{"data":_vm.data,"endpoint":_vm.endpoint},model:{value:(_vm.filtersValue),callback:function ($$v) {_vm.filtersValue=$$v},expression:"filtersValue"}}):_vm._e(),_vm._v(" "),(_vm.range)?_c('filter-range-date',{staticClass:"mr-2",staticStyle:{"max-width":"26em"},model:{value:(_vm.filterDate),callback:function ($$v) {_vm.filterDate=$$v},expression:"filterDate"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-filters btn btn-outline-primary text-nowrap",class:{'btn-filters-dirty': _vm.hasFilters},on:{"click":_vm.showFilters}},[_c('small',[_c('font-awesome-icon',{attrs:{"icon":"filter"}})],1),_vm._v("\n    Фильтры\n  ")])],1):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/components/btn-filters.vue
function injectStyle (context) {
  __webpack_require__("z0i1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  btn_filters,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_btn_filters = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xb9M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/map.js
var map = __webpack_require__("nSPF");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.min.js
var vuedraggable_umd_min = __webpack_require__("6Top");
var vuedraggable_umd_min_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd_min);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// EXTERNAL MODULE: ./resources/assets/js/components/sample-modal-edit.vue + 2 modules
var sample_modal_edit = __webpack_require__("uQuk");

// EXTERNAL MODULE: ./resources/assets/js/query-encoder.js
var query_encoder = __webpack_require__("jhtD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/reports/samples.vue









/* harmony default export */ var samples = ({
  metaInfo: { title: 'Мои выборки' },
  components: {
    draggable: vuedraggable_umd_min_default.a
  },
  data: function data() {
    return {
      currentSamples: null,
      moving: null
    };
  },

  methods: {
    edit: function edit(sample, event) {
      var _this = this;

      this.$root.showModal(sample_modal_edit["default"], {
        id: sample.id,
        name: sample.name
      }).then(function (data) {
        if (data !== undefined) {
          var element = _this.currentSamples.find(function (current) {
            return current.id === sample.id;
          });
          if (element !== undefined) {
            assign_default()(element, data);
          }
        }
      });
    },
    remove: function remove(element, event) {
      var _this2 = this;

      if (!window.confirm('Подтвердить удаление?')) return;

      return api["a" /* default */].delete('samples/' + element.id).then(function () {
        _this2.currentSamples.splice(_this2.currentSamples.indexOf(element), 1);
      });
    },
    useSample: function useSample(sample) {
      var path = this.$router.resolve(sample.path + '?filters=' + Object(query_encoder["b" /* encode */])(sample.filters));
      window.open(path.href, '_blank');
    }
  },
  watch: {
    currentSamples: function currentSamples(list) {
      if (list !== undefined) {
        api["a" /* default */].post('samples/order', {
          ids: map_default()(list, function (current) {
            return current.id;
          })
        });
      }
    }
  },
  asyncComputed: {
    elements: function elements() {
      var _this3 = this;

      api["a" /* default */].get('samples').then(function (_ref) {
        var data = _ref.data;

        _this3.currentSamples = data.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18712b01","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/reports/samples.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid d-flex flex-column flex-grow-1"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table-full-width flex-grow-1 bg-white d-flex flex-column"},[_vm._m(1),_vm._v(" "),_c('height-tracker',{staticClass:"container-fluid flex-grow-1",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var height = ref.height;
return _c('div',{staticClass:"table-full-width"},[_c('div',{ref:"content",style:('overflow-y: auto; height: ' + height + 'px')},[_c('draggable',{model:{value:(_vm.currentSamples),callback:function ($$v) {_vm.currentSamples=$$v},expression:"currentSamples"}},_vm._l((_vm.currentSamples),function(element,index){return _c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.useSample(element)},"touchstart":function($event){return _vm.useSample(element)}}},[_c('div',{staticClass:"d-flex flex-row p-2 washy-bottom"},[_c('div',{staticClass:"mr-3",staticStyle:{"min-width":"2em"}},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(element.name))]),_vm._v(" "),_c('div',{staticClass:"ml-auto text-nowrap"},[_c('button',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function($event){$event.stopPropagation();return _vm.edit(element)}}},[_vm._v("Редактировать")]),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-sm btn-outline-light",on:{"click":function($event){$event.stopPropagation();return (function () { return _vm.remove(element); })($event)}}},[_vm._v("Удалить")])],1)])])}),0),_vm._v(" "),_vm._t("default")],2)])}}],null,true)})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('h2',{staticClass:"page-heading mr-auto"},[_vm._v("Мои выборки")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table mb-0"},[_c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"mr-3",staticStyle:{"min-width":"2em"}},[_vm._v("№")]),_vm._v(" "),_c('span',[_vm._v("Выборки")])])])])])}]

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/reports/samples.vue
function injectStyle (context) {
  __webpack_require__("baBi")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  samples,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_samples = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yabw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yhQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__("2247");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./resources/assets/js/api.js + 1 modules
var api = __webpack_require__("1H0F");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/machines/_id/matrix.vue






/* harmony default export */ var matrix = ({
  props: {
    id: { required: true },
    machine: { type: Object }
  },
  data: function data() {
    return {};
  },

  computed: {
    matrix: function matrix() {
      return this.machine.matrix;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01713eec","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/machines/_id/matrix.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"machines-show-matrix container-fluid"},[_c('h2',{staticClass:"page-heading"},[_vm._v("Матрица "+_vm._s(_vm._f("get")(_vm.matrix,'name')))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"row"},[(_vm.matrix)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card mb-4"},[_c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Матрица")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table-sm m-0 px-0"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right",staticStyle:{"width":"3em"}},[_vm._v("№")]),_vm._v(" "),_c('th',[_vm._v("Продукт")])])]),_vm._v(" "),_vm._l((_vm.matrix.products),function(product,index){return (product.product_id)?_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("get")(_vm.matrix,("product_numbers[" + index + "]"), index+1)))]),_vm._v(" "),(product.product)?_c('td',[_c('router-link',{staticClass:"text-dark",attrs:{"to":("/settings/recipes/products/" + (product.product_id))}},[_vm._v(_vm._s(product.product.name))])],1):_c('td',[_c('small',[_c('samp',{staticClass:"text-muted",attrs:{"data-title":"Некорректная ссылка","data-toggle":"tooltip","data-placement":"right"}},[_vm._v("\n                    "+_vm._s(product.product_id)+"\n                  ")])])])]):_vm._e()})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md"},[_c('div',{staticClass:"card mb-4"},[_c('h3',{staticClass:"card-header"},[_c('span',{staticClass:"text-caps"},[_vm._v("Остатки ингредиентов")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table-sm m-0 px-0 w-100"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Ингредиент")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Остаток")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.machine.critical_remainders),function(ingredient){return _c('tr',[_c('td',{class:{'text-danger': ingredient.remainder < 0.01}},[_vm._v(_vm._s(ingredient.component.name))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"media align-items-center justify-content-end"},[_c('small',[_vm._v(_vm._s(_vm._f("remainder")(ingredient.remainder))+" / "+_vm._s(ingredient.full)+" "+_vm._s(ingredient.component.measure))]),_vm._v(" "),_c('progress-bar',{staticClass:"ml-3",staticStyle:{"min-width":"100px","width":"10vw"},attrs:{"value":_vm._f("remainder")(ingredient.remainder),"max":parseInt(ingredient.full),"threshold":ingredient.critical,"state":ingredient.remainder > ingredient.critical ? 'success' : 'danger'}})],1)])])}),0)])])])])])])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/machines/_id/matrix.vue
function injectStyle (context) {
  __webpack_require__("yabw")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  matrix,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _id_matrix = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "z0i1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zPUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib?cacheDirectory!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/pages/modems/index/broadcasts/_id.vue


/* harmony default export */ var _id = ({
  props: {
    id: {}
  },
  data: function data() {
    return {
      data: {},
      loading: false,
      hasMore: true
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f34b9260","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/modems/index/broadcasts/_id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('filtered-data',{ref:"data",attrs:{"endpoint":("modems/broadcasts/" + (this.id)),"loading":_vm.loading,"hasMore":_vm.hasMore},on:{"update:loading":function($event){_vm.loading=$event},"update:hasMore":function($event){_vm.hasMore=$event},"update:has-more":function($event){_vm.hasMore=$event}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_vm._v(" "),(_vm.data && _vm.data.data)?[_c('data-table-full-height',{attrs:{"data":_vm.data.data,"hasMore":_vm.hasMore,"loading":_vm.loading},on:{"load-more":_vm.$refs.data.loadMore}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"modem-command-details-expand"},[_c('modem-command-details',{attrs:{"command":row}})],1)]}}],null,false,1854883838)}),_vm._v(" "),_c('table-column-date'),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Тип","width":"150","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"state","label":"Статус","width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(row.state)+"\n          "),(row.error_code)?_c('div',{staticClass:"text-danger"},[_vm._v("Ошибка "+_vm._s(row.error_code))]):_vm._e()]}}],null,false,1194376577)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"data_result","label":"Ответ"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.data_result)?_c('pre',{staticClass:"modem-command-data-result-preview m-0"},[_vm._v(_vm._s(row.data_result.trim()))]):_vm._e()]}}],null,false,4048390997)})],1)]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./resources/assets/js/pages/modems/index/broadcasts/_id.vue
function injectStyle (context) {
  __webpack_require__("KBW/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  _id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var broadcasts__id = __webpack_exports__["default"] = (Component.exports);


/***/ })

},["sV/x"]);


// WEBPACK FOOTER //
// static/app/js/app.75257428f1bb17fde7c8.js